(() => {

  var _a, _b;
(function polyfill() {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) {
    return;
  }
  for (const link of document.querySelectorAll('link[rel="modulepreload"]')) {
    processPreload(link);
  }
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") {
        continue;
      }
      for (const node of mutation.addedNodes) {
        if (node.tagName === "LINK" && node.rel === "modulepreload")
          processPreload(node);
      }
    }
  }).observe(document, { childList: true, subtree: true });
  function getFetchOpts(link) {
    const fetchOpts = {};
    if (link.integrity) fetchOpts.integrity = link.integrity;
    if (link.referrerPolicy) fetchOpts.referrerPolicy = link.referrerPolicy;
    if (link.crossOrigin === "use-credentials")
      fetchOpts.credentials = "include";
    else if (link.crossOrigin === "anonymous") fetchOpts.credentials = "omit";
    else fetchOpts.credentials = "same-origin";
    return fetchOpts;
  }
  function processPreload(link) {
    if (link.ep)
      return;
    link.ep = true;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
})();
!function(o) {
  (o.Shopify = o.Shopify || {}).modules = true;
}(window);
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
var react = { exports: {} };
var react_production_min = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l$1 = Symbol.for("react.element"), n$1 = Symbol.for("react.portal"), p$2 = Symbol.for("react.fragment"), q$1 = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v$1 = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z$1 = Symbol.iterator;
function A$1(a) {
  if (null === a || "object" !== typeof a) return null;
  a = z$1 && a[z$1] || a["@@iterator"];
  return "function" === typeof a ? a : null;
}
var B$1 = { isMounted: function() {
  return false;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, C$1 = Object.assign, D$1 = {};
function E$1(a, b, e) {
  this.props = a;
  this.context = b;
  this.refs = D$1;
  this.updater = e || B$1;
}
E$1.prototype.isReactComponent = {};
E$1.prototype.setState = function(a, b) {
  if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
  this.updater.enqueueSetState(this, a, b, "setState");
};
E$1.prototype.forceUpdate = function(a) {
  this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {
}
F.prototype = E$1.prototype;
function G$1(a, b, e) {
  this.props = a;
  this.context = b;
  this.refs = D$1;
  this.updater = e || B$1;
}
var H$1 = G$1.prototype = new F();
H$1.constructor = G$1;
C$1(H$1, E$1.prototype);
H$1.isPureReactComponent = true;
var I$1 = Array.isArray, J = Object.prototype.hasOwnProperty, K$1 = { current: null }, L$1 = { key: true, ref: true, __self: true, __source: true };
function M$1(a, b, e) {
  var d, c = {}, k2 = null, h = null;
  if (null != b) for (d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k2 = "" + b.key), b) J.call(b, d) && !L$1.hasOwnProperty(d) && (c[d] = b[d]);
  var g = arguments.length - 2;
  if (1 === g) c.children = e;
  else if (1 < g) {
    for (var f2 = Array(g), m2 = 0; m2 < g; m2++) f2[m2] = arguments[m2 + 2];
    c.children = f2;
  }
  if (a && a.defaultProps) for (d in g = a.defaultProps, g) void 0 === c[d] && (c[d] = g[d]);
  return { $$typeof: l$1, type: a, key: k2, ref: h, props: c, _owner: K$1.current };
}
function N$1(a, b) {
  return { $$typeof: l$1, type: a.type, key: b, ref: a.ref, props: a.props, _owner: a._owner };
}
function O$1(a) {
  return "object" === typeof a && null !== a && a.$$typeof === l$1;
}
function escape(a) {
  var b = { "=": "=0", ":": "=2" };
  return "$" + a.replace(/[=:]/g, function(a2) {
    return b[a2];
  });
}
var P$1 = /\/+/g;
function Q$1(a, b) {
  return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R$1(a, b, e, d, c) {
  var k2 = typeof a;
  if ("undefined" === k2 || "boolean" === k2) a = null;
  var h = false;
  if (null === a) h = true;
  else switch (k2) {
    case "string":
    case "number":
      h = true;
      break;
    case "object":
      switch (a.$$typeof) {
        case l$1:
        case n$1:
          h = true;
      }
  }
  if (h) return h = a, c = c(h), a = "" === d ? "." + Q$1(h, 0) : d, I$1(c) ? (e = "", null != a && (e = a.replace(P$1, "$&/") + "/"), R$1(c, b, e, "", function(a2) {
    return a2;
  })) : null != c && (O$1(c) && (c = N$1(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P$1, "$&/") + "/") + a)), b.push(c)), 1;
  h = 0;
  d = "" === d ? "." : d + ":";
  if (I$1(a)) for (var g = 0; g < a.length; g++) {
    k2 = a[g];
    var f2 = d + Q$1(k2, g);
    h += R$1(k2, b, e, f2, c);
  }
  else if (f2 = A$1(a), "function" === typeof f2) for (a = f2.call(a), g = 0; !(k2 = a.next()).done; ) k2 = k2.value, f2 = d + Q$1(k2, g++), h += R$1(k2, b, e, f2, c);
  else if ("object" === k2) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
  return h;
}
function S$1(a, b, e) {
  if (null == a) return a;
  var d = [], c = 0;
  R$1(a, d, "", "", function(a2) {
    return b.call(e, a2, c++);
  });
  return d;
}
function T$1(a) {
  if (-1 === a._status) {
    var b = a._result;
    b = b();
    b.then(function(b2) {
      if (0 === a._status || -1 === a._status) a._status = 1, a._result = b2;
    }, function(b2) {
      if (0 === a._status || -1 === a._status) a._status = 2, a._result = b2;
    });
    -1 === a._status && (a._status = 0, a._result = b);
  }
  if (1 === a._status) return a._result.default;
  throw a._result;
}
var U$1 = { current: null }, V$1 = { transition: null }, W$1 = { ReactCurrentDispatcher: U$1, ReactCurrentBatchConfig: V$1, ReactCurrentOwner: K$1 };
function X$1() {
  throw Error("act(...) is not supported in production builds of React.");
}
react_production_min.Children = { map: S$1, forEach: function(a, b, e) {
  S$1(a, function() {
    b.apply(this, arguments);
  }, e);
}, count: function(a) {
  var b = 0;
  S$1(a, function() {
    b++;
  });
  return b;
}, toArray: function(a) {
  return S$1(a, function(a2) {
    return a2;
  }) || [];
}, only: function(a) {
  if (!O$1(a)) throw Error("React.Children.only expected to receive a single React element child.");
  return a;
} };
react_production_min.Component = E$1;
react_production_min.Fragment = p$2;
react_production_min.Profiler = r;
react_production_min.PureComponent = G$1;
react_production_min.StrictMode = q$1;
react_production_min.Suspense = w;
react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W$1;
react_production_min.act = X$1;
react_production_min.cloneElement = function(a, b, e) {
  if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
  var d = C$1({}, a.props), c = a.key, k2 = a.ref, h = a._owner;
  if (null != b) {
    void 0 !== b.ref && (k2 = b.ref, h = K$1.current);
    void 0 !== b.key && (c = "" + b.key);
    if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
    for (f2 in b) J.call(b, f2) && !L$1.hasOwnProperty(f2) && (d[f2] = void 0 === b[f2] && void 0 !== g ? g[f2] : b[f2]);
  }
  var f2 = arguments.length - 2;
  if (1 === f2) d.children = e;
  else if (1 < f2) {
    g = Array(f2);
    for (var m2 = 0; m2 < f2; m2++) g[m2] = arguments[m2 + 2];
    d.children = g;
  }
  return { $$typeof: l$1, type: a.type, key: c, ref: k2, props: d, _owner: h };
};
react_production_min.createContext = function(a) {
  a = { $$typeof: u, _currentValue: a, _currentValue2: a, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null };
  a.Provider = { $$typeof: t, _context: a };
  return a.Consumer = a;
};
react_production_min.createElement = M$1;
react_production_min.createFactory = function(a) {
  var b = M$1.bind(null, a);
  b.type = a;
  return b;
};
react_production_min.createRef = function() {
  return { current: null };
};
react_production_min.forwardRef = function(a) {
  return { $$typeof: v$1, render: a };
};
react_production_min.isValidElement = O$1;
react_production_min.lazy = function(a) {
  return { $$typeof: y, _payload: { _status: -1, _result: a }, _init: T$1 };
};
react_production_min.memo = function(a, b) {
  return { $$typeof: x, type: a, compare: void 0 === b ? null : b };
};
react_production_min.startTransition = function(a) {
  var b = V$1.transition;
  V$1.transition = {};
  try {
    a();
  } finally {
    V$1.transition = b;
  }
};
react_production_min.unstable_act = X$1;
react_production_min.useCallback = function(a, b) {
  return U$1.current.useCallback(a, b);
};
react_production_min.useContext = function(a) {
  return U$1.current.useContext(a);
};
react_production_min.useDebugValue = function() {
};
react_production_min.useDeferredValue = function(a) {
  return U$1.current.useDeferredValue(a);
};
react_production_min.useEffect = function(a, b) {
  return U$1.current.useEffect(a, b);
};
react_production_min.useId = function() {
  return U$1.current.useId();
};
react_production_min.useImperativeHandle = function(a, b, e) {
  return U$1.current.useImperativeHandle(a, b, e);
};
react_production_min.useInsertionEffect = function(a, b) {
  return U$1.current.useInsertionEffect(a, b);
};
react_production_min.useLayoutEffect = function(a, b) {
  return U$1.current.useLayoutEffect(a, b);
};
react_production_min.useMemo = function(a, b) {
  return U$1.current.useMemo(a, b);
};
react_production_min.useReducer = function(a, b, e) {
  return U$1.current.useReducer(a, b, e);
};
react_production_min.useRef = function(a) {
  return U$1.current.useRef(a);
};
react_production_min.useState = function(a) {
  return U$1.current.useState(a);
};
react_production_min.useSyncExternalStore = function(a, b, e) {
  return U$1.current.useSyncExternalStore(a, b, e);
};
react_production_min.useTransition = function() {
  return U$1.current.useTransition();
};
react_production_min.version = "18.3.1";
{
  react.exports = react_production_min;
}
var reactExports = react.exports;
const React = /* @__PURE__ */ getDefaultExportFromCjs(reactExports);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = reactExports, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m$1 = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p$1 = { key: true, ref: true, __self: true, __source: true };
function q(c, a, g) {
  var b, d = {}, e = null, h = null;
  void 0 !== g && (e = "" + g);
  void 0 !== a.key && (e = "" + a.key);
  void 0 !== a.ref && (h = a.ref);
  for (b in a) m$1.call(a, b) && !p$1.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
  return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
}
reactJsxRuntime_production_min.Fragment = l;
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
var jsxRuntimeExports = jsxRuntime.exports;
var client = {};
var reactDom = { exports: {} };
var reactDom_production_min = {};
var scheduler = { exports: {} };
var scheduler_production_min = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function(exports) {
  function f2(a, b) {
    var c = a.length;
    a.push(b);
    a: for (; 0 < c; ) {
      var d = c - 1 >>> 1, e = a[d];
      if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
      else break a;
    }
  }
  function h(a) {
    return 0 === a.length ? null : a[0];
  }
  function k2(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
      a[0] = c;
      a: for (var d = 0, e = a.length, w2 = e >>> 1; d < w2; ) {
        var m2 = 2 * (d + 1) - 1, C2 = a[m2], n2 = m2 + 1, x2 = a[n2];
        if (0 > g(C2, c)) n2 < e && 0 > g(x2, C2) ? (a[d] = x2, a[n2] = c, d = n2) : (a[d] = C2, a[m2] = c, d = m2);
        else if (n2 < e && 0 > g(x2, c)) a[d] = x2, a[n2] = c, d = n2;
        else break a;
      }
    }
    return b;
  }
  function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
  }
  if ("object" === typeof performance && "function" === typeof performance.now) {
    var l2 = performance;
    exports.unstable_now = function() {
      return l2.now();
    };
  } else {
    var p2 = Date, q2 = p2.now();
    exports.unstable_now = function() {
      return p2.now() - q2;
    };
  }
  var r2 = [], t2 = [], u2 = 1, v2 = null, y2 = 3, z2 = false, A2 = false, B2 = false, D2 = "function" === typeof setTimeout ? setTimeout : null, E2 = "function" === typeof clearTimeout ? clearTimeout : null, F2 = "undefined" !== typeof setImmediate ? setImmediate : null;
  "undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
  function G2(a) {
    for (var b = h(t2); null !== b; ) {
      if (null === b.callback) k2(t2);
      else if (b.startTime <= a) k2(t2), b.sortIndex = b.expirationTime, f2(r2, b);
      else break;
      b = h(t2);
    }
  }
  function H2(a) {
    B2 = false;
    G2(a);
    if (!A2) if (null !== h(r2)) A2 = true, I2(J2);
    else {
      var b = h(t2);
      null !== b && K2(H2, b.startTime - a);
    }
  }
  function J2(a, b) {
    A2 = false;
    B2 && (B2 = false, E2(L2), L2 = -1);
    z2 = true;
    var c = y2;
    try {
      G2(b);
      for (v2 = h(r2); null !== v2 && (!(v2.expirationTime > b) || a && !M2()); ) {
        var d = v2.callback;
        if ("function" === typeof d) {
          v2.callback = null;
          y2 = v2.priorityLevel;
          var e = d(v2.expirationTime <= b);
          b = exports.unstable_now();
          "function" === typeof e ? v2.callback = e : v2 === h(r2) && k2(r2);
          G2(b);
        } else k2(r2);
        v2 = h(r2);
      }
      if (null !== v2) var w2 = true;
      else {
        var m2 = h(t2);
        null !== m2 && K2(H2, m2.startTime - b);
        w2 = false;
      }
      return w2;
    } finally {
      v2 = null, y2 = c, z2 = false;
    }
  }
  var N2 = false, O2 = null, L2 = -1, P2 = 5, Q2 = -1;
  function M2() {
    return exports.unstable_now() - Q2 < P2 ? false : true;
  }
  function R2() {
    if (null !== O2) {
      var a = exports.unstable_now();
      Q2 = a;
      var b = true;
      try {
        b = O2(true, a);
      } finally {
        b ? S2() : (N2 = false, O2 = null);
      }
    } else N2 = false;
  }
  var S2;
  if ("function" === typeof F2) S2 = function() {
    F2(R2);
  };
  else if ("undefined" !== typeof MessageChannel) {
    var T2 = new MessageChannel(), U2 = T2.port2;
    T2.port1.onmessage = R2;
    S2 = function() {
      U2.postMessage(null);
    };
  } else S2 = function() {
    D2(R2, 0);
  };
  function I2(a) {
    O2 = a;
    N2 || (N2 = true, S2());
  }
  function K2(a, b) {
    L2 = D2(function() {
      a(exports.unstable_now());
    }, b);
  }
  exports.unstable_IdlePriority = 5;
  exports.unstable_ImmediatePriority = 1;
  exports.unstable_LowPriority = 4;
  exports.unstable_NormalPriority = 3;
  exports.unstable_Profiling = null;
  exports.unstable_UserBlockingPriority = 2;
  exports.unstable_cancelCallback = function(a) {
    a.callback = null;
  };
  exports.unstable_continueExecution = function() {
    A2 || z2 || (A2 = true, I2(J2));
  };
  exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P2 = 0 < a ? Math.floor(1e3 / a) : 5;
  };
  exports.unstable_getCurrentPriorityLevel = function() {
    return y2;
  };
  exports.unstable_getFirstCallbackNode = function() {
    return h(r2);
  };
  exports.unstable_next = function(a) {
    switch (y2) {
      case 1:
      case 2:
      case 3:
        var b = 3;
        break;
      default:
        b = y2;
    }
    var c = y2;
    y2 = b;
    try {
      return a();
    } finally {
      y2 = c;
    }
  };
  exports.unstable_pauseExecution = function() {
  };
  exports.unstable_requestPaint = function() {
  };
  exports.unstable_runWithPriority = function(a, b) {
    switch (a) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        a = 3;
    }
    var c = y2;
    y2 = a;
    try {
      return b();
    } finally {
      y2 = c;
    }
  };
  exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch (a) {
      case 1:
        var e = -1;
        break;
      case 2:
        e = 250;
        break;
      case 5:
        e = 1073741823;
        break;
      case 4:
        e = 1e4;
        break;
      default:
        e = 5e3;
    }
    e = c + e;
    a = { id: u2++, callback: b, priorityLevel: a, startTime: c, expirationTime: e, sortIndex: -1 };
    c > d ? (a.sortIndex = c, f2(t2, a), null === h(r2) && a === h(t2) && (B2 ? (E2(L2), L2 = -1) : B2 = true, K2(H2, c - d))) : (a.sortIndex = e, f2(r2, a), A2 || z2 || (A2 = true, I2(J2)));
    return a;
  };
  exports.unstable_shouldYield = M2;
  exports.unstable_wrapCallback = function(a) {
    var b = y2;
    return function() {
      var c = y2;
      y2 = b;
      try {
        return a.apply(this, arguments);
      } finally {
        y2 = c;
      }
    };
  };
})(scheduler_production_min);
{
  scheduler.exports = scheduler_production_min;
}
var schedulerExports = scheduler.exports;
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aa = reactExports, ca = schedulerExports;
function p(a) {
  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) b += "&args[]=" + encodeURIComponent(arguments[c]);
  return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = /* @__PURE__ */ new Set(), ea = {};
function fa(a, b) {
  ha(a, b);
  ha(a + "Capture", b);
}
function ha(a, b) {
  ea[a] = b;
  for (a = 0; a < b.length; a++) da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
  if (ja.call(ma, a)) return true;
  if (ja.call(la, a)) return false;
  if (ka.test(a)) return ma[a] = true;
  la[a] = true;
  return false;
}
function pa(a, b, c, d) {
  if (null !== c && 0 === c.type) return false;
  switch (typeof b) {
    case "function":
    case "symbol":
      return true;
    case "boolean":
      if (d) return false;
      if (null !== c) return !c.acceptsBooleans;
      a = a.toLowerCase().slice(0, 5);
      return "data-" !== a && "aria-" !== a;
    default:
      return false;
  }
}
function qa(a, b, c, d) {
  if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return true;
  if (d) return false;
  if (null !== c) switch (c.type) {
    case 3:
      return !b;
    case 4:
      return false === b;
    case 5:
      return isNaN(b);
    case 6:
      return isNaN(b) || 1 > b;
  }
  return false;
}
function v(a, b, c, d, e, f2, g) {
  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
  this.attributeName = d;
  this.attributeNamespace = e;
  this.mustUseProperty = c;
  this.propertyName = a;
  this.type = b;
  this.sanitizeURL = f2;
  this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
  z[a] = new v(a, 0, false, a, null, false, false);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a) {
  var b = a[0];
  z[b] = new v(b, 1, false, a[1], null, false, false);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a) {
  z[a] = new v(a, 2, false, a.toLowerCase(), null, false, false);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a) {
  z[a] = new v(a, 2, false, a, null, false, false);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
  z[a] = new v(a, 3, false, a.toLowerCase(), null, false, false);
});
["checked", "multiple", "muted", "selected"].forEach(function(a) {
  z[a] = new v(a, 3, true, a, null, false, false);
});
["capture", "download"].forEach(function(a) {
  z[a] = new v(a, 4, false, a, null, false, false);
});
["cols", "rows", "size", "span"].forEach(function(a) {
  z[a] = new v(a, 6, false, a, null, false, false);
});
["rowSpan", "start"].forEach(function(a) {
  z[a] = new v(a, 5, false, a.toLowerCase(), null, false, false);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
  return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
  var b = a.replace(
    ra,
    sa
  );
  z[b] = new v(b, 1, false, a, null, false, false);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
  var b = a.replace(ra, sa);
  z[b] = new v(b, 1, false, a, "http://www.w3.org/1999/xlink", false, false);
});
["xml:base", "xml:lang", "xml:space"].forEach(function(a) {
  var b = a.replace(ra, sa);
  z[b] = new v(b, 1, false, a, "http://www.w3.org/XML/1998/namespace", false, false);
});
["tabIndex", "crossOrigin"].forEach(function(a) {
  z[a] = new v(a, 1, false, a.toLowerCase(), null, false, false);
});
z.xlinkHref = new v("xlinkHref", 1, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
["src", "href", "action", "formAction"].forEach(function(a) {
  z[a] = new v(a, 1, false, a.toLowerCase(), null, true, true);
});
function ta(a, b, c, d) {
  var e = z.hasOwnProperty(b) ? z[b] : null;
  if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? false : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && true === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
var Ia = Symbol.for("react.offscreen");
var Ja = Symbol.iterator;
function Ka(a) {
  if (null === a || "object" !== typeof a) return null;
  a = Ja && a[Ja] || a["@@iterator"];
  return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
  if (void 0 === La) try {
    throw Error();
  } catch (c) {
    var b = c.stack.trim().match(/\n( *(at )?)/);
    La = b && b[1] || "";
  }
  return "\n" + La + a;
}
var Na = false;
function Oa(a, b) {
  if (!a || Na) return "";
  Na = true;
  var c = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    if (b) if (b = function() {
      throw Error();
    }, Object.defineProperty(b.prototype, "props", { set: function() {
      throw Error();
    } }), "object" === typeof Reflect && Reflect.construct) {
      try {
        Reflect.construct(b, []);
      } catch (l2) {
        var d = l2;
      }
      Reflect.construct(a, [], b);
    } else {
      try {
        b.call();
      } catch (l2) {
        d = l2;
      }
      a.call(b.prototype);
    }
    else {
      try {
        throw Error();
      } catch (l2) {
        d = l2;
      }
      a();
    }
  } catch (l2) {
    if (l2 && d && "string" === typeof l2.stack) {
      for (var e = l2.stack.split("\n"), f2 = d.stack.split("\n"), g = e.length - 1, h = f2.length - 1; 1 <= g && 0 <= h && e[g] !== f2[h]; ) h--;
      for (; 1 <= g && 0 <= h; g--, h--) if (e[g] !== f2[h]) {
        if (1 !== g || 1 !== h) {
          do
            if (g--, h--, 0 > h || e[g] !== f2[h]) {
              var k2 = "\n" + e[g].replace(" at new ", " at ");
              a.displayName && k2.includes("<anonymous>") && (k2 = k2.replace("<anonymous>", a.displayName));
              return k2;
            }
          while (1 <= g && 0 <= h);
        }
        break;
      }
    }
  } finally {
    Na = false, Error.prepareStackTrace = c;
  }
  return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
  switch (a.tag) {
    case 5:
      return Ma(a.type);
    case 16:
      return Ma("Lazy");
    case 13:
      return Ma("Suspense");
    case 19:
      return Ma("SuspenseList");
    case 0:
    case 2:
    case 15:
      return a = Oa(a.type, false), a;
    case 11:
      return a = Oa(a.type.render, false), a;
    case 1:
      return a = Oa(a.type, true), a;
    default:
      return "";
  }
}
function Qa(a) {
  if (null == a) return null;
  if ("function" === typeof a) return a.displayName || a.name || null;
  if ("string" === typeof a) return a;
  switch (a) {
    case ya:
      return "Fragment";
    case wa:
      return "Portal";
    case Aa:
      return "Profiler";
    case za:
      return "StrictMode";
    case Ea:
      return "Suspense";
    case Fa:
      return "SuspenseList";
  }
  if ("object" === typeof a) switch (a.$$typeof) {
    case Ca:
      return (a.displayName || "Context") + ".Consumer";
    case Ba:
      return (a._context.displayName || "Context") + ".Provider";
    case Da:
      var b = a.render;
      a = a.displayName;
      a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
      return a;
    case Ga:
      return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
    case Ha:
      b = a._payload;
      a = a._init;
      try {
        return Qa(a(b));
      } catch (c) {
      }
  }
  return null;
}
function Ra(a) {
  var b = a.type;
  switch (a.tag) {
    case 24:
      return "Cache";
    case 9:
      return (b.displayName || "Context") + ".Consumer";
    case 10:
      return (b._context.displayName || "Context") + ".Provider";
    case 18:
      return "DehydratedFragment";
    case 11:
      return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
    case 7:
      return "Fragment";
    case 5:
      return b;
    case 4:
      return "Portal";
    case 3:
      return "Root";
    case 6:
      return "Text";
    case 16:
      return Qa(b);
    case 8:
      return b === za ? "StrictMode" : "Mode";
    case 22:
      return "Offscreen";
    case 12:
      return "Profiler";
    case 21:
      return "Scope";
    case 13:
      return "Suspense";
    case 19:
      return "SuspenseList";
    case 25:
      return "TracingMarker";
    case 1:
    case 0:
    case 17:
    case 2:
    case 14:
    case 15:
      if ("function" === typeof b) return b.displayName || b.name || null;
      if ("string" === typeof b) return b;
  }
  return null;
}
function Sa(a) {
  switch (typeof a) {
    case "boolean":
    case "number":
    case "string":
    case "undefined":
      return a;
    case "object":
      return a;
    default:
      return "";
  }
}
function Ta(a) {
  var b = a.type;
  return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
  var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
  if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
    var e = c.get, f2 = c.set;
    Object.defineProperty(a, b, { configurable: true, get: function() {
      return e.call(this);
    }, set: function(a2) {
      d = "" + a2;
      f2.call(this, a2);
    } });
    Object.defineProperty(a, b, { enumerable: c.enumerable });
    return { getValue: function() {
      return d;
    }, setValue: function(a2) {
      d = "" + a2;
    }, stopTracking: function() {
      a._valueTracker = null;
      delete a[b];
    } };
  }
}
function Va(a) {
  a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
  if (!a) return false;
  var b = a._valueTracker;
  if (!b) return true;
  var c = b.getValue();
  var d = "";
  a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
  a = d;
  return a !== c ? (b.setValue(a), true) : false;
}
function Xa(a) {
  a = a || ("undefined" !== typeof document ? document : void 0);
  if ("undefined" === typeof a) return null;
  try {
    return a.activeElement || a.body;
  } catch (b) {
    return a.body;
  }
}
function Ya(a, b) {
  var c = b.checked;
  return A({}, b, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: null != c ? c : a._wrapperState.initialChecked });
}
function Za(a, b) {
  var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
  c = Sa(null != b.value ? b.value : c);
  a._wrapperState = { initialChecked: d, initialValue: c, controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value };
}
function ab(a, b) {
  b = b.checked;
  null != b && ta(a, "checked", b, false);
}
function bb(a, b) {
  ab(a, b);
  var c = Sa(b.value), d = b.type;
  if (null != c) if ("number" === d) {
    if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
  } else a.value !== "" + c && (a.value = "" + c);
  else if ("submit" === d || "reset" === d) {
    a.removeAttribute("value");
    return;
  }
  b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
  null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
  if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
    var d = b.type;
    if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
    b = "" + a._wrapperState.initialValue;
    c || b === a.value || (a.value = b);
    a.defaultValue = b;
  }
  c = a.name;
  "" !== c && (a.name = "");
  a.defaultChecked = !!a._wrapperState.initialChecked;
  "" !== c && (a.name = c);
}
function cb(a, b, c) {
  if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
  a = a.options;
  if (b) {
    b = {};
    for (var e = 0; e < c.length; e++) b["$" + c[e]] = true;
    for (c = 0; c < a.length; c++) e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = true);
  } else {
    c = "" + Sa(c);
    b = null;
    for (e = 0; e < a.length; e++) {
      if (a[e].value === c) {
        a[e].selected = true;
        d && (a[e].defaultSelected = true);
        return;
      }
      null !== b || a[e].disabled || (b = a[e]);
    }
    null !== b && (b.selected = true);
  }
}
function gb(a, b) {
  if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
  return A({}, b, { value: void 0, defaultValue: void 0, children: "" + a._wrapperState.initialValue });
}
function hb(a, b) {
  var c = b.value;
  if (null == c) {
    c = b.children;
    b = b.defaultValue;
    if (null != c) {
      if (null != b) throw Error(p(92));
      if (eb(c)) {
        if (1 < c.length) throw Error(p(93));
        c = c[0];
      }
      b = c;
    }
    null == b && (b = "");
    c = b;
  }
  a._wrapperState = { initialValue: Sa(c) };
}
function ib(a, b) {
  var c = Sa(b.value), d = Sa(b.defaultValue);
  null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
  null != d && (a.defaultValue = "" + d);
}
function jb(a) {
  var b = a.textContent;
  b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
  switch (a) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function lb(a, b) {
  return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
  return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
    MSApp.execUnsafeLocalFunction(function() {
      return a(b, c, d, e);
    });
  } : a;
}(function(a, b) {
  if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
  else {
    mb = mb || document.createElement("div");
    mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
    for (b = mb.firstChild; a.firstChild; ) a.removeChild(a.firstChild);
    for (; b.firstChild; ) a.appendChild(b.firstChild);
  }
});
function ob(a, b) {
  if (b) {
    var c = a.firstChild;
    if (c && c === a.lastChild && 3 === c.nodeType) {
      c.nodeValue = b;
      return;
    }
  }
  a.textContent = b;
}
var pb = {
  animationIterationCount: true,
  aspectRatio: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridArea: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
}, qb = ["Webkit", "ms", "Moz", "O"];
Object.keys(pb).forEach(function(a) {
  qb.forEach(function(b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);
    pb[b] = pb[a];
  });
});
function rb(a, b, c) {
  return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
  a = a.style;
  for (var c in b) if (b.hasOwnProperty(c)) {
    var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
    "float" === c && (c = "cssFloat");
    d ? a.setProperty(c, e) : a[c] = e;
  }
}
var tb = A({ menuitem: true }, { area: true, base: true, br: true, col: true, embed: true, hr: true, img: true, input: true, keygen: true, link: true, meta: true, param: true, source: true, track: true, wbr: true });
function ub(a, b) {
  if (b) {
    if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
    if (null != b.dangerouslySetInnerHTML) {
      if (null != b.children) throw Error(p(60));
      if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
    }
    if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
  }
}
function vb(a, b) {
  if (-1 === a.indexOf("-")) return "string" === typeof b.is;
  switch (a) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return false;
    default:
      return true;
  }
}
var wb = null;
function xb(a) {
  a = a.target || a.srcElement || window;
  a.correspondingUseElement && (a = a.correspondingUseElement);
  return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
  if (a = Cb(a)) {
    if ("function" !== typeof yb) throw Error(p(280));
    var b = a.stateNode;
    b && (b = Db(b), yb(a.stateNode, a.type, b));
  }
}
function Eb(a) {
  zb ? Ab ? Ab.push(a) : Ab = [a] : zb = a;
}
function Fb() {
  if (zb) {
    var a = zb, b = Ab;
    Ab = zb = null;
    Bb(a);
    if (b) for (a = 0; a < b.length; a++) Bb(b[a]);
  }
}
function Gb(a, b) {
  return a(b);
}
function Hb() {
}
var Ib = false;
function Jb(a, b, c) {
  if (Ib) return a(b, c);
  Ib = true;
  try {
    return Gb(a, b, c);
  } finally {
    if (Ib = false, null !== zb || null !== Ab) Hb(), Fb();
  }
}
function Kb(a, b) {
  var c = a.stateNode;
  if (null === c) return null;
  var d = Db(c);
  if (null === d) return null;
  c = d[b];
  a: switch (b) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
      a = !d;
      break a;
    default:
      a = false;
  }
  if (a) return null;
  if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
  return c;
}
var Lb = false;
if (ia) try {
  var Mb = {};
  Object.defineProperty(Mb, "passive", { get: function() {
    Lb = true;
  } });
  window.addEventListener("test", Mb, Mb);
  window.removeEventListener("test", Mb, Mb);
} catch (a) {
  Lb = false;
}
function Nb(a, b, c, d, e, f2, g, h, k2) {
  var l2 = Array.prototype.slice.call(arguments, 3);
  try {
    b.apply(c, l2);
  } catch (m2) {
    this.onError(m2);
  }
}
var Ob = false, Pb = null, Qb = false, Rb = null, Sb = { onError: function(a) {
  Ob = true;
  Pb = a;
} };
function Tb(a, b, c, d, e, f2, g, h, k2) {
  Ob = false;
  Pb = null;
  Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f2, g, h, k2) {
  Tb.apply(this, arguments);
  if (Ob) {
    if (Ob) {
      var l2 = Pb;
      Ob = false;
      Pb = null;
    } else throw Error(p(198));
    Qb || (Qb = true, Rb = l2);
  }
}
function Vb(a) {
  var b = a, c = a;
  if (a.alternate) for (; b.return; ) b = b.return;
  else {
    a = b;
    do
      b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
    while (a);
  }
  return 3 === b.tag ? c : null;
}
function Wb(a) {
  if (13 === a.tag) {
    var b = a.memoizedState;
    null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
    if (null !== b) return b.dehydrated;
  }
  return null;
}
function Xb(a) {
  if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
  var b = a.alternate;
  if (!b) {
    b = Vb(a);
    if (null === b) throw Error(p(188));
    return b !== a ? null : a;
  }
  for (var c = a, d = b; ; ) {
    var e = c.return;
    if (null === e) break;
    var f2 = e.alternate;
    if (null === f2) {
      d = e.return;
      if (null !== d) {
        c = d;
        continue;
      }
      break;
    }
    if (e.child === f2.child) {
      for (f2 = e.child; f2; ) {
        if (f2 === c) return Xb(e), a;
        if (f2 === d) return Xb(e), b;
        f2 = f2.sibling;
      }
      throw Error(p(188));
    }
    if (c.return !== d.return) c = e, d = f2;
    else {
      for (var g = false, h = e.child; h; ) {
        if (h === c) {
          g = true;
          c = e;
          d = f2;
          break;
        }
        if (h === d) {
          g = true;
          d = e;
          c = f2;
          break;
        }
        h = h.sibling;
      }
      if (!g) {
        for (h = f2.child; h; ) {
          if (h === c) {
            g = true;
            c = f2;
            d = e;
            break;
          }
          if (h === d) {
            g = true;
            d = f2;
            c = e;
            break;
          }
          h = h.sibling;
        }
        if (!g) throw Error(p(189));
      }
    }
    if (c.alternate !== d) throw Error(p(190));
  }
  if (3 !== c.tag) throw Error(p(188));
  return c.stateNode.current === c ? a : b;
}
function Zb(a) {
  a = Yb(a);
  return null !== a ? $b(a) : null;
}
function $b(a) {
  if (5 === a.tag || 6 === a.tag) return a;
  for (a = a.child; null !== a; ) {
    var b = $b(a);
    if (null !== b) return b;
    a = a.sibling;
  }
  return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
  if (lc && "function" === typeof lc.onCommitFiberRoot) try {
    lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
  } catch (b) {
  }
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
  a >>>= 0;
  return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
  switch (a & -a) {
    case 1:
      return 1;
    case 2:
      return 2;
    case 4:
      return 4;
    case 8:
      return 8;
    case 16:
      return 16;
    case 32:
      return 32;
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return a & 4194240;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return a & 130023424;
    case 134217728:
      return 134217728;
    case 268435456:
      return 268435456;
    case 536870912:
      return 536870912;
    case 1073741824:
      return 1073741824;
    default:
      return a;
  }
}
function uc(a, b) {
  var c = a.pendingLanes;
  if (0 === c) return 0;
  var d = 0, e = a.suspendedLanes, f2 = a.pingedLanes, g = c & 268435455;
  if (0 !== g) {
    var h = g & ~e;
    0 !== h ? d = tc(h) : (f2 &= g, 0 !== f2 && (d = tc(f2)));
  } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f2 && (d = tc(f2));
  if (0 === d) return 0;
  if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f2 = b & -b, e >= f2 || 16 === e && 0 !== (f2 & 4194240))) return b;
  0 !== (d & 4) && (d |= c & 16);
  b = a.entangledLanes;
  if (0 !== b) for (a = a.entanglements, b &= d; 0 < b; ) c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
  return d;
}
function vc(a, b) {
  switch (a) {
    case 1:
    case 2:
    case 4:
      return b + 250;
    case 8:
    case 16:
    case 32:
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return b + 5e3;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return -1;
    case 134217728:
    case 268435456:
    case 536870912:
    case 1073741824:
      return -1;
    default:
      return -1;
  }
}
function wc(a, b) {
  for (var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f2 = a.pendingLanes; 0 < f2; ) {
    var g = 31 - oc(f2), h = 1 << g, k2 = e[g];
    if (-1 === k2) {
      if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
    } else k2 <= b && (a.expiredLanes |= h);
    f2 &= ~h;
  }
}
function xc(a) {
  a = a.pendingLanes & -1073741825;
  return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
  var a = rc;
  rc <<= 1;
  0 === (rc & 4194240) && (rc = 64);
  return a;
}
function zc(a) {
  for (var b = [], c = 0; 31 > c; c++) b.push(a);
  return b;
}
function Ac(a, b, c) {
  a.pendingLanes |= b;
  536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
  a = a.eventTimes;
  b = 31 - oc(b);
  a[b] = c;
}
function Bc(a, b) {
  var c = a.pendingLanes & ~b;
  a.pendingLanes = b;
  a.suspendedLanes = 0;
  a.pingedLanes = 0;
  a.expiredLanes &= b;
  a.mutableReadLanes &= b;
  a.entangledLanes &= b;
  b = a.entanglements;
  var d = a.eventTimes;
  for (a = a.expirationTimes; 0 < c; ) {
    var e = 31 - oc(c), f2 = 1 << e;
    b[e] = 0;
    d[e] = -1;
    a[e] = -1;
    c &= ~f2;
  }
}
function Cc(a, b) {
  var c = a.entangledLanes |= b;
  for (a = a.entanglements; c; ) {
    var d = 31 - oc(c), e = 1 << d;
    e & b | a[d] & b && (a[d] |= b);
    c &= ~e;
  }
}
var C = 0;
function Dc(a) {
  a &= -a;
  return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = false, Kc = [], Lc = null, Mc = null, Nc = null, Oc = /* @__PURE__ */ new Map(), Pc = /* @__PURE__ */ new Map(), Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
  switch (a) {
    case "focusin":
    case "focusout":
      Lc = null;
      break;
    case "dragenter":
    case "dragleave":
      Mc = null;
      break;
    case "mouseover":
    case "mouseout":
      Nc = null;
      break;
    case "pointerover":
    case "pointerout":
      Oc.delete(b.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      Pc.delete(b.pointerId);
  }
}
function Tc(a, b, c, d, e, f2) {
  if (null === a || a.nativeEvent !== f2) return a = { blockedOn: b, domEventName: c, eventSystemFlags: d, nativeEvent: f2, targetContainers: [e] }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
  a.eventSystemFlags |= d;
  b = a.targetContainers;
  null !== e && -1 === b.indexOf(e) && b.push(e);
  return a;
}
function Uc(a, b, c, d, e) {
  switch (b) {
    case "focusin":
      return Lc = Tc(Lc, a, b, c, d, e), true;
    case "dragenter":
      return Mc = Tc(Mc, a, b, c, d, e), true;
    case "mouseover":
      return Nc = Tc(Nc, a, b, c, d, e), true;
    case "pointerover":
      var f2 = e.pointerId;
      Oc.set(f2, Tc(Oc.get(f2) || null, a, b, c, d, e));
      return true;
    case "gotpointercapture":
      return f2 = e.pointerId, Pc.set(f2, Tc(Pc.get(f2) || null, a, b, c, d, e)), true;
  }
  return false;
}
function Vc(a) {
  var b = Wc(a.target);
  if (null !== b) {
    var c = Vb(b);
    if (null !== c) {
      if (b = c.tag, 13 === b) {
        if (b = Wb(c), null !== b) {
          a.blockedOn = b;
          Ic(a.priority, function() {
            Gc(c);
          });
          return;
        }
      } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
        a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
        return;
      }
    }
  }
  a.blockedOn = null;
}
function Xc(a) {
  if (null !== a.blockedOn) return false;
  for (var b = a.targetContainers; 0 < b.length; ) {
    var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
    if (null === c) {
      c = a.nativeEvent;
      var d = new c.constructor(c.type, c);
      wb = d;
      c.target.dispatchEvent(d);
      wb = null;
    } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, false;
    b.shift();
  }
  return true;
}
function Zc(a, b, c) {
  Xc(a) && c.delete(b);
}
function $c() {
  Jc = false;
  null !== Lc && Xc(Lc) && (Lc = null);
  null !== Mc && Xc(Mc) && (Mc = null);
  null !== Nc && Xc(Nc) && (Nc = null);
  Oc.forEach(Zc);
  Pc.forEach(Zc);
}
function ad(a, b) {
  a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = true, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
  function b(b2) {
    return ad(b2, a);
  }
  if (0 < Kc.length) {
    ad(Kc[0], a);
    for (var c = 1; c < Kc.length; c++) {
      var d = Kc[c];
      d.blockedOn === a && (d.blockedOn = null);
    }
  }
  null !== Lc && ad(Lc, a);
  null !== Mc && ad(Mc, a);
  null !== Nc && ad(Nc, a);
  Oc.forEach(b);
  Pc.forEach(b);
  for (c = 0; c < Qc.length; c++) d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
  for (; 0 < Qc.length && (c = Qc[0], null === c.blockedOn); ) Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = true;
function ed(a, b, c, d) {
  var e = C, f2 = cd.transition;
  cd.transition = null;
  try {
    C = 1, fd(a, b, c, d);
  } finally {
    C = e, cd.transition = f2;
  }
}
function gd(a, b, c, d) {
  var e = C, f2 = cd.transition;
  cd.transition = null;
  try {
    C = 4, fd(a, b, c, d);
  } finally {
    C = e, cd.transition = f2;
  }
}
function fd(a, b, c, d) {
  if (dd) {
    var e = Yc(a, b, c, d);
    if (null === e) hd(a, b, d, id, c), Sc(a, d);
    else if (Uc(e, a, b, c, d)) d.stopPropagation();
    else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
      for (; null !== e; ) {
        var f2 = Cb(e);
        null !== f2 && Ec(f2);
        f2 = Yc(a, b, c, d);
        null === f2 && hd(a, b, d, id, c);
        if (f2 === e) break;
        e = f2;
      }
      null !== e && d.stopPropagation();
    } else hd(a, b, d, null, c);
  }
}
var id = null;
function Yc(a, b, c, d) {
  id = null;
  a = xb(d);
  a = Wc(a);
  if (null !== a) if (b = Vb(a), null === b) a = null;
  else if (c = b.tag, 13 === c) {
    a = Wb(b);
    if (null !== a) return a;
    a = null;
  } else if (3 === c) {
    if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
    a = null;
  } else b !== a && (a = null);
  id = a;
  return null;
}
function jd(a) {
  switch (a) {
    case "cancel":
    case "click":
    case "close":
    case "contextmenu":
    case "copy":
    case "cut":
    case "auxclick":
    case "dblclick":
    case "dragend":
    case "dragstart":
    case "drop":
    case "focusin":
    case "focusout":
    case "input":
    case "invalid":
    case "keydown":
    case "keypress":
    case "keyup":
    case "mousedown":
    case "mouseup":
    case "paste":
    case "pause":
    case "play":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
    case "ratechange":
    case "reset":
    case "resize":
    case "seeked":
    case "submit":
    case "touchcancel":
    case "touchend":
    case "touchstart":
    case "volumechange":
    case "change":
    case "selectionchange":
    case "textInput":
    case "compositionstart":
    case "compositionend":
    case "compositionupdate":
    case "beforeblur":
    case "afterblur":
    case "beforeinput":
    case "blur":
    case "fullscreenchange":
    case "focus":
    case "hashchange":
    case "popstate":
    case "select":
    case "selectstart":
      return 1;
    case "drag":
    case "dragenter":
    case "dragexit":
    case "dragleave":
    case "dragover":
    case "mousemove":
    case "mouseout":
    case "mouseover":
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "scroll":
    case "toggle":
    case "touchmove":
    case "wheel":
    case "mouseenter":
    case "mouseleave":
    case "pointerenter":
    case "pointerleave":
      return 4;
    case "message":
      switch (ec()) {
        case fc:
          return 1;
        case gc:
          return 4;
        case hc:
        case ic:
          return 16;
        case jc:
          return 536870912;
        default:
          return 16;
      }
    default:
      return 16;
  }
}
var kd = null, ld = null, md = null;
function nd() {
  if (md) return md;
  var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f2 = e.length;
  for (a = 0; a < c && b[a] === e[a]; a++) ;
  var g = c - a;
  for (d = 1; d <= g && b[c - d] === e[f2 - d]; d++) ;
  return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
  var b = a.keyCode;
  "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
  10 === a && (a = 13);
  return 32 <= a || 13 === a ? a : 0;
}
function pd() {
  return true;
}
function qd() {
  return false;
}
function rd(a) {
  function b(b2, d, e, f2, g) {
    this._reactName = b2;
    this._targetInst = e;
    this.type = d;
    this.nativeEvent = f2;
    this.target = g;
    this.currentTarget = null;
    for (var c in a) a.hasOwnProperty(c) && (b2 = a[c], this[c] = b2 ? b2(f2) : f2[c]);
    this.isDefaultPrevented = (null != f2.defaultPrevented ? f2.defaultPrevented : false === f2.returnValue) ? pd : qd;
    this.isPropagationStopped = qd;
    return this;
  }
  A(b.prototype, { preventDefault: function() {
    this.defaultPrevented = true;
    var a2 = this.nativeEvent;
    a2 && (a2.preventDefault ? a2.preventDefault() : "unknown" !== typeof a2.returnValue && (a2.returnValue = false), this.isDefaultPrevented = pd);
  }, stopPropagation: function() {
    var a2 = this.nativeEvent;
    a2 && (a2.stopPropagation ? a2.stopPropagation() : "unknown" !== typeof a2.cancelBubble && (a2.cancelBubble = true), this.isPropagationStopped = pd);
  }, persist: function() {
  }, isPersistent: pd });
  return b;
}
var sd = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(a) {
  return a.timeStamp || Date.now();
}, defaultPrevented: 0, isTrusted: 0 }, td = rd(sd), ud = A({}, sd, { view: 0, detail: 0 }), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: zd, button: 0, buttons: 0, relatedTarget: function(a) {
  return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
}, movementX: function(a) {
  if ("movementX" in a) return a.movementX;
  a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
  return wd;
}, movementY: function(a) {
  return "movementY" in a ? a.movementY : xd;
} }), Bd = rd(Ad), Cd = A({}, Ad, { dataTransfer: 0 }), Dd = rd(Cd), Ed = A({}, ud, { relatedTarget: 0 }), Fd = rd(Ed), Gd = A({}, sd, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Hd = rd(Gd), Id = A({}, sd, { clipboardData: function(a) {
  return "clipboardData" in a ? a.clipboardData : window.clipboardData;
} }), Jd = rd(Id), Kd = A({}, sd, { data: 0 }), Ld = rd(Kd), Md = {
  Esc: "Escape",
  Spacebar: " ",
  Left: "ArrowLeft",
  Up: "ArrowUp",
  Right: "ArrowRight",
  Down: "ArrowDown",
  Del: "Delete",
  Win: "OS",
  Menu: "ContextMenu",
  Apps: "ContextMenu",
  Scroll: "ScrollLock",
  MozPrintableKey: "Unidentified"
}, Nd = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
}, Od = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
function Pd(a) {
  var b = this.nativeEvent;
  return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : false;
}
function zd() {
  return Pd;
}
var Qd = A({}, ud, { key: function(a) {
  if (a.key) {
    var b = Md[a.key] || a.key;
    if ("Unidentified" !== b) return b;
  }
  return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
}, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: zd, charCode: function(a) {
  return "keypress" === a.type ? od(a) : 0;
}, keyCode: function(a) {
  return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
}, which: function(a) {
  return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
} }), Rd = rd(Qd), Sd = A({}, Ad, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Td = rd(Sd), Ud = A({}, ud, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: zd }), Vd = rd(Ud), Wd = A({}, sd, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Xd = rd(Wd), Yd = A({}, Ad, {
  deltaX: function(a) {
    return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
  },
  deltaY: function(a) {
    return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
  },
  deltaZ: 0,
  deltaMode: 0
}), Zd = rd(Yd), $d = [9, 13, 27, 32], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = false;
function ge(a, b) {
  switch (a) {
    case "keyup":
      return -1 !== $d.indexOf(b.keyCode);
    case "keydown":
      return 229 !== b.keyCode;
    case "keypress":
    case "mousedown":
    case "focusout":
      return true;
    default:
      return false;
  }
}
function he(a) {
  a = a.detail;
  return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = false;
function je(a, b) {
  switch (a) {
    case "compositionend":
      return he(b);
    case "keypress":
      if (32 !== b.which) return null;
      fe = true;
      return ee;
    case "textInput":
      return a = b.data, a === ee && fe ? null : a;
    default:
      return null;
  }
}
function ke(a, b) {
  if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = false, a) : null;
  switch (a) {
    case "paste":
      return null;
    case "keypress":
      if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
        if (b.char && 1 < b.char.length) return b.char;
        if (b.which) return String.fromCharCode(b.which);
      }
      return null;
    case "compositionend":
      return de && "ko" !== b.locale ? null : b.data;
    default:
      return null;
  }
}
var le = { color: true, date: true, datetime: true, "datetime-local": true, email: true, month: true, number: true, password: true, range: true, search: true, tel: true, text: true, time: true, url: true, week: true };
function me(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return "input" === b ? !!le[a.type] : "textarea" === b ? true : false;
}
function ne(a, b, c, d) {
  Eb(d);
  b = oe(b, "onChange");
  0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({ event: c, listeners: b }));
}
var pe = null, qe = null;
function re(a) {
  se(a, 0);
}
function te(a) {
  var b = ue(a);
  if (Wa(b)) return a;
}
function ve(a, b) {
  if ("change" === a) return b;
}
var we = false;
if (ia) {
  var xe;
  if (ia) {
    var ye = "oninput" in document;
    if (!ye) {
      var ze = document.createElement("div");
      ze.setAttribute("oninput", "return;");
      ye = "function" === typeof ze.oninput;
    }
    xe = ye;
  } else xe = false;
  we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
  pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
  if ("value" === a.propertyName && te(qe)) {
    var b = [];
    ne(b, qe, a, xb(a));
    Jb(re, b);
  }
}
function Ce(a, b, c) {
  "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
  if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
  if ("click" === a) return te(b);
}
function Fe(a, b) {
  if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
  return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
  if (He(a, b)) return true;
  if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return false;
  var c = Object.keys(a), d = Object.keys(b);
  if (c.length !== d.length) return false;
  for (d = 0; d < c.length; d++) {
    var e = c[d];
    if (!ja.call(b, e) || !He(a[e], b[e])) return false;
  }
  return true;
}
function Je(a) {
  for (; a && a.firstChild; ) a = a.firstChild;
  return a;
}
function Ke(a, b) {
  var c = Je(a);
  a = 0;
  for (var d; c; ) {
    if (3 === c.nodeType) {
      d = a + c.textContent.length;
      if (a <= b && d >= b) return { node: c, offset: b - a };
      a = d;
    }
    a: {
      for (; c; ) {
        if (c.nextSibling) {
          c = c.nextSibling;
          break a;
        }
        c = c.parentNode;
      }
      c = void 0;
    }
    c = Je(c);
  }
}
function Le(a, b) {
  return a && b ? a === b ? true : a && 3 === a.nodeType ? false : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : false : false;
}
function Me() {
  for (var a = window, b = Xa(); b instanceof a.HTMLIFrameElement; ) {
    try {
      var c = "string" === typeof b.contentWindow.location.href;
    } catch (d) {
      c = false;
    }
    if (c) a = b.contentWindow;
    else break;
    b = Xa(a.document);
  }
  return b;
}
function Ne(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
  var b = Me(), c = a.focusedElem, d = a.selectionRange;
  if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
    if (null !== d && Ne(c)) {
      if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
      else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
        a = a.getSelection();
        var e = c.textContent.length, f2 = Math.min(d.start, e);
        d = void 0 === d.end ? f2 : Math.min(d.end, e);
        !a.extend && f2 > d && (e = d, d = f2, f2 = e);
        e = Ke(c, f2);
        var g = Ke(
          c,
          d
        );
        e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f2 > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
      }
    }
    b = [];
    for (a = c; a = a.parentNode; ) 1 === a.nodeType && b.push({ element: a, left: a.scrollLeft, top: a.scrollTop });
    "function" === typeof c.focus && c.focus();
    for (c = 0; c < b.length; c++) a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
  }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = false;
function Ue(a, b, c) {
  var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
  Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = { start: d.selectionStart, end: d.selectionEnd } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = { anchorNode: d.anchorNode, anchorOffset: d.anchorOffset, focusNode: d.focusNode, focusOffset: d.focusOffset }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({ event: b, listeners: d }), b.target = Qe)));
}
function Ve(a, b) {
  var c = {};
  c[a.toLowerCase()] = b.toLowerCase();
  c["Webkit" + a] = "webkit" + b;
  c["Moz" + a] = "moz" + b;
  return c;
}
var We = { animationend: Ve("Animation", "AnimationEnd"), animationiteration: Ve("Animation", "AnimationIteration"), animationstart: Ve("Animation", "AnimationStart"), transitionend: Ve("Transition", "TransitionEnd") }, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
  if (Xe[a]) return Xe[a];
  if (!We[a]) return a;
  var b = We[a], c;
  for (c in b) if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
  return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = /* @__PURE__ */ new Map(), ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
  df.set(a, b);
  fa(b, [a]);
}
for (var gf = 0; gf < ef.length; gf++) {
  var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
  ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", ["mouseout", "mouseover"]);
ha("onMouseLeave", ["mouseout", "mouseover"]);
ha("onPointerEnter", ["pointerout", "pointerover"]);
ha("onPointerLeave", ["pointerout", "pointerover"]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
  var d = a.type || "unknown-event";
  a.currentTarget = c;
  Ub(d, b, void 0, a);
  a.currentTarget = null;
}
function se(a, b) {
  b = 0 !== (b & 4);
  for (var c = 0; c < a.length; c++) {
    var d = a[c], e = d.event;
    d = d.listeners;
    a: {
      var f2 = void 0;
      if (b) for (var g = d.length - 1; 0 <= g; g--) {
        var h = d[g], k2 = h.instance, l2 = h.currentTarget;
        h = h.listener;
        if (k2 !== f2 && e.isPropagationStopped()) break a;
        nf(e, h, l2);
        f2 = k2;
      }
      else for (g = 0; g < d.length; g++) {
        h = d[g];
        k2 = h.instance;
        l2 = h.currentTarget;
        h = h.listener;
        if (k2 !== f2 && e.isPropagationStopped()) break a;
        nf(e, h, l2);
        f2 = k2;
      }
    }
  }
  if (Qb) throw a = Rb, Qb = false, Rb = null, a;
}
function D(a, b) {
  var c = b[of];
  void 0 === c && (c = b[of] = /* @__PURE__ */ new Set());
  var d = a + "__bubble";
  c.has(d) || (pf(b, a, 2, false), c.add(d));
}
function qf(a, b, c) {
  var d = 0;
  b && (d |= 4);
  pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
  if (!a[rf]) {
    a[rf] = true;
    da.forEach(function(b2) {
      "selectionchange" !== b2 && (mf.has(b2) || qf(b2, false, a), qf(b2, true, a));
    });
    var b = 9 === a.nodeType ? a : a.ownerDocument;
    null === b || b[rf] || (b[rf] = true, qf("selectionchange", false, b));
  }
}
function pf(a, b, c, d) {
  switch (jd(b)) {
    case 1:
      var e = ed;
      break;
    case 4:
      e = gd;
      break;
    default:
      e = fd;
  }
  c = e.bind(null, b, c, a);
  e = void 0;
  !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = true);
  d ? void 0 !== e ? a.addEventListener(b, c, { capture: true, passive: e }) : a.addEventListener(b, c, true) : void 0 !== e ? a.addEventListener(b, c, { passive: e }) : a.addEventListener(b, c, false);
}
function hd(a, b, c, d, e) {
  var f2 = d;
  if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for (; ; ) {
    if (null === d) return;
    var g = d.tag;
    if (3 === g || 4 === g) {
      var h = d.stateNode.containerInfo;
      if (h === e || 8 === h.nodeType && h.parentNode === e) break;
      if (4 === g) for (g = d.return; null !== g; ) {
        var k2 = g.tag;
        if (3 === k2 || 4 === k2) {
          if (k2 = g.stateNode.containerInfo, k2 === e || 8 === k2.nodeType && k2.parentNode === e) return;
        }
        g = g.return;
      }
      for (; null !== h; ) {
        g = Wc(h);
        if (null === g) return;
        k2 = g.tag;
        if (5 === k2 || 6 === k2) {
          d = f2 = g;
          continue a;
        }
        h = h.parentNode;
      }
    }
    d = d.return;
  }
  Jb(function() {
    var d2 = f2, e2 = xb(c), g2 = [];
    a: {
      var h2 = df.get(a);
      if (void 0 !== h2) {
        var k3 = td, n2 = a;
        switch (a) {
          case "keypress":
            if (0 === od(c)) break a;
          case "keydown":
          case "keyup":
            k3 = Rd;
            break;
          case "focusin":
            n2 = "focus";
            k3 = Fd;
            break;
          case "focusout":
            n2 = "blur";
            k3 = Fd;
            break;
          case "beforeblur":
          case "afterblur":
            k3 = Fd;
            break;
          case "click":
            if (2 === c.button) break a;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            k3 = Bd;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            k3 = Dd;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            k3 = Vd;
            break;
          case $e:
          case af:
          case bf:
            k3 = Hd;
            break;
          case cf:
            k3 = Xd;
            break;
          case "scroll":
            k3 = vd;
            break;
          case "wheel":
            k3 = Zd;
            break;
          case "copy":
          case "cut":
          case "paste":
            k3 = Jd;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            k3 = Td;
        }
        var t2 = 0 !== (b & 4), J2 = !t2 && "scroll" === a, x2 = t2 ? null !== h2 ? h2 + "Capture" : null : h2;
        t2 = [];
        for (var w2 = d2, u2; null !== w2; ) {
          u2 = w2;
          var F2 = u2.stateNode;
          5 === u2.tag && null !== F2 && (u2 = F2, null !== x2 && (F2 = Kb(w2, x2), null != F2 && t2.push(tf(w2, F2, u2))));
          if (J2) break;
          w2 = w2.return;
        }
        0 < t2.length && (h2 = new k3(h2, n2, null, c, e2), g2.push({ event: h2, listeners: t2 }));
      }
    }
    if (0 === (b & 7)) {
      a: {
        h2 = "mouseover" === a || "pointerover" === a;
        k3 = "mouseout" === a || "pointerout" === a;
        if (h2 && c !== wb && (n2 = c.relatedTarget || c.fromElement) && (Wc(n2) || n2[uf])) break a;
        if (k3 || h2) {
          h2 = e2.window === e2 ? e2 : (h2 = e2.ownerDocument) ? h2.defaultView || h2.parentWindow : window;
          if (k3) {
            if (n2 = c.relatedTarget || c.toElement, k3 = d2, n2 = n2 ? Wc(n2) : null, null !== n2 && (J2 = Vb(n2), n2 !== J2 || 5 !== n2.tag && 6 !== n2.tag)) n2 = null;
          } else k3 = null, n2 = d2;
          if (k3 !== n2) {
            t2 = Bd;
            F2 = "onMouseLeave";
            x2 = "onMouseEnter";
            w2 = "mouse";
            if ("pointerout" === a || "pointerover" === a) t2 = Td, F2 = "onPointerLeave", x2 = "onPointerEnter", w2 = "pointer";
            J2 = null == k3 ? h2 : ue(k3);
            u2 = null == n2 ? h2 : ue(n2);
            h2 = new t2(F2, w2 + "leave", k3, c, e2);
            h2.target = J2;
            h2.relatedTarget = u2;
            F2 = null;
            Wc(e2) === d2 && (t2 = new t2(x2, w2 + "enter", n2, c, e2), t2.target = u2, t2.relatedTarget = J2, F2 = t2);
            J2 = F2;
            if (k3 && n2) b: {
              t2 = k3;
              x2 = n2;
              w2 = 0;
              for (u2 = t2; u2; u2 = vf(u2)) w2++;
              u2 = 0;
              for (F2 = x2; F2; F2 = vf(F2)) u2++;
              for (; 0 < w2 - u2; ) t2 = vf(t2), w2--;
              for (; 0 < u2 - w2; ) x2 = vf(x2), u2--;
              for (; w2--; ) {
                if (t2 === x2 || null !== x2 && t2 === x2.alternate) break b;
                t2 = vf(t2);
                x2 = vf(x2);
              }
              t2 = null;
            }
            else t2 = null;
            null !== k3 && wf(g2, h2, k3, t2, false);
            null !== n2 && null !== J2 && wf(g2, J2, n2, t2, true);
          }
        }
      }
      a: {
        h2 = d2 ? ue(d2) : window;
        k3 = h2.nodeName && h2.nodeName.toLowerCase();
        if ("select" === k3 || "input" === k3 && "file" === h2.type) var na = ve;
        else if (me(h2)) if (we) na = Fe;
        else {
          na = De;
          var xa = Ce;
        }
        else (k3 = h2.nodeName) && "input" === k3.toLowerCase() && ("checkbox" === h2.type || "radio" === h2.type) && (na = Ee);
        if (na && (na = na(a, d2))) {
          ne(g2, na, c, e2);
          break a;
        }
        xa && xa(a, h2, d2);
        "focusout" === a && (xa = h2._wrapperState) && xa.controlled && "number" === h2.type && cb(h2, "number", h2.value);
      }
      xa = d2 ? ue(d2) : window;
      switch (a) {
        case "focusin":
          if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d2, Se = null;
          break;
        case "focusout":
          Se = Re = Qe = null;
          break;
        case "mousedown":
          Te = true;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          Te = false;
          Ue(g2, c, e2);
          break;
        case "selectionchange":
          if (Pe) break;
        case "keydown":
        case "keyup":
          Ue(g2, c, e2);
      }
      var $a;
      if (ae) b: {
        switch (a) {
          case "compositionstart":
            var ba = "onCompositionStart";
            break b;
          case "compositionend":
            ba = "onCompositionEnd";
            break b;
          case "compositionupdate":
            ba = "onCompositionUpdate";
            break b;
        }
        ba = void 0;
      }
      else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
      ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e2, ld = "value" in kd ? kd.value : kd.textContent, ie = true)), xa = oe(d2, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e2), g2.push({ event: ba, listeners: xa }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
      if ($a = ce ? je(a, c) : ke(a, c)) d2 = oe(d2, "onBeforeInput"), 0 < d2.length && (e2 = new Ld("onBeforeInput", "beforeinput", null, c, e2), g2.push({ event: e2, listeners: d2 }), e2.data = $a);
    }
    se(g2, b);
  });
}
function tf(a, b, c) {
  return { instance: a, listener: b, currentTarget: c };
}
function oe(a, b) {
  for (var c = b + "Capture", d = []; null !== a; ) {
    var e = a, f2 = e.stateNode;
    5 === e.tag && null !== f2 && (e = f2, f2 = Kb(a, c), null != f2 && d.unshift(tf(a, f2, e)), f2 = Kb(a, b), null != f2 && d.push(tf(a, f2, e)));
    a = a.return;
  }
  return d;
}
function vf(a) {
  if (null === a) return null;
  do
    a = a.return;
  while (a && 5 !== a.tag);
  return a ? a : null;
}
function wf(a, b, c, d, e) {
  for (var f2 = b._reactName, g = []; null !== c && c !== d; ) {
    var h = c, k2 = h.alternate, l2 = h.stateNode;
    if (null !== k2 && k2 === d) break;
    5 === h.tag && null !== l2 && (h = l2, e ? (k2 = Kb(c, f2), null != k2 && g.unshift(tf(c, k2, h))) : e || (k2 = Kb(c, f2), null != k2 && g.push(tf(c, k2, h))));
    c = c.return;
  }
  0 !== g.length && a.push({ event: b, listeners: g });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
  return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
  b = zf(b);
  if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {
}
var Cf = null, Df = null;
function Ef(a, b) {
  return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
  return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
  setTimeout(function() {
    throw a;
  });
}
function Kf(a, b) {
  var c = b, d = 0;
  do {
    var e = c.nextSibling;
    a.removeChild(c);
    if (e && 8 === e.nodeType) if (c = e.data, "/$" === c) {
      if (0 === d) {
        a.removeChild(e);
        bd(b);
        return;
      }
      d--;
    } else "$" !== c && "$?" !== c && "$!" !== c || d++;
    c = e;
  } while (c);
  bd(b);
}
function Lf(a) {
  for (; null != a; a = a.nextSibling) {
    var b = a.nodeType;
    if (1 === b || 3 === b) break;
    if (8 === b) {
      b = a.data;
      if ("$" === b || "$!" === b || "$?" === b) break;
      if ("/$" === b) return null;
    }
  }
  return a;
}
function Mf(a) {
  a = a.previousSibling;
  for (var b = 0; a; ) {
    if (8 === a.nodeType) {
      var c = a.data;
      if ("$" === c || "$!" === c || "$?" === c) {
        if (0 === b) return a;
        b--;
      } else "/$" === c && b++;
    }
    a = a.previousSibling;
  }
  return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
  var b = a[Of];
  if (b) return b;
  for (var c = a.parentNode; c; ) {
    if (b = c[uf] || c[Of]) {
      c = b.alternate;
      if (null !== b.child || null !== c && null !== c.child) for (a = Mf(a); null !== a; ) {
        if (c = a[Of]) return c;
        a = Mf(a);
      }
      return b;
    }
    a = c;
    c = a.parentNode;
  }
  return null;
}
function Cb(a) {
  a = a[Of] || a[uf];
  return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
  if (5 === a.tag || 6 === a.tag) return a.stateNode;
  throw Error(p(33));
}
function Db(a) {
  return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
  return { current: a };
}
function E(a) {
  0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
  Tf++;
  Sf[Tf] = a.current;
  a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(false), Xf = Vf;
function Yf(a, b) {
  var c = a.type.contextTypes;
  if (!c) return Vf;
  var d = a.stateNode;
  if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
  var e = {}, f2;
  for (f2 in c) e[f2] = b[f2];
  d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
  return e;
}
function Zf(a) {
  a = a.childContextTypes;
  return null !== a && void 0 !== a;
}
function $f() {
  E(Wf);
  E(H);
}
function ag(a, b, c) {
  if (H.current !== Vf) throw Error(p(168));
  G(H, b);
  G(Wf, c);
}
function bg(a, b, c) {
  var d = a.stateNode;
  b = b.childContextTypes;
  if ("function" !== typeof d.getChildContext) return c;
  d = d.getChildContext();
  for (var e in d) if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
  return A({}, c, d);
}
function cg(a) {
  a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
  Xf = H.current;
  G(H, a);
  G(Wf, Wf.current);
  return true;
}
function dg(a, b, c) {
  var d = a.stateNode;
  if (!d) throw Error(p(169));
  c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
  G(Wf, c);
}
var eg = null, fg = false, gg = false;
function hg(a) {
  null === eg ? eg = [a] : eg.push(a);
}
function ig(a) {
  fg = true;
  hg(a);
}
function jg() {
  if (!gg && null !== eg) {
    gg = true;
    var a = 0, b = C;
    try {
      var c = eg;
      for (C = 1; a < c.length; a++) {
        var d = c[a];
        do
          d = d(true);
        while (null !== d);
      }
      eg = null;
      fg = false;
    } catch (e) {
      throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
    } finally {
      C = b, gg = false;
    }
  }
  return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
  kg[lg++] = ng;
  kg[lg++] = mg;
  mg = a;
  ng = b;
}
function ug(a, b, c) {
  og[pg++] = rg;
  og[pg++] = sg;
  og[pg++] = qg;
  qg = a;
  var d = rg;
  a = sg;
  var e = 32 - oc(d) - 1;
  d &= ~(1 << e);
  c += 1;
  var f2 = 32 - oc(b) + e;
  if (30 < f2) {
    var g = e - e % 5;
    f2 = (d & (1 << g) - 1).toString(32);
    d >>= g;
    e -= g;
    rg = 1 << 32 - oc(b) + e | c << e | d;
    sg = f2 + a;
  } else rg = 1 << f2 | c << e | d, sg = a;
}
function vg(a) {
  null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
  for (; a === mg; ) mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
  for (; a === qg; ) qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = false, zg = null;
function Ag(a, b) {
  var c = Bg(5, null, null, 0);
  c.elementType = "DELETED";
  c.stateNode = b;
  c.return = a;
  b = a.deletions;
  null === b ? (a.deletions = [c], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
  switch (a.tag) {
    case 5:
      var c = a.type;
      b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
      return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), true) : false;
    case 6:
      return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, true) : false;
    case 13:
      return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? { id: rg, overflow: sg } : null, a.memoizedState = { dehydrated: b, treeContext: c, retryLane: 1073741824 }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, true) : false;
    default:
      return false;
  }
}
function Dg(a) {
  return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
  if (I) {
    var b = yg;
    if (b) {
      var c = b;
      if (!Cg(a, b)) {
        if (Dg(a)) throw Error(p(418));
        b = Lf(c.nextSibling);
        var d = xg;
        b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = false, xg = a);
      }
    } else {
      if (Dg(a)) throw Error(p(418));
      a.flags = a.flags & -4097 | 2;
      I = false;
      xg = a;
    }
  }
}
function Fg(a) {
  for (a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag; ) a = a.return;
  xg = a;
}
function Gg(a) {
  if (a !== xg) return false;
  if (!I) return Fg(a), I = true, false;
  var b;
  (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
  if (b && (b = yg)) {
    if (Dg(a)) throw Hg(), Error(p(418));
    for (; b; ) Ag(a, b), b = Lf(b.nextSibling);
  }
  Fg(a);
  if (13 === a.tag) {
    a = a.memoizedState;
    a = null !== a ? a.dehydrated : null;
    if (!a) throw Error(p(317));
    a: {
      a = a.nextSibling;
      for (b = 0; a; ) {
        if (8 === a.nodeType) {
          var c = a.data;
          if ("/$" === c) {
            if (0 === b) {
              yg = Lf(a.nextSibling);
              break a;
            }
            b--;
          } else "$" !== c && "$!" !== c && "$?" !== c || b++;
        }
        a = a.nextSibling;
      }
      yg = null;
    }
  } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
  return true;
}
function Hg() {
  for (var a = yg; a; ) a = Lf(a.nextSibling);
}
function Ig() {
  yg = xg = null;
  I = false;
}
function Jg(a) {
  null === zg ? zg = [a] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
  a = c.ref;
  if (null !== a && "function" !== typeof a && "object" !== typeof a) {
    if (c._owner) {
      c = c._owner;
      if (c) {
        if (1 !== c.tag) throw Error(p(309));
        var d = c.stateNode;
      }
      if (!d) throw Error(p(147, a));
      var e = d, f2 = "" + a;
      if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f2) return b.ref;
      b = function(a2) {
        var b2 = e.refs;
        null === a2 ? delete b2[f2] : b2[f2] = a2;
      };
      b._stringRef = f2;
      return b;
    }
    if ("string" !== typeof a) throw Error(p(284));
    if (!c._owner) throw Error(p(290, a));
  }
  return a;
}
function Mg(a, b) {
  a = Object.prototype.toString.call(b);
  throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
  var b = a._init;
  return b(a._payload);
}
function Og(a) {
  function b(b2, c2) {
    if (a) {
      var d2 = b2.deletions;
      null === d2 ? (b2.deletions = [c2], b2.flags |= 16) : d2.push(c2);
    }
  }
  function c(c2, d2) {
    if (!a) return null;
    for (; null !== d2; ) b(c2, d2), d2 = d2.sibling;
    return null;
  }
  function d(a2, b2) {
    for (a2 = /* @__PURE__ */ new Map(); null !== b2; ) null !== b2.key ? a2.set(b2.key, b2) : a2.set(b2.index, b2), b2 = b2.sibling;
    return a2;
  }
  function e(a2, b2) {
    a2 = Pg(a2, b2);
    a2.index = 0;
    a2.sibling = null;
    return a2;
  }
  function f2(b2, c2, d2) {
    b2.index = d2;
    if (!a) return b2.flags |= 1048576, c2;
    d2 = b2.alternate;
    if (null !== d2) return d2 = d2.index, d2 < c2 ? (b2.flags |= 2, c2) : d2;
    b2.flags |= 2;
    return c2;
  }
  function g(b2) {
    a && null === b2.alternate && (b2.flags |= 2);
    return b2;
  }
  function h(a2, b2, c2, d2) {
    if (null === b2 || 6 !== b2.tag) return b2 = Qg(c2, a2.mode, d2), b2.return = a2, b2;
    b2 = e(b2, c2);
    b2.return = a2;
    return b2;
  }
  function k2(a2, b2, c2, d2) {
    var f3 = c2.type;
    if (f3 === ya) return m2(a2, b2, c2.props.children, d2, c2.key);
    if (null !== b2 && (b2.elementType === f3 || "object" === typeof f3 && null !== f3 && f3.$$typeof === Ha && Ng(f3) === b2.type)) return d2 = e(b2, c2.props), d2.ref = Lg(a2, b2, c2), d2.return = a2, d2;
    d2 = Rg(c2.type, c2.key, c2.props, null, a2.mode, d2);
    d2.ref = Lg(a2, b2, c2);
    d2.return = a2;
    return d2;
  }
  function l2(a2, b2, c2, d2) {
    if (null === b2 || 4 !== b2.tag || b2.stateNode.containerInfo !== c2.containerInfo || b2.stateNode.implementation !== c2.implementation) return b2 = Sg(c2, a2.mode, d2), b2.return = a2, b2;
    b2 = e(b2, c2.children || []);
    b2.return = a2;
    return b2;
  }
  function m2(a2, b2, c2, d2, f3) {
    if (null === b2 || 7 !== b2.tag) return b2 = Tg(c2, a2.mode, d2, f3), b2.return = a2, b2;
    b2 = e(b2, c2);
    b2.return = a2;
    return b2;
  }
  function q2(a2, b2, c2) {
    if ("string" === typeof b2 && "" !== b2 || "number" === typeof b2) return b2 = Qg("" + b2, a2.mode, c2), b2.return = a2, b2;
    if ("object" === typeof b2 && null !== b2) {
      switch (b2.$$typeof) {
        case va:
          return c2 = Rg(b2.type, b2.key, b2.props, null, a2.mode, c2), c2.ref = Lg(a2, null, b2), c2.return = a2, c2;
        case wa:
          return b2 = Sg(b2, a2.mode, c2), b2.return = a2, b2;
        case Ha:
          var d2 = b2._init;
          return q2(a2, d2(b2._payload), c2);
      }
      if (eb(b2) || Ka(b2)) return b2 = Tg(b2, a2.mode, c2, null), b2.return = a2, b2;
      Mg(a2, b2);
    }
    return null;
  }
  function r2(a2, b2, c2, d2) {
    var e2 = null !== b2 ? b2.key : null;
    if ("string" === typeof c2 && "" !== c2 || "number" === typeof c2) return null !== e2 ? null : h(a2, b2, "" + c2, d2);
    if ("object" === typeof c2 && null !== c2) {
      switch (c2.$$typeof) {
        case va:
          return c2.key === e2 ? k2(a2, b2, c2, d2) : null;
        case wa:
          return c2.key === e2 ? l2(a2, b2, c2, d2) : null;
        case Ha:
          return e2 = c2._init, r2(
            a2,
            b2,
            e2(c2._payload),
            d2
          );
      }
      if (eb(c2) || Ka(c2)) return null !== e2 ? null : m2(a2, b2, c2, d2, null);
      Mg(a2, c2);
    }
    return null;
  }
  function y2(a2, b2, c2, d2, e2) {
    if ("string" === typeof d2 && "" !== d2 || "number" === typeof d2) return a2 = a2.get(c2) || null, h(b2, a2, "" + d2, e2);
    if ("object" === typeof d2 && null !== d2) {
      switch (d2.$$typeof) {
        case va:
          return a2 = a2.get(null === d2.key ? c2 : d2.key) || null, k2(b2, a2, d2, e2);
        case wa:
          return a2 = a2.get(null === d2.key ? c2 : d2.key) || null, l2(b2, a2, d2, e2);
        case Ha:
          var f3 = d2._init;
          return y2(a2, b2, c2, f3(d2._payload), e2);
      }
      if (eb(d2) || Ka(d2)) return a2 = a2.get(c2) || null, m2(b2, a2, d2, e2, null);
      Mg(b2, d2);
    }
    return null;
  }
  function n2(e2, g2, h2, k3) {
    for (var l3 = null, m3 = null, u2 = g2, w2 = g2 = 0, x2 = null; null !== u2 && w2 < h2.length; w2++) {
      u2.index > w2 ? (x2 = u2, u2 = null) : x2 = u2.sibling;
      var n3 = r2(e2, u2, h2[w2], k3);
      if (null === n3) {
        null === u2 && (u2 = x2);
        break;
      }
      a && u2 && null === n3.alternate && b(e2, u2);
      g2 = f2(n3, g2, w2);
      null === m3 ? l3 = n3 : m3.sibling = n3;
      m3 = n3;
      u2 = x2;
    }
    if (w2 === h2.length) return c(e2, u2), I && tg(e2, w2), l3;
    if (null === u2) {
      for (; w2 < h2.length; w2++) u2 = q2(e2, h2[w2], k3), null !== u2 && (g2 = f2(u2, g2, w2), null === m3 ? l3 = u2 : m3.sibling = u2, m3 = u2);
      I && tg(e2, w2);
      return l3;
    }
    for (u2 = d(e2, u2); w2 < h2.length; w2++) x2 = y2(u2, e2, w2, h2[w2], k3), null !== x2 && (a && null !== x2.alternate && u2.delete(null === x2.key ? w2 : x2.key), g2 = f2(x2, g2, w2), null === m3 ? l3 = x2 : m3.sibling = x2, m3 = x2);
    a && u2.forEach(function(a2) {
      return b(e2, a2);
    });
    I && tg(e2, w2);
    return l3;
  }
  function t2(e2, g2, h2, k3) {
    var l3 = Ka(h2);
    if ("function" !== typeof l3) throw Error(p(150));
    h2 = l3.call(h2);
    if (null == h2) throw Error(p(151));
    for (var u2 = l3 = null, m3 = g2, w2 = g2 = 0, x2 = null, n3 = h2.next(); null !== m3 && !n3.done; w2++, n3 = h2.next()) {
      m3.index > w2 ? (x2 = m3, m3 = null) : x2 = m3.sibling;
      var t3 = r2(e2, m3, n3.value, k3);
      if (null === t3) {
        null === m3 && (m3 = x2);
        break;
      }
      a && m3 && null === t3.alternate && b(e2, m3);
      g2 = f2(t3, g2, w2);
      null === u2 ? l3 = t3 : u2.sibling = t3;
      u2 = t3;
      m3 = x2;
    }
    if (n3.done) return c(
      e2,
      m3
    ), I && tg(e2, w2), l3;
    if (null === m3) {
      for (; !n3.done; w2++, n3 = h2.next()) n3 = q2(e2, n3.value, k3), null !== n3 && (g2 = f2(n3, g2, w2), null === u2 ? l3 = n3 : u2.sibling = n3, u2 = n3);
      I && tg(e2, w2);
      return l3;
    }
    for (m3 = d(e2, m3); !n3.done; w2++, n3 = h2.next()) n3 = y2(m3, e2, w2, n3.value, k3), null !== n3 && (a && null !== n3.alternate && m3.delete(null === n3.key ? w2 : n3.key), g2 = f2(n3, g2, w2), null === u2 ? l3 = n3 : u2.sibling = n3, u2 = n3);
    a && m3.forEach(function(a2) {
      return b(e2, a2);
    });
    I && tg(e2, w2);
    return l3;
  }
  function J2(a2, d2, f3, h2) {
    "object" === typeof f3 && null !== f3 && f3.type === ya && null === f3.key && (f3 = f3.props.children);
    if ("object" === typeof f3 && null !== f3) {
      switch (f3.$$typeof) {
        case va:
          a: {
            for (var k3 = f3.key, l3 = d2; null !== l3; ) {
              if (l3.key === k3) {
                k3 = f3.type;
                if (k3 === ya) {
                  if (7 === l3.tag) {
                    c(a2, l3.sibling);
                    d2 = e(l3, f3.props.children);
                    d2.return = a2;
                    a2 = d2;
                    break a;
                  }
                } else if (l3.elementType === k3 || "object" === typeof k3 && null !== k3 && k3.$$typeof === Ha && Ng(k3) === l3.type) {
                  c(a2, l3.sibling);
                  d2 = e(l3, f3.props);
                  d2.ref = Lg(a2, l3, f3);
                  d2.return = a2;
                  a2 = d2;
                  break a;
                }
                c(a2, l3);
                break;
              } else b(a2, l3);
              l3 = l3.sibling;
            }
            f3.type === ya ? (d2 = Tg(f3.props.children, a2.mode, h2, f3.key), d2.return = a2, a2 = d2) : (h2 = Rg(f3.type, f3.key, f3.props, null, a2.mode, h2), h2.ref = Lg(a2, d2, f3), h2.return = a2, a2 = h2);
          }
          return g(a2);
        case wa:
          a: {
            for (l3 = f3.key; null !== d2; ) {
              if (d2.key === l3) if (4 === d2.tag && d2.stateNode.containerInfo === f3.containerInfo && d2.stateNode.implementation === f3.implementation) {
                c(a2, d2.sibling);
                d2 = e(d2, f3.children || []);
                d2.return = a2;
                a2 = d2;
                break a;
              } else {
                c(a2, d2);
                break;
              }
              else b(a2, d2);
              d2 = d2.sibling;
            }
            d2 = Sg(f3, a2.mode, h2);
            d2.return = a2;
            a2 = d2;
          }
          return g(a2);
        case Ha:
          return l3 = f3._init, J2(a2, d2, l3(f3._payload), h2);
      }
      if (eb(f3)) return n2(a2, d2, f3, h2);
      if (Ka(f3)) return t2(a2, d2, f3, h2);
      Mg(a2, f3);
    }
    return "string" === typeof f3 && "" !== f3 || "number" === typeof f3 ? (f3 = "" + f3, null !== d2 && 6 === d2.tag ? (c(a2, d2.sibling), d2 = e(d2, f3), d2.return = a2, a2 = d2) : (c(a2, d2), d2 = Qg(f3, a2.mode, h2), d2.return = a2, a2 = d2), g(a2)) : c(a2, d2);
  }
  return J2;
}
var Ug = Og(true), Vg = Og(false), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
  Zg = Yg = Xg = null;
}
function ah(a) {
  var b = Wg.current;
  E(Wg);
  a._currentValue = b;
}
function bh(a, b, c) {
  for (; null !== a; ) {
    var d = a.alternate;
    (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
    if (a === c) break;
    a = a.return;
  }
}
function ch(a, b) {
  Xg = a;
  Zg = Yg = null;
  a = a.dependencies;
  null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = true), a.firstContext = null);
}
function eh(a) {
  var b = a._currentValue;
  if (Zg !== a) if (a = { context: a, memoizedValue: b, next: null }, null === Yg) {
    if (null === Xg) throw Error(p(308));
    Yg = a;
    Xg.dependencies = { lanes: 0, firstContext: a };
  } else Yg = Yg.next = a;
  return b;
}
var fh = null;
function gh(a) {
  null === fh ? fh = [a] : fh.push(a);
}
function hh(a, b, c, d) {
  var e = b.interleaved;
  null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
  b.interleaved = c;
  return ih(a, d);
}
function ih(a, b) {
  a.lanes |= b;
  var c = a.alternate;
  null !== c && (c.lanes |= b);
  c = a;
  for (a = a.return; null !== a; ) a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
  return 3 === c.tag ? c.stateNode : null;
}
var jh = false;
function kh(a) {
  a.updateQueue = { baseState: a.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
}
function lh(a, b) {
  a = a.updateQueue;
  b.updateQueue === a && (b.updateQueue = { baseState: a.baseState, firstBaseUpdate: a.firstBaseUpdate, lastBaseUpdate: a.lastBaseUpdate, shared: a.shared, effects: a.effects });
}
function mh(a, b) {
  return { eventTime: a, lane: b, tag: 0, payload: null, callback: null, next: null };
}
function nh(a, b, c) {
  var d = a.updateQueue;
  if (null === d) return null;
  d = d.shared;
  if (0 !== (K & 2)) {
    var e = d.pending;
    null === e ? b.next = b : (b.next = e.next, e.next = b);
    d.pending = b;
    return ih(a, c);
  }
  e = d.interleaved;
  null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
  d.interleaved = b;
  return ih(a, c);
}
function oh(a, b, c) {
  b = b.updateQueue;
  if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
    var d = b.lanes;
    d &= a.pendingLanes;
    c |= d;
    b.lanes = c;
    Cc(a, c);
  }
}
function ph(a, b) {
  var c = a.updateQueue, d = a.alternate;
  if (null !== d && (d = d.updateQueue, c === d)) {
    var e = null, f2 = null;
    c = c.firstBaseUpdate;
    if (null !== c) {
      do {
        var g = { eventTime: c.eventTime, lane: c.lane, tag: c.tag, payload: c.payload, callback: c.callback, next: null };
        null === f2 ? e = f2 = g : f2 = f2.next = g;
        c = c.next;
      } while (null !== c);
      null === f2 ? e = f2 = b : f2 = f2.next = b;
    } else e = f2 = b;
    c = { baseState: d.baseState, firstBaseUpdate: e, lastBaseUpdate: f2, shared: d.shared, effects: d.effects };
    a.updateQueue = c;
    return;
  }
  a = c.lastBaseUpdate;
  null === a ? c.firstBaseUpdate = b : a.next = b;
  c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
  var e = a.updateQueue;
  jh = false;
  var f2 = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
  if (null !== h) {
    e.shared.pending = null;
    var k2 = h, l2 = k2.next;
    k2.next = null;
    null === g ? f2 = l2 : g.next = l2;
    g = k2;
    var m2 = a.alternate;
    null !== m2 && (m2 = m2.updateQueue, h = m2.lastBaseUpdate, h !== g && (null === h ? m2.firstBaseUpdate = l2 : h.next = l2, m2.lastBaseUpdate = k2));
  }
  if (null !== f2) {
    var q2 = e.baseState;
    g = 0;
    m2 = l2 = k2 = null;
    h = f2;
    do {
      var r2 = h.lane, y2 = h.eventTime;
      if ((d & r2) === r2) {
        null !== m2 && (m2 = m2.next = {
          eventTime: y2,
          lane: 0,
          tag: h.tag,
          payload: h.payload,
          callback: h.callback,
          next: null
        });
        a: {
          var n2 = a, t2 = h;
          r2 = b;
          y2 = c;
          switch (t2.tag) {
            case 1:
              n2 = t2.payload;
              if ("function" === typeof n2) {
                q2 = n2.call(y2, q2, r2);
                break a;
              }
              q2 = n2;
              break a;
            case 3:
              n2.flags = n2.flags & -65537 | 128;
            case 0:
              n2 = t2.payload;
              r2 = "function" === typeof n2 ? n2.call(y2, q2, r2) : n2;
              if (null === r2 || void 0 === r2) break a;
              q2 = A({}, q2, r2);
              break a;
            case 2:
              jh = true;
          }
        }
        null !== h.callback && 0 !== h.lane && (a.flags |= 64, r2 = e.effects, null === r2 ? e.effects = [h] : r2.push(h));
      } else y2 = { eventTime: y2, lane: r2, tag: h.tag, payload: h.payload, callback: h.callback, next: null }, null === m2 ? (l2 = m2 = y2, k2 = q2) : m2 = m2.next = y2, g |= r2;
      h = h.next;
      if (null === h) if (h = e.shared.pending, null === h) break;
      else r2 = h, h = r2.next, r2.next = null, e.lastBaseUpdate = r2, e.shared.pending = null;
    } while (1);
    null === m2 && (k2 = q2);
    e.baseState = k2;
    e.firstBaseUpdate = l2;
    e.lastBaseUpdate = m2;
    b = e.shared.interleaved;
    if (null !== b) {
      e = b;
      do
        g |= e.lane, e = e.next;
      while (e !== b);
    } else null === f2 && (e.shared.lanes = 0);
    rh |= g;
    a.lanes = g;
    a.memoizedState = q2;
  }
}
function sh(a, b, c) {
  a = b.effects;
  b.effects = null;
  if (null !== a) for (b = 0; b < a.length; b++) {
    var d = a[b], e = d.callback;
    if (null !== e) {
      d.callback = null;
      d = c;
      if ("function" !== typeof e) throw Error(p(191, e));
      e.call(d);
    }
  }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
  if (a === th) throw Error(p(174));
  return a;
}
function yh(a, b) {
  G(wh, b);
  G(vh, a);
  G(uh, th);
  a = b.nodeType;
  switch (a) {
    case 9:
    case 11:
      b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
      break;
    default:
      a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
  }
  E(uh);
  G(uh, b);
}
function zh() {
  E(uh);
  E(vh);
  E(wh);
}
function Ah(a) {
  xh(wh.current);
  var b = xh(uh.current);
  var c = lb(b, a.type);
  b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
  vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
  for (var b = a; null !== b; ) {
    if (13 === b.tag) {
      var c = b.memoizedState;
      if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
    } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
      if (0 !== (b.flags & 128)) return b;
    } else if (null !== b.child) {
      b.child.return = b;
      b = b.child;
      continue;
    }
    if (b === a) break;
    for (; null === b.sibling; ) {
      if (null === b.return || b.return === a) return null;
      b = b.return;
    }
    b.sibling.return = b.return;
    b = b.sibling;
  }
  return null;
}
var Dh = [];
function Eh() {
  for (var a = 0; a < Dh.length; a++) Dh[a]._workInProgressVersionPrimary = null;
  Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = false, Jh = false, Kh = 0, Lh = 0;
function P() {
  throw Error(p(321));
}
function Mh(a, b) {
  if (null === b) return false;
  for (var c = 0; c < b.length && c < a.length; c++) if (!He(a[c], b[c])) return false;
  return true;
}
function Nh(a, b, c, d, e, f2) {
  Hh = f2;
  M = b;
  b.memoizedState = null;
  b.updateQueue = null;
  b.lanes = 0;
  Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
  a = c(d, e);
  if (Jh) {
    f2 = 0;
    do {
      Jh = false;
      Kh = 0;
      if (25 <= f2) throw Error(p(301));
      f2 += 1;
      O = N = null;
      b.updateQueue = null;
      Fh.current = Qh;
      a = c(d, e);
    } while (Jh);
  }
  Fh.current = Rh;
  b = null !== N && null !== N.next;
  Hh = 0;
  O = N = M = null;
  Ih = false;
  if (b) throw Error(p(300));
  return a;
}
function Sh() {
  var a = 0 !== Kh;
  Kh = 0;
  return a;
}
function Th() {
  var a = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
  null === O ? M.memoizedState = O = a : O = O.next = a;
  return O;
}
function Uh() {
  if (null === N) {
    var a = M.alternate;
    a = null !== a ? a.memoizedState : null;
  } else a = N.next;
  var b = null === O ? M.memoizedState : O.next;
  if (null !== b) O = b, N = a;
  else {
    if (null === a) throw Error(p(310));
    N = a;
    a = { memoizedState: N.memoizedState, baseState: N.baseState, baseQueue: N.baseQueue, queue: N.queue, next: null };
    null === O ? M.memoizedState = O = a : O = O.next = a;
  }
  return O;
}
function Vh(a, b) {
  return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
  var b = Uh(), c = b.queue;
  if (null === c) throw Error(p(311));
  c.lastRenderedReducer = a;
  var d = N, e = d.baseQueue, f2 = c.pending;
  if (null !== f2) {
    if (null !== e) {
      var g = e.next;
      e.next = f2.next;
      f2.next = g;
    }
    d.baseQueue = e = f2;
    c.pending = null;
  }
  if (null !== e) {
    f2 = e.next;
    d = d.baseState;
    var h = g = null, k2 = null, l2 = f2;
    do {
      var m2 = l2.lane;
      if ((Hh & m2) === m2) null !== k2 && (k2 = k2.next = { lane: 0, action: l2.action, hasEagerState: l2.hasEagerState, eagerState: l2.eagerState, next: null }), d = l2.hasEagerState ? l2.eagerState : a(d, l2.action);
      else {
        var q2 = {
          lane: m2,
          action: l2.action,
          hasEagerState: l2.hasEagerState,
          eagerState: l2.eagerState,
          next: null
        };
        null === k2 ? (h = k2 = q2, g = d) : k2 = k2.next = q2;
        M.lanes |= m2;
        rh |= m2;
      }
      l2 = l2.next;
    } while (null !== l2 && l2 !== f2);
    null === k2 ? g = d : k2.next = h;
    He(d, b.memoizedState) || (dh = true);
    b.memoizedState = d;
    b.baseState = g;
    b.baseQueue = k2;
    c.lastRenderedState = d;
  }
  a = c.interleaved;
  if (null !== a) {
    e = a;
    do
      f2 = e.lane, M.lanes |= f2, rh |= f2, e = e.next;
    while (e !== a);
  } else null === e && (c.lanes = 0);
  return [b.memoizedState, c.dispatch];
}
function Xh(a) {
  var b = Uh(), c = b.queue;
  if (null === c) throw Error(p(311));
  c.lastRenderedReducer = a;
  var d = c.dispatch, e = c.pending, f2 = b.memoizedState;
  if (null !== e) {
    c.pending = null;
    var g = e = e.next;
    do
      f2 = a(f2, g.action), g = g.next;
    while (g !== e);
    He(f2, b.memoizedState) || (dh = true);
    b.memoizedState = f2;
    null === b.baseQueue && (b.baseState = f2);
    c.lastRenderedState = f2;
  }
  return [f2, d];
}
function Yh() {
}
function Zh(a, b) {
  var c = M, d = Uh(), e = b(), f2 = !He(d.memoizedState, e);
  f2 && (d.memoizedState = e, dh = true);
  d = d.queue;
  $h(ai.bind(null, c, d, a), [a]);
  if (d.getSnapshot !== b || f2 || null !== O && O.memoizedState.tag & 1) {
    c.flags |= 2048;
    bi(9, ci.bind(null, c, d, e, b), void 0, null);
    if (null === Q) throw Error(p(349));
    0 !== (Hh & 30) || di(c, b, e);
  }
  return e;
}
function di(a, b, c) {
  a.flags |= 16384;
  a = { getSnapshot: b, value: c };
  b = M.updateQueue;
  null === b ? (b = { lastEffect: null, stores: null }, M.updateQueue = b, b.stores = [a]) : (c = b.stores, null === c ? b.stores = [a] : c.push(a));
}
function ci(a, b, c, d) {
  b.value = c;
  b.getSnapshot = d;
  ei(b) && fi(a);
}
function ai(a, b, c) {
  return c(function() {
    ei(b) && fi(a);
  });
}
function ei(a) {
  var b = a.getSnapshot;
  a = a.value;
  try {
    var c = b();
    return !He(a, c);
  } catch (d) {
    return true;
  }
}
function fi(a) {
  var b = ih(a, 1);
  null !== b && gi(b, a, 1, -1);
}
function hi(a) {
  var b = Th();
  "function" === typeof a && (a = a());
  b.memoizedState = b.baseState = a;
  a = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Vh, lastRenderedState: a };
  b.queue = a;
  a = a.dispatch = ii.bind(null, M, a);
  return [b.memoizedState, a];
}
function bi(a, b, c, d) {
  a = { tag: a, create: b, destroy: c, deps: d, next: null };
  b = M.updateQueue;
  null === b ? (b = { lastEffect: null, stores: null }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
  return a;
}
function ji() {
  return Uh().memoizedState;
}
function ki(a, b, c, d) {
  var e = Th();
  M.flags |= a;
  e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
  var e = Uh();
  d = void 0 === d ? null : d;
  var f2 = void 0;
  if (null !== N) {
    var g = N.memoizedState;
    f2 = g.destroy;
    if (null !== d && Mh(d, g.deps)) {
      e.memoizedState = bi(b, c, f2, d);
      return;
    }
  }
  M.flags |= a;
  e.memoizedState = bi(1 | b, c, f2, d);
}
function mi(a, b) {
  return ki(8390656, 8, a, b);
}
function $h(a, b) {
  return li(2048, 8, a, b);
}
function ni(a, b) {
  return li(4, 2, a, b);
}
function oi(a, b) {
  return li(4, 4, a, b);
}
function pi(a, b) {
  if ("function" === typeof b) return a = a(), b(a), function() {
    b(null);
  };
  if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
    b.current = null;
  };
}
function qi(a, b, c) {
  c = null !== c && void 0 !== c ? c.concat([a]) : null;
  return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {
}
function si(a, b) {
  var c = Uh();
  b = void 0 === b ? null : b;
  var d = c.memoizedState;
  if (null !== d && null !== b && Mh(b, d[1])) return d[0];
  c.memoizedState = [a, b];
  return a;
}
function ti(a, b) {
  var c = Uh();
  b = void 0 === b ? null : b;
  var d = c.memoizedState;
  if (null !== d && null !== b && Mh(b, d[1])) return d[0];
  a = a();
  c.memoizedState = [a, b];
  return a;
}
function ui(a, b, c) {
  if (0 === (Hh & 21)) return a.baseState && (a.baseState = false, dh = true), a.memoizedState = c;
  He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = true);
  return b;
}
function vi(a, b) {
  var c = C;
  C = 0 !== c && 4 > c ? c : 4;
  a(true);
  var d = Gh.transition;
  Gh.transition = {};
  try {
    a(false), b();
  } finally {
    C = c, Gh.transition = d;
  }
}
function wi() {
  return Uh().memoizedState;
}
function xi(a, b, c) {
  var d = yi(a);
  c = { lane: d, action: c, hasEagerState: false, eagerState: null, next: null };
  if (zi(a)) Ai(b, c);
  else if (c = hh(a, b, c, d), null !== c) {
    var e = R();
    gi(c, a, d, e);
    Bi(c, b, d);
  }
}
function ii(a, b, c) {
  var d = yi(a), e = { lane: d, action: c, hasEagerState: false, eagerState: null, next: null };
  if (zi(a)) Ai(b, e);
  else {
    var f2 = a.alternate;
    if (0 === a.lanes && (null === f2 || 0 === f2.lanes) && (f2 = b.lastRenderedReducer, null !== f2)) try {
      var g = b.lastRenderedState, h = f2(g, c);
      e.hasEagerState = true;
      e.eagerState = h;
      if (He(h, g)) {
        var k2 = b.interleaved;
        null === k2 ? (e.next = e, gh(b)) : (e.next = k2.next, k2.next = e);
        b.interleaved = e;
        return;
      }
    } catch (l2) {
    } finally {
    }
    c = hh(a, b, e, d);
    null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
  }
}
function zi(a) {
  var b = a.alternate;
  return a === M || null !== b && b === M;
}
function Ai(a, b) {
  Jh = Ih = true;
  var c = a.pending;
  null === c ? b.next = b : (b.next = c.next, c.next = b);
  a.pending = b;
}
function Bi(a, b, c) {
  if (0 !== (c & 4194240)) {
    var d = b.lanes;
    d &= a.pendingLanes;
    c |= d;
    b.lanes = c;
    Cc(a, c);
  }
}
var Rh = { readContext: eh, useCallback: P, useContext: P, useEffect: P, useImperativeHandle: P, useInsertionEffect: P, useLayoutEffect: P, useMemo: P, useReducer: P, useRef: P, useState: P, useDebugValue: P, useDeferredValue: P, useTransition: P, useMutableSource: P, useSyncExternalStore: P, useId: P, unstable_isNewReconciler: false }, Oh = { readContext: eh, useCallback: function(a, b) {
  Th().memoizedState = [a, void 0 === b ? null : b];
  return a;
}, useContext: eh, useEffect: mi, useImperativeHandle: function(a, b, c) {
  c = null !== c && void 0 !== c ? c.concat([a]) : null;
  return ki(
    4194308,
    4,
    pi.bind(null, b, a),
    c
  );
}, useLayoutEffect: function(a, b) {
  return ki(4194308, 4, a, b);
}, useInsertionEffect: function(a, b) {
  return ki(4, 2, a, b);
}, useMemo: function(a, b) {
  var c = Th();
  b = void 0 === b ? null : b;
  a = a();
  c.memoizedState = [a, b];
  return a;
}, useReducer: function(a, b, c) {
  var d = Th();
  b = void 0 !== c ? c(b) : b;
  d.memoizedState = d.baseState = b;
  a = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: a, lastRenderedState: b };
  d.queue = a;
  a = a.dispatch = xi.bind(null, M, a);
  return [d.memoizedState, a];
}, useRef: function(a) {
  var b = Th();
  a = { current: a };
  return b.memoizedState = a;
}, useState: hi, useDebugValue: ri, useDeferredValue: function(a) {
  return Th().memoizedState = a;
}, useTransition: function() {
  var a = hi(false), b = a[0];
  a = vi.bind(null, a[1]);
  Th().memoizedState = a;
  return [b, a];
}, useMutableSource: function() {
}, useSyncExternalStore: function(a, b, c) {
  var d = M, e = Th();
  if (I) {
    if (void 0 === c) throw Error(p(407));
    c = c();
  } else {
    c = b();
    if (null === Q) throw Error(p(349));
    0 !== (Hh & 30) || di(d, b, c);
  }
  e.memoizedState = c;
  var f2 = { value: c, getSnapshot: b };
  e.queue = f2;
  mi(ai.bind(
    null,
    d,
    f2,
    a
  ), [a]);
  d.flags |= 2048;
  bi(9, ci.bind(null, d, f2, c, b), void 0, null);
  return c;
}, useId: function() {
  var a = Th(), b = Q.identifierPrefix;
  if (I) {
    var c = sg;
    var d = rg;
    c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
    b = ":" + b + "R" + c;
    c = Kh++;
    0 < c && (b += "H" + c.toString(32));
    b += ":";
  } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
  return a.memoizedState = b;
}, unstable_isNewReconciler: false }, Ph = {
  readContext: eh,
  useCallback: si,
  useContext: eh,
  useEffect: $h,
  useImperativeHandle: qi,
  useInsertionEffect: ni,
  useLayoutEffect: oi,
  useMemo: ti,
  useReducer: Wh,
  useRef: ji,
  useState: function() {
    return Wh(Vh);
  },
  useDebugValue: ri,
  useDeferredValue: function(a) {
    var b = Uh();
    return ui(b, N.memoizedState, a);
  },
  useTransition: function() {
    var a = Wh(Vh)[0], b = Uh().memoizedState;
    return [a, b];
  },
  useMutableSource: Yh,
  useSyncExternalStore: Zh,
  useId: wi,
  unstable_isNewReconciler: false
}, Qh = { readContext: eh, useCallback: si, useContext: eh, useEffect: $h, useImperativeHandle: qi, useInsertionEffect: ni, useLayoutEffect: oi, useMemo: ti, useReducer: Xh, useRef: ji, useState: function() {
  return Xh(Vh);
}, useDebugValue: ri, useDeferredValue: function(a) {
  var b = Uh();
  return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
}, useTransition: function() {
  var a = Xh(Vh)[0], b = Uh().memoizedState;
  return [a, b];
}, useMutableSource: Yh, useSyncExternalStore: Zh, useId: wi, unstable_isNewReconciler: false };
function Ci(a, b) {
  if (a && a.defaultProps) {
    b = A({}, b);
    a = a.defaultProps;
    for (var c in a) void 0 === b[c] && (b[c] = a[c]);
    return b;
  }
  return b;
}
function Di(a, b, c, d) {
  b = a.memoizedState;
  c = c(d, b);
  c = null === c || void 0 === c ? b : A({}, b, c);
  a.memoizedState = c;
  0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = { isMounted: function(a) {
  return (a = a._reactInternals) ? Vb(a) === a : false;
}, enqueueSetState: function(a, b, c) {
  a = a._reactInternals;
  var d = R(), e = yi(a), f2 = mh(d, e);
  f2.payload = b;
  void 0 !== c && null !== c && (f2.callback = c);
  b = nh(a, f2, e);
  null !== b && (gi(b, a, e, d), oh(b, a, e));
}, enqueueReplaceState: function(a, b, c) {
  a = a._reactInternals;
  var d = R(), e = yi(a), f2 = mh(d, e);
  f2.tag = 1;
  f2.payload = b;
  void 0 !== c && null !== c && (f2.callback = c);
  b = nh(a, f2, e);
  null !== b && (gi(b, a, e, d), oh(b, a, e));
}, enqueueForceUpdate: function(a, b) {
  a = a._reactInternals;
  var c = R(), d = yi(a), e = mh(c, d);
  e.tag = 2;
  void 0 !== b && null !== b && (e.callback = b);
  b = nh(a, e, d);
  null !== b && (gi(b, a, d, c), oh(b, a, d));
} };
function Fi(a, b, c, d, e, f2, g) {
  a = a.stateNode;
  return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f2, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f2) : true;
}
function Gi(a, b, c) {
  var d = false, e = Vf;
  var f2 = b.contextType;
  "object" === typeof f2 && null !== f2 ? f2 = eh(f2) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f2 = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
  b = new b(c, f2);
  a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
  b.updater = Ei;
  a.stateNode = b;
  b._reactInternals = a;
  d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f2);
  return b;
}
function Hi(a, b, c, d) {
  a = b.state;
  "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
  "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
  b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
  var e = a.stateNode;
  e.props = c;
  e.state = a.memoizedState;
  e.refs = {};
  kh(a);
  var f2 = b.contextType;
  "object" === typeof f2 && null !== f2 ? e.context = eh(f2) : (f2 = Zf(b) ? Xf : H.current, e.context = Yf(a, f2));
  e.state = a.memoizedState;
  f2 = b.getDerivedStateFromProps;
  "function" === typeof f2 && (Di(a, b, f2, c), e.state = a.memoizedState);
  "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
  "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
  try {
    var c = "", d = b;
    do
      c += Pa(d), d = d.return;
    while (d);
    var e = c;
  } catch (f2) {
    e = "\nError generating stack: " + f2.message + "\n" + f2.stack;
  }
  return { value: a, source: b, stack: e, digest: null };
}
function Ki(a, b, c) {
  return { value: a, source: null, stack: null != c ? c : null, digest: null != b ? b : null };
}
function Li(a, b) {
  try {
    console.error(b.value);
  } catch (c) {
    setTimeout(function() {
      throw c;
    });
  }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
  c = mh(-1, c);
  c.tag = 3;
  c.payload = { element: null };
  var d = b.value;
  c.callback = function() {
    Oi || (Oi = true, Pi = d);
    Li(a, b);
  };
  return c;
}
function Qi(a, b, c) {
  c = mh(-1, c);
  c.tag = 3;
  var d = a.type.getDerivedStateFromError;
  if ("function" === typeof d) {
    var e = b.value;
    c.payload = function() {
      return d(e);
    };
    c.callback = function() {
      Li(a, b);
    };
  }
  var f2 = a.stateNode;
  null !== f2 && "function" === typeof f2.componentDidCatch && (c.callback = function() {
    Li(a, b);
    "function" !== typeof d && (null === Ri ? Ri = /* @__PURE__ */ new Set([this]) : Ri.add(this));
    var c2 = b.stack;
    this.componentDidCatch(b.value, { componentStack: null !== c2 ? c2 : "" });
  });
  return c;
}
function Si(a, b, c) {
  var d = a.pingCache;
  if (null === d) {
    d = a.pingCache = new Mi();
    var e = /* @__PURE__ */ new Set();
    d.set(b, e);
  } else e = d.get(b), void 0 === e && (e = /* @__PURE__ */ new Set(), d.set(b, e));
  e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
  do {
    var b;
    if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? true : false : true;
    if (b) return a;
    a = a.return;
  } while (null !== a);
  return null;
}
function Vi(a, b, c, d, e) {
  if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
  a.flags |= 65536;
  a.lanes = e;
  return a;
}
var Wi = ua.ReactCurrentOwner, dh = false;
function Xi(a, b, c, d) {
  b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
  c = c.render;
  var f2 = b.ref;
  ch(b, e);
  d = Nh(a, b, c, d, f2, e);
  c = Sh();
  if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
  I && c && vg(b);
  b.flags |= 1;
  Xi(a, b, d, e);
  return b.child;
}
function $i(a, b, c, d, e) {
  if (null === a) {
    var f2 = c.type;
    if ("function" === typeof f2 && !aj(f2) && void 0 === f2.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f2, bj(a, b, f2, d, e);
    a = Rg(c.type, null, d, b, b.mode, e);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
  }
  f2 = a.child;
  if (0 === (a.lanes & e)) {
    var g = f2.memoizedProps;
    c = c.compare;
    c = null !== c ? c : Ie;
    if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
  }
  b.flags |= 1;
  a = Pg(f2, d);
  a.ref = b.ref;
  a.return = b;
  return b.child = a;
}
function bj(a, b, c, d, e) {
  if (null !== a) {
    var f2 = a.memoizedProps;
    if (Ie(f2, d) && a.ref === b.ref) if (dh = false, b.pendingProps = d = f2, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = true);
    else return b.lanes = a.lanes, Zi(a, b, e);
  }
  return cj(a, b, c, d, e);
}
function dj(a, b, c) {
  var d = b.pendingProps, e = d.children, f2 = null !== a ? a.memoizedState : null;
  if ("hidden" === d.mode) if (0 === (b.mode & 1)) b.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, G(ej, fj), fj |= c;
  else {
    if (0 === (c & 1073741824)) return a = null !== f2 ? f2.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = { baseLanes: a, cachePool: null, transitions: null }, b.updateQueue = null, G(ej, fj), fj |= a, null;
    b.memoizedState = { baseLanes: 0, cachePool: null, transitions: null };
    d = null !== f2 ? f2.baseLanes : c;
    G(ej, fj);
    fj |= d;
  }
  else null !== f2 ? (d = f2.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
  Xi(a, b, e, c);
  return b.child;
}
function gj(a, b) {
  var c = b.ref;
  if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
  var f2 = Zf(c) ? Xf : H.current;
  f2 = Yf(b, f2);
  ch(b, e);
  c = Nh(a, b, c, d, f2, e);
  d = Sh();
  if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
  I && d && vg(b);
  b.flags |= 1;
  Xi(a, b, c, e);
  return b.child;
}
function hj(a, b, c, d, e) {
  if (Zf(c)) {
    var f2 = true;
    cg(b);
  } else f2 = false;
  ch(b, e);
  if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = true;
  else if (null === a) {
    var g = b.stateNode, h = b.memoizedProps;
    g.props = h;
    var k2 = g.context, l2 = c.contextType;
    "object" === typeof l2 && null !== l2 ? l2 = eh(l2) : (l2 = Zf(c) ? Xf : H.current, l2 = Yf(b, l2));
    var m2 = c.getDerivedStateFromProps, q2 = "function" === typeof m2 || "function" === typeof g.getSnapshotBeforeUpdate;
    q2 || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k2 !== l2) && Hi(b, g, d, l2);
    jh = false;
    var r2 = b.memoizedState;
    g.state = r2;
    qh(b, d, g, e);
    k2 = b.memoizedState;
    h !== d || r2 !== k2 || Wf.current || jh ? ("function" === typeof m2 && (Di(b, c, m2, d), k2 = b.memoizedState), (h = jh || Fi(b, c, h, d, r2, k2, l2)) ? (q2 || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k2), g.props = d, g.state = k2, g.context = l2, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = false);
  } else {
    g = b.stateNode;
    lh(a, b);
    h = b.memoizedProps;
    l2 = b.type === b.elementType ? h : Ci(b.type, h);
    g.props = l2;
    q2 = b.pendingProps;
    r2 = g.context;
    k2 = c.contextType;
    "object" === typeof k2 && null !== k2 ? k2 = eh(k2) : (k2 = Zf(c) ? Xf : H.current, k2 = Yf(b, k2));
    var y2 = c.getDerivedStateFromProps;
    (m2 = "function" === typeof y2 || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q2 || r2 !== k2) && Hi(b, g, d, k2);
    jh = false;
    r2 = b.memoizedState;
    g.state = r2;
    qh(b, d, g, e);
    var n2 = b.memoizedState;
    h !== q2 || r2 !== n2 || Wf.current || jh ? ("function" === typeof y2 && (Di(b, c, y2, d), n2 = b.memoizedState), (l2 = jh || Fi(b, c, l2, d, r2, n2, k2) || false) ? (m2 || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n2, k2), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n2, k2)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r2 === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r2 === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n2), g.props = d, g.state = n2, g.context = k2, d = l2) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r2 === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r2 === a.memoizedState || (b.flags |= 1024), d = false);
  }
  return jj(a, b, c, d, f2, e);
}
function jj(a, b, c, d, e, f2) {
  gj(a, b);
  var g = 0 !== (b.flags & 128);
  if (!d && !g) return e && dg(b, c, false), Zi(a, b, f2);
  d = b.stateNode;
  Wi.current = b;
  var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
  b.flags |= 1;
  null !== a && g ? (b.child = Ug(b, a.child, null, f2), b.child = Ug(b, null, h, f2)) : Xi(a, b, h, f2);
  b.memoizedState = d.state;
  e && dg(b, c, true);
  return b.child;
}
function kj(a) {
  var b = a.stateNode;
  b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, false);
  yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
  Ig();
  Jg(e);
  b.flags |= 256;
  Xi(a, b, c, d);
  return b.child;
}
var mj = { dehydrated: null, treeContext: null, retryLane: 0 };
function nj(a) {
  return { baseLanes: a, cachePool: null, transitions: null };
}
function oj(a, b, c) {
  var d = b.pendingProps, e = L.current, f2 = false, g = 0 !== (b.flags & 128), h;
  (h = g) || (h = null !== a && null === a.memoizedState ? false : 0 !== (e & 2));
  if (h) f2 = true, b.flags &= -129;
  else if (null === a || null !== a.memoizedState) e |= 1;
  G(L, e & 1);
  if (null === a) {
    Eg(b);
    a = b.memoizedState;
    if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
    g = d.children;
    a = d.fallback;
    return f2 ? (d = b.mode, f2 = b.child, g = { mode: "hidden", children: g }, 0 === (d & 1) && null !== f2 ? (f2.childLanes = 0, f2.pendingProps = g) : f2 = pj(g, d, 0, null), a = Tg(a, d, c, null), f2.return = b, a.return = b, f2.sibling = a, b.child = f2, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
  }
  e = a.memoizedState;
  if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
  if (f2) {
    f2 = d.fallback;
    g = b.mode;
    e = a.child;
    h = e.sibling;
    var k2 = { mode: "hidden", children: d.children };
    0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k2, b.deletions = null) : (d = Pg(e, k2), d.subtreeFlags = e.subtreeFlags & 14680064);
    null !== h ? f2 = Pg(h, f2) : (f2 = Tg(f2, g, c, null), f2.flags |= 2);
    f2.return = b;
    d.return = b;
    d.sibling = f2;
    b.child = d;
    d = f2;
    f2 = b.child;
    g = a.child.memoizedState;
    g = null === g ? nj(c) : { baseLanes: g.baseLanes | c, cachePool: null, transitions: g.transitions };
    f2.memoizedState = g;
    f2.childLanes = a.childLanes & ~c;
    b.memoizedState = mj;
    return d;
  }
  f2 = a.child;
  a = f2.sibling;
  d = Pg(f2, { mode: "visible", children: d.children });
  0 === (b.mode & 1) && (d.lanes = c);
  d.return = b;
  d.sibling = null;
  null !== a && (c = b.deletions, null === c ? (b.deletions = [a], b.flags |= 16) : c.push(a));
  b.child = d;
  b.memoizedState = null;
  return d;
}
function qj(a, b) {
  b = pj({ mode: "visible", children: b }, a.mode, 0, null);
  b.return = a;
  return a.child = b;
}
function sj(a, b, c, d) {
  null !== d && Jg(d);
  Ug(b, a.child, null, c);
  a = qj(b, b.pendingProps.children);
  a.flags |= 2;
  b.memoizedState = null;
  return a;
}
function rj(a, b, c, d, e, f2, g) {
  if (c) {
    if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
    if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
    f2 = d.fallback;
    e = b.mode;
    d = pj({ mode: "visible", children: d.children }, e, 0, null);
    f2 = Tg(f2, e, g, null);
    f2.flags |= 2;
    d.return = b;
    f2.return = b;
    d.sibling = f2;
    b.child = d;
    0 !== (b.mode & 1) && Ug(b, a.child, null, g);
    b.child.memoizedState = nj(g);
    b.memoizedState = mj;
    return f2;
  }
  if (0 === (b.mode & 1)) return sj(a, b, g, null);
  if ("$!" === e.data) {
    d = e.nextSibling && e.nextSibling.dataset;
    if (d) var h = d.dgst;
    d = h;
    f2 = Error(p(419));
    d = Ki(f2, d, void 0);
    return sj(a, b, g, d);
  }
  h = 0 !== (g & a.childLanes);
  if (dh || h) {
    d = Q;
    if (null !== d) {
      switch (g & -g) {
        case 4:
          e = 2;
          break;
        case 16:
          e = 8;
          break;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          e = 32;
          break;
        case 536870912:
          e = 268435456;
          break;
        default:
          e = 0;
      }
      e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
      0 !== e && e !== f2.retryLane && (f2.retryLane = e, ih(a, e), gi(d, a, e, -1));
    }
    tj();
    d = Ki(Error(p(421)));
    return sj(a, b, g, d);
  }
  if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
  a = f2.treeContext;
  yg = Lf(e.nextSibling);
  xg = b;
  I = true;
  zg = null;
  null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
  b = qj(b, d.children);
  b.flags |= 4096;
  return b;
}
function vj(a, b, c) {
  a.lanes |= b;
  var d = a.alternate;
  null !== d && (d.lanes |= b);
  bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
  var f2 = a.memoizedState;
  null === f2 ? a.memoizedState = { isBackwards: b, rendering: null, renderingStartTime: 0, last: d, tail: c, tailMode: e } : (f2.isBackwards = b, f2.rendering = null, f2.renderingStartTime = 0, f2.last = d, f2.tail = c, f2.tailMode = e);
}
function xj(a, b, c) {
  var d = b.pendingProps, e = d.revealOrder, f2 = d.tail;
  Xi(a, b, d.children, c);
  d = L.current;
  if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
  else {
    if (null !== a && 0 !== (a.flags & 128)) a: for (a = b.child; null !== a; ) {
      if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
      else if (19 === a.tag) vj(a, c, b);
      else if (null !== a.child) {
        a.child.return = a;
        a = a.child;
        continue;
      }
      if (a === b) break a;
      for (; null === a.sibling; ) {
        if (null === a.return || a.return === b) break a;
        a = a.return;
      }
      a.sibling.return = a.return;
      a = a.sibling;
    }
    d &= 1;
  }
  G(L, d);
  if (0 === (b.mode & 1)) b.memoizedState = null;
  else switch (e) {
    case "forwards":
      c = b.child;
      for (e = null; null !== c; ) a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
      c = e;
      null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
      wj(b, false, e, c, f2);
      break;
    case "backwards":
      c = null;
      e = b.child;
      for (b.child = null; null !== e; ) {
        a = e.alternate;
        if (null !== a && null === Ch(a)) {
          b.child = e;
          break;
        }
        a = e.sibling;
        e.sibling = c;
        c = e;
        e = a;
      }
      wj(b, true, c, null, f2);
      break;
    case "together":
      wj(b, false, null, null, void 0);
      break;
    default:
      b.memoizedState = null;
  }
  return b.child;
}
function ij(a, b) {
  0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
  null !== a && (b.dependencies = a.dependencies);
  rh |= b.lanes;
  if (0 === (c & b.childLanes)) return null;
  if (null !== a && b.child !== a.child) throw Error(p(153));
  if (null !== b.child) {
    a = b.child;
    c = Pg(a, a.pendingProps);
    b.child = c;
    for (c.return = b; null !== a.sibling; ) a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
    c.sibling = null;
  }
  return b.child;
}
function yj(a, b, c) {
  switch (b.tag) {
    case 3:
      kj(b);
      Ig();
      break;
    case 5:
      Ah(b);
      break;
    case 1:
      Zf(b.type) && cg(b);
      break;
    case 4:
      yh(b, b.stateNode.containerInfo);
      break;
    case 10:
      var d = b.type._context, e = b.memoizedProps.value;
      G(Wg, d._currentValue);
      d._currentValue = e;
      break;
    case 13:
      d = b.memoizedState;
      if (null !== d) {
        if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
        if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
        G(L, L.current & 1);
        a = Zi(a, b, c);
        return null !== a ? a.sibling : null;
      }
      G(L, L.current & 1);
      break;
    case 19:
      d = 0 !== (c & b.childLanes);
      if (0 !== (a.flags & 128)) {
        if (d) return xj(a, b, c);
        b.flags |= 128;
      }
      e = b.memoizedState;
      null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
      G(L, L.current);
      if (d) break;
      else return null;
    case 22:
    case 23:
      return b.lanes = 0, dj(a, b, c);
  }
  return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
  for (var c = b.child; null !== c; ) {
    if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
    else if (4 !== c.tag && null !== c.child) {
      c.child.return = c;
      c = c.child;
      continue;
    }
    if (c === b) break;
    for (; null === c.sibling; ) {
      if (null === c.return || c.return === b) return;
      c = c.return;
    }
    c.sibling.return = c.return;
    c = c.sibling;
  }
};
Aj = function() {
};
Bj = function(a, b, c, d) {
  var e = a.memoizedProps;
  if (e !== d) {
    a = b.stateNode;
    xh(uh.current);
    var f2 = null;
    switch (c) {
      case "input":
        e = Ya(a, e);
        d = Ya(a, d);
        f2 = [];
        break;
      case "select":
        e = A({}, e, { value: void 0 });
        d = A({}, d, { value: void 0 });
        f2 = [];
        break;
      case "textarea":
        e = gb(a, e);
        d = gb(a, d);
        f2 = [];
        break;
      default:
        "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
    }
    ub(c, d);
    var g;
    c = null;
    for (l2 in e) if (!d.hasOwnProperty(l2) && e.hasOwnProperty(l2) && null != e[l2]) if ("style" === l2) {
      var h = e[l2];
      for (g in h) h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
    } else "dangerouslySetInnerHTML" !== l2 && "children" !== l2 && "suppressContentEditableWarning" !== l2 && "suppressHydrationWarning" !== l2 && "autoFocus" !== l2 && (ea.hasOwnProperty(l2) ? f2 || (f2 = []) : (f2 = f2 || []).push(l2, null));
    for (l2 in d) {
      var k2 = d[l2];
      h = null != e ? e[l2] : void 0;
      if (d.hasOwnProperty(l2) && k2 !== h && (null != k2 || null != h)) if ("style" === l2) if (h) {
        for (g in h) !h.hasOwnProperty(g) || k2 && k2.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
        for (g in k2) k2.hasOwnProperty(g) && h[g] !== k2[g] && (c || (c = {}), c[g] = k2[g]);
      } else c || (f2 || (f2 = []), f2.push(
        l2,
        c
      )), c = k2;
      else "dangerouslySetInnerHTML" === l2 ? (k2 = k2 ? k2.__html : void 0, h = h ? h.__html : void 0, null != k2 && h !== k2 && (f2 = f2 || []).push(l2, k2)) : "children" === l2 ? "string" !== typeof k2 && "number" !== typeof k2 || (f2 = f2 || []).push(l2, "" + k2) : "suppressContentEditableWarning" !== l2 && "suppressHydrationWarning" !== l2 && (ea.hasOwnProperty(l2) ? (null != k2 && "onScroll" === l2 && D("scroll", a), f2 || h === k2 || (f2 = [])) : (f2 = f2 || []).push(l2, k2));
    }
    c && (f2 = f2 || []).push("style", c);
    var l2 = f2;
    if (b.updateQueue = l2) b.flags |= 4;
  }
};
Cj = function(a, b, c, d) {
  c !== d && (b.flags |= 4);
};
function Dj(a, b) {
  if (!I) switch (a.tailMode) {
    case "hidden":
      b = a.tail;
      for (var c = null; null !== b; ) null !== b.alternate && (c = b), b = b.sibling;
      null === c ? a.tail = null : c.sibling = null;
      break;
    case "collapsed":
      c = a.tail;
      for (var d = null; null !== c; ) null !== c.alternate && (d = c), c = c.sibling;
      null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
  }
}
function S(a) {
  var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
  if (b) for (var e = a.child; null !== e; ) c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
  else for (e = a.child; null !== e; ) c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
  a.subtreeFlags |= d;
  a.childLanes = c;
  return b;
}
function Ej(a, b, c) {
  var d = b.pendingProps;
  wg(b);
  switch (b.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return S(b), null;
    case 1:
      return Zf(b.type) && $f(), S(b), null;
    case 3:
      d = b.stateNode;
      zh();
      E(Wf);
      E(H);
      Eh();
      d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
      if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
      Aj(a, b);
      S(b);
      return null;
    case 5:
      Bh(b);
      var e = xh(wh.current);
      c = b.type;
      if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
      else {
        if (!d) {
          if (null === b.stateNode) throw Error(p(166));
          S(b);
          return null;
        }
        a = xh(uh.current);
        if (Gg(b)) {
          d = b.stateNode;
          c = b.type;
          var f2 = b.memoizedProps;
          d[Of] = b;
          d[Pf] = f2;
          a = 0 !== (b.mode & 1);
          switch (c) {
            case "dialog":
              D("cancel", d);
              D("close", d);
              break;
            case "iframe":
            case "object":
            case "embed":
              D("load", d);
              break;
            case "video":
            case "audio":
              for (e = 0; e < lf.length; e++) D(lf[e], d);
              break;
            case "source":
              D("error", d);
              break;
            case "img":
            case "image":
            case "link":
              D(
                "error",
                d
              );
              D("load", d);
              break;
            case "details":
              D("toggle", d);
              break;
            case "input":
              Za(d, f2);
              D("invalid", d);
              break;
            case "select":
              d._wrapperState = { wasMultiple: !!f2.multiple };
              D("invalid", d);
              break;
            case "textarea":
              hb(d, f2), D("invalid", d);
          }
          ub(c, f2);
          e = null;
          for (var g in f2) if (f2.hasOwnProperty(g)) {
            var h = f2[g];
            "children" === g ? "string" === typeof h ? d.textContent !== h && (true !== f2.suppressHydrationWarning && Af(d.textContent, h, a), e = ["children", h]) : "number" === typeof h && d.textContent !== "" + h && (true !== f2.suppressHydrationWarning && Af(
              d.textContent,
              h,
              a
            ), e = ["children", "" + h]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
          }
          switch (c) {
            case "input":
              Va(d);
              db(d, f2, true);
              break;
            case "textarea":
              Va(d);
              jb(d);
              break;
            case "select":
            case "option":
              break;
            default:
              "function" === typeof f2.onClick && (d.onclick = Bf);
          }
          d = e;
          b.updateQueue = d;
          null !== d && (b.flags |= 4);
        } else {
          g = 9 === e.nodeType ? e : e.ownerDocument;
          "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
          "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script><\/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, { is: d.is }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = true : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
          a[Of] = b;
          a[Pf] = d;
          zj(a, b, false, false);
          b.stateNode = a;
          a: {
            g = vb(c, d);
            switch (c) {
              case "dialog":
                D("cancel", a);
                D("close", a);
                e = d;
                break;
              case "iframe":
              case "object":
              case "embed":
                D("load", a);
                e = d;
                break;
              case "video":
              case "audio":
                for (e = 0; e < lf.length; e++) D(lf[e], a);
                e = d;
                break;
              case "source":
                D("error", a);
                e = d;
                break;
              case "img":
              case "image":
              case "link":
                D(
                  "error",
                  a
                );
                D("load", a);
                e = d;
                break;
              case "details":
                D("toggle", a);
                e = d;
                break;
              case "input":
                Za(a, d);
                e = Ya(a, d);
                D("invalid", a);
                break;
              case "option":
                e = d;
                break;
              case "select":
                a._wrapperState = { wasMultiple: !!d.multiple };
                e = A({}, d, { value: void 0 });
                D("invalid", a);
                break;
              case "textarea":
                hb(a, d);
                e = gb(a, d);
                D("invalid", a);
                break;
              default:
                e = d;
            }
            ub(c, e);
            h = e;
            for (f2 in h) if (h.hasOwnProperty(f2)) {
              var k2 = h[f2];
              "style" === f2 ? sb(a, k2) : "dangerouslySetInnerHTML" === f2 ? (k2 = k2 ? k2.__html : void 0, null != k2 && nb(a, k2)) : "children" === f2 ? "string" === typeof k2 ? ("textarea" !== c || "" !== k2) && ob(a, k2) : "number" === typeof k2 && ob(a, "" + k2) : "suppressContentEditableWarning" !== f2 && "suppressHydrationWarning" !== f2 && "autoFocus" !== f2 && (ea.hasOwnProperty(f2) ? null != k2 && "onScroll" === f2 && D("scroll", a) : null != k2 && ta(a, f2, k2, g));
            }
            switch (c) {
              case "input":
                Va(a);
                db(a, d, false);
                break;
              case "textarea":
                Va(a);
                jb(a);
                break;
              case "option":
                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                break;
              case "select":
                a.multiple = !!d.multiple;
                f2 = d.value;
                null != f2 ? fb(a, !!d.multiple, f2, false) : null != d.defaultValue && fb(
                  a,
                  !!d.multiple,
                  d.defaultValue,
                  true
                );
                break;
              default:
                "function" === typeof e.onClick && (a.onclick = Bf);
            }
            switch (c) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                d = !!d.autoFocus;
                break a;
              case "img":
                d = true;
                break a;
              default:
                d = false;
            }
          }
          d && (b.flags |= 4);
        }
        null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
      }
      S(b);
      return null;
    case 6:
      if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
      else {
        if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
        c = xh(wh.current);
        xh(uh.current);
        if (Gg(b)) {
          d = b.stateNode;
          c = b.memoizedProps;
          d[Of] = b;
          if (f2 = d.nodeValue !== c) {
            if (a = xg, null !== a) switch (a.tag) {
              case 3:
                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                break;
              case 5:
                true !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
            }
          }
          f2 && (b.flags |= 4);
        } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
      }
      S(b);
      return null;
    case 13:
      E(L);
      d = b.memoizedState;
      if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
        if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f2 = false;
        else if (f2 = Gg(b), null !== d && null !== d.dehydrated) {
          if (null === a) {
            if (!f2) throw Error(p(318));
            f2 = b.memoizedState;
            f2 = null !== f2 ? f2.dehydrated : null;
            if (!f2) throw Error(p(317));
            f2[Of] = b;
          } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
          S(b);
          f2 = false;
        } else null !== zg && (Fj(zg), zg = null), f2 = true;
        if (!f2) return b.flags & 65536 ? b : null;
      }
      if (0 !== (b.flags & 128)) return b.lanes = c, b;
      d = null !== d;
      d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
      null !== b.updateQueue && (b.flags |= 4);
      S(b);
      return null;
    case 4:
      return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
    case 10:
      return ah(b.type._context), S(b), null;
    case 17:
      return Zf(b.type) && $f(), S(b), null;
    case 19:
      E(L);
      f2 = b.memoizedState;
      if (null === f2) return S(b), null;
      d = 0 !== (b.flags & 128);
      g = f2.rendering;
      if (null === g) if (d) Dj(f2, false);
      else {
        if (0 !== T || null !== a && 0 !== (a.flags & 128)) for (a = b.child; null !== a; ) {
          g = Ch(a);
          if (null !== g) {
            b.flags |= 128;
            Dj(f2, false);
            d = g.updateQueue;
            null !== d && (b.updateQueue = d, b.flags |= 4);
            b.subtreeFlags = 0;
            d = c;
            for (c = b.child; null !== c; ) f2 = c, a = d, f2.flags &= 14680066, g = f2.alternate, null === g ? (f2.childLanes = 0, f2.lanes = a, f2.child = null, f2.subtreeFlags = 0, f2.memoizedProps = null, f2.memoizedState = null, f2.updateQueue = null, f2.dependencies = null, f2.stateNode = null) : (f2.childLanes = g.childLanes, f2.lanes = g.lanes, f2.child = g.child, f2.subtreeFlags = 0, f2.deletions = null, f2.memoizedProps = g.memoizedProps, f2.memoizedState = g.memoizedState, f2.updateQueue = g.updateQueue, f2.type = g.type, a = g.dependencies, f2.dependencies = null === a ? null : { lanes: a.lanes, firstContext: a.firstContext }), c = c.sibling;
            G(L, L.current & 1 | 2);
            return b.child;
          }
          a = a.sibling;
        }
        null !== f2.tail && B() > Gj && (b.flags |= 128, d = true, Dj(f2, false), b.lanes = 4194304);
      }
      else {
        if (!d) if (a = Ch(g), null !== a) {
          if (b.flags |= 128, d = true, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f2, true), null === f2.tail && "hidden" === f2.tailMode && !g.alternate && !I) return S(b), null;
        } else 2 * B() - f2.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = true, Dj(f2, false), b.lanes = 4194304);
        f2.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f2.last, null !== c ? c.sibling = g : b.child = g, f2.last = g);
      }
      if (null !== f2.tail) return b = f2.tail, f2.rendering = b, f2.tail = b.sibling, f2.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
      S(b);
      return null;
    case 22:
    case 23:
      return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
    case 24:
      return null;
    case 25:
      return null;
  }
  throw Error(p(156, b.tag));
}
function Ij(a, b) {
  wg(b);
  switch (b.tag) {
    case 1:
      return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
    case 3:
      return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
    case 5:
      return Bh(b), null;
    case 13:
      E(L);
      a = b.memoizedState;
      if (null !== a && null !== a.dehydrated) {
        if (null === b.alternate) throw Error(p(340));
        Ig();
      }
      a = b.flags;
      return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
    case 19:
      return E(L), null;
    case 4:
      return zh(), null;
    case 10:
      return ah(b.type._context), null;
    case 22:
    case 23:
      return Hj(), null;
    case 24:
      return null;
    default:
      return null;
  }
}
var Jj = false, U = false, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
  var c = a.ref;
  if (null !== c) if ("function" === typeof c) try {
    c(null);
  } catch (d) {
    W(a, b, d);
  }
  else c.current = null;
}
function Mj(a, b, c) {
  try {
    c();
  } catch (d) {
    W(a, b, d);
  }
}
var Nj = false;
function Oj(a, b) {
  Cf = dd;
  a = Me();
  if (Ne(a)) {
    if ("selectionStart" in a) var c = { start: a.selectionStart, end: a.selectionEnd };
    else a: {
      c = (c = a.ownerDocument) && c.defaultView || window;
      var d = c.getSelection && c.getSelection();
      if (d && 0 !== d.rangeCount) {
        c = d.anchorNode;
        var e = d.anchorOffset, f2 = d.focusNode;
        d = d.focusOffset;
        try {
          c.nodeType, f2.nodeType;
        } catch (F2) {
          c = null;
          break a;
        }
        var g = 0, h = -1, k2 = -1, l2 = 0, m2 = 0, q2 = a, r2 = null;
        b: for (; ; ) {
          for (var y2; ; ) {
            q2 !== c || 0 !== e && 3 !== q2.nodeType || (h = g + e);
            q2 !== f2 || 0 !== d && 3 !== q2.nodeType || (k2 = g + d);
            3 === q2.nodeType && (g += q2.nodeValue.length);
            if (null === (y2 = q2.firstChild)) break;
            r2 = q2;
            q2 = y2;
          }
          for (; ; ) {
            if (q2 === a) break b;
            r2 === c && ++l2 === e && (h = g);
            r2 === f2 && ++m2 === d && (k2 = g);
            if (null !== (y2 = q2.nextSibling)) break;
            q2 = r2;
            r2 = q2.parentNode;
          }
          q2 = y2;
        }
        c = -1 === h || -1 === k2 ? null : { start: h, end: k2 };
      } else c = null;
    }
    c = c || { start: 0, end: 0 };
  } else c = null;
  Df = { focusedElem: a, selectionRange: c };
  dd = false;
  for (V = b; null !== V; ) if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
  else for (; null !== V; ) {
    b = V;
    try {
      var n2 = b.alternate;
      if (0 !== (b.flags & 1024)) switch (b.tag) {
        case 0:
        case 11:
        case 15:
          break;
        case 1:
          if (null !== n2) {
            var t2 = n2.memoizedProps, J2 = n2.memoizedState, x2 = b.stateNode, w2 = x2.getSnapshotBeforeUpdate(b.elementType === b.type ? t2 : Ci(b.type, t2), J2);
            x2.__reactInternalSnapshotBeforeUpdate = w2;
          }
          break;
        case 3:
          var u2 = b.stateNode.containerInfo;
          1 === u2.nodeType ? u2.textContent = "" : 9 === u2.nodeType && u2.documentElement && u2.removeChild(u2.documentElement);
          break;
        case 5:
        case 6:
        case 4:
        case 17:
          break;
        default:
          throw Error(p(163));
      }
    } catch (F2) {
      W(b, b.return, F2);
    }
    a = b.sibling;
    if (null !== a) {
      a.return = b.return;
      V = a;
      break;
    }
    V = b.return;
  }
  n2 = Nj;
  Nj = false;
  return n2;
}
function Pj(a, b, c) {
  var d = b.updateQueue;
  d = null !== d ? d.lastEffect : null;
  if (null !== d) {
    var e = d = d.next;
    do {
      if ((e.tag & a) === a) {
        var f2 = e.destroy;
        e.destroy = void 0;
        void 0 !== f2 && Mj(b, c, f2);
      }
      e = e.next;
    } while (e !== d);
  }
}
function Qj(a, b) {
  b = b.updateQueue;
  b = null !== b ? b.lastEffect : null;
  if (null !== b) {
    var c = b = b.next;
    do {
      if ((c.tag & a) === a) {
        var d = c.create;
        c.destroy = d();
      }
      c = c.next;
    } while (c !== b);
  }
}
function Rj(a) {
  var b = a.ref;
  if (null !== b) {
    var c = a.stateNode;
    switch (a.tag) {
      case 5:
        a = c;
        break;
      default:
        a = c;
    }
    "function" === typeof b ? b(a) : b.current = a;
  }
}
function Sj(a) {
  var b = a.alternate;
  null !== b && (a.alternate = null, Sj(b));
  a.child = null;
  a.deletions = null;
  a.sibling = null;
  5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
  a.stateNode = null;
  a.return = null;
  a.dependencies = null;
  a.memoizedProps = null;
  a.memoizedState = null;
  a.pendingProps = null;
  a.stateNode = null;
  a.updateQueue = null;
}
function Tj(a) {
  return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
  a: for (; ; ) {
    for (; null === a.sibling; ) {
      if (null === a.return || Tj(a.return)) return null;
      a = a.return;
    }
    a.sibling.return = a.return;
    for (a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag; ) {
      if (a.flags & 2) continue a;
      if (null === a.child || 4 === a.tag) continue a;
      else a.child.return = a, a = a.child;
    }
    if (!(a.flags & 2)) return a.stateNode;
  }
}
function Vj(a, b, c) {
  var d = a.tag;
  if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
  else if (4 !== d && (a = a.child, null !== a)) for (Vj(a, b, c), a = a.sibling; null !== a; ) Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
  var d = a.tag;
  if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
  else if (4 !== d && (a = a.child, null !== a)) for (Wj(a, b, c), a = a.sibling; null !== a; ) Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = false;
function Yj(a, b, c) {
  for (c = c.child; null !== c; ) Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
  if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
    lc.onCommitFiberUnmount(kc, c);
  } catch (h) {
  }
  switch (c.tag) {
    case 5:
      U || Lj(c, b);
    case 6:
      var d = X, e = Xj;
      X = null;
      Yj(a, b, c);
      X = d;
      Xj = e;
      null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
      break;
    case 18:
      null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
      break;
    case 4:
      d = X;
      e = Xj;
      X = c.stateNode.containerInfo;
      Xj = true;
      Yj(a, b, c);
      X = d;
      Xj = e;
      break;
    case 0:
    case 11:
    case 14:
    case 15:
      if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
        e = d = d.next;
        do {
          var f2 = e, g = f2.destroy;
          f2 = f2.tag;
          void 0 !== g && (0 !== (f2 & 2) ? Mj(c, b, g) : 0 !== (f2 & 4) && Mj(c, b, g));
          e = e.next;
        } while (e !== d);
      }
      Yj(a, b, c);
      break;
    case 1:
      if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
        d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
      } catch (h) {
        W(c, b, h);
      }
      Yj(a, b, c);
      break;
    case 21:
      Yj(a, b, c);
      break;
    case 22:
      c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
      break;
    default:
      Yj(a, b, c);
  }
}
function ak(a) {
  var b = a.updateQueue;
  if (null !== b) {
    a.updateQueue = null;
    var c = a.stateNode;
    null === c && (c = a.stateNode = new Kj());
    b.forEach(function(b2) {
      var d = bk.bind(null, a, b2);
      c.has(b2) || (c.add(b2), b2.then(d, d));
    });
  }
}
function ck(a, b) {
  var c = b.deletions;
  if (null !== c) for (var d = 0; d < c.length; d++) {
    var e = c[d];
    try {
      var f2 = a, g = b, h = g;
      a: for (; null !== h; ) {
        switch (h.tag) {
          case 5:
            X = h.stateNode;
            Xj = false;
            break a;
          case 3:
            X = h.stateNode.containerInfo;
            Xj = true;
            break a;
          case 4:
            X = h.stateNode.containerInfo;
            Xj = true;
            break a;
        }
        h = h.return;
      }
      if (null === X) throw Error(p(160));
      Zj(f2, g, e);
      X = null;
      Xj = false;
      var k2 = e.alternate;
      null !== k2 && (k2.return = null);
      e.return = null;
    } catch (l2) {
      W(e, b, l2);
    }
  }
  if (b.subtreeFlags & 12854) for (b = b.child; null !== b; ) dk(b, a), b = b.sibling;
}
function dk(a, b) {
  var c = a.alternate, d = a.flags;
  switch (a.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      ck(b, a);
      ek(a);
      if (d & 4) {
        try {
          Pj(3, a, a.return), Qj(3, a);
        } catch (t2) {
          W(a, a.return, t2);
        }
        try {
          Pj(5, a, a.return);
        } catch (t2) {
          W(a, a.return, t2);
        }
      }
      break;
    case 1:
      ck(b, a);
      ek(a);
      d & 512 && null !== c && Lj(c, c.return);
      break;
    case 5:
      ck(b, a);
      ek(a);
      d & 512 && null !== c && Lj(c, c.return);
      if (a.flags & 32) {
        var e = a.stateNode;
        try {
          ob(e, "");
        } catch (t2) {
          W(a, a.return, t2);
        }
      }
      if (d & 4 && (e = a.stateNode, null != e)) {
        var f2 = a.memoizedProps, g = null !== c ? c.memoizedProps : f2, h = a.type, k2 = a.updateQueue;
        a.updateQueue = null;
        if (null !== k2) try {
          "input" === h && "radio" === f2.type && null != f2.name && ab(e, f2);
          vb(h, g);
          var l2 = vb(h, f2);
          for (g = 0; g < k2.length; g += 2) {
            var m2 = k2[g], q2 = k2[g + 1];
            "style" === m2 ? sb(e, q2) : "dangerouslySetInnerHTML" === m2 ? nb(e, q2) : "children" === m2 ? ob(e, q2) : ta(e, m2, q2, l2);
          }
          switch (h) {
            case "input":
              bb(e, f2);
              break;
            case "textarea":
              ib(e, f2);
              break;
            case "select":
              var r2 = e._wrapperState.wasMultiple;
              e._wrapperState.wasMultiple = !!f2.multiple;
              var y2 = f2.value;
              null != y2 ? fb(e, !!f2.multiple, y2, false) : r2 !== !!f2.multiple && (null != f2.defaultValue ? fb(
                e,
                !!f2.multiple,
                f2.defaultValue,
                true
              ) : fb(e, !!f2.multiple, f2.multiple ? [] : "", false));
          }
          e[Pf] = f2;
        } catch (t2) {
          W(a, a.return, t2);
        }
      }
      break;
    case 6:
      ck(b, a);
      ek(a);
      if (d & 4) {
        if (null === a.stateNode) throw Error(p(162));
        e = a.stateNode;
        f2 = a.memoizedProps;
        try {
          e.nodeValue = f2;
        } catch (t2) {
          W(a, a.return, t2);
        }
      }
      break;
    case 3:
      ck(b, a);
      ek(a);
      if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
        bd(b.containerInfo);
      } catch (t2) {
        W(a, a.return, t2);
      }
      break;
    case 4:
      ck(b, a);
      ek(a);
      break;
    case 13:
      ck(b, a);
      ek(a);
      e = a.child;
      e.flags & 8192 && (f2 = null !== e.memoizedState, e.stateNode.isHidden = f2, !f2 || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
      d & 4 && ak(a);
      break;
    case 22:
      m2 = null !== c && null !== c.memoizedState;
      a.mode & 1 ? (U = (l2 = U) || m2, ck(b, a), U = l2) : ck(b, a);
      ek(a);
      if (d & 8192) {
        l2 = null !== a.memoizedState;
        if ((a.stateNode.isHidden = l2) && !m2 && 0 !== (a.mode & 1)) for (V = a, m2 = a.child; null !== m2; ) {
          for (q2 = V = m2; null !== V; ) {
            r2 = V;
            y2 = r2.child;
            switch (r2.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                Pj(4, r2, r2.return);
                break;
              case 1:
                Lj(r2, r2.return);
                var n2 = r2.stateNode;
                if ("function" === typeof n2.componentWillUnmount) {
                  d = r2;
                  c = r2.return;
                  try {
                    b = d, n2.props = b.memoizedProps, n2.state = b.memoizedState, n2.componentWillUnmount();
                  } catch (t2) {
                    W(d, c, t2);
                  }
                }
                break;
              case 5:
                Lj(r2, r2.return);
                break;
              case 22:
                if (null !== r2.memoizedState) {
                  gk(q2);
                  continue;
                }
            }
            null !== y2 ? (y2.return = r2, V = y2) : gk(q2);
          }
          m2 = m2.sibling;
        }
        a: for (m2 = null, q2 = a; ; ) {
          if (5 === q2.tag) {
            if (null === m2) {
              m2 = q2;
              try {
                e = q2.stateNode, l2 ? (f2 = e.style, "function" === typeof f2.setProperty ? f2.setProperty("display", "none", "important") : f2.display = "none") : (h = q2.stateNode, k2 = q2.memoizedProps.style, g = void 0 !== k2 && null !== k2 && k2.hasOwnProperty("display") ? k2.display : null, h.style.display = rb("display", g));
              } catch (t2) {
                W(a, a.return, t2);
              }
            }
          } else if (6 === q2.tag) {
            if (null === m2) try {
              q2.stateNode.nodeValue = l2 ? "" : q2.memoizedProps;
            } catch (t2) {
              W(a, a.return, t2);
            }
          } else if ((22 !== q2.tag && 23 !== q2.tag || null === q2.memoizedState || q2 === a) && null !== q2.child) {
            q2.child.return = q2;
            q2 = q2.child;
            continue;
          }
          if (q2 === a) break a;
          for (; null === q2.sibling; ) {
            if (null === q2.return || q2.return === a) break a;
            m2 === q2 && (m2 = null);
            q2 = q2.return;
          }
          m2 === q2 && (m2 = null);
          q2.sibling.return = q2.return;
          q2 = q2.sibling;
        }
      }
      break;
    case 19:
      ck(b, a);
      ek(a);
      d & 4 && ak(a);
      break;
    case 21:
      break;
    default:
      ck(
        b,
        a
      ), ek(a);
  }
}
function ek(a) {
  var b = a.flags;
  if (b & 2) {
    try {
      a: {
        for (var c = a.return; null !== c; ) {
          if (Tj(c)) {
            var d = c;
            break a;
          }
          c = c.return;
        }
        throw Error(p(160));
      }
      switch (d.tag) {
        case 5:
          var e = d.stateNode;
          d.flags & 32 && (ob(e, ""), d.flags &= -33);
          var f2 = Uj(a);
          Wj(a, f2, e);
          break;
        case 3:
        case 4:
          var g = d.stateNode.containerInfo, h = Uj(a);
          Vj(a, h, g);
          break;
        default:
          throw Error(p(161));
      }
    } catch (k2) {
      W(a, a.return, k2);
    }
    a.flags &= -3;
  }
  b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
  V = a;
  ik(a);
}
function ik(a, b, c) {
  for (var d = 0 !== (a.mode & 1); null !== V; ) {
    var e = V, f2 = e.child;
    if (22 === e.tag && d) {
      var g = null !== e.memoizedState || Jj;
      if (!g) {
        var h = e.alternate, k2 = null !== h && null !== h.memoizedState || U;
        h = Jj;
        var l2 = U;
        Jj = g;
        if ((U = k2) && !l2) for (V = e; null !== V; ) g = V, k2 = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k2 ? (k2.return = g, V = k2) : jk(e);
        for (; null !== f2; ) V = f2, ik(f2), f2 = f2.sibling;
        V = e;
        Jj = h;
        U = l2;
      }
      kk(a);
    } else 0 !== (e.subtreeFlags & 8772) && null !== f2 ? (f2.return = e, V = f2) : kk(a);
  }
}
function kk(a) {
  for (; null !== V; ) {
    var b = V;
    if (0 !== (b.flags & 8772)) {
      var c = b.alternate;
      try {
        if (0 !== (b.flags & 8772)) switch (b.tag) {
          case 0:
          case 11:
          case 15:
            U || Qj(5, b);
            break;
          case 1:
            var d = b.stateNode;
            if (b.flags & 4 && !U) if (null === c) d.componentDidMount();
            else {
              var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
              d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
            }
            var f2 = b.updateQueue;
            null !== f2 && sh(b, f2, d);
            break;
          case 3:
            var g = b.updateQueue;
            if (null !== g) {
              c = null;
              if (null !== b.child) switch (b.child.tag) {
                case 5:
                  c = b.child.stateNode;
                  break;
                case 1:
                  c = b.child.stateNode;
              }
              sh(b, g, c);
            }
            break;
          case 5:
            var h = b.stateNode;
            if (null === c && b.flags & 4) {
              c = h;
              var k2 = b.memoizedProps;
              switch (b.type) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  k2.autoFocus && c.focus();
                  break;
                case "img":
                  k2.src && (c.src = k2.src);
              }
            }
            break;
          case 6:
            break;
          case 4:
            break;
          case 12:
            break;
          case 13:
            if (null === b.memoizedState) {
              var l2 = b.alternate;
              if (null !== l2) {
                var m2 = l2.memoizedState;
                if (null !== m2) {
                  var q2 = m2.dehydrated;
                  null !== q2 && bd(q2);
                }
              }
            }
            break;
          case 19:
          case 17:
          case 21:
          case 22:
          case 23:
          case 25:
            break;
          default:
            throw Error(p(163));
        }
        U || b.flags & 512 && Rj(b);
      } catch (r2) {
        W(b, b.return, r2);
      }
    }
    if (b === a) {
      V = null;
      break;
    }
    c = b.sibling;
    if (null !== c) {
      c.return = b.return;
      V = c;
      break;
    }
    V = b.return;
  }
}
function gk(a) {
  for (; null !== V; ) {
    var b = V;
    if (b === a) {
      V = null;
      break;
    }
    var c = b.sibling;
    if (null !== c) {
      c.return = b.return;
      V = c;
      break;
    }
    V = b.return;
  }
}
function jk(a) {
  for (; null !== V; ) {
    var b = V;
    try {
      switch (b.tag) {
        case 0:
        case 11:
        case 15:
          var c = b.return;
          try {
            Qj(4, b);
          } catch (k2) {
            W(b, c, k2);
          }
          break;
        case 1:
          var d = b.stateNode;
          if ("function" === typeof d.componentDidMount) {
            var e = b.return;
            try {
              d.componentDidMount();
            } catch (k2) {
              W(b, e, k2);
            }
          }
          var f2 = b.return;
          try {
            Rj(b);
          } catch (k2) {
            W(b, f2, k2);
          }
          break;
        case 5:
          var g = b.return;
          try {
            Rj(b);
          } catch (k2) {
            W(b, g, k2);
          }
      }
    } catch (k2) {
      W(b, b.return, k2);
    }
    if (b === a) {
      V = null;
      break;
    }
    var h = b.sibling;
    if (null !== h) {
      h.return = b.return;
      V = h;
      break;
    }
    V = b.return;
  }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = false, Pi = null, Ri = null, vk = false, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
  return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
  if (0 === (a.mode & 1)) return 1;
  if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
  if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
  a = C;
  if (0 !== a) return a;
  a = window.event;
  a = void 0 === a ? 16 : jd(a.type);
  return a;
}
function gi(a, b, c, d) {
  if (50 < yk) throw yk = 0, zk = null, Error(p(185));
  Ac(a, c, d);
  if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
  var c = a.callbackNode;
  wc(a, b);
  var d = uc(a, a === Q ? Z : 0);
  if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
  else if (b = d & -d, a.callbackPriority !== b) {
    null != c && bc(c);
    if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
      0 === (K & 6) && jg();
    }), c = null;
    else {
      switch (Dc(d)) {
        case 1:
          c = fc;
          break;
        case 4:
          c = gc;
          break;
        case 16:
          c = hc;
          break;
        case 536870912:
          c = jc;
          break;
        default:
          c = hc;
      }
      c = Fk(c, Gk.bind(null, a));
    }
    a.callbackPriority = b;
    a.callbackNode = c;
  }
}
function Gk(a, b) {
  Ak = -1;
  Bk = 0;
  if (0 !== (K & 6)) throw Error(p(327));
  var c = a.callbackNode;
  if (Hk() && a.callbackNode !== c) return null;
  var d = uc(a, a === Q ? Z : 0);
  if (0 === d) return null;
  if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
  else {
    b = d;
    var e = K;
    K |= 2;
    var f2 = Jk();
    if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
    do
      try {
        Lk();
        break;
      } catch (h) {
        Mk(a, h);
      }
    while (1);
    $g();
    mk.current = f2;
    K = e;
    null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
  }
  if (0 !== b) {
    2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
    if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
    if (6 === b) Ck(a, d);
    else {
      e = a.current.alternate;
      if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f2 = xc(a), 0 !== f2 && (d = f2, b = Nk(a, f2))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
      a.finishedWork = e;
      a.finishedLanes = d;
      switch (b) {
        case 0:
        case 1:
          throw Error(p(345));
        case 2:
          Pk(a, tk, uk);
          break;
        case 3:
          Ck(a, d);
          if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
            if (0 !== uc(a, 0)) break;
            e = a.suspendedLanes;
            if ((e & d) !== d) {
              R();
              a.pingedLanes |= a.suspendedLanes & e;
              break;
            }
            a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
            break;
          }
          Pk(a, tk, uk);
          break;
        case 4:
          Ck(a, d);
          if ((d & 4194240) === d) break;
          b = a.eventTimes;
          for (e = -1; 0 < d; ) {
            var g = 31 - oc(d);
            f2 = 1 << g;
            g = b[g];
            g > e && (e = g);
            d &= ~f2;
          }
          d = e;
          d = B() - d;
          d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3e3 > d ? 3e3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
          if (10 < d) {
            a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
            break;
          }
          Pk(a, tk, uk);
          break;
        case 5:
          Pk(a, tk, uk);
          break;
        default:
          throw Error(p(329));
      }
    }
  }
  Dk(a, B());
  return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
  var c = sk;
  a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
  a = Ik(a, b);
  2 !== a && (b = tk, tk = c, null !== b && Fj(b));
  return a;
}
function Fj(a) {
  null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
  for (var b = a; ; ) {
    if (b.flags & 16384) {
      var c = b.updateQueue;
      if (null !== c && (c = c.stores, null !== c)) for (var d = 0; d < c.length; d++) {
        var e = c[d], f2 = e.getSnapshot;
        e = e.value;
        try {
          if (!He(f2(), e)) return false;
        } catch (g) {
          return false;
        }
      }
    }
    c = b.child;
    if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
    else {
      if (b === a) break;
      for (; null === b.sibling; ) {
        if (null === b.return || b.return === a) return true;
        b = b.return;
      }
      b.sibling.return = b.return;
      b = b.sibling;
    }
  }
  return true;
}
function Ck(a, b) {
  b &= ~rk;
  b &= ~qk;
  a.suspendedLanes |= b;
  a.pingedLanes &= ~b;
  for (a = a.expirationTimes; 0 < b; ) {
    var c = 31 - oc(b), d = 1 << c;
    a[c] = -1;
    b &= ~d;
  }
}
function Ek(a) {
  if (0 !== (K & 6)) throw Error(p(327));
  Hk();
  var b = uc(a, 0);
  if (0 === (b & 1)) return Dk(a, B()), null;
  var c = Ik(a, b);
  if (0 !== a.tag && 2 === c) {
    var d = xc(a);
    0 !== d && (b = d, c = Nk(a, d));
  }
  if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
  if (6 === c) throw Error(p(345));
  a.finishedWork = a.current.alternate;
  a.finishedLanes = b;
  Pk(a, tk, uk);
  Dk(a, B());
  return null;
}
function Qk(a, b) {
  var c = K;
  K |= 1;
  try {
    return a(b);
  } finally {
    K = c, 0 === K && (Gj = B() + 500, fg && jg());
  }
}
function Rk(a) {
  null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
  var b = K;
  K |= 1;
  var c = ok.transition, d = C;
  try {
    if (ok.transition = null, C = 1, a) return a();
  } finally {
    C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
  }
}
function Hj() {
  fj = ej.current;
  E(ej);
}
function Kk(a, b) {
  a.finishedWork = null;
  a.finishedLanes = 0;
  var c = a.timeoutHandle;
  -1 !== c && (a.timeoutHandle = -1, Gf(c));
  if (null !== Y) for (c = Y.return; null !== c; ) {
    var d = c;
    wg(d);
    switch (d.tag) {
      case 1:
        d = d.type.childContextTypes;
        null !== d && void 0 !== d && $f();
        break;
      case 3:
        zh();
        E(Wf);
        E(H);
        Eh();
        break;
      case 5:
        Bh(d);
        break;
      case 4:
        zh();
        break;
      case 13:
        E(L);
        break;
      case 19:
        E(L);
        break;
      case 10:
        ah(d.type._context);
        break;
      case 22:
      case 23:
        Hj();
    }
    c = c.return;
  }
  Q = a;
  Y = a = Pg(a.current, null);
  Z = fj = b;
  T = 0;
  pk = null;
  rk = qk = rh = 0;
  tk = sk = null;
  if (null !== fh) {
    for (b = 0; b < fh.length; b++) if (c = fh[b], d = c.interleaved, null !== d) {
      c.interleaved = null;
      var e = d.next, f2 = c.pending;
      if (null !== f2) {
        var g = f2.next;
        f2.next = e;
        d.next = g;
      }
      c.pending = d;
    }
    fh = null;
  }
  return a;
}
function Mk(a, b) {
  do {
    var c = Y;
    try {
      $g();
      Fh.current = Rh;
      if (Ih) {
        for (var d = M.memoizedState; null !== d; ) {
          var e = d.queue;
          null !== e && (e.pending = null);
          d = d.next;
        }
        Ih = false;
      }
      Hh = 0;
      O = N = M = null;
      Jh = false;
      Kh = 0;
      nk.current = null;
      if (null === c || null === c.return) {
        T = 1;
        pk = b;
        Y = null;
        break;
      }
      a: {
        var f2 = a, g = c.return, h = c, k2 = b;
        b = Z;
        h.flags |= 32768;
        if (null !== k2 && "object" === typeof k2 && "function" === typeof k2.then) {
          var l2 = k2, m2 = h, q2 = m2.tag;
          if (0 === (m2.mode & 1) && (0 === q2 || 11 === q2 || 15 === q2)) {
            var r2 = m2.alternate;
            r2 ? (m2.updateQueue = r2.updateQueue, m2.memoizedState = r2.memoizedState, m2.lanes = r2.lanes) : (m2.updateQueue = null, m2.memoizedState = null);
          }
          var y2 = Ui(g);
          if (null !== y2) {
            y2.flags &= -257;
            Vi(y2, g, h, f2, b);
            y2.mode & 1 && Si(f2, l2, b);
            b = y2;
            k2 = l2;
            var n2 = b.updateQueue;
            if (null === n2) {
              var t2 = /* @__PURE__ */ new Set();
              t2.add(k2);
              b.updateQueue = t2;
            } else n2.add(k2);
            break a;
          } else {
            if (0 === (b & 1)) {
              Si(f2, l2, b);
              tj();
              break a;
            }
            k2 = Error(p(426));
          }
        } else if (I && h.mode & 1) {
          var J2 = Ui(g);
          if (null !== J2) {
            0 === (J2.flags & 65536) && (J2.flags |= 256);
            Vi(J2, g, h, f2, b);
            Jg(Ji(k2, h));
            break a;
          }
        }
        f2 = k2 = Ji(k2, h);
        4 !== T && (T = 2);
        null === sk ? sk = [f2] : sk.push(f2);
        f2 = g;
        do {
          switch (f2.tag) {
            case 3:
              f2.flags |= 65536;
              b &= -b;
              f2.lanes |= b;
              var x2 = Ni(f2, k2, b);
              ph(f2, x2);
              break a;
            case 1:
              h = k2;
              var w2 = f2.type, u2 = f2.stateNode;
              if (0 === (f2.flags & 128) && ("function" === typeof w2.getDerivedStateFromError || null !== u2 && "function" === typeof u2.componentDidCatch && (null === Ri || !Ri.has(u2)))) {
                f2.flags |= 65536;
                b &= -b;
                f2.lanes |= b;
                var F2 = Qi(f2, h, b);
                ph(f2, F2);
                break a;
              }
          }
          f2 = f2.return;
        } while (null !== f2);
      }
      Sk(c);
    } catch (na) {
      b = na;
      Y === c && null !== c && (Y = c = c.return);
      continue;
    }
    break;
  } while (1);
}
function Jk() {
  var a = mk.current;
  mk.current = Rh;
  return null === a ? Rh : a;
}
function tj() {
  if (0 === T || 3 === T || 2 === T) T = 4;
  null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
  var c = K;
  K |= 2;
  var d = Jk();
  if (Q !== a || Z !== b) uk = null, Kk(a, b);
  do
    try {
      Tk();
      break;
    } catch (e) {
      Mk(a, e);
    }
  while (1);
  $g();
  K = c;
  mk.current = d;
  if (null !== Y) throw Error(p(261));
  Q = null;
  Z = 0;
  return T;
}
function Tk() {
  for (; null !== Y; ) Uk(Y);
}
function Lk() {
  for (; null !== Y && !cc(); ) Uk(Y);
}
function Uk(a) {
  var b = Vk(a.alternate, a, fj);
  a.memoizedProps = a.pendingProps;
  null === b ? Sk(a) : Y = b;
  nk.current = null;
}
function Sk(a) {
  var b = a;
  do {
    var c = b.alternate;
    a = b.return;
    if (0 === (b.flags & 32768)) {
      if (c = Ej(c, b, fj), null !== c) {
        Y = c;
        return;
      }
    } else {
      c = Ij(c, b);
      if (null !== c) {
        c.flags &= 32767;
        Y = c;
        return;
      }
      if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
      else {
        T = 6;
        Y = null;
        return;
      }
    }
    b = b.sibling;
    if (null !== b) {
      Y = b;
      return;
    }
    Y = b = a;
  } while (null !== b);
  0 === T && (T = 5);
}
function Pk(a, b, c) {
  var d = C, e = ok.transition;
  try {
    ok.transition = null, C = 1, Wk(a, b, c, d);
  } finally {
    ok.transition = e, C = d;
  }
  return null;
}
function Wk(a, b, c, d) {
  do
    Hk();
  while (null !== wk);
  if (0 !== (K & 6)) throw Error(p(327));
  c = a.finishedWork;
  var e = a.finishedLanes;
  if (null === c) return null;
  a.finishedWork = null;
  a.finishedLanes = 0;
  if (c === a.current) throw Error(p(177));
  a.callbackNode = null;
  a.callbackPriority = 0;
  var f2 = c.lanes | c.childLanes;
  Bc(a, f2);
  a === Q && (Y = Q = null, Z = 0);
  0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = true, Fk(hc, function() {
    Hk();
    return null;
  }));
  f2 = 0 !== (c.flags & 15990);
  if (0 !== (c.subtreeFlags & 15990) || f2) {
    f2 = ok.transition;
    ok.transition = null;
    var g = C;
    C = 1;
    var h = K;
    K |= 4;
    nk.current = null;
    Oj(a, c);
    dk(c, a);
    Oe(Df);
    dd = !!Cf;
    Df = Cf = null;
    a.current = c;
    hk(c);
    dc();
    K = h;
    C = g;
    ok.transition = f2;
  } else a.current = c;
  vk && (vk = false, wk = a, xk = e);
  f2 = a.pendingLanes;
  0 === f2 && (Ri = null);
  mc(c.stateNode);
  Dk(a, B());
  if (null !== b) for (d = a.onRecoverableError, c = 0; c < b.length; c++) e = b[c], d(e.value, { componentStack: e.stack, digest: e.digest });
  if (Oi) throw Oi = false, a = Pi, Pi = null, a;
  0 !== (xk & 1) && 0 !== a.tag && Hk();
  f2 = a.pendingLanes;
  0 !== (f2 & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
  jg();
  return null;
}
function Hk() {
  if (null !== wk) {
    var a = Dc(xk), b = ok.transition, c = C;
    try {
      ok.transition = null;
      C = 16 > a ? 16 : a;
      if (null === wk) var d = false;
      else {
        a = wk;
        wk = null;
        xk = 0;
        if (0 !== (K & 6)) throw Error(p(331));
        var e = K;
        K |= 4;
        for (V = a.current; null !== V; ) {
          var f2 = V, g = f2.child;
          if (0 !== (V.flags & 16)) {
            var h = f2.deletions;
            if (null !== h) {
              for (var k2 = 0; k2 < h.length; k2++) {
                var l2 = h[k2];
                for (V = l2; null !== V; ) {
                  var m2 = V;
                  switch (m2.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Pj(8, m2, f2);
                  }
                  var q2 = m2.child;
                  if (null !== q2) q2.return = m2, V = q2;
                  else for (; null !== V; ) {
                    m2 = V;
                    var r2 = m2.sibling, y2 = m2.return;
                    Sj(m2);
                    if (m2 === l2) {
                      V = null;
                      break;
                    }
                    if (null !== r2) {
                      r2.return = y2;
                      V = r2;
                      break;
                    }
                    V = y2;
                  }
                }
              }
              var n2 = f2.alternate;
              if (null !== n2) {
                var t2 = n2.child;
                if (null !== t2) {
                  n2.child = null;
                  do {
                    var J2 = t2.sibling;
                    t2.sibling = null;
                    t2 = J2;
                  } while (null !== t2);
                }
              }
              V = f2;
            }
          }
          if (0 !== (f2.subtreeFlags & 2064) && null !== g) g.return = f2, V = g;
          else b: for (; null !== V; ) {
            f2 = V;
            if (0 !== (f2.flags & 2048)) switch (f2.tag) {
              case 0:
              case 11:
              case 15:
                Pj(9, f2, f2.return);
            }
            var x2 = f2.sibling;
            if (null !== x2) {
              x2.return = f2.return;
              V = x2;
              break b;
            }
            V = f2.return;
          }
        }
        var w2 = a.current;
        for (V = w2; null !== V; ) {
          g = V;
          var u2 = g.child;
          if (0 !== (g.subtreeFlags & 2064) && null !== u2) u2.return = g, V = u2;
          else b: for (g = w2; null !== V; ) {
            h = V;
            if (0 !== (h.flags & 2048)) try {
              switch (h.tag) {
                case 0:
                case 11:
                case 15:
                  Qj(9, h);
              }
            } catch (na) {
              W(h, h.return, na);
            }
            if (h === g) {
              V = null;
              break b;
            }
            var F2 = h.sibling;
            if (null !== F2) {
              F2.return = h.return;
              V = F2;
              break b;
            }
            V = h.return;
          }
        }
        K = e;
        jg();
        if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
          lc.onPostCommitFiberRoot(kc, a);
        } catch (na) {
        }
        d = true;
      }
      return d;
    } finally {
      C = c, ok.transition = b;
    }
  }
  return false;
}
function Xk(a, b, c) {
  b = Ji(c, b);
  b = Ni(a, b, 1);
  a = nh(a, b, 1);
  b = R();
  null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
  if (3 === a.tag) Xk(a, a, c);
  else for (; null !== b; ) {
    if (3 === b.tag) {
      Xk(b, a, c);
      break;
    } else if (1 === b.tag) {
      var d = b.stateNode;
      if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
        a = Ji(c, a);
        a = Qi(b, a, 1);
        b = nh(b, a, 1);
        a = R();
        null !== b && (Ac(b, 1, a), Dk(b, a));
        break;
      }
    }
    b = b.return;
  }
}
function Ti(a, b, c) {
  var d = a.pingCache;
  null !== d && d.delete(b);
  b = R();
  a.pingedLanes |= a.suspendedLanes & c;
  Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
  Dk(a, b);
}
function Yk(a, b) {
  0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
  var c = R();
  a = ih(a, b);
  null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
  var b = a.memoizedState, c = 0;
  null !== b && (c = b.retryLane);
  Yk(a, c);
}
function bk(a, b) {
  var c = 0;
  switch (a.tag) {
    case 13:
      var d = a.stateNode;
      var e = a.memoizedState;
      null !== e && (c = e.retryLane);
      break;
    case 19:
      d = a.stateNode;
      break;
    default:
      throw Error(p(314));
  }
  null !== d && d.delete(b);
  Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
  if (null !== a) if (a.memoizedProps !== b.pendingProps || Wf.current) dh = true;
  else {
    if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = false, yj(a, b, c);
    dh = 0 !== (a.flags & 131072) ? true : false;
  }
  else dh = false, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
  b.lanes = 0;
  switch (b.tag) {
    case 2:
      var d = b.type;
      ij(a, b);
      a = b.pendingProps;
      var e = Yf(b, H.current);
      ch(b, c);
      e = Nh(null, b, d, a, e, c);
      var f2 = Sh();
      b.flags |= 1;
      "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f2 = true, cg(b)) : f2 = false, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, true, f2, c)) : (b.tag = 0, I && f2 && vg(b), Xi(null, b, e, c), b = b.child);
      return b;
    case 16:
      d = b.elementType;
      a: {
        ij(a, b);
        a = b.pendingProps;
        e = d._init;
        d = e(d._payload);
        b.type = d;
        e = b.tag = Zk(d);
        a = Ci(d, a);
        switch (e) {
          case 0:
            b = cj(null, b, d, a, c);
            break a;
          case 1:
            b = hj(null, b, d, a, c);
            break a;
          case 11:
            b = Yi(null, b, d, a, c);
            break a;
          case 14:
            b = $i(null, b, d, Ci(d.type, a), c);
            break a;
        }
        throw Error(p(
          306,
          d,
          ""
        ));
      }
      return b;
    case 0:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
    case 1:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
    case 3:
      a: {
        kj(b);
        if (null === a) throw Error(p(387));
        d = b.pendingProps;
        f2 = b.memoizedState;
        e = f2.element;
        lh(a, b);
        qh(b, d, null, c);
        var g = b.memoizedState;
        d = g.element;
        if (f2.isDehydrated) if (f2 = { element: d, isDehydrated: false, cache: g.cache, pendingSuspenseBoundaries: g.pendingSuspenseBoundaries, transitions: g.transitions }, b.updateQueue.baseState = f2, b.memoizedState = f2, b.flags & 256) {
          e = Ji(Error(p(423)), b);
          b = lj(a, b, d, c, e);
          break a;
        } else if (d !== e) {
          e = Ji(Error(p(424)), b);
          b = lj(a, b, d, c, e);
          break a;
        } else for (yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = true, zg = null, c = Vg(b, null, d, c), b.child = c; c; ) c.flags = c.flags & -3 | 4096, c = c.sibling;
        else {
          Ig();
          if (d === e) {
            b = Zi(a, b, c);
            break a;
          }
          Xi(a, b, d, c);
        }
        b = b.child;
      }
      return b;
    case 5:
      return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f2 = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f2 && Ef(d, f2) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
    case 6:
      return null === a && Eg(b), null;
    case 13:
      return oj(a, b, c);
    case 4:
      return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
    case 11:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
    case 7:
      return Xi(a, b, b.pendingProps, c), b.child;
    case 8:
      return Xi(a, b, b.pendingProps.children, c), b.child;
    case 12:
      return Xi(a, b, b.pendingProps.children, c), b.child;
    case 10:
      a: {
        d = b.type._context;
        e = b.pendingProps;
        f2 = b.memoizedProps;
        g = e.value;
        G(Wg, d._currentValue);
        d._currentValue = g;
        if (null !== f2) if (He(f2.value, g)) {
          if (f2.children === e.children && !Wf.current) {
            b = Zi(a, b, c);
            break a;
          }
        } else for (f2 = b.child, null !== f2 && (f2.return = b); null !== f2; ) {
          var h = f2.dependencies;
          if (null !== h) {
            g = f2.child;
            for (var k2 = h.firstContext; null !== k2; ) {
              if (k2.context === d) {
                if (1 === f2.tag) {
                  k2 = mh(-1, c & -c);
                  k2.tag = 2;
                  var l2 = f2.updateQueue;
                  if (null !== l2) {
                    l2 = l2.shared;
                    var m2 = l2.pending;
                    null === m2 ? k2.next = k2 : (k2.next = m2.next, m2.next = k2);
                    l2.pending = k2;
                  }
                }
                f2.lanes |= c;
                k2 = f2.alternate;
                null !== k2 && (k2.lanes |= c);
                bh(
                  f2.return,
                  c,
                  b
                );
                h.lanes |= c;
                break;
              }
              k2 = k2.next;
            }
          } else if (10 === f2.tag) g = f2.type === b.type ? null : f2.child;
          else if (18 === f2.tag) {
            g = f2.return;
            if (null === g) throw Error(p(341));
            g.lanes |= c;
            h = g.alternate;
            null !== h && (h.lanes |= c);
            bh(g, c, b);
            g = f2.sibling;
          } else g = f2.child;
          if (null !== g) g.return = f2;
          else for (g = f2; null !== g; ) {
            if (g === b) {
              g = null;
              break;
            }
            f2 = g.sibling;
            if (null !== f2) {
              f2.return = g.return;
              g = f2;
              break;
            }
            g = g.return;
          }
          f2 = g;
        }
        Xi(a, b, e.children, c);
        b = b.child;
      }
      return b;
    case 9:
      return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
    case 14:
      return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
    case 15:
      return bj(a, b, b.type, b.pendingProps, c);
    case 17:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = true, cg(b)) : a = false, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, true, a, c);
    case 19:
      return xj(a, b, c);
    case 22:
      return dj(a, b, c);
  }
  throw Error(p(156, b.tag));
};
function Fk(a, b) {
  return ac(a, b);
}
function $k(a, b, c, d) {
  this.tag = a;
  this.key = c;
  this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
  this.index = 0;
  this.ref = null;
  this.pendingProps = b;
  this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
  this.mode = d;
  this.subtreeFlags = this.flags = 0;
  this.deletions = null;
  this.childLanes = this.lanes = 0;
  this.alternate = null;
}
function Bg(a, b, c, d) {
  return new $k(a, b, c, d);
}
function aj(a) {
  a = a.prototype;
  return !(!a || !a.isReactComponent);
}
function Zk(a) {
  if ("function" === typeof a) return aj(a) ? 1 : 0;
  if (void 0 !== a && null !== a) {
    a = a.$$typeof;
    if (a === Da) return 11;
    if (a === Ga) return 14;
  }
  return 2;
}
function Pg(a, b) {
  var c = a.alternate;
  null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
  c.flags = a.flags & 14680064;
  c.childLanes = a.childLanes;
  c.lanes = a.lanes;
  c.child = a.child;
  c.memoizedProps = a.memoizedProps;
  c.memoizedState = a.memoizedState;
  c.updateQueue = a.updateQueue;
  b = a.dependencies;
  c.dependencies = null === b ? null : { lanes: b.lanes, firstContext: b.firstContext };
  c.sibling = a.sibling;
  c.index = a.index;
  c.ref = a.ref;
  return c;
}
function Rg(a, b, c, d, e, f2) {
  var g = 2;
  d = a;
  if ("function" === typeof a) aj(a) && (g = 1);
  else if ("string" === typeof a) g = 5;
  else a: switch (a) {
    case ya:
      return Tg(c.children, e, f2, b);
    case za:
      g = 8;
      e |= 8;
      break;
    case Aa:
      return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f2, a;
    case Ea:
      return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f2, a;
    case Fa:
      return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f2, a;
    case Ia:
      return pj(c, e, f2, b);
    default:
      if ("object" === typeof a && null !== a) switch (a.$$typeof) {
        case Ba:
          g = 10;
          break a;
        case Ca:
          g = 9;
          break a;
        case Da:
          g = 11;
          break a;
        case Ga:
          g = 14;
          break a;
        case Ha:
          g = 16;
          d = null;
          break a;
      }
      throw Error(p(130, null == a ? a : typeof a, ""));
  }
  b = Bg(g, c, b, e);
  b.elementType = a;
  b.type = d;
  b.lanes = f2;
  return b;
}
function Tg(a, b, c, d) {
  a = Bg(7, a, d, b);
  a.lanes = c;
  return a;
}
function pj(a, b, c, d) {
  a = Bg(22, a, d, b);
  a.elementType = Ia;
  a.lanes = c;
  a.stateNode = { isHidden: false };
  return a;
}
function Qg(a, b, c) {
  a = Bg(6, a, null, b);
  a.lanes = c;
  return a;
}
function Sg(a, b, c) {
  b = Bg(4, null !== a.children ? a.children : [], a.key, b);
  b.lanes = c;
  b.stateNode = { containerInfo: a.containerInfo, pendingChildren: null, implementation: a.implementation };
  return b;
}
function al(a, b, c, d, e) {
  this.tag = b;
  this.containerInfo = a;
  this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
  this.timeoutHandle = -1;
  this.callbackNode = this.pendingContext = this.context = null;
  this.callbackPriority = 0;
  this.eventTimes = zc(0);
  this.expirationTimes = zc(-1);
  this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
  this.entanglements = zc(0);
  this.identifierPrefix = d;
  this.onRecoverableError = e;
  this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f2, g, h, k2) {
  a = new al(a, b, c, h, k2);
  1 === b ? (b = 1, true === f2 && (b |= 8)) : b = 0;
  f2 = Bg(3, null, null, b);
  a.current = f2;
  f2.stateNode = a;
  f2.memoizedState = { element: d, isDehydrated: c, cache: null, transitions: null, pendingSuspenseBoundaries: null };
  kh(f2);
  return a;
}
function cl(a, b, c) {
  var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
  return { $$typeof: wa, key: null == d ? null : "" + d, children: a, containerInfo: b, implementation: c };
}
function dl(a) {
  if (!a) return Vf;
  a = a._reactInternals;
  a: {
    if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
    var b = a;
    do {
      switch (b.tag) {
        case 3:
          b = b.stateNode.context;
          break a;
        case 1:
          if (Zf(b.type)) {
            b = b.stateNode.__reactInternalMemoizedMergedChildContext;
            break a;
          }
      }
      b = b.return;
    } while (null !== b);
    throw Error(p(171));
  }
  if (1 === a.tag) {
    var c = a.type;
    if (Zf(c)) return bg(a, c, b);
  }
  return b;
}
function el(a, b, c, d, e, f2, g, h, k2) {
  a = bl(c, d, true, a, e, f2, g, h, k2);
  a.context = dl(null);
  c = a.current;
  d = R();
  e = yi(c);
  f2 = mh(d, e);
  f2.callback = void 0 !== b && null !== b ? b : null;
  nh(c, f2, e);
  a.current.lanes = e;
  Ac(a, e, d);
  Dk(a, d);
  return a;
}
function fl(a, b, c, d) {
  var e = b.current, f2 = R(), g = yi(e);
  c = dl(c);
  null === b.context ? b.context = c : b.pendingContext = c;
  b = mh(f2, g);
  b.payload = { element: a };
  d = void 0 === d ? null : d;
  null !== d && (b.callback = d);
  a = nh(e, b, g);
  null !== a && (gi(a, e, g, f2), oh(a, e, g));
  return g;
}
function gl(a) {
  a = a.current;
  if (!a.child) return null;
  switch (a.child.tag) {
    case 5:
      return a.child.stateNode;
    default:
      return a.child.stateNode;
  }
}
function hl(a, b) {
  a = a.memoizedState;
  if (null !== a && null !== a.dehydrated) {
    var c = a.retryLane;
    a.retryLane = 0 !== c && c < b ? c : b;
  }
}
function il(a, b) {
  hl(a, b);
  (a = a.alternate) && hl(a, b);
}
function jl() {
  return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
  console.error(a);
};
function ll(a) {
  this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
  var b = this._internalRoot;
  if (null === b) throw Error(p(409));
  fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
  var a = this._internalRoot;
  if (null !== a) {
    this._internalRoot = null;
    var b = a.containerInfo;
    Rk(function() {
      fl(null, a, null, null);
    });
    b[uf] = null;
  }
};
function ml(a) {
  this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
  if (a) {
    var b = Hc();
    a = { blockedOn: null, target: a, priority: b };
    for (var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++) ;
    Qc.splice(c, 0, a);
    0 === c && Vc(a);
  }
};
function nl(a) {
  return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
  return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {
}
function ql(a, b, c, d, e) {
  if (e) {
    if ("function" === typeof d) {
      var f2 = d;
      d = function() {
        var a2 = gl(g);
        f2.call(a2);
      };
    }
    var g = el(b, d, a, 0, null, false, false, "", pl);
    a._reactRootContainer = g;
    a[uf] = g.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk();
    return g;
  }
  for (; e = a.lastChild; ) a.removeChild(e);
  if ("function" === typeof d) {
    var h = d;
    d = function() {
      var a2 = gl(k2);
      h.call(a2);
    };
  }
  var k2 = bl(a, 0, false, null, null, false, false, "", pl);
  a._reactRootContainer = k2;
  a[uf] = k2.current;
  sf(8 === a.nodeType ? a.parentNode : a);
  Rk(function() {
    fl(b, k2, c, d);
  });
  return k2;
}
function rl(a, b, c, d, e) {
  var f2 = c._reactRootContainer;
  if (f2) {
    var g = f2;
    if ("function" === typeof e) {
      var h = e;
      e = function() {
        var a2 = gl(g);
        h.call(a2);
      };
    }
    fl(b, g, a, e);
  } else g = ql(c, b, a, e, d);
  return gl(g);
}
Ec = function(a) {
  switch (a.tag) {
    case 3:
      var b = a.stateNode;
      if (b.current.memoizedState.isDehydrated) {
        var c = tc(b.pendingLanes);
        0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
      }
      break;
    case 13:
      Rk(function() {
        var b2 = ih(a, 1);
        if (null !== b2) {
          var c2 = R();
          gi(b2, a, 1, c2);
        }
      }), il(a, 1);
  }
};
Fc = function(a) {
  if (13 === a.tag) {
    var b = ih(a, 134217728);
    if (null !== b) {
      var c = R();
      gi(b, a, 134217728, c);
    }
    il(a, 134217728);
  }
};
Gc = function(a) {
  if (13 === a.tag) {
    var b = yi(a), c = ih(a, b);
    if (null !== c) {
      var d = R();
      gi(c, a, b, d);
    }
    il(a, b);
  }
};
Hc = function() {
  return C;
};
Ic = function(a, b) {
  var c = C;
  try {
    return C = a, b();
  } finally {
    C = c;
  }
};
yb = function(a, b, c) {
  switch (b) {
    case "input":
      bb(a, c);
      b = c.name;
      if ("radio" === c.type && null != b) {
        for (c = a; c.parentNode; ) c = c.parentNode;
        c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
        for (b = 0; b < c.length; b++) {
          var d = c[b];
          if (d !== a && d.form === a.form) {
            var e = Db(d);
            if (!e) throw Error(p(90));
            Wa(d);
            bb(d, e);
          }
        }
      }
      break;
    case "textarea":
      ib(a, c);
      break;
    case "select":
      b = c.value, null != b && fb(a, !!c.multiple, b, false);
  }
};
Gb = Qk;
Hb = Rk;
var sl = { usingClientEntryPoint: false, Events: [Cb, ue, Db, Eb, Fb, Qk] }, tl = { findFiberByHostInstance: Wc, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" };
var ul = { bundleType: tl.bundleType, version: tl.version, rendererPackageName: tl.rendererPackageName, rendererConfig: tl.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: ua.ReactCurrentDispatcher, findHostInstanceByFiber: function(a) {
  a = Zb(a);
  return null === a ? null : a.stateNode;
}, findFiberByHostInstance: tl.findFiberByHostInstance || jl, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
  var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!vl.isDisabled && vl.supportsFiber) try {
    kc = vl.inject(ul), lc = vl;
  } catch (a) {
  }
}
reactDom_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
reactDom_production_min.createPortal = function(a, b) {
  var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
  if (!nl(b)) throw Error(p(200));
  return cl(a, b, null, c);
};
reactDom_production_min.createRoot = function(a, b) {
  if (!nl(a)) throw Error(p(299));
  var c = false, d = "", e = kl;
  null !== b && void 0 !== b && (true === b.unstable_strictMode && (c = true), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
  b = bl(a, 1, false, null, null, c, false, d, e);
  a[uf] = b.current;
  sf(8 === a.nodeType ? a.parentNode : a);
  return new ll(b);
};
reactDom_production_min.findDOMNode = function(a) {
  if (null == a) return null;
  if (1 === a.nodeType) return a;
  var b = a._reactInternals;
  if (void 0 === b) {
    if ("function" === typeof a.render) throw Error(p(188));
    a = Object.keys(a).join(",");
    throw Error(p(268, a));
  }
  a = Zb(b);
  a = null === a ? null : a.stateNode;
  return a;
};
reactDom_production_min.flushSync = function(a) {
  return Rk(a);
};
reactDom_production_min.hydrate = function(a, b, c) {
  if (!ol(b)) throw Error(p(200));
  return rl(null, a, b, true, c);
};
reactDom_production_min.hydrateRoot = function(a, b, c) {
  if (!nl(a)) throw Error(p(405));
  var d = null != c && c.hydratedSources || null, e = false, f2 = "", g = kl;
  null !== c && void 0 !== c && (true === c.unstable_strictMode && (e = true), void 0 !== c.identifierPrefix && (f2 = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
  b = el(b, null, a, 1, null != c ? c : null, e, false, f2, g);
  a[uf] = b.current;
  sf(a);
  if (d) for (a = 0; a < d.length; a++) c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [c, e] : b.mutableSourceEagerHydrationData.push(
    c,
    e
  );
  return new ml(b);
};
reactDom_production_min.render = function(a, b, c) {
  if (!ol(b)) throw Error(p(200));
  return rl(null, a, b, false, c);
};
reactDom_production_min.unmountComponentAtNode = function(a) {
  if (!ol(a)) throw Error(p(40));
  return a._reactRootContainer ? (Rk(function() {
    rl(null, null, a, false, function() {
      a._reactRootContainer = null;
      a[uf] = null;
    });
  }), true) : false;
};
reactDom_production_min.unstable_batchedUpdates = Qk;
reactDom_production_min.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
  if (!ol(c)) throw Error(p(200));
  if (null == a || void 0 === a._reactInternals) throw Error(p(38));
  return rl(a, b, c, false, d);
};
reactDom_production_min.version = "18.3.1-next-f1338f8080-20240426";
function checkDCE() {
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") {
    return;
  }
  try {
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    console.error(err);
  }
}
{
  checkDCE();
  reactDom.exports = reactDom_production_min;
}
var reactDomExports = reactDom.exports;
var m = reactDomExports;
{
  client.createRoot = m.createRoot;
  client.hydrateRoot = m.hydrateRoot;
}
const skinConcerns = [
  {
    label: "Fine Lines & Wrinkles",
    shortLabel: "fine lines",
    type: "text",
    name: "wrinkles"
  },
  {
    label: "Hyperpigmentation & Dark Spots",
    shortLabel: "dark spots",
    type: "text",
    name: "dark_spots"
  },
  {
    label: "Dryness & Tightness",
    shortLabel: "dryness",
    type: "text",
    name: "dryness"
  },
  {
    label: "Redness & Irritation",
    shortLabel: "redness",
    type: "text",
    name: "redness"
  },
  {
    label: "Acne & Blemishes",
    shortLabel: "breakouts",
    type: "text",
    name: "acne"
  },
  {
    label: "Uneven Texture",
    shortLabel: "uneven texture",
    type: "text",
    name: "uneven_texture"
  },
  {
    label: "Oil Control & Pores",
    shortLabel: "oil & pores",
    type: "text",
    name: "oil_control"
  }
];
const PRODUCT_MAPPING_DEV = {
  "glow_maker": {
    "product_id": 9166118715694,
    "variant_id": null,
    "title": "Glow Maker",
    "quantity": 1
  },
  "moonlight": {
    "product_id": 9166119043374,
    "variant_id": null,
    "title": "Moonlight",
    "quantity": 1
  },
  "peptide_squad": {
    "product_id": 9166119600430,
    "variant_id": null,
    "title": "Peptide Squad",
    "quantity": 1
  },
  "night_renewer": {
    "product_id": 9166118519086,
    "variant_id": null,
    "title": "Night Renewer",
    "quantity": 1
  },
  "hydro_relief": {
    "product_id": 9166119731502,
    "variant_id": null,
    "title": "Hydro Relief",
    "quantity": 1
  },
  "hydrator": {
    "product_id": 9166118945070,
    "variant_id": null,
    "title": "Hydrator",
    "quantity": 1
  },
  "fade_away": {
    "product_id": 9166119567662,
    "variant_id": null,
    "title": "Fade Away",
    "quantity": 1
  },
  "nia_10": {
    "product_id": 9166118846766,
    "variant_id": null,
    "title": "NIA 10",
    "quantity": 1
  },
  "exfoliator": {
    "product_id": 9166118977838,
    "variant_id": null,
    "title": "Exfoliator",
    "quantity": 1
  },
  "sheer_silk": {
    "product_id": 9166119502126,
    "variant_id": null,
    "title": "Sheer Silk",
    "quantity": 1
  },
  "love_31": {
    "product_id": 9166118650158,
    "variant_id": null,
    "title": "Love 31",
    "quantity": 1
  },
  "super_smooth": {
    "product_id": 9166119338286,
    "variant_id": null,
    "title": "Super Smooth",
    "quantity": 1
  },
  "refresher": {
    "product_id": 9166118584622,
    "variant_id": null,
    "title": "Refresher",
    "quantity": 1
  },
  "plush_cream": {
    "product_id": 9166119371054,
    "variant_id": null,
    "title": "Plush Cream",
    "quantity": 1
  },
  "additional_eye_enhancer": {
    "product_id": 1584059023394,
    "variant_id": null,
    "title": "Eye Enhancer",
    "quantity": 1
  },
  // Added for the neck answer on the eye/neck question. Like the eye enhancer
  // above, this carries the production id — the dev store's id is unknown.
  "forever_firm": {
    "product_id": 8219113029827,
    "variant_id": null,
    "title": "Forever Firm",
    "quantity": 1
  }
};
const PRODUCT_MAPPING_PROD = {
  "glow_maker": {
    "product_id": 20097630225,
    "variant_id": null,
    "title": "Glow Maker",
    "quantity": 1
  },
  "moonlight": {
    "product_id": 5964432867523,
    "variant_id": null,
    "title": "Moonlight",
    "quantity": 1
  },
  "peptide_squad": {
    "product_id": 7644265578691,
    "variant_id": null,
    "title": "Peptide Squad",
    "quantity": 1
  },
  "night_renewer": {
    "product_id": 20098744337,
    "variant_id": null,
    "title": "Night Renewer",
    "quantity": 1
  },
  "hydro_relief": {
    "product_id": 7702866428099,
    "variant_id": null,
    "title": "Hydro Relief",
    "quantity": 1
  },
  "hydrator": {
    "product_id": 3813924208674,
    "variant_id": null,
    "title": "Hydrator",
    "quantity": 1
  },
  "fade_away": {
    "product_id": 7275481858243,
    "variant_id": null,
    "title": "Fade Away",
    "quantity": 1
  },
  "nia_10": {
    "product_id": 3752973303842,
    "variant_id": null,
    "title": "NIA 10",
    "quantity": 1
  },
  "exfoliator": {
    "product_id": 3825700831266,
    "variant_id": null,
    "title": "Exfoliator",
    "quantity": 1
  },
  "sheer_silk": {
    "product_id": 7116688130243,
    "variant_id": null,
    "title": "Sheer Silk",
    "quantity": 1
  },
  "love_31": {
    "product_id": 3781176852514,
    "variant_id": null,
    "title": "Love 31",
    "quantity": 1
  },
  "super_smooth": {
    "product_id": 6234008355011,
    "variant_id": null,
    "title": "Super Smooth",
    "quantity": 1
  },
  "refresher": {
    "product_id": 1666765127714,
    "variant_id": null,
    "title": "Refresher",
    "quantity": 1
  },
  "plush_cream": {
    "product_id": 6990562296003,
    "variant_id": null,
    "title": "Plush Cream",
    "quantity": 1
  },
  "additional_eye_enhancer": {
    "product_id": 1584059023394,
    "variant_id": null,
    "title": "Eye Enhancer",
    "quantity": 1
  },
  "forever_firm": {
    "product_id": 8219113029827,
    "variant_id": null,
    "title": "Forever Firm",
    "quantity": 1
  }
};
const PRODUCT_MAPPING = ((_a = window.Shopify) == null ? void 0 : _a.shop) === "maelove.myshopify.com" ? PRODUCT_MAPPING_PROD : PRODUCT_MAPPING_DEV;
const FOUNDER_VIDEO = {
  glow_maker: { video: "https://cdn.shopify.com/videos/c/vp/53061a7a1aaf426e8ab38dfe46c13ad5/53061a7a1aaf426e8ab38dfe46c13ad5.HD-720p-1.6Mbps-27902214.mp4", poster: "https://cdn.shopify.com/s/files/1/1919/1971/files/preview_images/Jackie_Glow_Maker_thumbnail.jpg" },
  moonlight: { video: "https://cdn.shopify.com/videos/c/vp/b22ac8b7862d4bd5b6563688b11d6e65/b22ac8b7862d4bd5b6563688b11d6e65.HD-720p-1.6Mbps-26986750.mp4", poster: "https://cdn.shopify.com/s/files/1/1919/1971/files/preview_images/Jackie_introduces_Moonlight.jpg" },
  peptide_squad: { video: "https://cdn.shopify.com/videos/c/vp/f544f97a9098488098e5c1476702cce0/f544f97a9098488098e5c1476702cce0.HD-720p-1.6Mbps-65956955.mp4", poster: "https://cdn.shopify.com/s/files/1/1919/1971/files/preview_images/Jackie_Peptide_Squad_video.jpg" },
  night_renewer: { video: "https://cdn.shopify.com/videos/c/vp/0fb129186a684411ac336976e67ca8e5/0fb129186a684411ac336976e67ca8e5.HD-720p-1.6Mbps-64501685.mp4", poster: "https://cdn.shopify.com/s/files/1/1919/1971/files/preview_images/Night_Renewer_Jackie_Thumbnail.jpg" },
  hydro_relief: { video: "https://cdn.shopify.com/videos/c/vp/86da5344b683473fb8b6110b0758fe7a/86da5344b683473fb8b6110b0758fe7a.HD-720p-1.6Mbps-23617217.mp4", poster: "https://cdn.shopify.com/s/files/1/1919/1971/files/preview_images/Hydro_Relief_jackie_video_thumbnail.jpg" },
  hydrator: { video: "https://cdn.shopify.com/videos/c/vp/15ee95af0dee43bdb982373b702ccb83/15ee95af0dee43bdb982373b702ccb83.HD-720p-1.6Mbps-27027421.mp4", poster: "https://cdn.shopify.com/s/files/1/1919/1971/files/preview_images/Hydrator_B5_Jackie_Thumbnail.jpg" },
  fade_away: { video: "https://cdn.shopify.com/videos/c/vp/36d941df5ebb4f59b5ad3e37c33dd812/36d941df5ebb4f59b5ad3e37c33dd812.HD-720p-1.6Mbps-27028885.mp4", poster: "https://cdn.shopify.com/s/files/1/1919/1971/files/preview_images/Fade_Away_Jackie_thumbnail.jpg" }
};
const SCIENCE_ARTICLES = {
  vitamin_c: {
    ingredient: "Vitamin C",
    title: "A deep guide to great skin with vitamin C",
    excerpt: "Topically applied Vitamin C is one of the best-proven ways to keep your skin healthy — but with so many products, concentrations, and competing claims out…",
    readTime: "28 min read",
    tags: ["active ingredients", "science"],
    url: "https://maelove.com/blogs/skincare-science/vitamin-c-serum-guide-skincare-routine",
    image: "https://maelove.com/cdn/shop/articles/blog_drip.webp?v=1764832947&width=640"
  },
  retinal: {
    ingredient: "Retinal",
    title: "Retinol vs. retinaldehyde: which should you use?",
    excerpt: "Retinaldehyde is about ten times more effective than retinol — and despite its high potency, it's remarkably gentle. Here's the science behind why, and how…",
    readTime: "4 min read",
    tags: ["active ingredients", "retinoids"],
    url: "https://maelove.com/blogs/skincare-science/what-s-the-difference-between-retinol-and-retinaldehyde-retinal-and-which-one-should-you-use",
    image: "https://maelove.com/cdn/shop/articles/blog_moon_light.webp?v=1762925713&width=640"
  },
  peptides: {
    ingredient: "Peptides",
    title: "A deep dive into peptides and skin care",
    excerpt: "Peptides are the new buzzwords on the face of numerous serums, each claiming transformative benefits — but how do you decide if they will actually do…",
    readTime: "28 min read",
    tags: ["active ingredients", "peptides"],
    url: "https://maelove.com/blogs/skincare-science/all-about-peptides-in-skin-care-the-deep-guide",
    image: "https://maelove.com/cdn/shop/articles/ARGIRELINE_d7b2433c-d184-4990-ae18-5fb95d422c79.png?v=1762918926&width=640"
  },
  hydroxy_acids: {
    ingredient: "Exfoliating acids",
    title: "How AHAs and BHAs actually work",
    excerpt: "Hydroxy acids — including AHAs like glycolic and lactic acid, and salicylic acid (BHA) — are among the most proven and powerful ingredients in skincare…",
    readTime: "19 min read",
    tags: ["exfoliation", "science"],
    url: "https://maelove.com/blogs/skincare-science/deep-guide-to-hydroxy-acids-how-do-they-work-and-how-to-choose-the-right-products-for-your-skin",
    image: "https://maelove.com/cdn/shop/articles/blog_hydroxy_acids_2.webp?v=1762917920&width=640"
  },
  niacinamide: {
    ingredient: "Niacinamide",
    title: "The deep guide to niacinamide",
    excerpt: "Niacinamide (Vitamin B3) is one of the most extensively studied and broadly beneficial ingredients in skincare — and yet it often plays second fiddle to…",
    readTime: "24 min read",
    tags: ["active ingredients", "niacinamide"],
    url: "https://maelove.com/blogs/skincare-science/deep-guide-to-niacinamide-how-it-works-and-why-it-should-be-a-part-of-everyones-skincare-routine",
    image: "https://maelove.com/cdn/shop/articles/blog_nia10_03c41c43-7bbf-410c-83ad-d9607247ac68.webp?v=1764832643&width=640"
  },
  hyaluronic: {
    ingredient: "Hyaluronic acid",
    title: "All about hyaluronic acid",
    excerpt: "Hyaluronic acid is everywhere in skincare right now, but what makes it so special? It can hold up to 1,000 times its weight in water…",
    readTime: "6 min read",
    tags: ["active ingredients", "hyaluronic acid"],
    url: "https://maelove.com/blogs/skincare-science/all-about-hyaluronic-acid-casual-science-edition",
    image: "https://maelove.com/cdn/shop/articles/ARGIRELINE_4_c7db9b07-4ae3-4914-9779-577e5f320dcd.jpg?v=1762925395&width=640"
  },
  hyperpigmentation: {
    ingredient: "Dark spots",
    title: "What causes dark spots, and how to treat them",
    excerpt: "Hyperpigmentation is one of the most common — and most misunderstood — skin concerns, affecting people across every skin tone and background. This deep…",
    readTime: "28 min read",
    tags: ["hyperpigmentation", "science"],
    url: "https://maelove.com/blogs/skincare-science/deep-guide-to-hyperpigmentation-what-causes-it-and-how-best-to-treat-it",
    image: "https://maelove.com/cdn/shop/articles/blog_fade_away.webp?v=1762918094&width=640"
  }
};
const SCIENCE_BY_SLUG = {
  glow_maker: "vitamin_c",
  moonlight: "retinal",
  peptide_squad: "peptides",
  additional_eye_enhancer: "peptides",
  forever_firm: "peptides",
  // Night Renewer is glycolic-acid–specific; the hydroxy-acids deep guide is the
  // broad AHA/BHA post, which fits the multi-acid products below, not it.
  super_smooth: "hydroxy_acids",
  exfoliator: "hydroxy_acids",
  refresher: "hydroxy_acids",
  nia_10: "niacinamide",
  plush_cream: "niacinamide",
  fade_away: "hyperpigmentation",
  hydrator: "hyaluronic",
  hydro_relief: "hyaluronic"
};
const SCIENCE_COMBOS = [
  {
    topics: ["vitamin_c", "retinal"],
    ingredient: "Vitamin C + Retinal",
    title: "Can you use vitamin C and retinoids together?",
    excerpt: "Vitamin C and retinoids are two of the most studied, most proven ingredients in all of skincare — and yes, you can absolutely use them together. Here's…",
    readTime: "5 min read",
    tags: ["active ingredients", "retinoids"],
    url: "https://maelove.com/blogs/skincare-science/can-you-use-vitamin-c-and-retinoids-together",
    image: "https://maelove.com/cdn/shop/articles/blog_gm_ml.webp?v=1762918189&width=640"
  },
  {
    topics: ["vitamin_c", "niacinamide"],
    ingredient: "Vitamin C + Niacinamide",
    title: "Can you use vitamin C with niacinamide?",
    excerpt: "You may have heard not to mix Vitamin C and Niacinamide — but the truth is, not only can you use them together, you probably should. Here's the science…",
    readTime: "6 min read",
    tags: ["active ingredients", "niacinamide"],
    url: "https://maelove.com/blogs/skincare-science/can-you-use-vitamin-c-with-niacinamide-yes-you-can",
    image: "https://maelove.com/cdn/shop/articles/blog_glow_maker.webp?v=1762918221&width=640"
  },
  {
    topics: ["vitamin_c", "hydroxy_acids"],
    ingredient: "Vitamin C + Acids",
    title: "Can you use vitamin C and hydroxy acids together?",
    excerpt: "Can you use Vitamin C and hydroxy acids like AHAs and BHAs together? The short answer is yes — as long as your skin can tolerate it and you don't…",
    readTime: "4 min read",
    tags: ["active ingredients", "exfoliation"],
    url: "https://maelove.com/blogs/skincare-science/can-you-use-vitamin-c-and-hydroxy-acids-together-yes-you-can",
    image: "https://maelove.com/cdn/shop/articles/blog_bestseller_duo.webp?v=1762917898&width=640"
  }
];
const getScienceReads = (products) => {
  const seen = /* @__PURE__ */ new Set();
  const topics = [];
  (products || []).forEach((p2) => {
    const topic = SCIENCE_BY_SLUG[getSlugForProduct(p2)];
    if (!topic || seen.has(topic)) return;
    seen.add(topic);
    topics.push(topic);
  });
  const reads = topics.map((t2) => SCIENCE_ARTICLES[t2]);
  SCIENCE_COMBOS.forEach((combo) => {
    if (combo.topics.every((t2) => seen.has(t2))) reads.push(combo);
  });
  return reads;
};
const SKIN_CONCERN_PRODUCTS = {
  "(none)": {
    "basic": [],
    "core": [],
    "advanced": []
  },
  "wrinkles": {
    "basic": [
      PRODUCT_MAPPING.glow_maker,
      PRODUCT_MAPPING.moonlight,
      PRODUCT_MAPPING.peptide_squad
    ],
    "core": [
      PRODUCT_MAPPING.glow_maker,
      PRODUCT_MAPPING.moonlight,
      PRODUCT_MAPPING.peptide_squad,
      PRODUCT_MAPPING.night_renewer
    ],
    "advanced": [
      PRODUCT_MAPPING.glow_maker,
      PRODUCT_MAPPING.moonlight,
      PRODUCT_MAPPING.peptide_squad,
      PRODUCT_MAPPING.night_renewer,
      PRODUCT_MAPPING.hydro_relief,
      PRODUCT_MAPPING.hydrator
    ]
  },
  "dark_spots": {
    "basic": [
      PRODUCT_MAPPING.fade_away,
      PRODUCT_MAPPING.glow_maker,
      PRODUCT_MAPPING.moonlight
    ],
    "core": [
      PRODUCT_MAPPING.fade_away,
      PRODUCT_MAPPING.glow_maker,
      PRODUCT_MAPPING.moonlight,
      PRODUCT_MAPPING.nia_10
    ],
    "advanced": [
      PRODUCT_MAPPING.fade_away,
      PRODUCT_MAPPING.glow_maker,
      PRODUCT_MAPPING.moonlight,
      PRODUCT_MAPPING.nia_10,
      PRODUCT_MAPPING.night_renewer,
      PRODUCT_MAPPING.exfoliator
    ]
  },
  "dryness": {
    "basic": [
      PRODUCT_MAPPING.hydrator,
      PRODUCT_MAPPING.hydro_relief,
      PRODUCT_MAPPING.peptide_squad
    ],
    "core": [
      PRODUCT_MAPPING.hydrator,
      PRODUCT_MAPPING.hydro_relief,
      PRODUCT_MAPPING.peptide_squad,
      PRODUCT_MAPPING.sheer_silk
    ],
    "advanced": [
      PRODUCT_MAPPING.hydrator,
      PRODUCT_MAPPING.hydro_relief,
      PRODUCT_MAPPING.peptide_squad,
      PRODUCT_MAPPING.sheer_silk,
      PRODUCT_MAPPING.exfoliator,
      PRODUCT_MAPPING.love_31
    ]
  },
  "oil_control": {
    "basic": [
      PRODUCT_MAPPING.super_smooth,
      PRODUCT_MAPPING.nia_10,
      PRODUCT_MAPPING.exfoliator
    ],
    "core": [
      PRODUCT_MAPPING.super_smooth,
      PRODUCT_MAPPING.nia_10,
      PRODUCT_MAPPING.exfoliator,
      PRODUCT_MAPPING.night_renewer
    ],
    "advanced": [
      PRODUCT_MAPPING.super_smooth,
      PRODUCT_MAPPING.nia_10,
      PRODUCT_MAPPING.exfoliator,
      PRODUCT_MAPPING.night_renewer,
      PRODUCT_MAPPING.refresher,
      PRODUCT_MAPPING.plush_cream
    ]
  },
  "uneven_texture": {
    "basic": [
      PRODUCT_MAPPING.super_smooth,
      PRODUCT_MAPPING.nia_10,
      PRODUCT_MAPPING.exfoliator
    ],
    "core": [
      PRODUCT_MAPPING.super_smooth,
      PRODUCT_MAPPING.nia_10,
      PRODUCT_MAPPING.exfoliator,
      PRODUCT_MAPPING.night_renewer
    ],
    "advanced": [
      PRODUCT_MAPPING.super_smooth,
      PRODUCT_MAPPING.nia_10,
      PRODUCT_MAPPING.exfoliator,
      PRODUCT_MAPPING.night_renewer,
      PRODUCT_MAPPING.refresher,
      PRODUCT_MAPPING.plush_cream
    ]
  },
  "redness": {
    "basic": [
      PRODUCT_MAPPING.nia_10,
      PRODUCT_MAPPING.peptide_squad
    ],
    "core": [
      PRODUCT_MAPPING.nia_10,
      PRODUCT_MAPPING.peptide_squad,
      PRODUCT_MAPPING.plush_cream,
      PRODUCT_MAPPING.hydrator
    ],
    "advanced": [
      PRODUCT_MAPPING.nia_10,
      PRODUCT_MAPPING.peptide_squad,
      PRODUCT_MAPPING.plush_cream,
      PRODUCT_MAPPING.hydrator,
      PRODUCT_MAPPING.sheer_silk,
      PRODUCT_MAPPING.hydro_relief
    ]
  },
  "acne": {
    "basic": [
      PRODUCT_MAPPING.night_renewer,
      PRODUCT_MAPPING.nia_10,
      PRODUCT_MAPPING.moonlight
    ],
    "core": [
      PRODUCT_MAPPING.night_renewer,
      PRODUCT_MAPPING.nia_10,
      PRODUCT_MAPPING.moonlight,
      PRODUCT_MAPPING.refresher
    ],
    "advanced": [
      PRODUCT_MAPPING.night_renewer,
      PRODUCT_MAPPING.nia_10,
      PRODUCT_MAPPING.moonlight,
      PRODUCT_MAPPING.refresher,
      PRODUCT_MAPPING.exfoliator,
      PRODUCT_MAPPING.super_smooth
    ]
  }
};
const PRODUCT_COUNT_FOR_CONCERN = {
  basic: {
    total: 3,
    combinations: [2, 1]
  },
  core: {
    total: 4,
    combinations: [3, 1]
  },
  advanced: {
    total: 6,
    combinations: [4, 2]
  }
};
const RESULTS_SUMMARY = [
  {
    "concerns": ["wrinkles"],
    "routines": {
      "basic": "Fine lines develop when collagen breaks down faster than skin can rebuild it. This focused trio addresses the core of the problem: Glow Maker's 15% vitamin C with ferulic acid neutralizes the oxidative stress that drives collagen breakdown. Moonlight's encapsulated retinaldehyde — one of the most potent retinoids available — accelerates cell renewal overnight to smooth existing lines. Peptide Squad layers four collagen-signaling peptides to rebuild firmness from the inside.",
      "core": "A more complete approach to wrinkles combines collagen rebuilding with surface renewal. Glow Maker's 15% vitamin C defends against free-radical damage by day, Moonlight's encapsulated retinaldehyde resurfaces overnight, and Peptide Squad's four-peptide complex signals your skin to produce more collagen. Night Renewer's 10% glycolic acid adds gentle resurfacing while you sleep, sloughing the dull surface layer where fine lines look deepest so smoother, brighter skin comes through.",
      "advanced": "Our most comprehensive anti-aging system pairs powerful actives with the deep hydration that lets them work. Glow Maker's 15% vitamin C and Moonlight's retinaldehyde drive cell renewal, Peptide Squad rebuilds collagen, and Night Renewer's 10% glycolic acid resurfaces. Hydrator and Hydro Relief then layer in hyaluronic acid, soy peptides, and barrier-supporting amino acids — because plump, well-moisturized skin reveals the smoothing effects of every other step."
    }
  },
  {
    "concerns": ["dark_spots"],
    "routines": {
      "basic": "Dark spots form when melanocytes overproduce pigment in response to sun, hormones, or inflammation. This focused trio interrupts that process at its source: Fade Away combines alpha arbutin, kojic acid, and licorice root — three well-studied non-irritating brighteners — to lighten existing discoloration. Glow Maker's 15% vitamin C blocks new pigment through antioxidant defense, and Moonlight's encapsulated retinaldehyde accelerates cell turnover so darker skin sloughs away faster.",
      "core": "A more complete approach to uneven tone tackles pigmentation from multiple angles. Fade Away's trio of alpha arbutin, kojic acid, and licorice root lightens existing spots, while Glow Maker's 15% vitamin C and Moonlight's retinaldehyde brighten and accelerate renewal. Nia 10's 10% niacinamide rounds it out by calming the inflammation that triggers new pigmentation, while strengthening your barrier against sun-driven discoloration.",
      "advanced": "Our most comprehensive brightening system layers treatment across the entire skin cycle. Fade Away's brightening trio and Nia 10's 10% niacinamide work on existing pigment from two angles, Glow Maker's 15% vitamin C and Moonlight's retinaldehyde prevent new spots and accelerate renewal, and Night Renewer's 10% glycolic acid resurfaces nightly. The Exfoliator's BHA and clay scrub lifts surface buildup weekly so brighteners reach where they need to."
    }
  },
  {
    "concerns": ["dryness"],
    "routines": {
      "basic": "Dryness happens when your skin's barrier can't hold onto water. This focused trio rebuilds and refills it: Hydrator delivers hyaluronic acid to draw moisture deep into the skin and vitamin B5 to soothe and condition. Hydro Relief's rich cream layers in soy peptides, rice amino acids, and squalane to seal that moisture in. Peptide Squad's collagen-signaling peptides plump skin from underneath so it stays smooth and supple all day.",
      "core": "A more complete approach to dryness starts with how you cleanse. Sheer Silk's ceramide-based cleanser hydrates while it removes the day instead of stripping your barrier. Hydrator then floods skin with hyaluronic acid and B5, Hydro Relief seals it in with soy peptides and rice amino acids, and Peptide Squad's collagen peptides keep skin plump and supple from the inside out.",
      "advanced": "Our most comprehensive routine for dry skin builds moisture at every layer. Sheer Silk's ceramide cleanser preserves your barrier, Hydrator and Hydro Relief deliver hyaluronic acid, peptides, and amino acids deep into the skin, Peptide Squad signals collagen renewal, the Exfoliator's gentle BHA-clay scrub clears away dead surface cells weekly so moisturizers can absorb properly, and Love 31's 31-oil blend seals everything in with omega-rich nourishment."
    }
  },
  {
    "concerns": ["oil_control"],
    "routines": {
      "basic": "Excess oil and visible pores often go together — both stem from overactive sebaceous glands and rough surface texture. This focused trio addresses both: Super Smooth's blend of glycolic, lactic, and salicylic acids dissolves oil-trapping buildup and refines texture. Nia 10's 10% niacinamide regulates oil production at the source and tightens the look of pores. The Exfoliator's BHA and kaolin clay scrub draws excess sebum out of clogged pores.",
      "core": "A more complete approach combines daily oil control with overnight renewal. Super Smooth's AHA-BHA blend keeps surface oil and dead cells in check, Nia 10's 10% niacinamide regulates sebum production and minimizes pore appearance, the Exfoliator's BHA-clay scrub deep-cleans congested pores weekly, and Night Renewer's 10% glycolic acid resurfaces while you sleep — so you wake up to refined, less shiny skin.",
      "advanced": "Our most comprehensive oil-control system manages sebum from cleanse to cream. The Refresher's triple-AHA cleanser starts the day with congestion-clearing exfoliation, Super Smooth and the Exfoliator refine texture, Nia 10's 10% niacinamide regulates oil at the source, Night Renewer's glycolic acid resurfaces overnight, and Plush Cream — a lightweight moisturizer with niacinamide and squalane — keeps skin balanced and hydrated without adding shine."
    }
  },
  {
    "concerns": ["uneven_texture"],
    "routines": {
      "basic": "Uneven texture comes from buildup of dead cells, clogged pores, and weakened cell turnover. This focused trio resurfaces and renews: Super Smooth's blend of glycolic, lactic, and salicylic acids dissolves the rough surface layer, Nia 10's 10% niacinamide refines pores and supports a healthier turnover cycle, and the Exfoliator's BHA-and-clay scrub physically lifts away buildup for an immediately smoother, more refined finish.",
      "core": "A more complete approach to texture works at every cycle of cell renewal. Super Smooth's AHA-BHA acids smooth bumps and refine pores, Nia 10's 10% niacinamide keeps the renewal process going and softens the look of texture irregularities, the Exfoliator's BHA-clay scrub clears surface buildup, and Night Renewer's 10% glycolic acid resurfaces overnight — revealing the softer, more refined skin underneath day after day.",
      "advanced": "Our most comprehensive routine for texture irregularities works on every stage of cell turnover. The Refresher's triple-AHA cleanser starts the day with gentle exfoliation, Super Smooth and the Exfoliator refine and resurface, Nia 10's 10% niacinamide keeps renewal steady, Night Renewer's glycolic acid smooths overnight, and Plush Cream — a barrier-supporting moisturizer with niacinamide and squalane — keeps skin balanced so resurfacing doesn't compromise comfort."
    }
  },
  {
    "concerns": ["redness"],
    "routines": {
      "basic": "Redness is rooted in inflammation and a compromised skin barrier. This focused pair tackles both: Nia 10's 10% niacinamide is one of the most studied ingredients for calming redness and reducing reactivity — it reinforces your barrier while regulating the inflammatory signals that make skin flush. Peptide Squad layers in soothing soy peptides, hyaluronic acid, and barrier-supporting niacinamide to keep skin calm and resilient.",
      "core": "A more complete approach to redness combines calming actives with deeper hydration. Nia 10's 10% niacinamide reduces inflammation and strengthens your barrier, Peptide Squad's soy peptides and amino acids reinforce skin from inside, Plush Cream's lightweight blend of niacinamide and bisabolol soothes flare-ups without feeling heavy, and Hydrator's hyaluronic acid and B5 keep dehydration (a hidden driver of redness) at bay.",
      "advanced": "Our most comprehensive routine for reactive skin treats redness from cleanse to seal. Sheer Silk's ceramide cleanser preserves your barrier instead of stripping it, Nia 10's 10% niacinamide and Peptide Squad's calming peptides quiet inflammation, Plush Cream layers in soothing bisabolol and niacinamide, and Hydrator with Hydro Relief lock in barrier-replenishing hyaluronic acid, soy peptides, and amino acids — because a healthy barrier is the foundation of calm, even skin."
    }
  },
  {
    "concerns": ["acne"],
    "routines": {
      "basic": "Acne happens when oil, dead cells, and bacteria combine in clogged pores. This focused trio breaks the cycle at each stage: Night Renewer's 10% glycolic acid keeps pores clear by gently dissolving the buildup that traps breakouts, Nia 10's 10% niacinamide regulates oil production and calms post-blemish redness, and Moonlight's encapsulated retinaldehyde accelerates cell turnover so blemishes heal faster and fewer new ones form.",
      "core": "A more complete approach to blemish-prone skin starts at the cleanser. The Refresher's triple-AHA blend (lactic, malic, tartaric) clears congestion at the first step, Night Renewer's 10% glycolic acid keeps pores clear overnight, Nia 10's 10% niacinamide regulates oil and soothes inflammation, and Moonlight's encapsulated retinaldehyde resurfaces and treats blemishes at their source — supporting clearer skin from morning to night.",
      "advanced": "Our most comprehensive acne system targets every factor behind breakouts. The Refresher's AHA cleanser clears daily congestion, the Exfoliator's BHA-clay scrub deep-cleans clogged pores weekly, Super Smooth's AHA-BHA serum and Night Renewer's glycolic acid resurface and refine, Nia 10's 10% niacinamide regulates oil and calms post-blemish redness, and Moonlight's encapsulated retinaldehyde renews cells overnight to heal active blemishes and prevent new ones."
    }
  },
  {
    "concerns": ["wrinkles", "dark_spots"],
    "routines": {
      "basic": "Aging skin and uneven tone share a root cause: slowed cell renewal. This focused trio works on both: Glow Maker's 15% vitamin C brightens spots and protects collagen, Moonlight's encapsulated retinaldehyde accelerates renewal to smooth fine lines and fade discoloration, and Fade Away's blend of alpha arbutin, kojic acid, and licorice root targets stubborn dark spots without irritation.",
      "core": "A more complete approach addresses fine lines and pigmentation from multiple angles. Glow Maker's 15% vitamin C and Moonlight's retinaldehyde defend against damage and accelerate cell turnover, Peptide Squad's four-peptide complex signals collagen renewal for visible firming, and Fade Away's alpha arbutin, kojic acid, and licorice root trio lightens existing dark spots while preventing new ones — covering both concerns in one cohesive routine.",
      "advanced": "Our most comprehensive system tackles aging and discoloration across every stage of renewal. Glow Maker's 15% vitamin C and Moonlight's retinaldehyde drive cell turnover, Peptide Squad rebuilds collagen, and Night Renewer's 10% glycolic acid resurfaces overnight. Fade Away's brightening trio and Nia 10's 10% niacinamide work on dark spots from two angles — calming the inflammation that triggers new pigment while fading existing discoloration."
    }
  },
  {
    "concerns": ["wrinkles", "dryness"],
    "routines": {
      "basic": "Plump, hydrated skin is the foundation of a smooth complexion — dryness exaggerates every fine line. This focused trio combines anti-aging with intense moisture: Glow Maker's 15% vitamin C protects collagen by day, Moonlight's encapsulated retinaldehyde accelerates cell renewal overnight to smooth wrinkles, and Hydrator's hyaluronic acid and vitamin B5 draw deep moisture into the skin and keep it there.",
      "core": "A more complete approach pairs collagen rebuilding with hydration that lasts. Glow Maker's 15% vitamin C and Moonlight's retinaldehyde drive cell renewal, Peptide Squad's four-peptide complex signals firmer, plumper skin, and Hydrator delivers hyaluronic acid and B5 deep into the skin to keep it soft, supple, and visibly smoother — because moisture is what makes anti-aging actives actually show.",
      "advanced": "Our most comprehensive routine for aging, thirsty skin layers powerful actives with rich barrier support. Glow Maker's 15% vitamin C and Moonlight's retinaldehyde renew cells, Peptide Squad rebuilds collagen, and Night Renewer's 10% glycolic acid resurfaces overnight. Hydrator and Hydro Relief then flood skin with hyaluronic acid, soy peptides, and barrier-supporting amino acids — locking moisture in so every smoothing effect is visible."
    }
  },
  {
    "concerns": ["wrinkles", "oil_control"],
    "routines": {
      "basic": "Aging and oily skin need a routine that smooths without weighing skin down. This focused trio handles both: Glow Maker's 15% vitamin C with ferulic acid defends collagen by day, Moonlight's encapsulated retinaldehyde renews cells and refines pores overnight, and Super Smooth's blend of glycolic, lactic, and salicylic acids dissolves the excess oil and surface buildup that make fine lines look deeper.",
      "core": "A more complete approach addresses aging and excess oil simultaneously. Glow Maker's 15% vitamin C protects against free-radical damage, Moonlight's retinaldehyde resurfaces overnight, Peptide Squad's four-peptide complex signals collagen renewal, and Super Smooth's AHA-BHA blend keeps pores clear and surface texture smooth — proof that anti-aging doesn't have to mean rich, heavy products.",
      "advanced": "Our most comprehensive routine for mature, oil-prone skin pairs collagen support with continuous resurfacing. Glow Maker's vitamin C and Moonlight's retinaldehyde renew cells, Peptide Squad rebuilds firmness, and Night Renewer's glycolic acid resurfaces overnight. Super Smooth's AHA-BHA serum and Nia 10's 10% niacinamide regulate oil at the source and refine pores — keeping fine lines from looking deeper than they are."
    }
  },
  {
    "concerns": ["wrinkles", "uneven_texture"],
    "routines": {
      "basic": "Texture and fine lines both come down to cell turnover. This focused trio rebuilds both at once: Glow Maker's 15% vitamin C protects existing collagen by day, Moonlight's encapsulated retinaldehyde smooths wrinkles and refines texture overnight, and Super Smooth's blend of glycolic, lactic, and salicylic acids dissolves the rough surface layer where fine lines look deepest.",
      "core": "A more complete approach combines collagen support with continuous resurfacing. Glow Maker's 15% vitamin C and Moonlight's retinaldehyde drive cell renewal, Peptide Squad's four peptides rebuild firmness from underneath, and Super Smooth's AHA-BHA acids dissolve dead cells and refine texture — revealing smoother, plumper skin that catches light evenly.",
      "advanced": "Our most comprehensive routine for mature, uneven skin works at every stage of renewal. Glow Maker's vitamin C and Moonlight's retinaldehyde renew cells, Peptide Squad rebuilds collagen, and Night Renewer's 10% glycolic acid resurfaces overnight. Super Smooth's AHA-BHA serum and Nia 10's 10% niacinamide refine texture and pores — so the smoothing effect of every anti-aging step actually shows on the surface."
    }
  },
  {
    "concerns": ["wrinkles", "redness"],
    "routines": {
      "basic": "Reactive skin needs anti-aging that doesn't trigger flushing. This focused trio walks that line: Glow Maker's 15% vitamin C with ferulic acid brightens and protects without irritation, Moonlight's encapsulated retinaldehyde delivers retinoid-level renewal with a Skin Comforting Complex of niacinamide, bisabolol, and aloe, and Nia 10's 10% niacinamide actively calms redness while reinforcing your barrier.",
      "core": "A more complete approach to aging, sensitive skin layers gentle actives. Glow Maker's 15% vitamin C and Moonlight's retinaldehyde — formulated with niacinamide and ceramides — renew cells without overworking the barrier. Peptide Squad's soothing peptides and Nia 10's 10% niacinamide quiet inflammation and rebuild collagen at the same time, addressing both wrinkles and reactivity in one cohesive routine.",
      "advanced": "Our most comprehensive routine for reactive, aging skin pairs powerful renewal with deep calming support. Glow Maker's 15% vitamin C and Moonlight's encapsulated retinaldehyde renew cells gently, Peptide Squad rebuilds collagen, and Night Renewer's 10% glycolic acid resurfaces. Nia 10's niacinamide and Plush Cream's blend of bisabolol and squalane reduce inflammation and reinforce the barrier — so anti-aging never comes at the cost of comfort."
    }
  },
  {
    "concerns": ["wrinkles", "acne"],
    "routines": {
      "basic": "Adult acne and fine lines often appear together, and they share treatment ground. This focused trio addresses both: Glow Maker's 15% vitamin C defends collagen and brightens post-blemish marks, Moonlight's encapsulated retinaldehyde renews cells to smooth wrinkles and treat breakouts at their source, and Night Renewer's 10% glycolic acid keeps pores clear and surface texture smooth.",
      "core": "A more complete approach treats aging and blemishes with the same renewal-focused actives. Glow Maker's 15% vitamin C and Moonlight's retinaldehyde drive cell turnover — addressing wrinkles, breakouts, and post-blemish marks all at once. Peptide Squad rebuilds collagen for visible firming, and Night Renewer's 10% glycolic acid keeps pores clear so blemishes have fewer places to form.",
      "advanced": "Our most comprehensive routine for aging, blemish-prone skin works on every renewal cycle. Glow Maker's vitamin C and Moonlight's retinaldehyde renew cells, Peptide Squad rebuilds firmness, and Night Renewer's glycolic acid resurfaces overnight. Nia 10's 10% niacinamide regulates oil and calms post-blemish redness, and the Refresher's triple-AHA cleanser clears congestion at the first step of every routine."
    }
  },
  {
    "concerns": ["dark_spots", "wrinkles"],
    "routines": {
      "basic": "Dark spots and fine lines share a common driver: slowed cell turnover and sun-related damage. This focused trio tackles both: Fade Away's alpha arbutin, kojic acid, and licorice root lighten existing discoloration, Glow Maker's 15% vitamin C protects collagen and prevents new pigment, and Moonlight's encapsulated retinaldehyde accelerates renewal to fade spots and smooth fine lines overnight.",
      "core": "A more complete approach treats pigmentation and fine lines from multiple angles. Fade Away's brightening trio targets existing dark spots, Glow Maker's 15% vitamin C and Moonlight's retinaldehyde drive cell renewal, and Peptide Squad's four-peptide complex rebuilds the collagen scaffolding underneath — so skin looks brighter, firmer, and more even at every level.",
      "advanced": "Our most comprehensive system layers brightening, anti-aging, and renewal across the entire skin cycle. Fade Away's alpha arbutin, kojic acid, and licorice root work on existing spots, Glow Maker's 15% vitamin C and Moonlight's retinaldehyde renew cells, Nia 10's 10% niacinamide calms the inflammation that triggers new pigment, Peptide Squad rebuilds collagen, and Night Renewer's glycolic acid resurfaces overnight."
    }
  },
  {
    "concerns": ["dark_spots", "dryness"],
    "routines": {
      "basic": "Brightening actives work better on hydrated skin — dehydration makes discoloration look more pronounced. This focused trio addresses both: Fade Away's alpha arbutin, kojic acid, and licorice root fade existing dark spots without irritation, Glow Maker's 15% vitamin C blocks new pigment formation, and Hydrator's hyaluronic acid and vitamin B5 keep skin plump and supple so brighteners absorb properly.",
      "core": "A more complete approach combines targeted brightening with deeper hydration. Fade Away's brightening trio lightens stubborn spots, Glow Maker's 15% vitamin C and Moonlight's encapsulated retinaldehyde brighten and accelerate cell renewal, and Hydrator delivers hyaluronic acid and B5 deep into the skin — because hydrated, healthy skin is what makes brightening results actually visible.",
      "advanced": "Our most comprehensive routine for uneven, dry skin layers brightening across a strong moisture foundation. Fade Away's trio of brighteners and Nia 10's 10% niacinamide tackle pigment from two angles, Glow Maker's vitamin C and Moonlight's retinaldehyde renew cells, and Hydrator with Hydro Relief flood skin with hyaluronic acid, soy peptides, and amino acids — keeping skin plump enough to reveal every shade of progress."
    }
  },
  {
    "concerns": ["dark_spots", "oil_control"],
    "routines": {
      "basic": "Oily skin often comes with post-blemish marks and uneven tone. This focused trio addresses both: Fade Away's alpha arbutin, kojic acid, and licorice root lighten dark spots without the irritation that can trigger more breakouts, Glow Maker's 15% vitamin C brightens and protects, and Super Smooth's AHA-BHA blend keeps pores clear and surface texture refined — preventing new marks from forming.",
      "core": "A more complete approach treats pigmentation and oil at the same time. Fade Away's brightening trio fades existing spots, Glow Maker's 15% vitamin C and Moonlight's retinaldehyde drive cell renewal, and Super Smooth's AHA-BHA serum dissolves oil-trapping buildup and keeps congestion-driven discoloration from forming in the first place.",
      "advanced": "Our most comprehensive routine for oily, uneven skin layers brightening with continuous pore care. Fade Away and Nia 10's 10% niacinamide fade existing pigment while regulating the inflammation that triggers new marks, Glow Maker and Moonlight renew cells, and Super Smooth with the Exfoliator's BHA-clay scrub keep pores clear so oil and dead skin don't undermine your brightening results."
    }
  },
  {
    "concerns": ["dark_spots", "uneven_texture"],
    "routines": {
      "basic": "Rough texture and dark spots both come down to cell turnover. This focused trio addresses both: Fade Away's alpha arbutin, kojic acid, and licorice root fade existing discoloration, Glow Maker's 15% vitamin C brightens overall tone and prevents new pigment, and Super Smooth's AHA-BHA blend dissolves the surface buildup that traps darker, rougher skin in place.",
      "core": "A more complete approach refines tone and texture together. Fade Away's brightening trio fades existing spots, Glow Maker's 15% vitamin C and Moonlight's retinaldehyde drive cell renewal, and Super Smooth's blend of glycolic, lactic, and salicylic acids resurfaces — so skin looks brighter, smoother, and more uniform with each cycle of turnover.",
      "advanced": "Our most comprehensive routine for uneven tone and texture layers resurfacing across the whole skin cycle. Fade Away and Nia 10's 10% niacinamide tackle pigment from two angles, Glow Maker and Moonlight renew cells, and Super Smooth with the Exfoliator's BHA-clay scrub refine the surface — revealing the brighter, smoother skin that's been hiding under the buildup."
    }
  },
  {
    "concerns": ["dark_spots", "redness"],
    "routines": {
      "basic": "Inflammation drives pigmentation — calmer skin fades spots faster. This focused trio addresses both: Fade Away's alpha arbutin, kojic acid, and licorice root lighten existing dark spots without irritation, Glow Maker's 15% vitamin C brightens and protects, and Nia 10's 10% niacinamide actively reduces the redness and inflammation that signal new pigment to form.",
      "core": "A more complete approach pairs brightening with continuous calming. Fade Away's brightening trio fades stubborn spots, Glow Maker's 15% vitamin C and Moonlight's encapsulated retinaldehyde — formulated with niacinamide and ceramides — renew cells gently, and Nia 10's 10% niacinamide quiets the inflammatory signals that drive new pigmentation in reactive skin.",
      "advanced": "Our most comprehensive system treats pigment and redness in a single cohesive routine. Fade Away's brightening trio and Nia 10's 10% niacinamide fade spots while reducing inflammation, Glow Maker and Moonlight renew cells, and Peptide Squad with Plush Cream layer in soothing peptides, bisabolol, and squalane — strengthening your barrier so brightening actives can work without triggering more flushing."
    }
  },
  {
    "concerns": ["dark_spots", "acne"],
    "routines": {
      "basic": "Post-blemish marks and active breakouts share a single root: inflammation. This focused trio addresses both: Fade Away's alpha arbutin, kojic acid, and licorice root fade post-acne discoloration, Glow Maker's 15% vitamin C brightens overall tone, and Night Renewer's 10% glycolic acid keeps pores clear — preventing the breakouts that leave new marks behind.",
      "core": "A more complete approach treats existing marks and active blemishes at the same time. Fade Away's brightening trio fades post-acne discoloration, Glow Maker's 15% vitamin C and Moonlight's encapsulated retinaldehyde drive cell renewal — addressing both pigment and blemishes at their source — and Night Renewer's 10% glycolic acid keeps pores clear so new marks don't form.",
      "advanced": "Our most comprehensive routine for blemish-prone, uneven skin layers brightening with continuous renewal. Fade Away and Nia 10's 10% niacinamide tackle existing pigment while regulating oil and inflammation, Glow Maker and Moonlight renew cells, and Night Renewer with the Refresher's triple-AHA cleanser keep pores clear at every step — breaking the cycle of breakouts and the marks they leave."
    }
  },
  {
    "concerns": ["dryness", "dark_spots"],
    "routines": {
      "basic": "Hydrated skin shows brightening results faster — dehydration makes pigment look more pronounced. This focused trio addresses both: Hydrator's hyaluronic acid and B5 plump and condition skin, Hydro Relief's rich cream layers in soy peptides and amino acids to seal moisture in, and Fade Away's alpha arbutin, kojic acid, and licorice root fade existing dark spots without irritation.",
      "core": "A more complete approach combines deep moisture with targeted brightening. Hydrator's hyaluronic acid and B5 plump the skin, Hydro Relief's peptides and amino acids reinforce the barrier, Peptide Squad's collagen-signaling peptides keep skin firm and supple, and Fade Away's brightening trio works on existing dark spots — because brighteners need healthy, hydrated skin to actually show.",
      "advanced": "Our most comprehensive routine for dry, uneven skin layers brightening across a strong moisture foundation. Hydrator, Hydro Relief, and Peptide Squad flood skin with hyaluronic acid, soy peptides, and amino acids, Sheer Silk's ceramide cleanser protects the barrier from cleanse to seal, and Fade Away with Glow Maker's 15% vitamin C brighten existing spots and prevent new ones."
    }
  },
  {
    "concerns": ["dryness", "wrinkles"],
    "routines": {
      "basic": "Dryness exaggerates every fine line — plumping the skin is half the work. This focused trio combines hydration with anti-aging: Hydrator's hyaluronic acid and B5 draw moisture deep into the skin, Hydro Relief's rich cream layers in soy peptides and amino acids to lock it in, and Glow Maker's 15% vitamin C with ferulic acid defends collagen so fine lines don't deepen.",
      "core": "A more complete approach pairs deep hydration with collagen rebuilding. Hydrator and Hydro Relief deliver hyaluronic acid, B5, and soy peptides to plump dehydrated skin, Peptide Squad's four-peptide complex signals collagen renewal, and Glow Maker's 15% vitamin C protects against the daily damage that drives wrinkles — keeping skin both well-moisturized and visibly firmer.",
      "advanced": "Our most comprehensive routine for dry, mature skin layers anti-aging across a strong moisture foundation. Hydrator, Hydro Relief, and Peptide Squad flood skin with hyaluronic acid, peptides, and amino acids, Sheer Silk's ceramide cleanser protects the barrier, and Glow Maker with Moonlight's encapsulated retinaldehyde renew cells — smoothing fine lines on plump, well-supported skin."
    }
  },
  {
    "concerns": ["dryness", "oil_control"],
    "routines": {
      "basic": "Combination skin needs a balanced approach — hydration where you're dry, oil control where you're not. This focused trio handles both: Hydrator's hyaluronic acid and B5 deliver lightweight moisture, Hydro Relief's rich cream supports dry patches with soy peptides and amino acids, and Super Smooth's AHA-BHA serum dissolves the excess oil and buildup in your T-zone.",
      "core": "A more complete approach balances moisture and oil control across the whole face. Hydrator's hyaluronic acid and Hydro Relief's rich peptide cream hydrate where skin is dry, Peptide Squad's collagen peptides keep skin resilient, and Super Smooth's blend of glycolic, lactic, and salicylic acids refines texture and keeps oilier zones clear and balanced.",
      "advanced": "Our most comprehensive routine for combination skin layers hydration with continuous oil control. Hydrator, Hydro Relief, and Peptide Squad deliver hyaluronic acid, soy peptides, and amino acids to dry areas, Sheer Silk's ceramide cleanser preserves the barrier, and Super Smooth with Nia 10's 10% niacinamide regulate oil and refine pores — keeping skin balanced from cleanse to cream."
    }
  },
  {
    "concerns": ["dryness", "uneven_texture"],
    "routines": {
      "basic": "Dry skin often shows texture more obviously — dehydrated cells don't reflect light evenly. This focused trio addresses both: Hydrator's hyaluronic acid and B5 plump and condition skin, Hydro Relief's rich cream layers in soy peptides and amino acids to seal moisture in, and Super Smooth's AHA-BHA blend dissolves the rough surface buildup that makes dry patches look more pronounced.",
      "core": "A more complete approach pairs deep moisture with continuous resurfacing. Hydrator and Hydro Relief deliver hyaluronic acid, B5, and peptides to plump dehydrated skin, Peptide Squad's collagen-signaling peptides rebuild firmness, and Super Smooth's blend of glycolic, lactic, and salicylic acids refines texture — so smoother, brighter skin comes through.",
      "advanced": "Our most comprehensive routine for dry, uneven skin layers resurfacing across a strong moisture foundation. Hydrator, Hydro Relief, and Peptide Squad flood skin with hyaluronic acid, peptides, and amino acids, Sheer Silk's ceramide cleanser preserves the barrier, and Super Smooth with Nia 10's 10% niacinamide refine texture and pores — revealing softer skin that catches light evenly."
    }
  },
  {
    "concerns": ["dryness", "redness"],
    "routines": {
      "basic": "A weakened barrier drives both dryness and redness — fix one and you help the other. This focused trio addresses both: Hydrator's hyaluronic acid and vitamin B5 deeply hydrate and condition, Hydro Relief's rich cream layers in soy peptides, rice amino acids, and squalane to rebuild the barrier, and Peptide Squad's soothing peptides quiet the inflammation that drives reactivity.",
      "core": "A more complete approach combines deep hydration with continuous calming. Hydrator and Hydro Relief deliver hyaluronic acid, B5, and soy peptides to a thirsty barrier, Peptide Squad's soothing peptides reinforce skin from inside, and Plush Cream's lightweight blend of niacinamide and bisabolol calms redness without feeling heavy — addressing both concerns in one cohesive routine.",
      "advanced": "Our most comprehensive routine for dry, reactive skin rebuilds the barrier at every step. Hydrator, Hydro Relief, and Peptide Squad flood skin with hyaluronic acid, peptides, and amino acids, Sheer Silk's ceramide cleanser preserves the barrier from the first step, and Plush Cream layers in soothing bisabolol and niacinamide — calming redness while keeping skin deeply moisturized."
    }
  },
  {
    "concerns": ["dryness", "acne"],
    "routines": {
      "basic": "Dry, blemish-prone skin is the trickiest combination — most acne treatments worsen dryness. This focused trio threads the needle: Hydrator's hyaluronic acid and B5 deliver hydration without clogging, Hydro Relief's peptide-amino-acid cream rebuilds the barrier, and Night Renewer's 10% glycolic acid gently clears pores without stripping — so breakouts heal while dry patches stay supple.",
      "core": "A more complete approach treats blemishes without sacrificing moisture. Hydrator and Hydro Relief deliver hyaluronic acid, peptides, and amino acids to a thirsty barrier, Peptide Squad's collagen peptides keep skin resilient, and Night Renewer's 10% glycolic acid clears congestion gently — so blemish-prone skin can heal without flaking or tightness.",
      "advanced": "Our most comprehensive routine for dry, blemish-prone skin balances renewal with deep hydration. Hydrator, Hydro Relief, and Peptide Squad flood skin with moisture-locking actives, Sheer Silk's ceramide cleanser preserves the barrier, and Night Renewer with Nia 10's 10% niacinamide clear pores and regulate oil — keeping skin clear and comfortable at the same time."
    }
  },
  {
    "concerns": ["oil_control", "dark_spots"],
    "routines": {
      "basic": "Oily skin and pigmentation often share a trigger — inflammation from breakouts or sun damage. This focused trio addresses both: Super Smooth's blend of glycolic, lactic, and salicylic acids dissolves oil-trapping buildup, Nia 10's 10% niacinamide regulates sebum and calms the inflammation that drives pigment, and Fade Away's alpha arbutin, kojic acid, and licorice root fade existing dark spots.",
      "core": "A more complete approach treats oil and pigmentation at the same time. Super Smooth's AHA-BHA blend refines texture and clears pores, Nia 10's 10% niacinamide regulates oil and reduces the inflammation that triggers new spots, the Exfoliator's BHA-clay scrub deep-cleans congested areas, and Fade Away's brightening trio fades existing discoloration.",
      "advanced": "Our most comprehensive routine for oily, uneven skin works at every stage of renewal. Super Smooth, the Exfoliator, and Nia 10's 10% niacinamide keep oil and pores under control, Night Renewer's 10% glycolic acid resurfaces overnight, and Fade Away with Glow Maker's 15% vitamin C lighten existing spots while preventing new ones from forming."
    }
  },
  {
    "concerns": ["oil_control", "dryness"],
    "routines": {
      "basic": "Combination skin — oily T-zone, dry cheeks — needs a balanced approach. This focused trio handles both: Super Smooth's AHA-BHA blend dissolves excess oil and refines pores where you need it, Nia 10's 10% niacinamide balances sebum production across the whole face, and Hydrator's hyaluronic acid and B5 deliver lightweight moisture to dry zones.",
      "core": "A more complete approach balances moisture and oil across the entire face. Super Smooth's blend of glycolic, lactic, and salicylic acids refines oilier areas, Nia 10's 10% niacinamide regulates sebum, the Exfoliator's BHA-clay scrub deep-cleans congested zones weekly, and Hydrator's hyaluronic acid and B5 keep drier areas plump and supple.",
      "advanced": "Our most comprehensive routine for combination skin manages every zone independently. Super Smooth and the Exfoliator refine oilier areas, Nia 10's 10% niacinamide regulates sebum, Night Renewer's glycolic acid resurfaces overnight, and Hydrator with Hydro Relief flood drier areas with hyaluronic acid, B5, and soy peptides — keeping skin balanced from cleanse to cream."
    }
  },
  {
    "concerns": ["oil_control", "wrinkles"],
    "routines": {
      "basic": "Oily skin ages too — and it needs anti-aging that doesn't weigh it down. This focused trio handles both: Super Smooth's blend of glycolic, lactic, and salicylic acids dissolves excess oil and refines pores, Nia 10's 10% niacinamide regulates sebum and supports skin firmness, and Glow Maker's 15% vitamin C with ferulic acid defends collagen by day.",
      "core": "A more complete approach combines oil control with continuous anti-aging. Super Smooth's AHA-BHA blend refines texture, Nia 10's 10% niacinamide regulates oil and reduces pore appearance, the Exfoliator's BHA-clay scrub deep-cleans congested areas, and Glow Maker's 15% vitamin C protects against the daily damage that breaks down collagen — proving anti-aging doesn't need rich, heavy formulas.",
      "advanced": "Our most comprehensive routine for oily, aging skin pairs collagen support with constant pore care. Super Smooth, the Exfoliator, and Nia 10 keep oil and texture in check, Night Renewer's 10% glycolic acid resurfaces overnight, and Glow Maker with Moonlight's encapsulated retinaldehyde drive cell renewal — so fine lines smooth out without ever feeling heavy."
    }
  },
  {
    "concerns": ["oil_control", "uneven_texture"],
    "routines": {
      "basic": "Oil and texture irregularities go hand-in-hand — both stem from buildup in and around pores. This focused trio handles both: Super Smooth's blend of glycolic, lactic, and salicylic acids dissolves oil-trapping buildup, Nia 10's 10% niacinamide regulates sebum and refines pore appearance, and the Exfoliator's BHA-and-clay scrub physically lifts away the dead cells making skin look rough.",
      "core": "A more complete approach refines texture and oil from every angle. Super Smooth's AHA-BHA serum smooths bumps and refines pores, Nia 10's 10% niacinamide regulates oil at the source, the Exfoliator's BHA-clay scrub deep-cleans congested areas, and Night Renewer's 10% glycolic acid resurfaces overnight — revealing softer, more refined skin every cycle.",
      "advanced": "Our most comprehensive routine for oily, uneven skin works at every step of renewal. The Refresher's triple-AHA cleanser, Super Smooth, and the Exfoliator refine and resurface, Nia 10's 10% niacinamide regulates oil, Night Renewer's glycolic acid smooths overnight, and Plush Cream's lightweight blend of niacinamide and squalane keeps skin balanced without adding shine."
    }
  },
  {
    "concerns": ["oil_control", "redness"],
    "routines": {
      "basic": "Oily, reactive skin needs ingredients that calm without weighing skin down. This focused trio walks that line: Super Smooth's blend of glycolic, lactic, and salicylic acids refines pores and clears oil gently, Nia 10's 10% niacinamide regulates sebum while actively reducing redness and inflammation, and Peptide Squad's soothing peptides reinforce the barrier without feeling heavy.",
      "core": "A more complete approach controls oil while continuously calming reactive skin. Super Smooth's AHA-BHA serum refines texture and pores, Nia 10's 10% niacinamide regulates sebum and reduces inflammation, the Exfoliator's BHA-clay scrub deep-cleans congested areas, and Peptide Squad's soy peptides reinforce a barrier that often flares from harsh oil-control products.",
      "advanced": "Our most comprehensive routine for oily, reactive skin balances pore care with constant calming. Super Smooth, the Exfoliator, and Night Renewer refine and resurface gently, Nia 10's 10% niacinamide regulates oil and calms redness, and Peptide Squad with Plush Cream layer in soothing peptides, bisabolol, and squalane — supporting the barrier that oil control can sometimes compromise."
    }
  },
  {
    "concerns": ["oil_control", "acne"],
    "routines": {
      "basic": "Oily, breakout-prone skin needs a routine focused on pore clarity. This focused trio handles both: Super Smooth's blend of glycolic, lactic, and salicylic acids dissolves the oil and dead cells that clog pores, Nia 10's 10% niacinamide regulates sebum and calms post-blemish inflammation, and Night Renewer's 10% glycolic acid keeps pores clear overnight to prevent new breakouts.",
      "core": "A more complete approach treats oil and acne from the same angle — clear pores. Super Smooth's AHA-BHA serum dissolves congestion, Nia 10's 10% niacinamide regulates sebum and reduces redness, the Exfoliator's BHA-clay scrub deep-cleans weekly, and Night Renewer's 10% glycolic acid resurfaces overnight to keep breakouts from forming.",
      "advanced": "Our most comprehensive routine for oily, blemish-prone skin attacks every factor behind breakouts. Super Smooth, the Exfoliator, and the Refresher's triple-AHA cleanser keep pores continuously clear, Nia 10's 10% niacinamide regulates oil at the source, Night Renewer resurfaces, and Moonlight's encapsulated retinaldehyde renews cells overnight — healing active blemishes and preventing new ones."
    }
  },
  {
    "concerns": ["uneven_texture", "dark_spots"],
    "routines": {
      "basic": "Rough texture and dark spots both come from the same place: slow cell turnover and surface buildup. This focused trio resurfaces and brightens: Super Smooth's blend of glycolic, lactic, and salicylic acids dissolves the buildup that makes skin look rough and dull, Nia 10's 10% niacinamide refines pores and softens texture, and Fade Away's brightening trio fades existing discoloration.",
      "core": "A more complete approach addresses tone and texture from the same angle — renewal. Super Smooth's AHA-BHA serum smooths and refines, Nia 10's 10% niacinamide supports steady cell turnover, the Exfoliator's BHA-clay scrub clears surface buildup weekly, and Fade Away's alpha arbutin, kojic acid, and licorice root work on stubborn dark spots.",
      "advanced": "Our most comprehensive routine for uneven tone and texture layers resurfacing across the entire skin cycle. Super Smooth, the Exfoliator, and Night Renewer refine and renew at every step, Nia 10's 10% niacinamide keeps turnover steady, and Fade Away with Glow Maker's 15% vitamin C lighten existing pigment while preventing new spots."
    }
  },
  {
    "concerns": ["uneven_texture", "dryness"],
    "routines": {
      "basic": "Dry skin shows texture more obviously — dehydrated cells don't catch light evenly. This focused trio addresses both: Super Smooth's blend of glycolic, lactic, and salicylic acids dissolves the rough surface layer, Nia 10's 10% niacinamide softens texture and strengthens the barrier, and Hydrator's hyaluronic acid and B5 plump dehydrated skin so it reflects light smoothly.",
      "core": "A more complete approach refines texture while flooding skin with moisture. Super Smooth's AHA-BHA serum smooths bumps and refines pores, Nia 10's 10% niacinamide softens texture and reinforces the barrier, the Exfoliator's BHA-clay scrub clears buildup weekly, and Hydrator's hyaluronic acid and B5 keep skin plump and supple — so smoother skin actually shows.",
      "advanced": "Our most comprehensive routine for dry, uneven skin layers resurfacing with deep hydration. Super Smooth and the Exfoliator refine texture, Nia 10's 10% niacinamide reinforces the barrier, Night Renewer's 10% glycolic acid resurfaces overnight, and Hydrator with Hydro Relief flood skin with hyaluronic acid, B5, soy peptides, and amino acids — keeping skin plump enough to reveal every shade of refinement."
    }
  },
  {
    "concerns": ["uneven_texture", "oil_control"],
    "routines": {
      "basic": "Rough texture and excess oil share a single trigger: congested pores. This focused pair addresses both: Super Smooth's blend of glycolic, lactic, and salicylic acids dissolves the oil and dead cells that make skin look rough, while Nia 10's 10% niacinamide regulates sebum production and refines pore appearance — so skin looks smoother and shines less.",
      "core": "A more complete approach refines texture and controls oil at every stage. Super Smooth's AHA-BHA serum smooths bumps and clears pores, Nia 10's 10% niacinamide regulates oil and supports steady turnover, the Exfoliator's BHA-clay scrub deep-cleans weekly, and Night Renewer's 10% glycolic acid resurfaces overnight — revealing softer, more refined skin every cycle.",
      "advanced": "Our most comprehensive routine for oily, uneven skin works on texture at every step. The Refresher's triple-AHA cleanser starts the day with gentle exfoliation, Super Smooth and the Exfoliator refine and resurface, Nia 10's 10% niacinamide regulates oil, Night Renewer's glycolic acid smooths overnight, and Plush Cream's lightweight blend of niacinamide and squalane balances skin without adding shine."
    }
  },
  {
    "concerns": ["uneven_texture", "wrinkles"],
    "routines": {
      "basic": "Texture and fine lines both come down to cell turnover. This focused trio addresses both: Super Smooth's blend of glycolic, lactic, and salicylic acids dissolves the rough surface layer where lines look deepest, Nia 10's 10% niacinamide refines pores and softens texture, and Glow Maker's 15% vitamin C defends collagen by day so wrinkles don't deepen.",
      "core": "A more complete approach refines texture while supporting collagen. Super Smooth's AHA-BHA serum smooths bumps and refines pores, Nia 10's 10% niacinamide softens texture and supports turnover, the Exfoliator's BHA-clay scrub clears buildup weekly, and Glow Maker's 15% vitamin C protects against the damage that drives fine lines — so refinement and anti-aging happen at the same time.",
      "advanced": "Our most comprehensive routine for aging, uneven skin works at every stage of renewal. Super Smooth and the Exfoliator refine texture, Nia 10's 10% niacinamide supports steady turnover, Night Renewer's 10% glycolic acid resurfaces overnight, and Glow Maker with Moonlight's encapsulated retinaldehyde drive cell renewal — smoothing both texture irregularities and fine lines."
    }
  },
  {
    "concerns": ["uneven_texture", "redness"],
    "routines": {
      "basic": "Reactive skin needs gentle resurfacing that won't trigger flushing. This focused trio walks that line: Super Smooth's blend of glycolic, lactic, and salicylic acids smooths bumps without aggression, Nia 10's 10% niacinamide refines texture while actively calming redness and inflammation, and Peptide Squad's soothing peptides reinforce the barrier so resurfacing doesn't compromise comfort.",
      "core": "A more complete approach refines texture while continuously calming reactive skin. Super Smooth's AHA-BHA serum smooths bumps and refines pores, Nia 10's 10% niacinamide softens texture and reduces inflammation, the Exfoliator's BHA-clay scrub clears buildup gently, and Peptide Squad's soy peptides reinforce a barrier that exfoliation can sometimes irritate.",
      "advanced": "Our most comprehensive routine for reactive, uneven skin layers gentle resurfacing with constant calming. Super Smooth, the Exfoliator, and Night Renewer refine texture without aggression, Nia 10's 10% niacinamide softens texture and reduces redness, and Peptide Squad with Plush Cream layer in soothing peptides, bisabolol, and squalane — protecting the barrier that texture work can otherwise stress."
    }
  },
  {
    "concerns": ["uneven_texture", "acne"],
    "routines": {
      "basic": "Rough texture and active breakouts share a root: clogged pores and slow cell turnover. This focused trio addresses both: Super Smooth's blend of glycolic, lactic, and salicylic acids dissolves the buildup that traps blemishes and roughens skin, Nia 10's 10% niacinamide regulates oil and softens texture, and Night Renewer's 10% glycolic acid clears pores overnight.",
      "core": "A more complete approach refines texture while clearing active blemishes. Super Smooth's AHA-BHA serum smooths and clears, Nia 10's 10% niacinamide regulates oil and calms post-blemish inflammation, the Exfoliator's BHA-clay scrub deep-cleans congested areas weekly, and Night Renewer's 10% glycolic acid resurfaces overnight — keeping new breakouts from forming.",
      "advanced": "Our most comprehensive routine for blemish-prone, uneven skin works at every stage of renewal. The Refresher's triple-AHA cleanser, Super Smooth, and the Exfoliator continuously refine and clear, Nia 10's 10% niacinamide regulates oil, Night Renewer resurfaces overnight, and Moonlight's encapsulated retinaldehyde renews cells — healing active blemishes and preventing new texture issues."
    }
  },
  {
    "concerns": ["redness", "dark_spots"],
    "routines": {
      "basic": "Inflammation drives both redness and pigmentation — calming skin is the foundation for fading spots. This focused trio addresses both: Nia 10's 10% niacinamide actively reduces redness and the inflammatory signals that trigger pigment, Peptide Squad's soothing peptides reinforce the barrier, and Fade Away's alpha arbutin, kojic acid, and licorice root fade existing dark spots without irritation.",
      "core": "A more complete approach pairs constant calming with targeted brightening. Nia 10's 10% niacinamide reduces inflammation and fades pigmentation, Peptide Squad's soy peptides reinforce skin from inside, Plush Cream's lightweight blend of niacinamide and bisabolol soothes flare-ups, and Fade Away's alpha arbutin, kojic acid, and licorice root work on stubborn discoloration.",
      "advanced": "Our most comprehensive routine for reactive, uneven skin treats redness and pigmentation in one cohesive system. Nia 10's 10% niacinamide and Peptide Squad's peptides quiet inflammation, Plush Cream and Hydrator layer in soothing bisabolol, niacinamide, hyaluronic acid, and B5, and Fade Away with Glow Maker's 15% vitamin C fade existing spots while preventing new ones — without ever overworking the barrier."
    }
  },
  {
    "concerns": ["redness", "dryness"],
    "routines": {
      "basic": "A compromised barrier drives both dryness and redness — treating one helps the other. This focused trio addresses both: Nia 10's 10% niacinamide reduces inflammation and reinforces the barrier, Peptide Squad's soothing peptides and hyaluronic acid calm and plump skin, and Hydrator's hyaluronic acid and vitamin B5 deliver the deep moisture a reactive barrier needs.",
      "core": "A more complete approach combines constant calming with deeper hydration. Nia 10's 10% niacinamide reduces inflammation, Peptide Squad's soy peptides reinforce skin from inside, Plush Cream's lightweight blend of niacinamide and bisabolol soothes flare-ups, and Hydrator's hyaluronic acid and B5 keep dehydration (a hidden driver of redness) at bay.",
      "advanced": "Our most comprehensive routine for dry, reactive skin rebuilds the barrier from cleanse to seal. Sheer Silk's ceramide cleanser preserves the barrier, Nia 10's 10% niacinamide and Peptide Squad's peptides quiet inflammation, Plush Cream layers in bisabolol and niacinamide, and Hydrator with Hydro Relief flood skin with hyaluronic acid, B5, soy peptides, and amino acids."
    }
  },
  {
    "concerns": ["redness", "oil_control"],
    "routines": {
      "basic": "Reactive, oily skin needs ingredients that control oil without triggering flushing. This focused trio walks that line: Nia 10's 10% niacinamide regulates sebum production and actively reduces redness in the same step, Peptide Squad's soothing peptides reinforce a barrier that harsh oil-control products often compromise, and Super Smooth's gentle AHA-BHA blend refines pores without aggression.",
      "core": "A more complete approach balances oil control with continuous calming. Nia 10's 10% niacinamide regulates sebum and reduces inflammation, Peptide Squad's soy peptides reinforce the barrier, Plush Cream's lightweight blend of bisabolol and niacinamide soothes flare-ups, and Super Smooth's AHA-BHA serum refines pores and texture without overworking reactive skin.",
      "advanced": "Our most comprehensive routine for reactive, oily skin balances pore care with constant calming. Nia 10's 10% niacinamide regulates oil and reduces redness, Peptide Squad and Plush Cream layer in soothing peptides and bisabolol, Hydrator delivers hyaluronic acid and B5 for barrier support, and Super Smooth with the Exfoliator refine pores and surface texture gently."
    }
  },
  {
    "concerns": ["redness", "uneven_texture"],
    "routines": {
      "basic": "Reactive skin needs resurfacing that won't trigger flushing. This focused trio walks that line: Nia 10's 10% niacinamide reduces redness and supports cell turnover, Peptide Squad's soothing peptides reinforce the barrier, and Super Smooth's blend of glycolic, lactic, and salicylic acids refines texture gently — smoothing bumps without compromising comfort.",
      "core": "A more complete approach refines texture while continuously calming. Nia 10's 10% niacinamide softens texture and reduces inflammation, Peptide Squad's soy peptides reinforce skin from inside, Plush Cream's lightweight blend of bisabolol and niacinamide soothes flare-ups, and Super Smooth's AHA-BHA serum smooths bumps and refines pores without aggression.",
      "advanced": "Our most comprehensive routine for reactive, uneven skin treats texture and redness in a single cohesive system. Nia 10's 10% niacinamide reduces inflammation, Peptide Squad with Plush Cream layer in soothing peptides and bisabolol, Hydrator delivers hyaluronic acid and B5, and Super Smooth with the Exfoliator refine texture gently — keeping the barrier supported through every resurfacing step."
    }
  },
  {
    "concerns": ["redness", "wrinkles"],
    "routines": {
      "basic": "Reactive skin needs anti-aging that won't trigger flushing. This focused trio walks that line: Nia 10's 10% niacinamide actively reduces redness while supporting skin firmness, Peptide Squad's four-peptide complex rebuilds collagen with soothing soy peptides, and Glow Maker's 15% vitamin C with ferulic acid protects against the daily damage that drives fine lines.",
      "core": "A more complete approach combines anti-aging with continuous calming. Nia 10's 10% niacinamide reduces inflammation and supports turnover, Peptide Squad's four peptides rebuild collagen, Plush Cream's lightweight blend of bisabolol and niacinamide soothes flare-ups, and Glow Maker's 15% vitamin C protects collagen — keeping anti-aging gentle enough for reactive skin.",
      "advanced": "Our most comprehensive routine for reactive, aging skin pairs powerful renewal with constant calming. Nia 10's 10% niacinamide reduces redness, Peptide Squad and Plush Cream layer in soothing peptides and bisabolol, Hydrator supports the barrier with hyaluronic acid and B5, and Glow Maker with Moonlight's encapsulated retinaldehyde — formulated with niacinamide and ceramides — renew cells without overworking sensitive skin."
    }
  },
  {
    "concerns": ["redness", "acne"],
    "routines": {
      "basic": "Reactive, breakout-prone skin needs ingredients that clear pores without triggering more inflammation. This focused trio walks that line: Nia 10's 10% niacinamide regulates oil and reduces both redness and post-blemish inflammation, Peptide Squad's soothing peptides reinforce the barrier, and Night Renewer's 10% glycolic acid clears pores gently overnight.",
      "core": "A more complete approach treats acne while continuously calming reactive skin. Nia 10's 10% niacinamide regulates oil and reduces inflammation, Peptide Squad's soy peptides reinforce skin from inside, Plush Cream's lightweight blend of bisabolol and niacinamide soothes flare-ups, and Night Renewer's 10% glycolic acid clears congestion without stripping or irritating.",
      "advanced": "Our most comprehensive routine for reactive, blemish-prone skin pairs gentle renewal with constant calming. Nia 10's 10% niacinamide and Peptide Squad's peptides quiet inflammation, Plush Cream and Hydrator support the barrier with bisabolol, hyaluronic acid, and B5, and Night Renewer with Moonlight's encapsulated retinaldehyde renew cells overnight — healing blemishes without flaring reactivity."
    }
  },
  {
    "concerns": ["acne", "dark_spots"],
    "routines": {
      "basic": "Active breakouts and the marks they leave behind share a single root: inflammation. This focused trio addresses both: Night Renewer's 10% glycolic acid keeps pores clear to prevent new blemishes, Nia 10's 10% niacinamide regulates oil and calms the inflammation that leaves spots behind, and Fade Away's alpha arbutin, kojic acid, and licorice root fade existing post-blemish discoloration.",
      "core": "A more complete approach treats blemishes and the marks they leave at the same time. Night Renewer's 10% glycolic acid clears pores, Nia 10's 10% niacinamide regulates oil and calms inflammation, Moonlight's encapsulated retinaldehyde renews cells to heal blemishes and fade marks, and Fade Away's brightening trio targets existing dark spots without irritation.",
      "advanced": "Our most comprehensive routine for blemish-prone, uneven skin works at every cycle of renewal. Night Renewer, the Refresher's triple-AHA cleanser, and Nia 10's 10% niacinamide keep pores clear and inflammation controlled, Moonlight's encapsulated retinaldehyde renews cells overnight, and Fade Away with Glow Maker's 15% vitamin C fade existing post-blemish marks while preventing new ones."
    }
  },
  {
    "concerns": ["acne", "dryness"],
    "routines": {
      "basic": "Treating blemishes without drying skin out is the hardest balance — most acne products strip the barrier. This focused trio threads the needle: Night Renewer's 10% glycolic acid clears pores gently, Nia 10's 10% niacinamide regulates oil while reinforcing the barrier, and Hydrator's hyaluronic acid and B5 deliver the deep moisture acne-prone skin still needs.",
      "core": "A more complete approach treats blemishes while flooding skin with moisture. Night Renewer's 10% glycolic acid keeps pores clear, Nia 10's 10% niacinamide regulates oil and reduces inflammation, Moonlight's encapsulated retinaldehyde renews cells with a Skin Comforting Complex, and Hydrator's hyaluronic acid and B5 keep dry skin supple — so acne care doesn't mean flaking and tightness.",
      "advanced": "Our most comprehensive routine for dry, blemish-prone skin balances renewal with deep hydration. Night Renewer, Nia 10, and Moonlight clear pores and renew cells, the Refresher's triple-AHA cleanser supports continuous clarity, and Hydrator with Hydro Relief flood skin with hyaluronic acid, B5, soy peptides, and amino acids — keeping skin clear and comfortable in the same routine."
    }
  },
  {
    "concerns": ["acne", "oil_control"],
    "routines": {
      "basic": "Excess oil and active breakouts share a root: clogged pores. This focused trio attacks both: Night Renewer's 10% glycolic acid dissolves the buildup that traps blemishes, Nia 10's 10% niacinamide regulates sebum production and calms post-blemish inflammation, and Super Smooth's blend of glycolic, lactic, and salicylic acids refines pores and clears surface oil.",
      "core": "A more complete approach treats oil and acne from the same angle — keeping pores continuously clear. Night Renewer's 10% glycolic acid resurfaces overnight, Nia 10's 10% niacinamide regulates sebum, Moonlight's encapsulated retinaldehyde renews cells to treat blemishes at their source, and Super Smooth's AHA-BHA serum dissolves the oil and dead cells that trap breakouts.",
      "advanced": "Our most comprehensive routine for oily, blemish-prone skin attacks every factor behind breakouts. Night Renewer, Nia 10's 10% niacinamide, and Moonlight's encapsulated retinaldehyde clear pores and renew cells, the Refresher's triple-AHA cleanser and the Exfoliator's BHA-clay scrub keep congestion in check, and Super Smooth refines pores and surface texture all day."
    }
  },
  {
    "concerns": ["acne", "uneven_texture"],
    "routines": {
      "basic": "Active breakouts and rough texture come from the same place: clogged pores and slow cell turnover. This focused trio resurfaces and clears: Night Renewer's 10% glycolic acid dissolves the buildup that traps blemishes and roughens skin, Nia 10's 10% niacinamide regulates oil and softens texture, and Super Smooth's AHA-BHA blend refines pores and smooths bumps.",
      "core": "A more complete approach treats blemishes and texture from the same angle — renewal. Night Renewer's 10% glycolic acid resurfaces overnight, Nia 10's 10% niacinamide regulates oil and supports turnover, Moonlight's encapsulated retinaldehyde renews cells to heal blemishes, and Super Smooth's AHA-BHA serum smooths bumps and clears congestion in one step.",
      "advanced": "Our most comprehensive routine for blemish-prone, uneven skin works at every cycle of cell turnover. Night Renewer, Moonlight, and Nia 10's 10% niacinamide clear pores and renew cells, the Refresher's triple-AHA cleanser and the Exfoliator's BHA-clay scrub keep congestion in check, and Super Smooth refines pores and surface texture — revealing smoother, clearer skin every cycle."
    }
  },
  {
    "concerns": ["acne", "redness"],
    "routines": {
      "basic": "Acne and redness share a root: inflammation. This focused trio addresses both without overworking the barrier: Night Renewer's 10% glycolic acid clears pores gently, Nia 10's 10% niacinamide regulates oil and reduces redness and post-blemish inflammation, and Peptide Squad's soothing peptides reinforce a barrier that aggressive acne treatments often compromise.",
      "core": "A more complete approach treats blemishes while continuously calming reactive skin. Night Renewer's 10% glycolic acid keeps pores clear, Nia 10's 10% niacinamide regulates oil and reduces inflammation, Moonlight's encapsulated retinaldehyde renews cells with a Skin Comforting Complex of niacinamide, bisabolol, and aloe, and Peptide Squad's soy peptides reinforce skin from inside.",
      "advanced": "Our most comprehensive routine for reactive, blemish-prone skin balances gentle renewal with constant calming. Night Renewer, Nia 10, and Moonlight clear pores and renew cells without aggression, the Refresher's triple-AHA cleanser supports clarity, and Peptide Squad with Plush Cream layer in soothing peptides, bisabolol, and squalane — protecting the barrier through every step of acne care."
    }
  },
  {
    "concerns": ["acne", "wrinkles"],
    "routines": {
      "basic": "Adult acne and fine lines often appear together — and they respond to the same renewal-focused actives. This focused trio addresses both: Night Renewer's 10% glycolic acid keeps pores clear and smooths surface lines, Nia 10's 10% niacinamide regulates oil and supports skin firmness, and Glow Maker's 15% vitamin C defends collagen and brightens post-blemish marks.",
      "core": "A more complete approach treats blemishes and wrinkles with the same actives. Night Renewer's 10% glycolic acid resurfaces overnight, Nia 10's 10% niacinamide regulates oil and supports turnover, Moonlight's encapsulated retinaldehyde renews cells to heal blemishes and smooth fine lines, and Glow Maker's 15% vitamin C brightens post-blemish marks while protecting collagen.",
      "advanced": "Our most comprehensive routine for aging, blemish-prone skin works on every renewal cycle. Night Renewer, Moonlight, and Nia 10 clear pores and renew cells, the Refresher's triple-AHA cleanser supports continuous clarity, Glow Maker's 15% vitamin C brightens and protects, and Peptide Squad's four-peptide complex rebuilds collagen — addressing every angle of aging and active blemishes in one cohesive system."
    }
  }
];
const RESULTS_SUMMARY_ADDL = {
  "eye_concern": "We recommend adding Eye Enhancer De-puffing Peptide Cream to address dark circles, fine lines, and enhance radiance around the eyes.",
  "neck_concern": "We recommend adding Forever Firm Neck Treatment to firm crepey skin and soften the horizontal lines on the neck and décolleté.",
  "pregnant": "Since you're pregnant or breastfeeding, we've left retinoids out of your routine. As always, check with your doctor before adding new skincare products."
};
const EYE_CONCERN_OPTION = "Dark circles or puffiness around your eyes";
const NECK_CONCERN_OPTION = "Sagging, crepey texture or lines in your neck";
const parseEyeNeckAnswer = (selectedAnswer) => {
  if (Array.isArray(selectedAnswer)) {
    return {
      eye: selectedAnswer.includes(EYE_CONCERN_OPTION),
      neck: selectedAnswer.includes(NECK_CONCERN_OPTION)
    };
  }
  return { eye: selectedAnswer === "Yes", neck: false };
};
const quizQuestions = [
  {
    id: "skin_sensitivity",
    title: "Is Your Skin Sensitive?",
    titleMeta: "",
    options: [
      { label: "Yes", type: "text" },
      { label: "No", type: "text" }
    ],
    displayDirection: "row",
    canSkip: false,
    selectedAnswer: "",
    callout: "Don't worry, all our products are dermatologist-tested and formulated for sensitive skin."
  },
  {
    id: "main_skin_concern",
    title: "What Is Your Main Skin Concern?",
    titleMeta: "Select up to two options",
    options: skinConcerns,
    displayDirection: "column",
    canSkip: false,
    selectedAnswer: [],
    multiSelect: true,
    maxSelections: 2,
    // The first pick is the primary concern and drives the routine, so the
    // options are badged in the order they were chosen.
    rankSelections: true
  },
  {
    id: "eye_concern",
    title: "Do Either Of These Concern You?",
    titleMeta: "Select any that apply",
    options: [
      { label: EYE_CONCERN_OPTION, type: "text" },
      { label: NECK_CONCERN_OPTION, type: "text" }
    ],
    displayDirection: "column",
    canSkip: true,
    selectedAnswer: [],
    multiSelect: true,
    // Neither is a valid answer here (it replaces the old "No"), unlike the
    // concern question where a selection is required.
    allowNoSelection: true,
    callout: "The skin around the eyes and on the neck is thinner and more delicate than the rest of the face. We can factor either in by adding a treatment made for it."
  },
  {
    id: "pregnancy",
    title: "Are You Pregnant Or Breast Feeding?",
    titleMeta: "",
    options: [
      { label: "Yes", type: "text" },
      { label: "No", type: "text" }
    ],
    displayDirection: "row",
    canSkip: false,
    selectedAnswer: "",
    callout: "During pregnancy or breastfeeding, it's best to avoid retinoids, high-dose salicylic acid, hydroquinone, and chemical sunscreen filters like oxybenzone. We'll tailor your routine to keep things safe and effective for you and baby."
  },
  {
    id: "first_name",
    type: "name",
    title: "What Is Your First Name?",
    titleMeta: "",
    options: [],
    canSkip: true,
    selectedAnswer: ""
  },
  {
    id: "email_capture",
    type: "email",
    title: "Your Personalized Product Picks Are Ready!",
    titleMeta: "Enter your email to see your results and get 10% off your first subscription order",
    options: [],
    canSkip: true,
    selectedAnswer: ""
  }
];
const routineOptions = ["Basic", "Core", "Advanced"];
const RB_LOCALSTORAGE_KEY = "routine-finder-response";
const RB_CUSTOMER_EMAIL_SENT_LOCALSTORAGE_KEY = "routine-finder-email";
const QUIZ_RESET_HOURS = 1;
const ACTIVE_TAB_MAPPING = {
  0: "basic",
  1: "core",
  2: "advanced"
};
const ACTIVE_TAB_MAPPING_REVERSE = {
  "basic": 0,
  "core": 1,
  "advanced": 2
};
const PRODUCT_CONTENT = {
  glow_maker: {
    type: "Vitamin C serum",
    tagline: "Your skin, but brighter.",
    keyBenefits: [
      "Brightens tone, smooths fine lines, and shields against future sun damage",
      "Plumps and hydrates to counteract age-related dryness",
      "High-potency results without the stinging common to vitamin C"
    ],
    keyIngredients: [
      { label: "Antioxidant Trio", detail: "15% Vitamin C + Vitamin E + Ferulic Acid" },
      { label: "Hydration", detail: "Hyaluronic Acid" },
      { label: "Calming Complex", detail: "Aloe, Grape Seed, Magnolia Bark" }
    ],
    quote: { body: '"My skin has a bounce."', who: "Susan G. · 8 wks" },
    learnMore: "Full ingredients & study",
    whyForYou: {
      default: "This is the AM step that protects your progress and keeps tone even all day.",
      dark_spots: "For dark spots, vitamin C is the daytime workhorse that blocks new pigment while it brightens.",
      uneven_texture: "You flagged uneven tone. Vitamin C evens things out and makes every other step show up.",
      wrinkles: "You flagged dullness as a top frustration. This is the AM step that makes the rest of the routine actually show up on camera."
    }
  },
  moonlight: {
    type: "Retinal serum",
    tagline: "Gentle overnight smoothing.",
    keyBenefits: [
      "Prescription-like retinoid results with far less irritation",
      "Softens fine lines, refines texture, and minimizes the look of pores",
      "No typical retinoid redness or flaking"
    ],
    keyIngredients: [
      { label: "The Retinoid", detail: "0.11% Encapsulated Retinaldehyde" },
      { label: "Skin Comforting Complex", detail: "Niacinamide, Bisabolol, Aloe" },
      { label: "Moisture Shield", detail: "Ceramides, Squalane, Hyaluronic Acid" }
    ],
    quote: { body: '"No bad smell, melts right in."', who: "Brooke T. · 5 wks" },
    learnMore: "Start-slow protocol & FAQ",
    whyForYou: {
      default: "Retinaldehyde is the most-studied anti-aging active. Ours is encapsulated to work without redness.",
      wrinkles: "Fine lines were your top concern. Retinaldehyde is the most-studied anti-aging active, and ours works without the redness.",
      acne: "For breakouts, retinal keeps pores clear and refines texture while you sleep."
    }
  },
  peptide_squad: {
    type: "Peptide serum",
    tagline: "Four peptides for firmer skin.",
    keyBenefits: [
      "The only serum with all four categories of wrinkle-fighting peptides",
      "Fortifies the skin’s protective barrier, which weakens with age",
      "Draws moisture into the skin for a smooth, plump appearance"
    ],
    keyIngredients: [
      { label: "4-Peptide Complex", detail: "Copper Tripeptide-1, Matrixyl 3000, Argireline, Rice Peptides" },
      { label: "Calm & Barrier Support", detail: "Niacinamide, Panthenol, Ceramides" },
      { label: "Hydration Boost", detail: "Hyaluronic Acid, Glycerin" }
    ],
    quote: { body: '"Look five years younger."', who: "Mara S. · 12 wks" },
    learnMore: "Peptide science explainer",
    whyForYou: {
      default: "This is the slow-burn collagen step that pays off long-term.",
      wrinkles: "You marked skin feeling less firm than it used to. This is the slow-burn collagen step that pays off long-term.",
      redness: "Copper peptides calm and strengthen the barrier while they firm, ideal for reactive skin."
    }
  },
  hydrator: {
    type: "Hydrating serum",
    tagline: "Instant fix for dry, tight skin.",
    keyBenefits: [
      "Draws water into the skin to smooth dehydration lines and plump the surface",
      "Conditions for soft, resilient, comfortable skin",
      "Helps neutralize environmental stressors"
    ],
    keyIngredients: [
      { label: "Moisture Magnet", detail: "Hyaluronic Acid" },
      { label: "Soothing & Conditioning", detail: "Panthenol (Provitamin B5)" },
      { label: "Super Antioxidant", detail: "Resveratrol" }
    ],
    quote: { body: '"Tightness, gone."', who: "Erika P. · 4 wks" },
    learnMore: "Full ingredient list",
    whyForYou: {
      default: "Anti-aging actives can only work on a hydrated barrier. This is the foundation that goes first.",
      dryness: "You marked tightness plus dryness. This is the foundation that hydrates every layer so the actives can work.",
      redness: "B5 and hyaluronic acid calm reactive skin and rebuild a barrier that holds water."
    }
  },
  night_renewer: {
    type: "Resurfacing serum",
    tagline: "Smoother, brighter skin by morning.",
    keyBenefits: [
      "Unglues and sweeps away dead cells to smooth rough texture",
      "Clears clogged pores and neutralizes redness",
      "Signals fresh collagen for a firmer appearance"
    ],
    keyIngredients: [
      { label: "The Resurfacer", detail: "10% Glycolic Acid" },
      { label: "Soothing Botanicals", detail: "Arnica, Aloe, Mugwort" },
      { label: "Moisturizing Trio", detail: "Squalane, Shea Butter, Hyaluronic Acid" }
    ],
    quote: { body: '"My pores basically disappeared."', who: "Dana R. · 6 wks" },
    learnMore: "How to use glycolic acid",
    whyForYou: {
      default: "A gentle overnight resurfacer that keeps texture smooth and pores clear.",
      acne: "For breakouts, glycolic acid keeps pores clear and fades post-acne marks overnight.",
      uneven_texture: "You flagged uneven texture, so this nightly resurfacer is the fastest path to a smoother surface."
    }
  },
  hydro_relief: {
    type: "Moisturizer",
    tagline: "Upgrade to hydration that actually lasts.",
    keyBenefits: [
      "Rice amino acids and soy peptides replenish moisture for a smoother complexion",
      "Squalane, shea butter, and jojoba seal in moisture without grease",
      "Niacinamide and panthenol fortify the barrier against stressors"
    ],
    keyIngredients: [
      { label: "Moisture Replenishers", detail: "Soy Peptides, Rice Amino Acids" },
      { label: "Barrier Seal", detail: "Squalane, Shea Butter, Jojoba Esters" },
      { label: "Barrier Support", detail: "Niacinamide, Panthenol" }
    ],
    quote: { body: '"Finally relief for my dry patches."', who: "Nina K. · 5 wks" },
    learnMore: "Full ingredient list",
    whyForYou: {
      default: "An extra layer of lasting moisture for skin that runs dry.",
      dryness: "You marked persistent dryness, so this seals in moisture so skin stays comfortable all day."
    }
  },
  fade_away: {
    type: "Dark spot serum",
    tagline: "Fade stubborn spots and patches.",
    keyBenefits: [
      "Visibly fades dark spots, sun damage, and melasma",
      "Potent brightening without typical irritation or redness"
    ],
    keyIngredients: [
      { label: "Targeted Fading Trio", detail: "Alpha Arbutin, Kojic Acid, Licorice Root" },
      { label: "Future Spot Prevention", detail: "Glutathione, Red Algae" },
      { label: "Botanical Complex", detail: "Aloe, Thyme, Neem, Cucumber" }
    ],
    quote: { body: '"My sun spots are actually fading."', who: "Priya M. · 10 wks" },
    learnMore: "How brightening works",
    whyForYou: {
      default: "A gentle, targeted brightener for stubborn discoloration.",
      dark_spots: "Dark spots were your top concern, so this is the dedicated brightener that lightens existing pigment."
    }
  },
  nia_10: {
    type: "Niacinamide serum",
    tagline: "Finally quiets redness and flare-ups.",
    keyBenefits: [
      "Calms redness",
      "Strengthens the skin barrier"
    ],
    keyIngredients: [
      { label: "Niacinamide (Vitamin B3)", detail: "" },
      { label: "Redness & Pore Control", detail: "Zinc PCA, Mushroom Extract, Witch Hazel" },
      { label: "Irritation Insurance", detail: "Aloe, White Tea" }
    ],
    quote: { body: '"My redness is so much calmer."', who: "Leah B. · 6 wks" },
    learnMore: "Full ingredient list",
    whyForYou: {
      default: "Niacinamide calms, balances oil, and refines pores. A quiet multitasker.",
      redness: "You flagged redness, and 10% niacinamide is the calming, barrier-strengthening step that settles it.",
      oil_control: "For oil and pores, niacinamide balances sebum and tightens the look of pores.",
      acne: "Niacinamide calms inflammation and keeps breakouts from leaving marks."
    }
  },
  exfoliator: {
    type: "Exfoliating scrub",
    tagline: "Instantly smoother skin.",
    keyBenefits: [
      "Pore-clearing trio deep-cleans while buffing away rough patches",
      "Calm & comfort blend keeps skin balanced during exfoliation"
    ],
    keyIngredients: [
      { label: "Pore-Clearing Trio", detail: "Salicylic Acid, Kaolin Clay, Diatomaceous Earth" },
      { label: "Calm & Comfort Blend", detail: "Niacinamide, Allantoin, Glycerin, Honeysuckle" }
    ],
    quote: { body: '"The only scrub that doesn’t dry me out."', who: "Tom H. · 4 wks" },
    learnMore: "How to exfoliate safely",
    whyForYou: {
      default: "A weekly reset that lifts buildup so the rest of your routine reaches deeper.",
      oil_control: "For oily, congested skin, this BHA + clay step clears pores weekly without over-drying.",
      uneven_texture: "This weekly deep-clean smooths rough texture and lets your serums absorb."
    }
  },
  super_smooth: {
    type: "Smoothing serum",
    tagline: "Silky smooth texture, delivered gently.",
    keyBenefits: [
      "Skin feels noticeably smoother and more hydrated",
      "Texture refines and rough patches soften",
      "Makeup applies more evenly"
    ],
    keyIngredients: [
      { label: "Peptide Technology", detail: "Perfection Peptide P3" },
      { label: "Multi-Acid Blend", detail: "Lactic, Glycolic, Tartaric & Salicylic Acids" },
      { label: "Soothing Buffer", detail: "Argan Oil, Resveratrol, Hyaluronic Acid" }
    ],
    quote: { body: '"My T-zone finally behaves."', who: "Alex W. · 5 wks" },
    learnMore: "Full ingredient list",
    whyForYou: {
      default: "A daily smoother that keeps texture refined and shine in check.",
      oil_control: "You flagged oil and pores, so this is the daily step that refines texture and controls shine.",
      uneven_texture: "You flagged uneven texture, so this smooths the surface day over day."
    }
  },
  sheer_silk: {
    type: "Ceramide cleanser",
    tagline: "Luxurious, rich and creamy. Ideal for dry skin.",
    keyBenefits: [
      "Ceramides, cholesterol, and HA mimic a luxury moisturizer",
      "Coconut-derived cleansers lift impurities without harming the barrier",
      "A botanical complex soothes skin and calms redness"
    ],
    keyIngredients: [
      { label: "Barrier Lipids", detail: "Ceramides, Cholesterol, Hyaluronic Acid" },
      { label: "Soothing Botanicals", detail: "Cucumber, Aloe, Grape Seed, Green Tea" }
    ],
    quote: { body: '"Light but it actually moisturizes."', who: "Gina F. · 4 wks" },
    learnMore: "Full ingredient list",
    whyForYou: { default: "A weightless finish that seals in moisture without any heaviness." }
  },
  love_31: {
    type: "Facial oil",
    tagline: "Botanical facial oil with a beautiful aroma.",
    keyBenefits: [
      "Sinks in instantly to soothe redness and balance the complexion",
      "Deeply hydrating but never heavy or greasy",
      "Locks in a dewy, spa-like glow"
    ],
    keyIngredients: [
      { label: "Barrier Repair", detail: "Evening Primrose, Argan, Hemp" },
      { label: "Healing & Radiance", detail: "Tamanu, Pomegranate, Rosehip" },
      { label: "Dry-Oil Base", detail: "Grapeseed, Squalane, Jojoba" }
    ],
    quote: { body: '"The sunscreen I actually reach for."', who: "Hannah D. · daily" },
    learnMore: "About this oil",
    whyForYou: { default: "A nourishing finish that locks in moisture and gives a dewy glow." }
  },
  refresher: {
    type: "AHA cleanser",
    tagline: "Ideal cleanser for oily skin.",
    keyBenefits: [
      "Cleanses without stripping",
      "Unclogs pores",
      "Gently exfoliates"
    ],
    keyIngredients: [
      { label: "Triple AHA Blend", detail: "Lactic, Tartaric & Malic Acids" }
    ],
    quote: { body: '"Great midday reset."', who: "Cara L. · 3 wks" },
    learnMore: "Full ingredient list",
    whyForYou: { default: "A balancing prep step that helps the rest of the routine absorb." }
  },
  plush_cream: {
    type: "Moisturizer",
    tagline: "Moisturizes without being greasy.",
    keyBenefits: [
      "Weightless hydration that plumps and smooths fine lines",
      "Strengthens defenses and quiets redness through barrier repair",
      "Velvety finish that locks in serums and sits well under makeup"
    ],
    keyIngredients: [
      { label: "Humectants", detail: "Hyaluronic Acid, Glycerin" },
      { label: "Barrier & Calm", detail: "Niacinamide, Panthenol, Bisabolol" },
      { label: "Nourishing Oils", detail: "Squalane, Marula Oil, White Tea" }
    ],
    quote: { body: '"My skin drinks this up."', who: "Maya T. · 5 wks" },
    learnMore: "Full ingredient list",
    whyForYou: {
      default: "A rich seal that repairs the barrier and locks everything in overnight.",
      redness: "For reactive skin, ceramides rebuild the barrier so it stays calm and comfortable."
    }
  },
  additional_eye_enhancer: {
    type: "Eye cream",
    tagline: "Coffee for your eyes.",
    keyBenefits: [
      "Eyeseryl peptide reduces under-eye puffiness",
      "Argireline relaxes muscles to soften expression lines",
      "Caffeine boosts circulation to de-puff and reduce dark circles"
    ],
    keyIngredients: [
      { label: "De-Puffing Peptides", detail: "Eyeseryl, Argireline" },
      { label: "Circulation Boost", detail: "Caffeine" },
      { label: "Light Hydration", detail: "Hyaluronic Acid, Camellia Oil, Squalane" }
    ],
    quote: { body: '"My dark circles finally lifted."', who: "Rachel S. · 6 wks" },
    learnMore: "Full ingredient list",
    whyForYou: { default: "You flagged the eye area, so this dedicated treatment targets puffiness and dark circles." }
  },
  forever_firm: {
    type: "Neck treatment",
    tagline: "Skincare below the jawline.",
    keyBenefits: [
      "Firms crepey, loose skin on the neck",
      "Softens the look of horizontal neck lines",
      "Hydrates the often-neglected décolleté"
    ],
    keyIngredients: [
      { label: "Firming Peptides", detail: "support firmness and elasticity" },
      { label: "Nourishing Emollients", detail: "soften and smooth the skin" }
    ],
    quote: { body: '"The skin is definitely firmer and not crepey."', who: "Sheryl W." },
    learnMore: "Full ingredient list",
    whyForYou: { default: "This treatment extends your routine past the jawline, where skin ages just as fast but rarely gets treated." }
  }
};
const SLUG_BY_PRODUCT_ID = Object.fromEntries(
  Object.entries(PRODUCT_MAPPING).map(([slug, v2]) => [String(v2.product_id), slug])
);
const getProductContent = (product) => product && PRODUCT_CONTENT[SLUG_BY_PRODUCT_ID[String(product.id)]] || null;
const getSlugForProduct = (product) => product && SLUG_BY_PRODUCT_ID[String(product.id)] || null;
const productAnchorId = (slug) => slug ? `rbm-product-${slug}` : void 0;
const getShortName = (product) => {
  var _a2;
  const slug = getSlugForProduct(product);
  return slug && ((_a2 = PRODUCT_MAPPING[slug]) == null ? void 0 : _a2.title) || (product == null ? void 0 : product.title) || "";
};
const CURATED_REVIEWS = {
  glow_maker: [
    { quote: "I have a glow on my face and I get a lot of compliments that I look younger.", name: "Andrea C.", concerns: ["dark_spots", "acne", "oil_control"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/101f3680-a76f-49fc-ae79-9188432d7623.jpg?d=120x120&crop=center" }
  ],
  moonlight: [
    { quote: "The Moonlight Serum leaves my skin feeling smooth, calm, and visibly more even.", name: "Vanessa M.", concerns: ["wrinkles", "redness"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/70c49df2-3b1b-4793-96a2-8f5b06f4982e.jpg?d=120x120&crop=center" }
  ],
  peptide_squad: [
    { quote: "My face feels somewhat tighter and my complexion looks a little better and more glowy.", name: "Jennifer T.", concerns: ["wrinkles", "dryness"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/ae80fb80-1f6f-465f-b3ee-c04ca943cfa5.jpg?d=120x120&crop=center" },
    { quote: "Definitely decreased my fine lines — it’s amazing.", name: "Kristen M.", concerns: ["wrinkles", "dark_spots"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/ac4852f8-9388-42dc-880b-b8a47e7baf38.jpg?d=120x120&crop=center" }
  ],
  hydrator: [
    { quote: "Has made my skin soft, bright, and is helping to minimize fine lines and wrinkles.", name: "Stephanie N.", concerns: ["wrinkles", "dark_spots"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/5046a0bd-f8bb-4433-adee-68052966e457.jpg?d=120x120&crop=center" },
    { quote: "I see results after about 3 weeks — my skin is so much more hydrated!", name: "Ulia P.", concerns: [], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/cd545b6b-7c82-40a4-ae62-34af3392d794.jpg?d=120x120&crop=center" }
  ],
  night_renewer: [
    { quote: "The texture is rich but not heavy, and it gently helps even out tone and texture over time.", name: "Vanessa M.", concerns: ["wrinkles", "redness"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/26f6064f-cfe4-406e-a389-0bc572c76aa3.jpg?d=120x120&crop=center" },
    { quote: "After just a few uses, I noticed my skin felt softer and looked more even.", name: "Natasha A.", concerns: ["wrinkles", "dark_spots", "dryness", "redness", "acne"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/ee9e7a23-0609-40fc-a0f9-fc622f2d4da8.jpg?d=120x120&crop=center" }
  ],
  hydro_relief: [
    { quote: "I noticed my fine lines are a lot fewer and my face actually glows!", name: "Paulette K.", concerns: ["wrinkles", "dark_spots", "dryness", "oil_control"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/96f68467-8a24-4e6d-abe6-4b730dee736d.jpg?d=120x120&crop=center" },
    { quote: "I use it as a night cream, and when I wake up my skin is very soft and not flaky.", name: "Barbara J.", concerns: ["wrinkles", "dryness"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/409a526e-ed8d-4c5a-994e-3aaeab47cffc.jpg?d=120x120&crop=center" }
  ],
  fade_away: [
    { quote: "I’ve tried a lot of products for my post-acne marks, but none worked as fast as this!", name: "Jazzie G.", concerns: ["dark_spots", "acne"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/e110bf03-bf71-4e3b-b1a0-35947516a97e.jpg?d=120x120&crop=center" }
  ],
  nia_10: [
    { quote: "This serum is my absolute favorite for calming redness on my face.", name: "Amy B.", concerns: ["wrinkles", "redness"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/7200312e-a369-4380-841d-235de3234029.jpg?d=120x120&crop=center" }
  ],
  exfoliator: [
    { quote: "The texture is gritty but not harsh, and it leaves my skin feeling super smooth every time.", name: "Ja'Nya J.", concerns: ["dryness", "acne"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/6896309d-c206-4a47-9a99-435122547aa6.jpg?d=120x120&crop=center" },
    { quote: "I’m 74 and still have some lines and wrinkles, but overall I’m happy with the improvements in the texture of my skin.", name: "Alice A.", concerns: ["wrinkles", "dryness", "redness"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/9cefd579-3c50-4f7a-99a8-bd10a28c471e.jpg?d=120x120&crop=center" }
  ],
  super_smooth: [
    { quote: "This has helped even my skin tone, prevent breakouts, and cut down on fine lines and wrinkles.", name: "Holly P.", concerns: ["wrinkles", "dark_spots", "dryness"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/17f7a9d2-9ee7-417a-8fe0-094b32c8e6f9.jpg?d=120x120&crop=center" },
    { quote: "My dark spots on my face and chest are starting to fade.", name: "Kristine K.", concerns: ["wrinkles", "dark_spots", "dryness"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/9d952b67-1205-4aed-80ff-7146840e1265.jpg?d=120x120&crop=center" }
  ],
  sheer_silk: [
    { quote: "It leaves my skin feeling so soft and doesn’t irritate it at all.", name: "Kela P.", concerns: ["dark_spots", "dryness", "redness"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/22a1ec94-394c-4f94-bfcd-f306750c8016.jpg?d=120x120&crop=center" },
    { quote: "Not many cream cleansers leave your face feeling clean with the benefit of soft skin afterwards — this one does.", name: "Ryan D.", concerns: ["dryness", "redness", "acne"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/400176c1-41f3-420f-bc00-b925c48eaf5d.jpg?d=120x120&crop=center" }
  ],
  love_31: [
    { quote: "This oil has significantly reduced the fine lines under my eyes creasing during the day.", name: "Hannah K.", concerns: ["wrinkles", "dryness", "acne"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/5a8271f3-33c1-4a6f-9e46-3e8bb91a37ae.jpg?d=120x120&crop=center" },
    { quote: "I use this as the last step in my nightly routine and wake up with super soft skin.", name: "Karen I.", concerns: ["wrinkles", "redness"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/4af36721-1563-4388-97f6-d714d3628af4.jpg?d=120x120&crop=center" }
  ],
  refresher: [
    { quote: "It smells like a spa and leaves my skin so smooth!", name: "Nicole A.", concerns: ["wrinkles", "dark_spots", "dryness", "redness"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/42fc64f5-4aa5-4f5f-8582-8581822f859a.jpg?d=120x120&crop=center" },
    { quote: "This cleanser is gentle, yet effective, and I can definitely see a difference in my skin’s appearance.", name: "Kassandra D.", concerns: ["dryness", "redness", "acne"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/90cbb686-9ad2-44ad-9b4d-e6a7359ad046.jpg?d=120x120&crop=center" }
  ],
  plush_cream: [
    { quote: "Since adding it to my routine, I’ve noticed a big difference: way fewer dry patches and smoother skin overall.", name: "Ja'Nya J.", concerns: ["dryness", "acne"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/3fdfd8c4-b1fe-4d3a-9f34-26d28115a70a.jpg?d=120x120&crop=center" },
    { quote: "Love the moisturizer as it’s very comfortable to wear, even under makeup!", name: "Rosanne D.", concerns: ["wrinkles", "dark_spots", "dryness"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/0d4c2e70-9155-4a7a-9a55-3e41e0c0a872.jpg?d=120x120&crop=center" }
  ],
  additional_eye_enhancer: [
    { quote: "People have asked if I’m getting Botox treatments — no, just using Maelove and seeing incredible results!", name: "Patricia C.", concerns: ["wrinkles", "dryness"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/e127f883-c7ae-412a-93db-88fd564edd56.jpg?d=120x120&crop=center" },
    { quote: "I can honestly say that my eye wrinkles have shrunk.", name: "Mary C.", concerns: ["wrinkles", "dark_spots", "dryness"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/7d57488b-f223-4157-896d-964e21a14963.jpg?d=120x120&crop=center" }
  ],
  forever_firm: [
    { quote: "I get compliments on my skin frequently, which amazes me at my age.", name: "Deborah H.", concerns: ["wrinkles", "dark_spots"], photo: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/b1b92abc-3d68-46e4-9523-86b2038bf9e8.jpg?d=120x120&crop=center" }
  ]
};
const getCuratedReview = (product, concern) => {
  const slug = getSlugForProduct(product);
  const pool = slug && CURATED_REVIEWS[slug];
  if (!pool || !pool.length) return null;
  const matched = pool.filter((r2) => r2.concerns.includes(concern));
  const list = matched.length ? matched : pool;
  let h = 0;
  for (let i = 0; i < slug.length; i++) h = h + slug.charCodeAt(i) | 0;
  return list[Math.abs(h) % list.length];
};
const CONCERN_PRODUCT_SLUGS = Object.fromEntries(
  Object.entries(SKIN_CONCERN_PRODUCTS).map(([concern, tiers]) => {
    const slugs = [];
    (tiers.core || []).forEach((p2) => {
      const slug = SLUG_BY_PRODUCT_ID[String(p2.product_id)];
      if (slug && !slugs.includes(slug)) slugs.push(slug);
    });
    return [concern, slugs];
  })
);
const CONCERN_CONTENT = {
  wrinkles: {
    label: "Fine lines & wrinkles",
    how: "Retinaldehyde drives cell turnover overnight, and copper peptides signal firmer, plumper skin while you sleep. A slow, sensitive-skin-safe path to smoother texture.",
    productSlugs: ["moonlight", "peptide_squad"]
  },
  dark_spots: {
    label: "Hyperpigmentation & dark spots",
    how: "Targeted brighteners lighten existing pigment while 15% Vitamin C blocks new spots and protects against the sun that drives them.",
    productSlugs: ["fade_away", "glow_maker"]
  },
  dryness: {
    label: "Dryness & tightness",
    how: "Three molecular weights of hyaluronic acid plus B5 hydrate every layer of skin, the foundation that lets anti-aging actives actually show up.",
    productSlugs: ["hydrator", "hydro_relief"]
  },
  redness: {
    label: "Redness & irritation",
    how: "10% niacinamide calms reactivity while ceramides and peptides rebuild a barrier that stays comfortable instead of flaring.",
    productSlugs: ["nia_10", "plush_cream"]
  },
  acne: {
    label: "Acne & blemishes",
    how: "Glycolic acid keeps pores clear overnight while niacinamide calms inflammation and stops breakouts from leaving marks.",
    productSlugs: ["night_renewer", "nia_10"]
  },
  uneven_texture: {
    label: "Uneven texture",
    how: "A daily smoother plus a weekly resurfacer refine the surface, while niacinamide tightens the look of pores over time.",
    productSlugs: ["super_smooth", "exfoliator"]
  },
  oil_control: {
    label: "Oil control & pores",
    how: "Niacinamide balances sebum and a BHA + clay step clears congestion weekly, so shine and pores both come down without over-drying.",
    productSlugs: ["super_smooth", "nia_10"]
  }
};
const CONCERN_PRODUCT_BLURB = {
  wrinkles: {
    glow_maker: "Glow Maker's 15% vitamin C with ferulic acid defends collagen against free-radical damage by day",
    moonlight: "Moonlight's encapsulated retinaldehyde accelerates cell renewal overnight to smooth existing lines",
    peptide_squad: "Peptide Squad's four-peptide complex signals your skin to rebuild firmness from the inside",
    night_renewer: "Night Renewer's 10% glycolic acid resurfaces while you sleep, sloughing the dull surface layer where fine lines look deepest"
  },
  dark_spots: {
    fade_away: "Fade Away pairs alpha arbutin, kojic acid, and licorice root (three non-irritating brighteners) to lighten existing discoloration",
    glow_maker: "Glow Maker's 15% vitamin C blocks new pigment through antioxidant defense",
    moonlight: "Moonlight's encapsulated retinaldehyde speeds cell turnover so darker skin sloughs away faster",
    nia_10: "Nia 10's 10% niacinamide calms the inflammation that triggers new pigmentation while strengthening your barrier"
  },
  dryness: {
    hydrator: "Hydrator draws hyaluronic acid and vitamin B5 deep into the skin and keeps it there",
    hydro_relief: "Hydro Relief's rich cream seals moisture in with soy peptides, rice amino acids, and squalane",
    peptide_squad: "Peptide Squad's collagen-signaling peptides plump skin from underneath so it stays smooth and supple",
    sheer_silk: "Sheer Silk's ceramide cleanser hydrates while it removes the day instead of stripping your barrier"
  },
  oil_control: {
    super_smooth: "Super Smooth's blend of glycolic, lactic, and salicylic acids dissolves oil-trapping buildup and refines texture",
    nia_10: "Nia 10's 10% niacinamide regulates oil at the source and tightens the look of pores",
    exfoliator: "the Exfoliator's BHA and kaolin clay scrub draws excess sebum out of clogged pores",
    night_renewer: "Night Renewer's 10% glycolic acid resurfaces overnight so you wake up to less shiny skin"
  },
  uneven_texture: {
    super_smooth: "Super Smooth's blend of glycolic, lactic, and salicylic acids dissolves the rough surface layer",
    nia_10: "Nia 10's 10% niacinamide refines pores and supports a healthier turnover cycle",
    exfoliator: "the Exfoliator's BHA-and-clay scrub lifts away buildup for an immediately smoother finish",
    night_renewer: "Night Renewer's 10% glycolic acid resurfaces overnight, revealing the softer skin underneath"
  },
  redness: {
    nia_10: "Nia 10's 10% niacinamide calms redness and reactivity while reinforcing your barrier",
    peptide_squad: "Peptide Squad layers in soothing soy peptides, hyaluronic acid, and niacinamide to keep skin calm and resilient",
    plush_cream: "Plush Cream's lightweight blend of niacinamide and bisabolol soothes flare-ups without feeling heavy",
    hydrator: "Hydrator's hyaluronic acid and B5 keep dehydration (a hidden driver of redness) at bay"
  },
  acne: {
    night_renewer: "Night Renewer's 10% glycolic acid keeps pores clear by dissolving the buildup that traps breakouts",
    nia_10: "Nia 10's 10% niacinamide regulates oil and calms post-blemish redness",
    moonlight: "Moonlight's encapsulated retinaldehyde speeds cell turnover so blemishes heal faster and fewer form",
    refresher: "the Refresher's triple-AHA blend clears congestion at the very first step"
  }
};
const buildConcernHow = (concern, productSlugs) => {
  var _a2;
  const clauses = CONCERN_PRODUCT_BLURB[concern] || {};
  const parts = (productSlugs || []).map((slug) => clauses[slug]).filter(Boolean).map((clause) => clause.charAt(0).toUpperCase() + clause.slice(1));
  if (!parts.length) return ((_a2 = CONCERN_CONTENT[concern]) == null ? void 0 : _a2.how) || "";
  return `${parts.join(". ")}.`;
};
const CONCERN_TIMELINE = {
  wrinkles: [
    { when: "Week 1", title: "Calmer & comfortable", body: "The hydrating and peptide steps settle in first, so **skin feels softer, plumper to the touch**, and your retinal stays comfortable with no 'retinol burn'.", add: "Fine lines also look a little softer as skin plumps with hydration." },
    { when: "Week 4", title: "Smoother & more radiant", body: "Tone evens and dullness lifts as vitamin C gets to work; skin looks brighter and **fine lines start to soften** in side-light.", add: "Expression lines and crow’s-feet begin to look smoother." },
    { when: "Week 8", title: "Lines visibly soften", body: "Your retinal refines the surface, so **fine lines and wrinkles visibly soften**, pores look smaller, and texture smooths.", add: "Deeper lines keep softening as cell turnover ramps up." },
    { when: "Week 12+", title: "Firmer & resilient", body: "Collagen-supporting peptides and retinal build firmness; **skin looks plumper, bounces back**, and the effect keeps compounding.", add: "Firmness and elasticity keep improving the longer you stay consistent." }
  ],
  dark_spots: [
    { when: "Week 1", title: "Calmer, more even start", body: "**Skin looks less blotchy** in the morning and new marks are less likely to set in deeply.", add: "Redness around marks calms so discoloration looks less angry." },
    { when: "Week 4", title: "Brighter & clearer", body: "Daily vitamin C and brightening actives lift dullness, so **skin looks more radiant** and overall tone starts to even out.", add: "Skin also looks brighter and more luminous overall." },
    { when: "Week 8", title: "Spots visibly fade", body: "**Dark spots visibly lighten** and melasma softens around the edges; tone looks noticeably more even.", add: "Dark spots also start to lighten and tone looks more even." },
    { when: "Week 12+", title: "Even, luminous tone", body: "With steady twice-daily use **discoloration keeps fading**, and many people reach for less concealer as tone evens and stays balanced.", add: "Stubborn spots keep fading the longer you stay consistent." }
  ],
  dryness: [
    { when: "Week 1", title: "Soft & comfortable", body: "Hydration lands fast, and the tight, dehydrated 'mask' feeling disappears as **skin feels cool, soft, and supple**.", add: "Skin also feels more hydrated and comfortable from the first few days." },
    { when: "Week 4", title: "Plump & smooth", body: "**Dry patches smooth out** and fine lines caused by dehydration plump up; makeup goes on more evenly.", add: "Dry patches smooth and skin holds moisture better." },
    { when: "Week 8", title: "Barrier strengthens", body: "Your **barrier feels more resilient**, so skin stays comfortable longer between applications and looks healthier and more radiant.", add: "The barrier feels stronger and skin stays comfortable longer." },
    { when: "Week 12+", title: "Resilient & dewy", body: "Consistent moisture and barrier support add up: **skin looks dewy, calm**, and far less prone to tightness or flaking.", add: "Hydration holds and flaking stays away with continued use." }
  ],
  redness: [
    { when: "Week 1", title: "Calmer & less reactive", body: "Soothing niacinamide and barrier support kick in first, so **skin feels calmer, less reactive**, and the tight, irritated feeling eases.", add: "Skin also looks calmer and less flushed." },
    { when: "Week 4", title: "Visibly soothed", body: "**Redness starts to visibly soften** and skin overreacts less to triggers; tone looks more balanced.", add: "Redness softens and tone looks more balanced." },
    { when: "Week 8", title: "More resilient", body: "The barrier feels noticeably more resilient, so **flare-ups settle faster** and overall redness keeps fading.", add: "Flare-ups settle faster as the barrier strengthens." },
    { when: "Week 12+", title: "Even & balanced", body: "Skin looks calm and even-toned, with **redness kept in check** as your barrier stays strong day to day.", add: "Calm, even tone holds with continued daily use." }
  ],
  acne: [
    { when: "Week 1", title: "Clearer & balanced", body: "Clarifying acids begin lifting the oil and buildup that clog pores; **skin feels cleaner and smoother** without feeling stripped.", add: "Pores also feel clearer and skin looks less congested." },
    { when: "Week 4", title: "Fewer breakouts", body: "Oil balances and pores stay clearer, so you'll notice **fewer new breakouts** and less congestion across the T-zone.", add: "Breakouts become less frequent as pores stay clear." },
    { when: "Week 8", title: "Smoother & calmer", body: "**Post-blemish marks look calmer** and texture smooths as resurfacing keeps pores clear overnight.", add: "Post-acne marks calm and texture smooths." },
    { when: "Week 12+", title: "Clear & even", body: "**Skin looks clearer and more even**, with breakouts kept in check and marks continuing to fade.", add: "Clarity holds and old marks keep fading with steady use." }
  ],
  uneven_texture: [
    { when: "Week 1", title: "Smoother to the touch", body: "Gentle resurfacing makes skin feel deep-cleaned and **touchably soft right away**, and your serums absorb better.", add: "Skin also feels smoother and more polished." },
    { when: "Week 4", title: "Refined surface", body: "**Texture refines** as rough patches soften, so makeup applies more evenly and skin looks clearer and more rested.", add: "Rough patches soften and the surface looks more refined." },
    { when: "Week 8", title: "Pores look smaller", body: "Resurfacing actives smooth the surface, so **pores look smaller**, bumps reduce, and fine surface lines soften.", add: "Pores look smaller and surface bumps reduce." },
    { when: "Week 12+", title: "Smooth & even", body: "Texture, pore appearance, and tone keep improving with continued use, leaving skin **smooth and evenly polished**.", add: "Texture and tone keep refining the longer you stay consistent." }
  ],
  oil_control: [
    { when: "Week 1", title: "Balanced & fresh", body: "Clarifying and sebum-balancing steps lift excess oil and buildup; **skin feels clean and fresh** without the dry-then-oily rebound.", add: "Skin also looks less shiny as oil starts to balance." },
    { when: "Week 4", title: "Matte & clearer", body: "Oil production balances, so you'll **stay matte a few hours longer**, pores look clearer, and shine is easier to manage.", add: "You stay matte longer as oil production balances." },
    { when: "Week 8", title: "Pores refined", body: "**Pores look smaller and clearer** as buildup stays dissolved, and tone looks more even and bright.", add: "Pores look refined and tone looks more even." },
    { when: "Week 12+", title: "Balanced & even", body: "Sebum stays regulated and pores stay clear, leaving skin looking **balanced, smooth, and even** day to day.", add: "Oil stays regulated and pores stay clear with continued use." }
  ],
  // Fallback when the primary concern is missing or unmapped — the original
  // generic copy. No `add` needed (only ever used as the primary set).
  default: [
    { when: "Week 1", title: "Calmer, more comfortable", body: "The hydrating, barrier-supporting steps work first. **Skin feels softer, calmer**, and less tight within days." },
    { when: "Week 4", title: "Plumper & more even", body: "Tone starts to even and hydration holds. Dullness lifts and **skin looks plumper and healthier**." },
    { when: "Week 8", title: "Smoother texture", body: "Resurfacing actives refine the surface. **Texture smooths**, pores look smaller, and fine lines soften in side-light." },
    { when: "Week 12+", title: "Firmer & resilient", body: "Collagen-supporting actives build firmness. **Skin looks plumper and bounces back**." }
  ]
};
const FAQ_CONTENT = [
  { q: "What if it doesn't work for my skin?", a: "You have 100 days to return it for a full refund, including the bottles you've already opened. We'll even cover the return shipping. No questions." },
  { q: "Can I customize what's in this routine?", a: "Yes. The default is the routine we recommend based on your quiz, but you can swap products in or out at any time." },
  { q: "How does Family Circle subscription work?", a: "You pick a cadence (every 1, 2, or 3 months) and we ship automatically at up to 20% off. Pause, edit, or cancel any time from your account. No calls, no forms." },
  { q: "Pregnancy & nursing safe?", a: "Most of our serums are pregnancy-safe. Retinoids like Moonlight should be paused during pregnancy and nursing. If you told us you're expecting, we've already left them out of your routine." }
];
const LAYERING = [
  { slug: "sheer_silk", layer: "cleanse", am: true, pm: true },
  { slug: "refresher", layer: "cleanse", am: true, pm: true },
  { slug: "exfoliator", layer: "cleanse", am: false, pm: true, freq: "Up to 3× a week" },
  { slug: "glow_maker", layer: "serum", am: true, pm: false },
  { slug: "super_smooth", layer: "serum", am: false, pm: true, freq: "Start 3x a week" },
  { slug: "nia_10", layer: "serum", am: true, pm: true },
  { slug: "peptide_squad", layer: "serum", am: true, pm: true },
  { slug: "fade_away", layer: "serum", am: true, pm: true, freq: "Start 3× a week" },
  { slug: "hydrator", layer: "serum", am: true, pm: true },
  { slug: "moonlight", layer: "serum", am: false, pm: true, freq: "Start 3x a week" },
  { slug: "additional_eye_enhancer", layer: "cream", am: true, pm: true },
  { slug: "night_renewer", layer: "cream", am: false, pm: true, freq: "Start 3x a week" },
  { slug: "hydro_relief", layer: "cream", am: true, pm: true },
  { slug: "plush_cream", layer: "cream", am: true, pm: true },
  // Off-face, so it goes on after everything the face gets.
  { slug: "forever_firm", layer: "cream", am: true, pm: true },
  { slug: "love_31", layer: "oil", am: true, pm: true }
];
const ROUTINE_SCHEDULE = {
  glow_maker: { slot: "am", active: true },
  // vitamin C — morning antioxidant
  fade_away: { slot: "flex", active: true },
  // brightener — AM if there's room, else PM
  nia_10: { slot: "am" },
  peptide_squad: { slot: "am" },
  hydrator: { slot: "am" },
  full_follicle: { slot: "am" },
  // scalp serum — once, morning
  moonlight: { slot: "pm", active: true },
  // retinoid — night (locked)
  night_renewer: { slot: "pm", active: true },
  // glycolic night cream (locked)
  super_smooth: { slot: "flex", active: true },
  // multi-acid — balances AM/PM
  exfoliator: { slot: "flex", active: true },
  // BHA scrub — balances AM/PM
  sheer_silk: { both: true },
  refresher: { both: true },
  hydro_relief: { both: true },
  plush_cream: { both: true },
  love_31: { both: true },
  additional_eye_enhancer: { both: true },
  forever_firm: { both: true }
};
const CONCERN_BENEFIT_CLAUSE = {
  wrinkles: "smoother, firmer skin with softer fine lines",
  dark_spots: "a brighter, more even tone",
  dryness: "deeply hydrated, plumper skin",
  redness: "calmer, less reactive skin",
  acne: "clearer skin with fewer breakouts",
  oil_control: "balanced oil and tighter-looking pores",
  uneven_texture: "smoother, more refined texture",
  default: "visibly healthier, more resilient skin"
};
const getResultBenefit = (concerns) => {
  const list = (Array.isArray(concerns) ? concerns : [concerns]).filter(Boolean);
  const clauses = [];
  for (const c of list) {
    const clause = CONCERN_BENEFIT_CLAUSE[c];
    if (clause && !clauses.includes(clause)) clauses.push(clause);
  }
  if (!clauses.length) clauses.push(CONCERN_BENEFIT_CLAUSE.default);
  const joined = clauses.length > 1 ? `${clauses[0]}, plus ${clauses[1]}` : clauses[0];
  return `${joined.charAt(0).toUpperCase()}${joined.slice(1)}.`;
};
const RESULT_REVIEWS = [
  { stars: 5, body: "“I’ve been using the Maelove skin care line for about 4 years and have noticed a visible difference in my skin.”", name: "Deborah H.", meta: "Fine lines & wrinkles", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/65740801-4d02-4339-ad60-cd8cc1dec72b.jpg?d=120x120&crop=center", concerns: ["wrinkles", "dark_spots"], face: true },
  { stars: 5, body: "“It has made my skin soft and bright, and is helping to minimize fine lines and wrinkles.”", name: "Stephanie N.", meta: "Fine lines & wrinkles", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/5046a0bd-f8bb-4433-adee-68052966e457.jpg?d=120x120&crop=center", concerns: ["wrinkles", "dark_spots"], face: true },
  { stars: 5, body: "“My skin tone has become noticeably more even, with visible improvement in imperfections and the appearance of my pores.”", name: "C M.", meta: "Redness & irritation", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/b5b78c64-c312-424f-a51e-86b86cc08bb3.jpg?d=120x120&crop=center", concerns: ["redness", "dryness", "wrinkles", "dark_spots", "uneven_texture", "oil_control"], face: true },
  { stars: 5, body: "“I’ve been using the Glow Maker now for a couple of years, and for the price it’s a great Vitamin C serum.”", name: "Leslie B.", meta: "Fine lines & wrinkles", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/5aa768ae-6b6e-4af7-a1d8-dc42a107298f.jpg?d=120x120&crop=center", concerns: ["wrinkles"], face: true },
  { stars: 5, body: "“I’ve been strictly using the Maelove product line for the last three years & I swear my face has never looked better, younger!”", name: "Amy R.", meta: "Fine lines & wrinkles", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/4dec9cf3-ad96-4781-896a-1e14fcaad8ba.jpg?d=120x120&crop=center", concerns: ["wrinkles", "dark_spots"], face: true },
  { stars: 5, body: "“My skin feels much smoother and softer than it has in a long time.”", name: "Betty A. W.", meta: "Fine lines & wrinkles", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/cf5340c8-0d0f-4a40-a67e-408ff9040172.jpg?d=120x120&crop=center", concerns: ["wrinkles", "dark_spots", "uneven_texture"], face: true },
  { stars: 5, body: "“I am 77, so it’s important that I keep my face hydrated — this cream fits the bill.”", name: "Barbara J.", meta: "Dryness & tightness", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/409a526e-ed8d-4c5a-994e-3aaeab47cffc.jpg?d=120x120&crop=center", concerns: ["dryness", "wrinkles"], face: true },
  { stars: 5, body: "“Using this daily every morning has helped make my skin look youthful and even out my skin tone.”", name: "Amber M.", meta: "Fine lines & wrinkles", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/31207af4-f2f9-4dc0-92d8-2dfc29f3df69.jpg?d=120x120&crop=center", concerns: ["wrinkles", "redness", "dryness"], face: true },
  { stars: 5, body: "“Woke up with plump, fresh, hydrated skin.”", name: "Myriam K.", meta: "Fine lines & wrinkles", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/6befa092-e005-436e-ad32-f74edd44fc42.jpg?d=120x120&crop=center", concerns: ["wrinkles", "dark_spots", "dryness"], face: true },
  { stars: 5, body: "“The texture is rich but not heavy, and it gently helps even out tone and texture over time.”", name: "Vanessa M.", meta: "Redness & irritation", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/26f6064f-cfe4-406e-a389-0bc572c76aa3.jpg?d=120x120&crop=center", concerns: ["redness", "wrinkles", "uneven_texture"], face: true },
  { stars: 4, body: "“I’ve been using it for a month now and my skin is glowing.”", name: "Annette van G.", meta: "Acne & blemishes", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/9fc2e6bc-210f-428f-9cc3-c6ec0a9f2de8.jpg?d=120x120&crop=center", concerns: ["acne", "dark_spots", "wrinkles", "dryness"], face: true },
  { stars: 5, body: "“I have noticed how smooth my skin is getting, and a nice glow without makeup!”", name: "Julie H.", meta: "Fine lines & wrinkles", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/9cb531a9-2253-4072-8181-bc0335e30428.jpg?d=120x120&crop=center", concerns: ["wrinkles", "dryness", "uneven_texture"], face: true },
  { stars: 5, body: "“My skin doesn’t dry out all day and I have noticed a reduction in my fine lines (age 40).”", name: "Jenny M.", meta: "Dryness & tightness", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/7ce1909b-aa28-40b2-a29e-a4fa4c7004fd.jpg?d=120x120&crop=center", concerns: ["dryness", "wrinkles", "dark_spots"], face: true },
  { stars: 5, body: "“I am 51 and I have been told I look 10+ years younger.”", name: "Cindy R.", meta: "Fine lines & wrinkles", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/b21df9f4-8696-43a5-9f13-2773f3a42908.jpg?d=120x120&crop=center", concerns: ["wrinkles", "oil_control"], face: true },
  { stars: 5, body: "“I’ve been using Glow Maker daily for about a year and I love the results!”", name: "Leigh Ann D.", meta: "Fine lines & wrinkles", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/21f890a2-b805-4c1f-9f50-6bd3bef58609.jpg?d=120x120&crop=center", concerns: ["wrinkles", "dark_spots"], face: true },
  { stars: 5, body: "“Glow Maker serum works great!”", name: "Debra W.", meta: "Fine lines & wrinkles", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/6fe41f29-4f18-434a-afe2-b8cd5b78502b.jpg?d=120x120&crop=center", concerns: ["wrinkles", "dark_spots"], face: true },
  { stars: 5, body: "“Pores have shrunk, fine lines are fading & my skin feels & looks smoother, while feeling fully moisturized.”", name: "Rachel W.", meta: "Fine lines & wrinkles", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/3aa8dc77-44d6-4e30-8292-c305e092111b.jpg?d=120x120&crop=center", concerns: ["wrinkles", "dryness", "uneven_texture", "oil_control"], face: true },
  { stars: 5, body: "“I generally have good skin but these products have made improvements in texture and dark spots.”", name: "Gail B.", meta: "Redness & irritation", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/c56ff84a-5fa1-45f5-b6b2-c55575a338ab.jpg?d=120x120&crop=center", concerns: ["redness", "dryness", "dark_spots", "wrinkles", "uneven_texture"], face: true },
  { stars: 5, body: "“I really have seen a nice difference in the hydration and glow of my skin using this serum.”", name: "Lauren M.", meta: "Fine lines & wrinkles", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/50455512-02a3-4f54-8ccf-a3c23b0a859a.jpg?d=120x120&crop=center", concerns: ["wrinkles", "uneven_texture"], face: true },
  { stars: 5, body: "“It goes on smoothly and effortlessly, and I’m seeing results in just one month.”", name: "Theresa T.", meta: "Dryness & tightness", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/4d66836c-e998-48c9-be4e-2668eea58f9b.jpg?d=120x120&crop=center", concerns: ["dryness", "dark_spots", "uneven_texture"], face: true },
  { stars: 5, body: "“I cannot believe how it fades my sun spots and freckles while giving my skin a glow.”", name: "Michele C.", meta: "Fine lines & wrinkles", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/f4c027d9-ecb1-42d6-818b-d70e06c0b537.jpg?d=120x120&crop=center", concerns: ["wrinkles", "dark_spots", "redness"], face: true },
  { stars: 5, body: "“It makes my skin feel very hydrated, and within a week I know it’s made a big difference, so don’t hesitate and buy it.”", name: "Rosa P.", meta: "Dryness & tightness", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/d6dc84c8-6041-4ae8-8b59-2921d9f2acc1.jpg?d=120x120&crop=center", concerns: ["dryness"], face: true },
  { stars: 5, body: "“I highly recommend Glow Maker if you want radiant skin!”", name: "Dani W.", meta: "Fine lines & wrinkles", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/5521085e-51da-439f-b19c-3d3a419ab397.jpg?d=120x120&crop=center", concerns: ["wrinkles", "dark_spots"], face: true },
  { stars: 5, body: "“It brightens my skin so well. I use it every morning and love it.”", name: "Noelle C.", meta: "Hyperpigmentation & dark spots", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/af322544-c5e7-4b72-b077-adcfb03632ec.jpg?d=120x120&crop=center", concerns: ["dark_spots", "wrinkles"], face: true },
  { stars: 5, body: "“Yet another amazing product from Maelove.”", name: "thomas b.", meta: "Fine lines & wrinkles", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/4d19e5aa-7c55-4911-afc2-9910764965ba.jpg?d=120x120&crop=center", concerns: ["wrinkles"], face: true },
  { stars: 5, body: "“My makeup goes on smoother, my wrinkles and fine lines have improved and my complexion has cleared up.”", name: "Danee G.", meta: "Fine lines & wrinkles", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/09d9a512-e386-4032-bc22-777fb15bd0b1.jpg?d=120x120&crop=center", concerns: ["wrinkles", "uneven_texture"], face: true },
  { stars: 5, body: "“The product has a yellow tint that gives a glowing aftertint!”", name: "Nichole P.", meta: "Dryness & tightness", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/fa1292a7-877e-42d4-8140-1b0bf73b9e53.jpg?d=120x120&crop=center", concerns: ["dryness", "wrinkles", "dark_spots"], face: true },
  { stars: 5, body: "“Leaves your skin baby smooth.”", name: "Sharon H.", meta: "Hyperpigmentation & dark spots", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/bb42e43d-9be2-48c4-9f25-d6ccadb5cc0c.jpg?d=120x120&crop=center", concerns: ["dark_spots", "wrinkles", "uneven_texture", "oil_control"], face: true },
  { stars: 5, body: "“I feel like I’m finally getting back the glow of my early 20s.”", name: "Josianne A.", meta: "Hyperpigmentation & dark spots", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/0d7ab7a6-1612-4ab0-b3b9-360992ed8ac8.jpg?d=120x120&crop=center", concerns: ["dark_spots", "acne"], face: true },
  { stars: 5, body: "“Sinks into the skin and hydrates beautifully without any stickiness or oily residue (my T-zone does not like moisturizer in warm weather, but this was…)”", name: "Abigail W.", meta: "Fine lines & wrinkles", image: "https://media-dynamic.okendo.io/images/d95214f0-8869-4cea-b466-0053808d0d20/cbf05a5a-40ca-4df0-811d-921c26d307e7.jpg?d=120x120&crop=center", concerns: ["wrinkles", "uneven_texture", "oil_control"], face: true }
];
const stats = [
  { value: "Dermatologist", label: "Recommended" },
  { value: "15,000+", label: "5-Star Reviews" },
  { value: "100-Day", label: "Money-Back Guarantee" }
];
const FaceIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "img",
  {
    src: "https://cdn.shopify.com/s/files/1/1919/1971/files/rf_face_icon_1dcbfe43-8dcd-4d1c-aded-6f997aacbf59.png?v=1779143161",
    alt: "",
    "aria-hidden": "true",
    className: "quiz-callout__icon"
  }
);
const BackIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { viewBox: "0 0 24 24", "aria-hidden": "true", width: "14", height: "14", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M15 6l-6 6 6 6", stroke: "currentColor", strokeWidth: "2", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" }) });
const Checkbox = ({ checked }) => /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: `quiz-checkbox${checked ? " quiz-checkbox--checked" : ""}`, "aria-hidden": "true", children: checked && /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { viewBox: "0 0 16 16", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M3.5 8.5l3 3 6-6", stroke: "#fff", strokeWidth: "2", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" }) }) });
function Question({ question, setSelectedAnswer, toggleMultiAnswer, advanceQuestion, goBackQuestion, currentQuestionIndex, questions }) {
  const isMultiSelect = !!question.multiSelect;
  const isRow = question.displayDirection === "row";
  const isEmailStep = question.type === "email";
  const isNameStep = question.type === "name";
  const totalSteps = questions.length;
  const currentStep = currentQuestionIndex + 1;
  const progressPct = currentStep / totalSteps * 100;
  const [emailInput, setEmailInput] = reactExports.useState(() => {
    const v2 = question.selectedAnswer;
    return typeof v2 === "string" && v2.includes("@") ? v2 : "";
  });
  const [nameInput, setNameInput] = reactExports.useState(() => {
    const v2 = question.selectedAnswer;
    return typeof v2 === "string" && !v2.includes("@") ? v2 : "";
  });
  const selectedAnswers = Array.isArray(question.selectedAnswer) ? question.selectedAnswer : question.selectedAnswer ? [question.selectedAnswer] : [];
  const isSelected = (label) => selectedAnswers.includes(label);
  const canAdvance = isMultiSelect ? question.allowNoSelection || selectedAnswers.length > 0 : false;
  const handleOptionClick = (label) => {
    if (isMultiSelect) {
      toggleMultiAnswer(currentQuestionIndex, label);
    } else {
      setSelectedAnswer(currentQuestionIndex, label);
    }
  };
  const topbar = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "quiz__topbar", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("button", { type: "button", className: "quiz__back", onClick: () => goBackQuestion(currentQuestionIndex), children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(BackIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "BACK" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "quiz__progress", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "quiz__step-label", children: [
        "STEP ",
        currentStep,
        " OF ",
        totalSteps
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "quiz__progress-bar", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "quiz__progress-fill", style: { width: `${progressPct}%` } }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "quiz__topbar-spacer", "aria-hidden": "true" })
  ] });
  const heading = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "quiz__heading", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "quiz__title", children: question.title }),
    question.titleMeta && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "quiz__subtitle", children: question.titleMeta })
  ] });
  if (isNameStep) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: "quiz", children: [
      topbar,
      heading,
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "quiz__email-wrap", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "form",
          {
            className: "quiz__email-form",
            onSubmit: (e) => {
              e.preventDefault();
              setSelectedAnswer(currentQuestionIndex, nameInput.trim());
            },
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "input",
                {
                  type: "text",
                  className: "quiz__email-input quiz__name-input",
                  placeholder: "First name",
                  name: "rb-first-name",
                  autoComplete: "off",
                  autoCorrect: "off",
                  autoCapitalize: "words",
                  spellCheck: false,
                  value: nameInput,
                  onChange: (e) => setNameInput(e.target.value)
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "submit", className: "quiz__email-submit", children: "Continue" })
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            type: "button",
            className: "quiz__skip-light",
            onClick: () => setSelectedAnswer(currentQuestionIndex, ""),
            children: "Skip"
          }
        )
      ] })
    ] });
  }
  if (isEmailStep) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: "quiz", children: [
      topbar,
      heading,
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "quiz__email-wrap", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "form",
          {
            className: "quiz__email-form",
            onSubmit: (e) => {
              e.preventDefault();
              setSelectedAnswer(currentQuestionIndex, emailInput.trim());
            },
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "input",
                {
                  type: "email",
                  className: "quiz__email-input",
                  placeholder: "Email address",
                  value: emailInput,
                  onChange: (e) => setEmailInput(e.target.value),
                  required: true
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "submit", className: "quiz__email-submit", children: "Submit and see results" })
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            type: "button",
            className: "quiz__skip-light",
            onClick: () => setSelectedAnswer(currentQuestionIndex, ""),
            children: "Skip"
          }
        )
      ] })
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: "quiz", children: [
    topbar,
    heading,
    /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: `quiz__options quiz__options--${isRow ? "row" : "column"}`, children: question.options.map((option) => {
      const selected = isSelected(option.label);
      const isPrimary = question.rankSelections && selected && selectedAnswers[0] === option.label;
      return /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "quiz__option-item", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "button",
        {
          type: "button",
          className: `quiz__option${selected ? " quiz__option--selected" : ""}${isRow ? " quiz__option--row" : ""}`,
          onClick: () => handleOptionClick(option.label),
          "aria-pressed": selected,
          children: [
            isMultiSelect && /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox, { checked: selected }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "quiz__option-label", children: option.label }),
            isPrimary && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "quiz__option-badge", children: "Primary" })
          ]
        }
      ) }, option.label);
    }) }),
    isMultiSelect && /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        type: "button",
        className: "quiz__next",
        onClick: () => advanceQuestion(currentQuestionIndex),
        disabled: !canAdvance,
        children: "Next"
      }
    ),
    question.callout && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "quiz-callout", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FaceIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "quiz-callout__text", children: question.callout })
    ] }),
    !question.callout && /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "quiz-stats", children: stats.map((s) => /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { className: "quiz-stats__item", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "quiz-stats__value", children: s.value }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "quiz-stats__label", children: s.label })
    ] }, s.label)) })
  ] });
}
const saveResponseDataWithCurrentTime = (data) => {
  const currentTime = /* @__PURE__ */ new Date();
  if (Array.isArray(data)) {
    data = { questions: data, time: currentTime };
  } else if (data == null ? void 0 : data.questions) {
    data.time = /* @__PURE__ */ new Date();
  }
  localStorage.setItem(RB_LOCALSTORAGE_KEY, JSON.stringify(data));
};
const getProductsOfSelectedTab = (selectedConcerns, active) => {
  const activeTab = ACTIVE_TAB_MAPPING[active];
  let productsToShow = SKIN_CONCERN_PRODUCTS[selectedConcerns[0]][activeTab];
  if (selectedConcerns.length === 2) {
    const combinations = PRODUCT_COUNT_FOR_CONCERN[activeTab].combinations;
    productsToShow = productsToShow.slice(0, combinations[0]);
    const productsCountToReplace = combinations[1];
    let secondaryProductsToShow = SKIN_CONCERN_PRODUCTS[selectedConcerns[1]][activeTab];
    const primaryProductIds = productsToShow.map((p2) => p2.product_id);
    secondaryProductsToShow = secondaryProductsToShow.filter((p2) => !primaryProductIds.includes(p2.product_id));
    const temp = secondaryProductsToShow.slice(0, productsCountToReplace);
    productsToShow = [...productsToShow, ...temp];
  }
  return {
    productsToShow
  };
};
const getProductResults = ({ quizQuestions: quizQuestions2, active }) => {
  const concernQuestion = quizQuestions2.find((question) => question.id === "main_skin_concern");
  const concernAnswers = Array.isArray(concernQuestion == null ? void 0 : concernQuestion.selectedAnswer) ? concernQuestion.selectedAnswer : (concernQuestion == null ? void 0 : concernQuestion.selectedAnswer) ? [concernQuestion.selectedAnswer] : [];
  const selectedConcerns = [];
  for (const answer of concernAnswers) {
    if (!answer) continue;
    const concernName = skinConcerns.find((sc2) => sc2.label === answer);
    if (concernName && !selectedConcerns.includes(concernName.name)) {
      selectedConcerns.push(concernName.name);
    }
  }
  const resultSummary = RESULTS_SUMMARY.find((rs) => rs.concerns.join() === selectedConcerns.join());
  let productsToShow = [];
  let routineLevelWiseProducts = {
    "basic": [],
    "core": [],
    "advanced": []
  };
  if (selectedConcerns.length) {
    productsToShow = getProductsOfSelectedTab(selectedConcerns, active).productsToShow;
    for (let key in routineLevelWiseProducts) {
      routineLevelWiseProducts[key] = getProductsOfSelectedTab(selectedConcerns, ACTIVE_TAB_MAPPING_REVERSE[key]).productsToShow;
    }
  }
  let shopifyProductsToShow = [];
  let eyeEnhancerProduct;
  let neckFirmingProduct;
  let pregnancynProduct;
  const eyeConcernQuestion = quizQuestions2.find((question) => question.id === "eye_concern");
  const pregnancyQuestion = quizQuestions2.find((question) => question.id === "pregnancy");
  const eyeNeck = parseEyeNeckAnswer(eyeConcernQuestion == null ? void 0 : eyeConcernQuestion.selectedAnswer);
  if (window.routineBuilderObj && Array.isArray(window.routineBuilderObj.allowed_products)) {
    for (const p2 of productsToShow) {
      const productFound = window.routineBuilderObj.allowed_products.find((prod) => prod.id == p2.product_id);
      if (productFound) {
        shopifyProductsToShow.push(productFound);
      }
    }
    const resolveAddOn = (mapping, badge) => {
      const product = window.routineBuilderObj.allowed_products.find((prod) => prod.id == mapping.product_id);
      if (!product) {
        console.warn("Routine Finder: add-on not in allowed_products", mapping.title);
        return void 0;
      }
      product.badge = badge;
      return product;
    };
    if (eyeNeck.eye) {
      eyeEnhancerProduct = resolveAddOn(PRODUCT_MAPPING.additional_eye_enhancer, "For your eye concern");
    }
    if (eyeNeck.neck) {
      neckFirmingProduct = resolveAddOn(PRODUCT_MAPPING.forever_firm, "For your neck concern");
    }
    if (pregnancyQuestion && pregnancyQuestion.selectedAnswer == "Yes") {
      pregnancynProduct = window.routineBuilderObj.allowed_products.find((prod) => prod.id == PRODUCT_MAPPING.moonlight.product_id);
    }
    console.log({ pregnancynProduct });
    const addOnProducts = [eyeEnhancerProduct, neckFirmingProduct].filter(Boolean);
    for (let key in routineLevelWiseProducts) {
      routineLevelWiseProducts[key] = routineLevelWiseProducts[key].map((localProduct) => window.routineBuilderObj.allowed_products.find((prod) => prod.id == localProduct.product_id));
      for (const addOn of addOnProducts) {
        if (!routineLevelWiseProducts[key].find((p2) => (p2 == null ? void 0 : p2.id) == addOn.id)) {
          routineLevelWiseProducts[key].push(addOn);
        }
      }
      if (pregnancynProduct && pregnancyQuestion.selectedAnswer == "Yes" && routineLevelWiseProducts[key].find((p2) => p2.id == pregnancynProduct.id)) {
        routineLevelWiseProducts[key] = routineLevelWiseProducts[key].filter((p2) => p2.id != pregnancynProduct.id);
      }
    }
  } else {
    window.routineBuilderObj = {
      allowed_products: [{
        id: 20097630225,
        title: "Glow Maker",
        featured_image: "https://cdn.shopify.com/s/files/1/1919/1971/files/product_glow_maker_award_800_1ade6ea1-8356-4f41-9439-70d524635fd7_720x.jpg?v=1697783502",
        handle: "glow-maker",
        price: 5e3,
        available: true
      }, {
        id: 5964432867523,
        title: "Glow Maker",
        featured_image: "https://cdn.shopify.com/s/files/1/1919/1971/files/product_glow_maker_award_800_1ade6ea1-8356-4f41-9439-70d524635fd7_720x.jpg?v=1697783502",
        handle: "glow-maker",
        price: 5e3,
        available: true
      }]
    };
  }
  if (eyeEnhancerProduct) {
    shopifyProductsToShow.push(eyeEnhancerProduct);
  }
  if (neckFirmingProduct) {
    shopifyProductsToShow.push(neckFirmingProduct);
  }
  if (pregnancynProduct && pregnancyQuestion.selectedAnswer == "Yes") {
    shopifyProductsToShow = shopifyProductsToShow.filter((p2) => p2.id != pregnancynProduct.id);
  }
  console.log({ resultSummary, selectedConcerns });
  return {
    shopifyProductsToShow,
    // shopifyAdvanceProductsToShow,
    resultSummary,
    eyeEnhancerProduct,
    neckFirmingProduct,
    routineLevelWiseProducts
  };
};
const buildRoutineSections = (routineLevelWiseProducts) => {
  const { basic = [], core = [], advanced = [] } = routineLevelWiseProducts || {};
  const clean = (arr) => (arr || []).filter(Boolean);
  const coreClean = clean(core);
  const basicClean = clean(basic);
  const advancedClean = clean(advanced);
  const coreIds = new Set(coreClean.map((p2) => p2.id));
  const basicIds = new Set(basicClean.map((p2) => p2.id));
  return {
    core: coreClean,
    // products in advanced that aren't already in core
    advancedDelta: advancedClean.filter((p2) => !coreIds.has(p2.id)),
    lite: basicClean,
    // products in core that lite drops — used to name the "gentler start"
    liteDrops: coreClean.filter((p2) => !basicIds.has(p2.id))
  };
};
const normalizeSavedAnswer = (question, saved) => {
  if (!question.multiSelect) return saved;
  if (Array.isArray(saved)) return saved;
  if (question.id === "eye_concern" && saved === "Yes") return [EYE_CONCERN_OPTION];
  return [];
};
const parseLocalStorageQuizResponse = (quizQuestions2) => {
  let quizResponse = null;
  let quizResponsePrevResponse = localStorage.getItem(RB_LOCALSTORAGE_KEY);
  const quizResponseParsed = quizResponsePrevResponse ? JSON.parse(quizResponsePrevResponse) : null;
  let lastViewedTime = quizResponseParsed && quizResponseParsed.time;
  let showViewRoutineBtn = false;
  if (quizResponseParsed && lastViewedTime) {
    try {
      if (quizResponseParsed == null ? void 0 : quizResponseParsed.questions) {
        quizResponse = quizResponseParsed.questions;
      }
      if (lastViewedTime) {
        if (typeof lastViewedTime === "string") {
          lastViewedTime = new Date(lastViewedTime);
        }
        const diffHours = Math.abs(/* @__PURE__ */ new Date() - lastViewedTime) / 36e5;
        console.log({ diffHours });
        if (diffHours > QUIZ_RESET_HOURS) {
          showViewRoutineBtn = true;
        }
      }
      if ((quizResponse == null ? void 0 : quizResponse.length) !== quizQuestions2.length) {
        quizResponse = null;
      } else {
        for (const q2 of quizQuestions2) {
          const savedResp = quizResponse.find((qr) => qr.id == q2.id);
          if (savedResp) {
            q2.selectedAnswer = normalizeSavedAnswer(q2, savedResp.selectedAnswer);
          }
        }
        saveResponseDataWithCurrentTime(quizResponse);
        showViewRoutineBtn = true;
      }
    } catch (error) {
      console.error(error);
    }
  }
  return { quizResponse, lastViewedTime, showViewRoutineBtn };
};
const isTruthyParam = (v2) => /^(1|yes|true)$/i.test((v2 || "").trim());
const parseAnswersFromUrl = (search = window.location.search) => {
  const p2 = new URLSearchParams(search);
  const toLabel = (v2) => {
    const s = (v2 || "").trim().toLowerCase();
    if (!s) return null;
    const m2 = skinConcerns.find((sc2) => sc2.name.toLowerCase() === s || sc2.label.toLowerCase() === s);
    return m2 ? m2.label : null;
  };
  const labels = [toLabel(p2.get("c1")), toLabel(p2.get("c2"))].filter(Boolean);
  if (!labels.length) return null;
  const yn = (v2) => isTruthyParam(v2) ? "Yes" : "No";
  const eyeNeck = [
    isTruthyParam(p2.get("eye")) && EYE_CONCERN_OPTION,
    isTruthyParam(p2.get("neck")) && NECK_CONCERN_OPTION
  ].filter(Boolean);
  const answers = {
    main_skin_concern: labels,
    eye_concern: eyeNeck,
    pregnancy: yn(p2.get("preg")),
    skin_sensitivity: yn(p2.get("sens")),
    first_name: (p2.get("name") || "").trim(),
    email_capture: ""
  };
  return quizQuestions.map((q2) => q2.id in answers ? { ...q2, selectedAnswer: answers[q2.id] } : { ...q2 });
};
const hydrateResultsFromUrl = (mode2, search) => {
  if (mode2 !== "results") return;
  const questions = parseAnswersFromUrl(search);
  if (!questions) return;
  localStorage.setItem(RB_LOCALSTORAGE_KEY, JSON.stringify({ questions, time: /* @__PURE__ */ new Date() }));
};
const buildResultsUrl = (questions, resultsUrl, origin = window.location.origin) => {
  if (!resultsUrl) return "";
  const get = (id2) => {
    var _a2;
    return (_a2 = questions.find((q2) => q2.id === id2)) == null ? void 0 : _a2.selectedAnswer;
  };
  const concernRaw = get("main_skin_concern");
  const concerns = Array.isArray(concernRaw) ? concernRaw : concernRaw ? [concernRaw] : [];
  const slug = (label) => {
    var _a2;
    return ((_a2 = skinConcerns.find((sc2) => sc2.label === label)) == null ? void 0 : _a2.name) || "";
  };
  const flag = (v2) => v2 === "Yes" ? "1" : "0";
  const eyeNeck = parseEyeNeckAnswer(get("eye_concern"));
  const params = new URLSearchParams();
  if (concerns[0]) params.set("c1", slug(concerns[0]));
  if (concerns[1]) params.set("c2", slug(concerns[1]));
  params.set("eye", eyeNeck.eye ? "1" : "0");
  params.set("neck", eyeNeck.neck ? "1" : "0");
  params.set("preg", flag(get("pregnancy")));
  params.set("sens", flag(get("skin_sensitivity")));
  const name = (get("first_name") || "").trim();
  if (name) params.set("name", name);
  return `${origin}${resultsUrl}?${params.toString()}`;
};
const getEventData = (questions, quizInitialDate, activeTab) => {
  var _a2, _b2, _c, _d, _e, _f, _g, _h, _i, _j;
  const concernRaw = (_a2 = questions.find((q2) => q2.id === "main_skin_concern")) == null ? void 0 : _a2.selectedAnswer;
  const concerns = Array.isArray(concernRaw) ? concernRaw : concernRaw ? [concernRaw] : [];
  const primaryConcern = concerns[0] || "";
  const secondaryConcern = concerns[1] || "";
  const eyeNeck = parseEyeNeckAnswer((_b2 = questions.find((q2) => q2.id === "eye_concern")) == null ? void 0 : _b2.selectedAnswer);
  const pregnant = (_c = questions.find((q2) => q2.id === "pregnancy")) == null ? void 0 : _c.selectedAnswer;
  const sensitive = (_d = questions.find((q2) => q2.id === "skin_sensitivity")) == null ? void 0 : _d.selectedAnswer;
  const pregnantDate = quizInitialDate || /* @__PURE__ */ new Date();
  const resultsPath = (_e = window.routineBuilderObj) == null ? void 0 : _e.results_url;
  const { eyeEnhancerProduct, neckFirmingProduct, resultSummary, routineLevelWiseProducts } = getProductResults({ quizQuestions: questions, active: activeTab });
  const primaryConcernName = ((_f = skinConcerns.find((sc2) => sc2.label === primaryConcern)) == null ? void 0 : _f.name) || "";
  const secondaryConcernName = ((_g = skinConcerns.find((sc2) => sc2.label === secondaryConcern)) == null ? void 0 : _g.name) || "";
  let ProductIDs = { ...routineLevelWiseProducts };
  for (let key in routineLevelWiseProducts) {
    ProductIDs[key] = routineLevelWiseProducts[key].map((shopifyProduct) => shopifyProduct.id);
  }
  const eventData = {
    "ConcernPrimary": primaryConcern,
    "ConcernSecondary": secondaryConcern,
    "EyeConcern": eyeNeck.eye,
    "NeckConcern": eyeNeck.neck,
    "Pregnant": pregnant === "Yes",
    "Sensitive": sensitive === "Yes",
    "PregnantDate": pregnantDate,
    "FamilyCircleURL": `${window.location.origin}/pages/family-circle?concern1=${primaryConcernName.replace("_", "+")}&concern2=${secondaryConcernName.replace("_", "+")}`,
    // Deep-link to the dedicated results page; the email button uses this.
    "ResultsURL": resultsPath ? buildResultsUrl(questions, resultsPath) : "",
    "ProductIDs": ProductIDs,
    "EyeConcernID": (eyeEnhancerProduct == null ? void 0 : eyeEnhancerProduct.id) || null,
    "NeckConcernID": (neckFirmingProduct == null ? void 0 : neckFirmingProduct.id) || null,
    Summary: {
      "base": {
        "basic": ((_h = resultSummary == null ? void 0 : resultSummary.routines) == null ? void 0 : _h.basic) || null,
        "core": ((_i = resultSummary == null ? void 0 : resultSummary.routines) == null ? void 0 : _i.core) || null,
        "advanced": ((_j = resultSummary == null ? void 0 : resultSummary.routines) == null ? void 0 : _j.advanced) || null
      },
      "eyeConcern": eyeNeck.eye ? RESULTS_SUMMARY_ADDL.eye_concern : null,
      "neckConcern": eyeNeck.neck ? RESULTS_SUMMARY_ADDL.neck_concern : null,
      "pregnant": pregnant === "Yes" ? RESULTS_SUMMARY_ADDL.pregnant : null
    }
  };
  return eventData;
};
const safeEventData = (questions, quizInitialDate, activeTab) => {
  try {
    return getEventData(questions, quizInitialDate, activeTab);
  } catch (err) {
    console.error("Routine Finder: failed to build Klaviyo event data", err);
    return null;
  }
};
const klaviyoQueue = () => window._learnq = window._learnq || [];
const sendSavedResultToKlaviyo = (questions, quizInitialDate, customer, activeTab) => {
  if (!questions || !(customer == null ? void 0 : customer.email)) return;
  const klaviyo = klaviyoQueue();
  klaviyo.push(["identify", {
    "$email": customer.email,
    "$first_name": customer.first_name || "",
    "$last_name": customer.last_name || ""
  }]);
  const eventData = safeEventData(questions, quizInitialDate, activeTab);
  if (!eventData) return;
  klaviyo.push(["identify", eventData]);
  klaviyo.push(["track", "Routine Finder Signup", eventData]);
};
const sendRoutineFinderResultsToKlaviyo = (questions, quizInitialDate, customer, activeTab) => {
  if (!questions) return;
  const klaviyo = klaviyoQueue();
  if (customer == null ? void 0 : customer.email) {
    klaviyo.push(["identify", {
      "$email": customer.email,
      "$first_name": customer.first_name || "",
      "$last_name": customer.last_name || ""
    }]);
  }
  const eventData = safeEventData(questions, quizInitialDate, activeTab);
  if (!eventData) return;
  klaviyo.push(["track", "Routine Finder Results", eventData]);
};
const FAMILY_CIRCLE_BUNDLE_ID = "319bfcd1a46042cabee419a29d122168";
const FAMILY_CIRCLE_SOURCE = "Routine Finder";
let _fcBundleDataCache = null;
const getFamilyCircleBundleData = async () => {
  if (_fcBundleDataCache) return _fcBundleDataCache;
  const response = await fetch(`https://apiv2.loopwork.co/bundleStorefront/${FAMILY_CIRCLE_BUNDLE_ID}`);
  if (!response.ok) throw new Error("Failed to load Family Circle bundle data");
  const data = await response.json();
  _fcBundleDataCache = (data == null ? void 0 : data.data) || data;
  return _fcBundleDataCache;
};
const FC_DISCOUNT_TIERS = [{ min: 4, pct: 20 }, { min: 3, pct: 15 }, { min: 2, pct: 7 }];
const fcDiscountForCount = (count) => {
  for (const tier of FC_DISCOUNT_TIERS) {
    if (count >= tier.min) return tier.pct;
  }
  return 0;
};
const fcSubtotalCents = (products) => {
  const full = (products || []).reduce((sum, p2) => sum + ((p2 == null ? void 0 : p2.price) || 0), 0);
  return Math.round(full * (1 - fcDiscountForCount((products || []).length) / 100));
};
const computeFcDiscount = (itemCount, bundleData) => {
  const discount = fcDiscountForCount(itemCount);
  if (!discount) return { discount: 0, code: "" };
  let code = "";
  const discounts = bundleData == null ? void 0 : bundleData.discounts;
  if (Array.isArray(discounts)) {
    const found = discounts.find(
      (d) => d.type === "PERCENTAGE" && d.purchaseType === "SUBSCRIPTION" && (d.value === discount || d.value === discount / 100)
    );
    if (found) code = found.code;
  }
  return { discount, code };
};
const addFamilyCircleBundleToCart = async (products, { sellingPlanId } = {}) => {
  var _a2, _b2;
  try {
    const variantIds = (products || []).filter((p2) => {
      var _a3, _b3;
      return (p2 == null ? void 0 : p2.available) && ((_b3 = (_a3 = p2.variants) == null ? void 0 : _a3[0]) == null ? void 0 : _b3.id);
    }).map((p2) => p2.variants[0].id);
    if (!variantIds.length) return false;
    const bundleData = await getFamilyCircleBundleData();
    const plans = (bundleData == null ? void 0 : bundleData.sellingPlans) || [];
    const sellingPlan = sellingPlanId && plans.find((sp) => sp.sellingPlanId === sellingPlanId) || plans.find((sp) => sp.isDefault) || plans[0];
    if (!sellingPlan) {
      console.error("No Family Circle selling plan available");
      return false;
    }
    const loopSellingPlanId = sellingPlan.sellingPlanId;
    const shopifySellingPlanId = sellingPlan.adminGraphQlApiId.split("/").pop();
    const txResp = await fetch("https://api-service.loopwork.co/bundleTransaction", {
      headers: {
        accept: "application/json, text/plain, */*",
        "content-type": "application/json"
      },
      body: JSON.stringify({
        bundleId: bundleData.id,
        sellingPlanId: loopSellingPlanId
      }),
      method: "POST"
    });
    if (!txResp.ok) throw new Error("Failed to create bundle transaction");
    const txData = await txResp.json();
    const loopBundleGuid = txData.loopBundleGuid;
    const cartItems = variantIds.map((variantId) => ({
      id: variantId,
      quantity: 1,
      selling_plan: shopifySellingPlanId || void 0,
      properties: {
        _source: FAMILY_CIRCLE_SOURCE,
        _bundleId: loopBundleGuid,
        _bundleRef: FAMILY_CIRCLE_BUNDLE_ID,
        bundle: FAMILY_CIRCLE_SOURCE,
        bundleName: (bundleData == null ? void 0 : bundleData.label) || ""
      }
    }));
    const addResp = await fetch("/cart/add.js", {
      headers: {
        accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ items: cartItems }),
      method: "POST"
    });
    if (!addResp.ok) throw new Error("Failed to add bundle items to cart");
    const addData = await addResp.json();
    const totalItemCount = variantIds.length;
    const { discount, code } = computeFcDiscount(totalItemCount, bundleData);
    if (discount > 0 && code) {
      try {
        const rootUrl = (((_b2 = (_a2 = window.Shopify) == null ? void 0 : _a2.routes) == null ? void 0 : _b2.root) || "/").replace(/\/$/, "");
        await fetch(`${rootUrl}/discount/${code}`);
      } catch (e) {
        console.error("Failed to apply Family Circle discount:", e);
      }
    }
    refreshCartAndOpenCartDrawer();
    return addData;
  } catch (error) {
    console.error("addFamilyCircleBundleToCart error:", error);
    return false;
  }
};
const addRoutineToCart = async (products) => {
  const items = products.filter((p2) => {
    var _a2, _b2;
    return (p2 == null ? void 0 : p2.available) && ((_b2 = (_a2 = p2.variants) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.id);
  }).map((p2) => ({
    id: p2.variants[0].id,
    quantity: 1,
    properties: { _source: "Routine Finder" }
  }));
  if (!items.length) return false;
  try {
    const response = await fetch("/cart/add.js", {
      headers: {
        "accept": "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ items }),
      method: "POST"
    });
    const data = await response.json();
    refreshCartAndOpenCartDrawer();
    return data;
  } catch (error) {
    console.error(error);
    return false;
  }
};
const refreshCartAndOpenCartDrawer = () => {
  if (typeof window.upcartOpenCart === "function") {
    window.upcartOpenOnAddToCartOverride = false;
  }
  function fireChange(newCart) {
    var _a2;
    document.dispatchEvent(
      new CustomEvent("theme:cart:change", {
        detail: {
          cart: newCart
        },
        bubbles: true
      })
    );
    console.debug("%c Firing theme:cart:change event", "color: red; font-size: 1rem");
    (_a2 = document.querySelector('[data-drawer="drawer-cart"]')) == null ? void 0 : _a2.dispatchEvent(
      new CustomEvent("theme:drawer:open", {
        bubbles: false
      })
    );
    console.debug("%c Firing theme:drawer:open event", "color: red; font-size: 1rem");
  }
  window.fetch(`${window.theme.routes.cart}.js`).then((response) => {
    return response.json();
  }).then((response) => {
    window.cart = response;
    fireChange(response);
    return response;
  }).catch((e) => {
    console.error(e);
  });
};
const WIDGET = "routine_finder";
const track = (event, properties = {}) => {
  var _a2;
  try {
    (_a2 = window.posthog) == null ? void 0 : _a2.capture(event, { widget: WIDGET, ...properties });
  } catch (err) {
    console.error("Routine Finder: PostHog capture failed", err);
  }
};
const isPiiQuestion = (question) => (question == null ? void 0 : question.type) === "name" || (question == null ? void 0 : question.type) === "email";
const answerProperties = (question, answer) => isPiiQuestion(question) ? { has_value: !!answer } : { answer };
const quizSummaryProperties = (questions, activeTab) => {
  const get = (id2) => {
    var _a2;
    return (_a2 = questions.find((q2) => q2.id === id2)) == null ? void 0 : _a2.selectedAnswer;
  };
  const concernRaw = get("main_skin_concern");
  const concerns = Array.isArray(concernRaw) ? concernRaw : concernRaw ? [concernRaw] : [];
  const eyeNeck = parseEyeNeckAnswer(get("eye_concern"));
  return {
    concern_primary: concerns[0] || "",
    concern_secondary: concerns[1] || "",
    eye_concern: eyeNeck.eye,
    neck_concern: eyeNeck.neck,
    pregnant: get("pregnancy") === "Yes",
    sensitive_skin: get("skin_sensitivity") === "Yes",
    active_tab: activeTab,
    email_captured: !!get("email_capture"),
    name_captured: !!get("first_name")
  };
};
const MOBILE_QUERY = "(max-width: 900px)";
function useIsMobile() {
  const [isMobile, setIsMobile] = reactExports.useState(() => window.matchMedia(MOBILE_QUERY).matches);
  reactExports.useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return isMobile;
}
const QuickViewContext = reactExports.createContext(null);
function useQuickView() {
  return reactExports.useContext(QuickViewContext);
}
const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const PRODUCT_NAMES = [...new Set(Object.values(PRODUCT_MAPPING).map((p2) => p2.title).filter(Boolean))].sort((a, b) => b.length - a.length);
const NAME_RE = new RegExp(`(${PRODUCT_NAMES.map(escapeRe).join("|")})`, "gi");
const NAME_SET = new Set(PRODUCT_NAMES.map((n2) => n2.toLowerCase()));
function boldProductNames(text) {
  return text.split(NAME_RE).map((part, i) => NAME_SET.has(part.toLowerCase()) ? /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: part }, i) : /* @__PURE__ */ jsxRuntimeExports.jsx(reactExports.Fragment, { children: part }, i));
}
function ConcernTable({ selectedConcernSlugs, coreProducts, treatmentName, treatmentLede, onEditQuiz }) {
  const isMobile = useIsMobile();
  const quickView = useQuickView();
  const slugs = (selectedConcernSlugs || []).filter((s) => CONCERN_CONTENT[s]);
  if (!slugs.length) return null;
  const handleChipClick = (e, chip, concern) => {
    const toQuickView = isMobile && quickView && chip.product;
    track("routine_finder_concern_chip_clicked", {
      product_slug: chip.key,
      product_name: chip.name,
      concern,
      action: toQuickView ? "quick_view" : "scroll"
    });
    if (toQuickView) {
      e.preventDefault();
      quickView.open(chip.product, "concern_chip");
      return;
    }
    const card = document.getElementById(productAnchorId(chip.key));
    if (!card) return;
    e.preventDefault();
    card.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const products = coreProducts || [];
  const chipsByConcern = Object.fromEntries(slugs.map((c) => [c, []]));
  products.forEach((p2) => {
    const slug = getSlugForProduct(p2);
    if (!slug) return;
    const concern = slugs.find((c) => (CONCERN_PRODUCT_SLUGS[c] || []).includes(slug));
    if (!concern) return;
    chipsByConcern[concern].push({
      key: slug,
      name: getShortName(p2),
      image: p2.featured_image,
      product: p2
    });
  });
  const routineBySlug = {};
  products.forEach((p2) => {
    const slug = getSlugForProduct(p2);
    if (slug) routineBySlug[slug] = p2;
  });
  slugs.forEach((concern) => {
    if (chipsByConcern[concern].length) return;
    chipsByConcern[concern] = (CONCERN_CONTENT[concern].productSlugs || []).filter((ps) => routineBySlug[ps]).map((ps) => {
      var _a2;
      return { key: ps, name: getShortName(routineBySlug[ps]) || ((_a2 = PRODUCT_MAPPING[ps]) == null ? void 0 : _a2.title) || ps, image: routineBySlug[ps].featured_image, product: routineBySlug[ps] };
    });
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: "rbm-section rbm-intro-section", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-result-intro", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: treatmentName }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "rbm-lede", children: treatmentLede }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: "rbm-edit-link", onClick: () => onEditQuiz(true), children: "↻ Edit your quiz answers" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("table", { className: "rbm-concern-table", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("thead", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("tr", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("th", { children: "Skin concern" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("th", { children: "How this routine helps" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("th", { children: "Products" })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", { children: slugs.map((concern) => /* @__PURE__ */ jsxRuntimeExports.jsxs("tr", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "rbm-concern", children: CONCERN_CONTENT[concern].label }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "rbm-how", children: boldProductNames(buildConcernHow(concern, chipsByConcern[concern].map((c) => c.key))) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "rbm-power", children: chipsByConcern[concern].map((chip) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "a",
          {
            className: "rbm-product-chip",
            href: `#${productAnchorId(chip.key)}`,
            onClick: (e) => handleChipClick(e, chip, concern),
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "span",
                {
                  className: "rbm-chip-thumb",
                  style: chip.image ? { backgroundImage: `url(${chip.image})` } : void 0
                }
              ),
              chip.name
            ]
          },
          chip.key
        )) })
      ] }, concern)) })
    ] })
  ] });
}
const INIT_RETRY_MS = 250;
const INIT_MAX_ATTEMPTS = 60;
let initTimer = null;
let initAttempts = 0;
const runInit = () => {
  var _a2;
  initTimer = null;
  if ((_a2 = window.okeWidgetApi) == null ? void 0 : _a2.initAllWidgets) {
    window.okeWidgetApi.initAllWidgets();
    return;
  }
  if ((initAttempts += 1) >= INIT_MAX_ATTEMPTS) return;
  initTimer = setTimeout(runInit, INIT_RETRY_MS);
};
const refreshOkendoRatings = () => {
  initAttempts = 0;
  if (initTimer) return;
  initTimer = setTimeout(runInit, 0);
};
function OkendoRating({ productId }) {
  reactExports.useEffect(() => {
    refreshOkendoRatings();
  }, [productId]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "span",
    {
      className: "rbm-rating-oke",
      "data-oke-star-rating": true,
      "data-oke-reviews-product-id": `shopify-${productId}`
    },
    productId
  );
}
function VideoModal({ video, poster, onClose }) {
  reactExports.useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-video-modal", role: "dialog", "aria-modal": "true", "aria-label": "Founder video", onClick: onClose, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-video-box", onClick: (e) => e.stopPropagation(), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: "rbm-video-close", onClick: onClose, "aria-label": "Close video", children: "×" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("video", { src: video, poster, controls: true, autoPlay: true, playsInline: true })
  ] }) });
}
function ProductCardFull({ product, primaryConcern, whyLabel = "Why it's in your routine", anchorId, pdpSource = "title" }) {
  const content = getProductContent(product);
  const slug = getSlugForProduct(product);
  const founderVideo = FOUNDER_VIDEO[slug];
  const [videoOpen, setVideoOpen] = reactExports.useState(false);
  const image = product.featured_image;
  const highlights = (content == null ? void 0 : content.keyBenefits) || [];
  const ingredients = (content == null ? void 0 : content.keyIngredients) || [];
  const why = (content == null ? void 0 : content.whyForYou) ? content.whyForYou[primaryConcern] || content.whyForYou.default : null;
  const curated = getCuratedReview(product, primaryConcern);
  const review = curated ? { text: `“${curated.quote}”`, attribution: curated.name, photo: { url: curated.photo, alt: `${curated.name} review photo` } } : (content == null ? void 0 : content.quote) ? { text: content.quote.body, attribution: content.quote.who, photo: null } : null;
  const openVideo = () => {
    track("routine_finder_founder_video_opened", { product_id: product.id, product_title: product.title });
    setVideoOpen(true);
  };
  const imageStyle = image ? { backgroundImage: `url(${image})` } : void 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("article", { className: "rbm-product", id: anchorId, children: [
    founderVideo ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        type: "button",
        className: "rbm-p-img rbm-p-img-btn",
        style: imageStyle,
        onClick: openVideo,
        "aria-label": `Play the founder video for ${product.title}`,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "rbm-video-link", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-video-play", "aria-hidden": "true", children: "▶" }),
          "Video"
        ] })
      }
    ) : product.handle ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      "a",
      {
        className: "rbm-p-img rbm-p-img-link",
        style: imageStyle,
        href: `/products/${product.handle}`,
        "aria-label": `View ${product.title}`,
        onClick: () => track("routine_finder_product_pdp_clicked", { product_id: product.id, product_title: product.title, handle: product.handle, source: "image" })
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-p-img", style: imageStyle }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-main", children: [
      product.badge && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-p-head", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-badge", children: product.badge }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { children: product.handle ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          className: "rbm-p-title-link",
          href: `/products/${product.handle}`,
          onClick: () => track("routine_finder_product_pdp_clicked", { product_id: product.id, product_title: product.title, handle: product.handle, source: pdpSource }),
          children: product.title
        }
      ) : product.title }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-rating", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-rating-star", "aria-hidden": "true", children: "★" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(OkendoRating, { productId: product.id })
      ] }),
      highlights.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "rbm-bullets", children: highlights.map((b) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: b }, b)) }),
      ingredients.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-ingredients", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-kicker", children: "Key ingredients" }),
        ingredients.map((ing) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-ingredient", children: [
          ing.label && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "rbm-ing-label", children: [
            ing.label,
            ing.detail ? ":" : ""
          ] }),
          ing.detail && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "rbm-ing-detail", children: [
            " ",
            ing.detail
          ] })
        ] }, ing.label || ing.detail))
      ] }),
      why && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-why", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-kicker", children: whyLabel }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: why })
      ] })
    ] }),
    review && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-quote", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-q-body", children: review.text }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-q-attrib", children: [
        review.photo && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "span",
          {
            className: "rbm-q-av",
            role: "img",
            "aria-label": review.photo.alt || review.attribution,
            style: { backgroundImage: `url(${review.photo.url})` }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-q-who", children: review.attribution })
      ] })
    ] }),
    videoOpen && founderVideo && /* @__PURE__ */ jsxRuntimeExports.jsx(VideoModal, { video: founderVideo.video, poster: founderVideo.poster, onClose: () => {
      track("routine_finder_founder_video_closed", { product_id: product.id });
      setVideoOpen(false);
    } })
  ] });
}
const DISMISS_PX = 90;
function ProductQuickSheet({ product, primaryConcern, whyLabel, onClose }) {
  const closeRef = reactExports.useRef(null);
  const dragStartY = reactExports.useRef(null);
  const dragDistance = reactExports.useRef(0);
  const [dragY, setDragY] = reactExports.useState(0);
  reactExports.useEffect(() => {
    var _a2;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    (_a2 = closeRef.current) == null ? void 0 : _a2.focus();
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, []);
  reactExports.useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose("esc");
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);
  const onPointerDown = (e) => {
    var _a2, _b2;
    dragStartY.current = e.clientY;
    dragDistance.current = 0;
    (_b2 = (_a2 = e.currentTarget).setPointerCapture) == null ? void 0 : _b2.call(_a2, e.pointerId);
  };
  const onPointerMove = (e) => {
    if (dragStartY.current === null) return;
    const dy = e.clientY - dragStartY.current;
    if (dy > 0) {
      dragDistance.current = dy;
      setDragY(dy);
    }
  };
  const onPointerUp = () => {
    if (dragStartY.current === null) return;
    const dy = dragDistance.current;
    dragStartY.current = null;
    dragDistance.current = 0;
    setDragY(0);
    if (dy > DISMISS_PX) onClose("swipe");
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-sheet-scrim", onClick: () => onClose("scrim"), children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: "rbm-sheet",
      role: "dialog",
      "aria-modal": "true",
      "aria-label": product.title,
      onClick: (e) => e.stopPropagation(),
      style: dragY ? { transform: `translateY(${dragY}px)`, transition: "none" } : void 0,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: "rbm-sheet-head",
            onPointerDown,
            onPointerMove,
            onPointerUp,
            onPointerCancel: onPointerUp,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-sheet-grab", "aria-hidden": "true" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  type: "button",
                  className: "rbm-sheet-close",
                  onClick: () => onClose("close_button"),
                  "aria-label": "Close",
                  ref: closeRef,
                  children: "×"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-sheet-body", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            ProductCardFull,
            {
              product,
              primaryConcern,
              whyLabel,
              pdpSource: "quickview"
            }
          ),
          product.handle && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              className: "rbm-sheet-cta",
              href: `/products/${product.handle}`,
              onClick: () => track("routine_finder_product_pdp_clicked", { product_id: product.id, product_title: product.title, handle: product.handle, source: "quickview_cta" }),
              children: "View full product page →"
            }
          )
        ] })
      ]
    }
  ) });
}
function QuickViewProvider({ primaryConcern, advancedDelta, children }) {
  const [product, setProduct] = reactExports.useState(null);
  const advancedIds = reactExports.useMemo(
    () => new Set((advancedDelta || []).map((p2) => p2.id)),
    [advancedDelta]
  );
  const open = reactExports.useCallback((p2, source) => {
    track("routine_finder_product_quickview_opened", { product_id: p2.id, product_title: p2.title, source });
    setProduct(p2);
  }, []);
  const close = reactExports.useCallback((reason) => {
    if (product) track("routine_finder_product_quickview_closed", { product_id: product.id, reason });
    setProduct(null);
  }, [product]);
  const value = reactExports.useMemo(() => ({ open }), [open]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(QuickViewContext.Provider, { value, children: [
    children,
    product && /* @__PURE__ */ jsxRuntimeExports.jsx(
      ProductQuickSheet,
      {
        product,
        primaryConcern,
        whyLabel: advancedIds.has(product.id) ? "Why it boosts your routine" : void 0,
        onClose: close
      }
    )
  ] });
}
function CondensedCard({ product, anchorId, onOpen }) {
  var _a2;
  const content = getProductContent(product);
  const benefit = (_a2 = content == null ? void 0 : content.keyBenefits) == null ? void 0 : _a2[0];
  const image = product.featured_image;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("article", { className: "rbm-product-mini", id: anchorId, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "span",
      {
        className: "rbm-mini-thumb",
        style: image ? { backgroundImage: `url(${image})` } : void 0
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-mini-text", children: [
      product.badge && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-badge rbm-mini-badge", children: product.badge }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "rbm-mini-title", children: product.title }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-rating rbm-mini-rating", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-rating-star", "aria-hidden": "true", children: "★" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(OkendoRating, { productId: product.id })
      ] }),
      benefit && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "rbm-mini-benefit", children: benefit })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        type: "button",
        className: "rbm-mini-cta",
        onClick: onOpen,
        "aria-haspopup": "dialog",
        "aria-label": `View details for ${product.title}`,
        children: "View details ›"
      }
    )
  ] });
}
function RoutineProductCard({ product, primaryConcern, whyLabel = "Why it's in your routine" }) {
  const isMobile = useIsMobile();
  const quickView = useQuickView();
  const anchorId = productAnchorId(getSlugForProduct(product));
  if (!isMobile) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      ProductCardFull,
      {
        product,
        primaryConcern,
        whyLabel,
        anchorId
      }
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CondensedCard,
    {
      product,
      anchorId,
      onOpen: () => quickView == null ? void 0 : quickView.open(product, "card")
    }
  );
}
const namesList = (products) => {
  const names = (products || []).map(getShortName);
  if (names.length <= 1) return names.join("");
  return `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
};
function IntensiveUpsell({ advancedDelta, primaryConcern, selected }) {
  if (!advancedDelta.length) return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: `rbm-section rbm-intensive${selected ? " rbm-selected" : ""}`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-section-head", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: "Upgrade to an Intensive routine" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
        "Add ",
        namesList(advancedDelta),
        " for faster, more complete results."
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-products-grid", children: advancedDelta.map((product) => /* @__PURE__ */ jsxRuntimeExports.jsx(RoutineProductCard, { product, primaryConcern, whyLabel: "Why it boosts your routine" }, product.id)) })
  ] });
}
function PeriodIcon({ period }) {
  if (period === "pm") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { className: "rbm-howto-period-icon rbm-period-pm", viewBox: "0 0 24 24", fill: "currentColor", stroke: "none", "aria-hidden": "true", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M21 13.4A9 9 0 1 1 10.6 3a7.2 7.2 0 0 0 10.4 10.4z" }) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { className: "rbm-howto-period-icon rbm-period-am", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", "aria-hidden": "true", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "12", cy: "12", r: "4" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12 2.6v2.3M12 19.1v2.3M2.6 12h2.3M19.1 12h2.3M5.3 5.3l1.6 1.6M17.1 17.1l1.6 1.6M18.7 5.3l-1.6 1.6M6.9 17.1l-1.6 1.6" })
  ] });
}
function StepIcon({ name }) {
  if (name === "sun") {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.6", strokeLinecap: "round", "aria-hidden": "true", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "12", cy: "12", r: "4" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12 2.5v2.2M12 19.3v2.2M2.5 12h2.2M19.3 12h2.2M5.2 5.2l1.6 1.6M17.2 17.2l1.6 1.6M18.8 5.2l-1.6 1.6M6.8 17.2l-1.6 1.6" })
    ] });
  }
  if (name === "drop") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.6", strokeLinejoin: "round", "aria-hidden": "true", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12 2.8c0 0-6.2 6.9-6.2 11.3a6.2 6.2 0 0 0 12.4 0C18.2 9.7 12 2.8 12 2.8z" }) });
  }
  return null;
}
function assignSessions(slugs) {
  const am = /* @__PURE__ */ new Set();
  const pm = /* @__PURE__ */ new Set();
  let amActives = 0;
  let pmActives = 0;
  const flex = [];
  slugs.forEach((slug) => {
    const s = ROUTINE_SCHEDULE[slug] || { both: true };
    if (s.both) {
      am.add(slug);
      pm.add(slug);
    } else if (s.slot === "pm") {
      pm.add(slug);
      if (s.active) pmActives += 1;
    } else if (s.slot === "am") {
      am.add(slug);
      if (s.active) amActives += 1;
    } else flex.push(slug);
  });
  flex.forEach((slug) => {
    const s = ROUTINE_SCHEDULE[slug];
    if (!s.active) {
      am.add(slug);
      return;
    }
    if (amActives < pmActives) {
      am.add(slug);
      amActives += 1;
    } else {
      pm.add(slug);
      pmActives += 1;
    }
  });
  return { am, pm };
}
function buildHowToRows(period, session, bySlug) {
  const rows = [];
  const hasCleanser = LAYERING.some((e) => session.has(e.slug) && e.layer === "cleanse" && e.slug !== "exfoliator");
  if (!hasCleanser) {
    rows.push({
      key: "cleanse-byo",
      name: "Cleanse",
      icon: "drop"
    });
  }
  LAYERING.forEach((e) => {
    var _a2, _b2;
    if (!session.has(e.slug)) return;
    const slot = bySlug[e.slug];
    if (!slot) return;
    const name = slot.comp ? slot.comp.title : getShortName(slot.product);
    const image = slot.comp ? slot.comp.image || ((_a2 = slot.comp.product) == null ? void 0 : _a2.featured_image) : (_b2 = slot.product) == null ? void 0 : _b2.featured_image;
    rows.push({ key: e.slug, name, note: e.freq || "", image: image || null, product: slot.comp ? slot.comp.product : slot.product });
  });
  Object.entries(bySlug).forEach(([slug, slot]) => {
    var _a2;
    if (!slot.comp || LAYERING.some((e) => e.slug === slug)) return;
    if (!session.has(slug)) return;
    const c = slot.comp;
    rows.push({ key: `comp-${c.productId}`, name: c.title, note: "", image: c.image || ((_a2 = c.product) == null ? void 0 : _a2.featured_image) || null, product: c.product });
  });
  if (period === "am") {
    rows.push({ key: "spf", name: "SPF 30+", icon: "sun" });
  }
  return rows;
}
function Step({ row, index, onOpenProduct }) {
  const tappable = onOpenProduct && row.product;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `rbm-howto-step${row.icon ? " rbm-howto-byo" : ""}`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-howto-num", children: index + 1 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "span",
      {
        className: `rbm-howto-thumb${row.icon ? " rbm-howto-thumb-icon" : ""}`,
        style: row.image ? { backgroundImage: `url(${row.image})` } : void 0,
        children: row.icon && /* @__PURE__ */ jsxRuntimeExports.jsx(StepIcon, { name: row.icon })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "rbm-howto-info", children: [
      tappable ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          type: "button",
          className: "rbm-howto-name rbm-howto-name-btn",
          onClick: () => onOpenProduct(row.product),
          "aria-haspopup": "dialog",
          "aria-label": `View details for ${row.name}`,
          children: row.name
        }
      ) : /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-howto-name", children: row.name }),
      row.note && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-howto-note-sm", children: row.note })
    ] })
  ] });
}
function HowToSection({ core, advancedDelta }) {
  const isMobile = useIsMobile();
  const quickView = useQuickView();
  const [previewTier, setPreviewTier] = reactExports.useState("core");
  const onOpenProduct = isMobile && quickView ? (product) => quickView.open(product, "how_to") : null;
  const hasIntensive = (advancedDelta || []).length > 0;
  const isIntensive = previewTier === "intensive";
  const routine = isIntensive ? [...core, ...advancedDelta] : core;
  const bySlug = {};
  routine.forEach((p2) => {
    const s = getSlugForProduct(p2);
    if (s) bySlug[s] = { product: p2 };
  });
  const sessions = assignSessions(Object.keys(bySlug));
  const rowsAM = buildHowToRows("am", sessions.am, bySlug);
  const rowsPM = buildHowToRows("pm", sessions.pm, bySlug);
  const alternateNote = sessions.pm.has("moonlight") && sessions.pm.has("night_renewer");
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: "rbm-section rbm-howto-section", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-section-head", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: "How to use your routine" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Layer thinnest to thickest, morning and night. Your own cleanser and SPF slot right in." })
    ] }),
    hasIntensive && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-howto-toggle", role: "tablist", "aria-label": "Preview routine level", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: !isIntensive ? "rbm-active" : "", onClick: () => {
        track("routine_finder_how_to_tier_toggled", { tier: "core" });
        setPreviewTier("core");
      }, children: "Core Routine" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: isIntensive ? "rbm-active" : "", onClick: () => {
        track("routine_finder_how_to_tier_toggled", { tier: "intensive" });
        setPreviewTier("intensive");
      }, children: "Intensive Routine" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-howto rbm-howto-split", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-howto-col", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("h3", { className: "rbm-howto-col-title", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(PeriodIcon, { period: "am" }),
          "Morning"
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-howto-stack", children: rowsAM.map((row, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(Step, { row, index: i, onOpenProduct }, row.key)) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-howto-col", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("h3", { className: "rbm-howto-col-title", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(PeriodIcon, { period: "pm" }),
          "Evening"
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-howto-stack", children: rowsPM.map((row, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(Step, { row, index: i, onOpenProduct }, row.key)) })
      ] })
    ] }),
    alternateNote && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "rbm-howto-foot", children: "Tip: alternate Moonlight and Night Renewer on different nights while your skin adjusts." })
  ] });
}
function renderRich(text) {
  return text.split("**").map((seg, i) => i % 2 === 1 ? /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: seg }, i) : seg);
}
function Timeline({ primaryConcern, secondaryConcern }) {
  const primarySet = CONCERN_TIMELINE[primaryConcern] || CONCERN_TIMELINE.default;
  const secondarySet = secondaryConcern ? CONCERN_TIMELINE[secondaryConcern] : null;
  const steps = primarySet.map((m2, i) => {
    var _a2;
    const add = (_a2 = secondarySet == null ? void 0 : secondarySet[i]) == null ? void 0 : _a2.add;
    return { when: m2.when, title: m2.title, body: add ? `${m2.body} ${add}` : m2.body };
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: "rbm-section rbm-alt", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-section-head", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: "Your 12-week arc" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Skincare results compound. Here's what your routine builds toward at each milestone." })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-timeline", style: { "--tl-steps": steps.length }, children: steps.map((step) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-tl-step", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-when", children: step.when }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { children: step.title }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: renderRich(step.body) })
    ] }, step.when)) })
  ] });
}
const fmt = (cents) => `$${(cents / 100).toFixed(2)}`;
const fullCents = (products) => (products || []).reduce((sum, p2) => sum + ((p2 == null ? void 0 : p2.price) || 0), 0);
function BuyBox({
  routine,
  firstName,
  core,
  advancedDelta,
  purchaseMode,
  setPurchaseMode,
  customProductIds,
  toggleCustomProduct,
  selectCustom,
  concernSlugs,
  sellingPlans,
  selectedSellingPlanId,
  setSelectedSellingPlanId,
  buyMode,
  setBuyMode,
  onBuy,
  busy
}) {
  const isSub = buyMode === "subscription";
  const routineFull = fullCents(routine);
  const savePercent = fcDiscountForCount(routine.length);
  const subCents = fcSubtotalCents(routine);
  const savingsCents = routineFull - subCents;
  const intensiveProducts = [...core, ...advancedDelta];
  const hasIntensive = advancedDelta.length > 0;
  const cadenceLabel = (sp) => {
    const base = `${sp.billingIntervalCount} ${sp.billingIntervalCount > 1 ? "months" : "month"}`;
    return sp.billingIntervalCount === 2 ? `${base} (most popular)` : base;
  };
  const selectInterval = (e) => {
    const sp = sellingPlans.find((s) => String(s.sellingPlanId) === e.target.value);
    if (sp) {
      track("routine_finder_delivery_interval_selected", { selling_plan_id: sp.sellingPlanId, interval_months: sp.billingIntervalCount });
      setSelectedSellingPlanId(sp.sellingPlanId);
    }
    setBuyMode("subscription");
  };
  const chooseBuyMode = (mode2) => {
    track("routine_finder_buy_mode_selected", { mode: mode2 });
    setBuyMode(mode2);
  };
  const canBuy = routine.length > 0;
  const possessive = firstName ? `${firstName}'s` : "Your";
  const heading = purchaseMode === "custom" ? `${possessive} Custom Routine` : `${possessive} ${purchaseMode === "intensive" ? "Intensive" : "Core"} Routine`;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("section", { className: "rbm-section rbm-buybox-section", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-buybox", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-bb-img", "data-count": routine.length, children: routine.map((p2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      "span",
      {
        className: "rbm-bb-tile",
        style: p2.featured_image ? { backgroundImage: `url(${p2.featured_image})` } : void 0
      },
      p2.id
    )) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { position: "relative" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: heading }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: `rbm-bb-sub${purchaseMode === "custom" ? " rbm-bb-sub-blank" : ""}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: purchaseMode === "custom" ? "rbm-bb-sub-hidden" : void 0, children: getResultBenefit(concernSlugs) }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-bb-section", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-kicker", children: "What would you like?" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-choice-list", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "button",
            {
              type: "button",
              className: `rbm-option${purchaseMode === "core" ? " rbm-selected" : ""}`,
              onClick: () => {
                track("routine_finder_purchase_mode_selected", { mode: "core" });
                setPurchaseMode("core");
              },
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-radio" }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "rbm-opt-main", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-opt-title", children: "Core routine" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-opt-sub", children: "The essentials we recommend" })
                ] })
              ]
            }
          ),
          hasIntensive && /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "button",
            {
              type: "button",
              className: `rbm-option${purchaseMode === "intensive" ? " rbm-selected" : ""}`,
              onClick: () => {
                track("routine_finder_purchase_mode_selected", { mode: "intensive" });
                setPurchaseMode("intensive");
              },
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-radio" }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "rbm-opt-main", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-opt-title", children: "Intensive routine" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-opt-sub", children: "Faster, more complete results" })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "button",
            {
              type: "button",
              className: `rbm-option${purchaseMode === "custom" ? " rbm-selected" : ""}`,
              onClick: () => {
                track("routine_finder_purchase_mode_selected", { mode: "custom" });
                selectCustom();
              },
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-radio" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-opt-main", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-opt-title", children: "Choose individual products" }) })
              ]
            }
          )
        ] }),
        purchaseMode === "custom" && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-pick-grid", children: intensiveProducts.map((p2) => {
          const picked = customProductIds.includes(p2.id);
          const locked = picked && customProductIds.length <= 2;
          return /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "button",
            {
              type: "button",
              className: `rbm-pick-card${picked ? " rbm-selected" : ""}${locked ? " rbm-locked" : ""}`,
              onClick: () => {
                track("routine_finder_custom_product_toggled", { product_id: p2.id, product_title: getShortName(p2), selected: !picked });
                toggleCustomProduct(p2.id);
              },
              "aria-pressed": picked,
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-pick-check", "aria-hidden": "true", children: "✓" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "span",
                  {
                    className: "rbm-pick-thumb",
                    style: p2.featured_image ? { backgroundImage: `url(${p2.featured_image})` } : void 0
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-pick-name", children: getShortName(p2) }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-pick-price", children: fmt(p2.price) })
              ]
            },
            p2.id
          );
        }) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-bb-section", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-kicker", children: "How would you like to buy" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-buy-rows", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "div",
            {
              className: `rbm-option rbm-buy-row${isSub ? " rbm-selected" : ""}`,
              role: "button",
              tabIndex: 0,
              onClick: () => chooseBuyMode("subscription"),
              onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  chooseBuyMode("subscription");
                }
              },
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-radio" }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "rbm-opt-main", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-opt-title", children: "Subscribe & Save" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-opt-sub", children: "Free shipping forever. Edit, pause or cancel anytime." }),
                  sellingPlans.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "rbm-interval-field", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-interval-label", children: "Deliver every" }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "select",
                      {
                        className: "rbm-interval-select",
                        value: selectedSellingPlanId != null ? String(selectedSellingPlanId) : "",
                        onClick: (e) => e.stopPropagation(),
                        onChange: selectInterval,
                        children: sellingPlans.map((sp) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: sp.sellingPlanId, children: cadenceLabel(sp) }, sp.sellingPlanId))
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "rbm-opt-pricecol", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-opt-price", children: fmt(subCents) }),
                  savingsCents > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "rbm-opt-save", children: [
                    "Save ",
                    savePercent,
                    "%"
                  ] })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "div",
            {
              className: `rbm-option rbm-buy-row${!isSub ? " rbm-selected" : ""}`,
              role: "button",
              tabIndex: 0,
              onClick: () => chooseBuyMode("onetime"),
              onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  chooseBuyMode("onetime");
                }
              },
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-radio" }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "rbm-opt-main", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-opt-title", children: "One-time purchase" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-opt-sub", children: "Free shipping over $50" })
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-opt-pricecol", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-opt-price", children: fmt(routineFull) }) })
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          type: "button",
          className: "rbm-btn rbm-primary rbm-lg rbm-block",
          onClick: onBuy,
          disabled: busy || !canBuy,
          children: !canBuy ? "Select at least one product" : busy ? "Adding…" : isSub ? "Subscribe" : "Add to cart"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-bb-guarantee", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-check", children: "✓" }),
          " In stock and ships next business day"
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-check", children: "✓" }),
          " Free returns within 100 days"
        ] })
      ] })
    ] })
  ] }) });
}
const CONCERN_LABEL = {
  wrinkles: "Fine lines & wrinkles",
  dark_spots: "Hyperpigmentation & dark spots",
  dryness: "Dryness & tightness",
  redness: "Redness & irritation",
  acne: "Acne & blemishes",
  oil_control: "Oil control & pores",
  uneven_texture: "Uneven texture"
};
const CONCERN_KEYWORDS = {
  wrinkles: ["wrinkle", "fine line", "younger", "firm", "aging", "lines"],
  dark_spots: ["spot", "bright", "even", "tone", "fade", "glow", "pigment"],
  dryness: ["dry", "hydrat", "moistur", "tight", "soft", "flak"],
  redness: ["red", "calm", "sensitiv", "irritat", "rosacea", "gentle"],
  acne: ["acne", "breakout", "blemish", "clear", "congest"],
  oil_control: ["oil", "pore", "shine", "greasy", "matte"],
  uneven_texture: ["texture", "smooth", "rough", "even", "bump"]
};
function pickReviews(concernSlugs) {
  const slugs = (concernSlugs || []).filter((s) => CONCERN_LABEL[s]);
  const faces = RESULT_REVIEWS.filter((r2) => r2.face !== false);
  const [primary, secondary] = slugs;
  const picks = [];
  const used = /* @__PURE__ */ new Set();
  const onTopic = (r2, c) => (CONCERN_KEYWORDS[c] || []).some((k2) => (r2.body || "").toLowerCase().includes(k2));
  const take = (concern, n2) => {
    if (!concern || n2 <= 0) return;
    const cands = faces.filter((r2) => !used.has(r2) && r2.concerns.includes(concern)).sort((a, b) => (onTopic(b, concern) ? 1 : 0) - (onTopic(a, concern) ? 1 : 0));
    for (const r2 of cands) {
      if (n2 <= 0 || picks.length >= 3) break;
      picks.push({ ...r2, meta: CONCERN_LABEL[concern] });
      used.add(r2);
      n2 -= 1;
    }
  };
  if (slugs.length >= 2) {
    take(primary, 2);
    take(secondary, 1);
  } else if (slugs.length === 1) {
    take(primary, 3);
  }
  take(primary, 3 - picks.length);
  take(secondary, 3 - picks.length);
  for (const r2 of faces) {
    if (picks.length >= 3) break;
    if (!used.has(r2)) {
      picks.push(r2);
      used.add(r2);
    }
  }
  return picks.slice(0, 3);
}
function bigPhoto(url) {
  return (url || "").replace(/d=\d+x\d+/, "d=480x480");
}
function ReviewsGrid({ selectedConcernSlugs }) {
  const reviews2 = pickReviews(selectedConcernSlugs);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: "rbm-section rbm-reviews", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-section-head", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: "Happy customers with skin concerns similar to yours" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "★ 4.6 / 5 across 15,000+ reviews — filtered to reviewers who flagged the same skin concerns as you." })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-reviews-grid", children: reviews2.map((review) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-review-card", children: [
      review.meta && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "rbm-review-tag", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-tag-check", "aria-hidden": "true", children: "✓" }),
        review.meta
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-review-photo", style: { backgroundImage: `url(${bigPhoto(review.image)})` } }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-review-body", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-stars", children: "★".repeat(review.stars) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "rbm-r-body", children: review.body }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-who", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-name", children: review.name }) })
      ] })
    ] }, review.name + review.meta)) })
  ] });
}
function ScienceReads({ products }) {
  const reads = getScienceReads(products);
  if (!reads.length) return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: "rbm-section rbm-science", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-section-head", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: "The science behind your routine" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Don't just take our word for it. Go deep on the actives we picked for you." })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-science-grid", children: reads.map((r2) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "a",
      {
        className: "rbm-science-card",
        href: r2.url,
        target: "_blank",
        rel: "noopener noreferrer",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-science-imgwrap", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-science-img", style: { backgroundImage: `url(${r2.image})` } }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-science-kicker", children: r2.ingredient }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "rbm-science-title", children: r2.title }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "rbm-science-excerpt", children: r2.excerpt }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-science-meta", children: r2.readTime })
        ]
      },
      r2.url
    )) })
  ] });
}
function FaqAccordion() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: "rbm-section rbm-faq", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-section-head", children: /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: "Frequently Asked Questions" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-faq-list", children: FAQ_CONTENT.map((item, index) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "details",
      {
        className: "rbm-qa",
        open: index === 0,
        onToggle: (e) => track("routine_finder_faq_toggled", { question: item.q, expanded: e.target.open }),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("summary", { children: [
            item.q,
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rbm-icon", children: "+" })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-a", children: item.a })
        ]
      },
      item.q
    )) })
  ] });
}
function Result({
  handleEditAnswerModal,
  selectedConcernSlugs,
  routineSections,
  treatmentName,
  treatmentLede,
  firstName
}) {
  const { core, advancedDelta } = routineSections;
  const [bundleData, setBundleData] = reactExports.useState(null);
  const [selectedSellingPlanId, setSelectedSellingPlanId] = reactExports.useState(null);
  const [buyMode, setBuyMode] = reactExports.useState("subscription");
  const [busyMain, setBusyMain] = reactExports.useState(false);
  const [purchaseMode, setPurchaseMode] = reactExports.useState("core");
  const [customProductIds, setCustomProductIds] = reactExports.useState([]);
  const primaryConcern = selectedConcernSlugs == null ? void 0 : selectedConcernSlugs[0];
  const productCount = core.length;
  const advancedRoutine = [...core, ...advancedDelta];
  const customRoutine = advancedRoutine.filter((p2) => customProductIds.includes(p2.id));
  const activeRoutine = purchaseMode === "intensive" && advancedDelta.length ? advancedRoutine : purchaseMode === "custom" ? customRoutine : core;
  const baseGridProducts = core;
  const selectCustom = () => {
    setPurchaseMode("custom");
    setCustomProductIds((ids) => ids.length ? ids : core.map((p2) => p2.id));
  };
  const toggleCustomProduct = (id2) => {
    setCustomProductIds((ids) => {
      if (!ids.includes(id2)) return [...ids, id2];
      if (ids.length <= 2) return ids;
      return ids.filter((x2) => x2 !== id2);
    });
  };
  reactExports.useEffect(() => {
    setPurchaseMode("core");
    setCustomProductIds([]);
  }, [productCount]);
  reactExports.useEffect(() => {
    let cancelled = false;
    getFamilyCircleBundleData().then((data) => {
      var _a2, _b2, _c;
      if (cancelled || !data) return;
      setBundleData(data);
      const defaultPlan = ((_a2 = data.sellingPlans) == null ? void 0 : _a2.find((sp) => sp.billingIntervalCount === 2)) || ((_b2 = data.sellingPlans) == null ? void 0 : _b2.find((sp) => sp.isDefault)) || ((_c = data.sellingPlans) == null ? void 0 : _c[0]);
      if (defaultPlan) setSelectedSellingPlanId(defaultPlan.sellingPlanId);
    }).catch((err) => {
      console.error("Could not load Family Circle bundle data", err);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  const sellingPlans = (bundleData == null ? void 0 : bundleData.sellingPlans) || [];
  const handleBuy = async () => {
    if (busyMain) return;
    track("routine_finder_buy_clicked", {
      purchase_mode: purchaseMode,
      buy_mode: buyMode,
      product_ids: activeRoutine.map((p2) => p2.id),
      product_count: activeRoutine.length,
      price_cents: buyMode === "subscription" ? fcSubtotalCents(activeRoutine) : activeRoutine.reduce((sum, p2) => sum + ((p2 == null ? void 0 : p2.price) || 0), 0),
      selling_plan_id: buyMode === "subscription" ? selectedSellingPlanId : null
    });
    setBusyMain(true);
    try {
      if (buyMode === "subscription") {
        await addFamilyCircleBundleToCart(activeRoutine, { sellingPlanId: selectedSellingPlanId });
      } else {
        await addRoutineToCart(activeRoutine);
      }
    } finally {
      setBusyMain(false);
    }
  };
  return (
    // The provider sits inside .rb-result because it renders the quick-view
    // sheet, and every sheet rule is scoped under that class.
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rb-result", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(QuickViewProvider, { primaryConcern, advancedDelta, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ConcernTable,
        {
          selectedConcernSlugs,
          coreProducts: core,
          treatmentName,
          treatmentLede,
          onEditQuiz: handleEditAnswerModal
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: "rbm-section rbm-products", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rbm-section-head", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { children: [
            "Your core ",
            baseGridProducts.length,
            "-product routine"
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "What each one does and why we chose it for you." })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rbm-products-grid", children: baseGridProducts.map((product) => /* @__PURE__ */ jsxRuntimeExports.jsx(RoutineProductCard, { product, primaryConcern }, product.id)) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        IntensiveUpsell,
        {
          advancedDelta,
          primaryConcern,
          selected: purchaseMode === "intensive"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        HowToSection,
        {
          core,
          advancedDelta
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Timeline, { primaryConcern, secondaryConcern: selectedConcernSlugs == null ? void 0 : selectedConcernSlugs[1] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        BuyBox,
        {
          routine: activeRoutine,
          firstName,
          core,
          advancedDelta,
          purchaseMode,
          setPurchaseMode,
          customProductIds,
          toggleCustomProduct,
          selectCustom,
          concernSlugs: selectedConcernSlugs,
          sellingPlans,
          selectedSellingPlanId,
          setSelectedSellingPlanId,
          buyMode,
          setBuyMode,
          onBuy: handleBuy,
          busy: busyMain
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ReviewsGrid, { selectedConcernSlugs }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ScienceReads, { products: [...core, ...advancedDelta] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FaqAccordion, {})
    ] }) })
  );
}
function SaveResults({ questions, lastViewedTime, activeTab }) {
  const [email, setEmail] = reactExports.useState("");
  const [emailSentTo, setEmailSentTo] = reactExports.useState(localStorage.getItem(RB_CUSTOMER_EMAIL_SENT_LOCALSTORAGE_KEY) || "");
  const handleSubmit = (e) => {
    var _a2, _b2, _c;
    e.preventDefault();
    const isEmailValid = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email);
    console.log({ isEmailValid });
    if (!isEmailValid) {
      track("routine_finder_save_results_invalid", {});
      alert("Email is invalid");
      return;
    }
    const quizFirstName = (_c = (_b2 = (_a2 = questions == null ? void 0 : questions.find) == null ? void 0 : _a2.call(questions, (q2) => q2.id === "first_name")) == null ? void 0 : _b2.selectedAnswer) == null ? void 0 : _c.trim();
    track("routine_finder_save_results_submitted", { has_name: !!quizFirstName });
    const routine_customer = window.routine_customer || {};
    const customer = { ...routine_customer, email };
    if (quizFirstName) customer.first_name = quizFirstName;
    sendSavedResultToKlaviyo(questions, lastViewedTime, customer, activeTab);
    localStorage.setItem(RB_CUSTOMER_EMAIL_SENT_LOCALSTORAGE_KEY, email);
    setEmailSentTo(email);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: "save-results", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h6", { className: "save-results__title", style: { display: emailSentTo ? "none" : "auto" }, children: "Save your routine!" }),
    emailSentTo && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "save-results__title results-saved", style: {}, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: "https://cdn.shopify.com/s/files/1/1919/1971/files/icon-check.png?v=1726293699", alt: "Checked", width: 30 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Your routine has been sent to your email!" })
    ] }),
    !emailSentTo && /* @__PURE__ */ jsxRuntimeExports.jsx("form", { className: "save-results__form", action: "#", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("fieldset", { className: "save-results__input-group", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          className: "save-results__input",
          type: "email",
          id: "email",
          name: "email",
          placeholder: "Email address",
          "aria-label": "Email address",
          value: email,
          onChange: (e) => setEmail(e.target.value)
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: "save-results__button", type: "submit", "aria-label": "Submit email", onClick: handleSubmit, children: /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { "aria-hidden": "true", focusable: "false", role: "presentation", className: "icon icon--wide icon-arrow-right-long", viewBox: "0 0 21 10", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "m14.982 1.01.696-.717 3.803 3.691.011-.01.338.348.359.348-.012.01.012.011-.354.343-.343.353-.011-.011-3.803 3.692-.696-.718 3.266-3.17H.5v-1h17.748z" }) }) })
    ] }) })
  ] });
}
const EditAnswer = ({ questions, handleEditAnswerModal, updateAnswer, saveAndUpdateResponse }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "section",
    {
      className: "edit-answer",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "button",
          {
            className: "edit-answer__close",
            onClick: () => handleEditAnswerModal(false),
            children: [
              "  ",
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "svg",
                {
                  fill: "#000000",
                  height: "20px",
                  width: "20px",
                  version: "1.1",
                  id: "Capa_1",
                  xmlns: "http://www.w3.org/2000/svg",
                  xmlnsXlink: "http://www.w3.org/1999/xlink",
                  viewBox: "0 0 490 490",
                  xmlSpace: "preserve",
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx("polygon", { points: "456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490 \n          489.292,457.678 277.331,245.004 489.292,32.337 " })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "edit-answer__content ", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "edit-answer__title", children: "Update your responses" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { maxWidth: "300px", margin: "auto" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("form", { className: "edit-answer__form", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: questions == null ? void 0 : questions.map((question, index) => {
            if (question.type === "email" || question.id === "first_name") return null;
            const options = question.options.slice();
            if (question.multiSelect) {
              const selected = Array.isArray(question.selectedAnswer) ? question.selectedAnswer : [];
              const max = question.maxSelections || Infinity;
              const toggle = (label) => {
                const next = [...selected];
                const idx = next.indexOf(label);
                if (idx >= 0) next.splice(idx, 1);
                else if (next.length < max) next.push(label);
                updateAnswer(index, next);
              };
              return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "edit-answer__field", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("label", { className: "edit-answer__label", children: question == null ? void 0 : question.title }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "edit-answer__checkbox-group", children: options.map((option) => /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "edit-answer__checkbox-row", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "input",
                    {
                      type: "checkbox",
                      checked: selected.includes(option.label),
                      onChange: () => toggle(option.label)
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: option.label })
                ] }, option.label)) })
              ] }, `edit-answer-index-${index}`);
            }
            return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "edit-answer__field", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: `edit-answer-${index}`, className: "edit-answer__label", children: question == null ? void 0 : question.title }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "select",
                {
                  className: "edit-answer__select",
                  value: question.selectedAnswer || "",
                  onChange: (event) => updateAnswer(index, event.target.value),
                  children: options == null ? void 0 : options.map((option, optionIndex) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: option == null ? void 0 : option.label, className: "edit-answer__option", children: option == null ? void 0 : option.label }, `question-${index}-${optionIndex}`))
                }
              )
            ] }, `edit-answer-index-${index}`);
          }) }) }) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "edit-answer__actions", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              type: "submit",
              className: "edit-answer__button edit-answer__button--primary",
              onClick: () => {
                saveAndUpdateResponse(null, "edit_answers");
                handleEditAnswerModal(false, "saved");
              },
              children: "Save & Update"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              type: "button",
              className: "edit-answer__button--secondary",
              onClick: () => handleEditAnswerModal(false),
              children: "Cancel"
            }
          )
        ] })
      ]
    }
  );
};
const reviews = [
  {
    image: "https://cdn.shopify.com/s/files/1/1919/1971/files/profo_dr_locke.jpg?v=1778888625",
    quote: "This is one of my all time favorite budget swaps for SkinCeuticals.",
    name: "Dr. Maren Locke, MD",
    title: "Board Certified Dermatologist"
  },
  {
    image: "https://cdn.shopify.com/s/files/1/1919/1971/files/profo_dr_strom.jpg?v=1778888625",
    quote: "Here are my biggest tips for maximizing that vitamin C glow with Maelove's The Glow Maker, which is one of my all time favorite vitamin c serums.",
    name: "Mark Strom, MD.",
    title: "Board Certified Dermatologist"
  },
  {
    image: "https://cdn.shopify.com/s/files/1/1919/1971/files/profo_dr_maxfield.jpg?v=1778888625",
    quote: "Maelove Glow Maker is an effective substitute for Skinceuticals C E Ferulic. They're similar in Vitamin C makeup, stablization profile and feel on the skin.",
    name: "Dr. Luke Maxfield, DO",
    title: "Board Certified Dermatologist"
  },
  {
    image: "https://cdn.shopify.com/s/files/1/1919/1971/files/profo_dr_price.jpg?v=1778888625",
    quote: "Not just derm approved but what I actually use myself",
    name: "Dr. Meredith Price",
    title: "Board Certified Dermatologist"
  }
];
const CheckIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { className: "review-slider__check", viewBox: "0 0 20 20", "aria-hidden": "true", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "10", cy: "10", r: "10", fill: "#3078CD" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M5.5 10.2l3 3 6-6", stroke: "#fff", strokeWidth: "2", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" })
] });
function ReviewSlider() {
  const trackRef = reactExports.useRef(null);
  const [activeIndex, setActiveIndex] = reactExports.useState(0);
  const drag = reactExports.useRef({ active: false, startX: 0, scrollLeft: 0, moved: false });
  reactExports.useEffect(() => {
    const track2 = trackRef.current;
    if (!track2) return;
    const cards = Array.from(track2.querySelectorAll(".review-slider__card"));
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = cards.indexOf(entry.target);
            if (idx !== -1) setActiveIndex(idx);
          }
        });
      },
      { root: track2, threshold: 0.6 }
    );
    cards.forEach((card) => observer.observe(card));
    return () => observer.disconnect();
  }, []);
  const scrollToCard = (index) => {
    const track2 = trackRef.current;
    if (!track2) return;
    const card = track2.querySelectorAll(".review-slider__card")[index];
    if (card) {
      track2.scrollTo({ left: card.offsetLeft - track2.offsetLeft, behavior: "smooth" });
    }
  };
  const onMouseDown = (e) => {
    const track2 = trackRef.current;
    if (!track2) return;
    drag.current = {
      active: true,
      startX: e.pageX,
      scrollLeft: track2.scrollLeft,
      moved: false
    };
    track2.classList.add("is-dragging");
  };
  const onMouseMove = (e) => {
    if (!drag.current.active) return;
    e.preventDefault();
    const track2 = trackRef.current;
    if (!track2) return;
    const dx = e.pageX - drag.current.startX;
    if (Math.abs(dx) > 4) drag.current.moved = true;
    track2.scrollLeft = drag.current.scrollLeft - dx;
  };
  const endDrag = () => {
    if (!drag.current.active) return;
    drag.current.active = false;
    const track2 = trackRef.current;
    if (track2) track2.classList.remove("is-dragging");
  };
  const onClickCapture = (e) => {
    if (drag.current.moved) {
      e.preventDefault();
      e.stopPropagation();
      drag.current.moved = false;
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "review-slider", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "ul",
      {
        className: "review-slider__track",
        ref: trackRef,
        onMouseDown,
        onMouseMove,
        onMouseUp: endDrag,
        onMouseLeave: endDrag,
        onClickCapture,
        children: reviews.map((r2, i) => /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { className: "review-slider__card", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "review-slider__image-wrap", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "review-slider__image", src: r2.image, alt: r2.name, loading: "lazy", draggable: false }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "review-slider__body", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "review-slider__quote", children: [
              "“",
              r2.quote,
              "”"
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "review-slider__attribution", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(CheckIcon, {}),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "review-slider__attribution-text", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "review-slider__name", children: r2.name }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "review-slider__title", children: r2.title })
              ] })
            ] })
          ] })
        ] }, i))
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "review-slider__dots", children: reviews.map((_, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        type: "button",
        className: `review-slider__dot${i === activeIndex ? " review-slider__dot--active" : ""}`,
        "aria-label": `Go to review ${i + 1}`,
        "aria-current": i === activeIndex ? "true" : void 0,
        onClick: () => {
          track("routine_finder_review_slider_nav_clicked", { slider: "testimonial", index: i });
          scrollToCard(i);
        }
      },
      i
    )) })
  ] });
}
function App({ mode: mode2 }) {
  var _a2, _b2, _c, _d, _e, _f, _g, _h;
  let { quizResponse, lastViewedTime, showViewRoutineBtn } = parseLocalStorageQuizResponse(quizQuestions);
  const isResults = mode2 === "results";
  const resultsUrl = (_a2 = window.routineBuilderObj) == null ? void 0 : _a2.results_url;
  const quizUrl = ((_b2 = window.routineBuilderObj) == null ? void 0 : _b2.quiz_url) || "/pages/routine-finder";
  const startResolved = isResults ? !!quizResponse : !!(quizResponse && !showViewRoutineBtn);
  console.log({ lastViewedTime, quizResponse, showViewRoutineBtn, mode: mode2 });
  const [questions, setQuestions] = reactExports.useState(quizQuestions);
  const [questionStarted, setQuestionStarted] = reactExports.useState(startResolved);
  const [currentQuestionIndex, setCurrentQuestionIndex] = reactExports.useState(startResolved ? quizQuestions.length : 0);
  const [allQuestionsAnswered, setAllQuestionsAnswered] = reactExports.useState(startResolved);
  const [isEditingAnswers, setIsEditingAnswers] = reactExports.useState(false);
  const [active, setActive] = reactExports.useState(1);
  const [routines] = reactExports.useState(routineOptions);
  const concernQuestionForLanding = questions.find((q2) => q2.id === "main_skin_concern");
  const selectedConcernsTexts = Array.isArray(concernQuestionForLanding == null ? void 0 : concernQuestionForLanding.selectedAnswer) ? concernQuestionForLanding.selectedAnswer : (concernQuestionForLanding == null ? void 0 : concernQuestionForLanding.selectedAnswer) ? [concernQuestionForLanding.selectedAnswer] : [];
  const multipleConcerns = selectedConcernsTexts.length > 1;
  reactExports.useEffect(() => {
    const backgroundImageElem = document.getElementById("MainContent");
    if (backgroundImageElem) {
      if (questionStarted) {
        backgroundImageElem.classList.add("started-editing");
        backgroundImageElem.classList.add("quiz-screen");
      } else {
        backgroundImageElem.classList.remove("started-editing");
        backgroundImageElem.classList.remove("quiz-screen");
      }
    }
    const familyCircle = document.querySelector(".family-circle");
    if (familyCircle) {
      familyCircle.style.display = "none";
    }
  }, [questionStarted]);
  reactExports.useEffect(() => {
    if (allQuestionsAnswered) {
      const backgroundImageElem = document.getElementById("MainContent");
      if (backgroundImageElem) {
        backgroundImageElem.classList.remove("quiz-screen");
      }
      const familyCircle = document.querySelector(".family-circle");
      if (familyCircle) {
        familyCircle.style.display = "none";
      }
    }
  }, [allQuestionsAnswered]);
  reactExports.useEffect(() => {
    if (isResults || !allQuestionsAnswered || !resultsUrl) return void 0;
    const t2 = setTimeout(() => {
      window.location.assign(resultsUrl);
    }, 450);
    return () => clearTimeout(t2);
  }, [isResults, allQuestionsAnswered, resultsUrl]);
  reactExports.useEffect(() => {
    window.handleQuickViewClose = (event, currentTarget) => {
      currentTarget.closest(".drawer__content").querySelector("button.drawer__button.drawer__close").click();
    };
    document.addEventListener("theme:scroll:lock", () => {
      const pFormInner = document.querySelector(".product__form__inner");
      if (pFormInner) {
        const divsToHide = pFormInner.nextElementSibling.querySelectorAll("div.box");
        for (const d of divsToHide) {
          if (d.textContent.includes("shipping")) {
            d.parentElement.parentElement.style.display = "none";
            break;
          }
        }
      }
    });
  }, []);
  const saveAndUpdateResponse = (resp, source = "quiz_completed") => {
    var _a3, _b3, _c2, _d2, _e2;
    console.log("saving...");
    const questionsResponse = resp || questions;
    localStorage.setItem(RB_LOCALSTORAGE_KEY, JSON.stringify({
      questions: questionsResponse,
      time: /* @__PURE__ */ new Date()
    }));
    const questionsArr = (questionsResponse == null ? void 0 : questionsResponse.questions) || questionsResponse;
    const submittedEmail = (_b3 = (_a3 = questionsArr == null ? void 0 : questionsArr.find) == null ? void 0 : _a3.call(questionsArr, (q2) => q2.id === "email_capture")) == null ? void 0 : _b3.selectedAnswer;
    const submittedName = (_e2 = (_d2 = (_c2 = questionsArr == null ? void 0 : questionsArr.find) == null ? void 0 : _c2.call(questionsArr, (q2) => q2.id === "first_name")) == null ? void 0 : _d2.selectedAnswer) == null ? void 0 : _e2.trim();
    const customerBase = { ...window.routine_customer || {} };
    if (submittedName) customerBase.first_name = submittedName;
    if (submittedEmail) customerBase.email = submittedEmail;
    const customer = customerBase.email || customerBase.first_name ? customerBase : window.routine_customer || null;
    localStorage.setItem(RB_CUSTOMER_EMAIL_SENT_LOCALSTORAGE_KEY, submittedEmail || "");
    const quizTime = (questionsResponse == null ? void 0 : questionsResponse.time) || /* @__PURE__ */ new Date();
    track(source === "edit_answers" ? "routine_finder_answers_updated" : "routine_finder_quiz_completed", quizSummaryProperties(questionsArr, active));
    sendRoutineFinderResultsToKlaviyo(questionsArr, quizTime, customer, active);
    if (submittedEmail) {
      sendSavedResultToKlaviyo(questionsArr, quizTime, customer, active);
    }
  };
  const updateAnswer = (index, answer) => {
    setQuestions((prev) => prev.map((q2, i) => i === index ? { ...q2, selectedAnswer: answer } : q2));
  };
  const setSelectedAnswer = (index, answer) => {
    var _a3;
    track("routine_finder_question_answered", {
      question_id: (_a3 = questions[index]) == null ? void 0 : _a3.id,
      question_index: index,
      ...answerProperties(questions[index], answer)
    });
    const next = questions.map((q2, i) => i === index ? { ...q2, selectedAnswer: answer } : q2);
    setQuestions(next);
    const nextQuestionIndex = index + 1;
    setCurrentQuestionIndex(nextQuestionIndex);
    if (!next[nextQuestionIndex]) {
      setAllQuestionsAnswered(true);
      saveAndUpdateResponse(next);
    }
  };
  const toggleMultiAnswer = (index, answer) => {
    const question = questions[index];
    const current = Array.isArray(question.selectedAnswer) ? [...question.selectedAnswer] : [];
    const max = question.maxSelections || Infinity;
    const existingIdx = current.indexOf(answer);
    if (existingIdx >= 0) {
      current.splice(existingIdx, 1);
    } else if (current.length < max) {
      current.push(answer);
    }
    track("routine_finder_option_toggled", {
      question_id: question.id,
      question_index: index,
      option: answer,
      selected: current.includes(answer),
      selection_count: current.length
    });
    setQuestions((prev) => prev.map((q2, i) => i === index ? { ...q2, selectedAnswer: current } : q2));
  };
  const advanceQuestion = (index) => {
    var _a3, _b3;
    track("routine_finder_question_advanced", {
      question_id: (_a3 = questions[index]) == null ? void 0 : _a3.id,
      question_index: index,
      selected_options: Array.isArray((_b3 = questions[index]) == null ? void 0 : _b3.selectedAnswer) ? questions[index].selectedAnswer : []
    });
    const nextQuestionIndex = index + 1;
    setCurrentQuestionIndex(nextQuestionIndex);
    if (!questions[nextQuestionIndex]) {
      setAllQuestionsAnswered(true);
      saveAndUpdateResponse(questions);
    }
  };
  const goBackQuestion = (index) => {
    var _a3;
    track("routine_finder_question_back", {
      question_id: (_a3 = questions[index]) == null ? void 0 : _a3.id,
      question_index: index,
      returned_to_landing: index <= 0
    });
    if (index <= 0) {
      setQuestionStarted(false);
      return;
    }
    setCurrentQuestionIndex(index - 1);
  };
  const handleEditAnswerModal = (open = false, reason) => {
    track(open ? "routine_finder_edit_answers_opened" : "routine_finder_edit_answers_closed", open ? {} : { reason: reason || "dismissed" });
    setIsEditingAnswers(open);
    if (open) {
      document.body.classList.add("stop-ovetflow");
    } else {
      document.body.classList.remove("stop-ovetflow");
    }
    setCurrentQuestionIndex(questions.length);
  };
  const handleResetQuiz = () => {
    console.log("handleResetQuiz:start");
    track("routine_finder_quiz_restarted", {});
    setCurrentQuestionIndex(0);
    setAllQuestionsAnswered(false);
    setQuestionStarted(true);
    localStorage.setItem(RB_CUSTOMER_EMAIL_SENT_LOCALSTORAGE_KEY, "");
  };
  const { shopifyProductsToShow, resultSummary, eyeEnhancerProduct, routineLevelWiseProducts } = getProductResults({ quizQuestions, active });
  const routineSections = buildRoutineSections(routineLevelWiseProducts);
  const selectedConcernSlugs = selectedConcernsTexts.map((label) => {
    var _a3;
    return (_a3 = skinConcerns.find((sc2) => sc2.label === label)) == null ? void 0 : _a3.name;
  }).filter(Boolean);
  const titleCase = (s) => s.replace(new RegExp("\\b\\p{L}", "gu"), (c) => c.toUpperCase());
  const quizFirstName = (_d = (_c = questions.find((q2) => q2.id === "first_name")) == null ? void 0 : _c.selectedAnswer) == null ? void 0 : _d.trim();
  const customerFirstNameRaw = quizFirstName || ((_f = (_e = window.routine_customer) == null ? void 0 : _e.first_name) == null ? void 0 : _f.trim());
  const customerFirstName = customerFirstNameRaw ? titleCase(customerFirstNameRaw) : "";
  const treatmentName = customerFirstName ? `${customerFirstName}'s Routine` : "Your Personalized Routine";
  const sensitiveSkin = ((_g = questions.find((q2) => q2.id === "skin_sensitivity")) == null ? void 0 : _g.selectedAnswer) === "Yes";
  const pregnant = ((_h = questions.find((q2) => q2.id === "pregnancy")) == null ? void 0 : _h.selectedAnswer) === "Yes";
  const concernShortLabels = selectedConcernSlugs.map((slug) => {
    var _a3;
    return (_a3 = skinConcerns.find((sc2) => sc2.name === slug)) == null ? void 0 : _a3.shortLabel;
  }).filter(Boolean);
  const concernText = concernShortLabels.length ? `your ${concernShortLabels.join(" and ")}` : "your skin";
  const treatmentLede = `Our best solution for ${concernText}.` + (sensitiveSkin ? " Gentle enough for sensitive skin." : "") + (pregnant ? " Safe to use during pregnancy." : "");
  const redirecting = !isResults && allQuestionsAnswered && !!resultsUrl;
  const showResult = isResults && allQuestionsAnswered || !isResults && allQuestionsAnswered && !resultsUrl;
  const resultBlock = /* @__PURE__ */ jsxRuntimeExports.jsxs("main", { className: "routine-builder__quiz-content", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Result,
      {
        routines,
        handleEditAnswerModal,
        active,
        setActive,
        shopifyProductsToShow,
        resultSummary,
        selectedConcernsTexts,
        selectedConcernSlugs,
        eyeEnhancerProduct,
        questions,
        routineSections,
        treatmentName,
        treatmentLede,
        firstName: customerFirstName
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SaveResults,
      {
        allQuestionsAnswered,
        questions,
        lastViewedTime,
        activeTab: active
      }
    )
  ] });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("section", {
    className: "routine-builder",
    /* Quiz-page landing (and the returning-visitor "View my results"). */
    children: [
      !isResults && !questionStarted && /* @__PURE__ */ jsxRuntimeExports.jsx("header", { className: "routine-builder__starter", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "routine-builder__content", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { className: "routine-builder__title", children: "Discover Your Treatments" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "routine-builder__description", children: "Clinically-backed formulas targeted to your exact skin concerns. Take our 30-second skin assessment to find yours." }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "routine-builder__actions with-routine-summary", children: [
          !showViewRoutineBtn && /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: "routine-builder__start-btn", onClick: () => {
            track("routine_finder_quiz_started", {});
            setQuestionStarted(true);
          }, children: "Find My Treatments" }),
          showViewRoutineBtn && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "my-routines", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
              "Your skin concern",
              multipleConcerns && `s`,
              ":"
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "routine-builder__concern", children: [
              selectedConcernsTexts[0],
              multipleConcerns && ` +`
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "routine-builder__concern", children: multipleConcerns && `${selectedConcernsTexts[1]}` })
          ] }),
          showViewRoutineBtn && /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: "routine-builder__start-btn", onClick: () => {
            track("routine_finder_view_results_clicked", { has_results_url: !!resultsUrl });
            if (resultsUrl) {
              window.location.assign(resultsUrl);
              return;
            }
            setQuestionStarted(true);
            const lastQuestion = questions[questions.length - 1];
            setSelectedAnswer(questions.length - 1, lastQuestion.selectedAnswer);
            setAllQuestionsAnswered(true);
          }, children: "View My Results" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "routine-builder__actions", children: showViewRoutineBtn && /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: "routine-builder__update-btn", onClick: () => handleResetQuiz(), children: "Start Over" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ReviewSlider, {})
      ] }) }),
      /* Quiz flow. */
      !isResults && questionStarted && !allQuestionsAnswered && /* @__PURE__ */ jsxRuntimeExports.jsx("main", { className: "routine-builder__quiz-content", children: questions[currentQuestionIndex] && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Question,
        {
          question: questions[currentQuestionIndex],
          setSelectedAnswer,
          toggleMultiAnswer,
          advanceQuestion,
          goBackQuestion,
          currentQuestionIndex,
          questions
        }
      ) }),
      /* Finished the quiz -> redirecting to the dedicated results URL. */
      redirecting && /* @__PURE__ */ jsxRuntimeExports.jsx("main", { className: "routine-builder__quiz-content", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "routine-builder__redirecting", children: "Building your routine…" }) }),
      showResult && resultBlock,
      /* Results page opened with no answers (bad/empty link, cleared storage). */
      isResults && !allQuestionsAnswered && /* @__PURE__ */ jsxRuntimeExports.jsx("header", { className: "routine-builder__starter", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "routine-builder__content", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { className: "routine-builder__title", children: "Discover Your Treatments" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "routine-builder__description", children: "Take our 30-second skin assessment to see your personalized routine." }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "routine-builder__actions", children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { className: "routine-builder__start-btn", href: quizUrl, onClick: () => track("routine_finder_take_quiz_clicked", {}), children: "Take the quiz" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ReviewSlider, {})
      ] }) }),
      isEditingAnswers && /* @__PURE__ */ jsxRuntimeExports.jsx(
        EditAnswer,
        {
          questions,
          handleEditAnswerModal,
          updateAnswer,
          saveAndUpdateResponse
        }
      )
    ]
  });
}
const rootEl = document.getElementById("routine-builder-root");
const mode = ((_b = rootEl == null ? void 0 : rootEl.dataset) == null ? void 0 : _b.rbMode) || new URLSearchParams(window.location.search).get("rbMode") || "quiz";
hydrateResultsFromUrl(mode);
client.createRoot(rootEl).render(
  /* @__PURE__ */ jsxRuntimeExports.jsx(React.StrictMode, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(App, { mode }) })
);


})();